
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1969"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1969"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c5a1G", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8cbdbaa620c64645$export$ffb0004e005737fa; }, function (v) { return $8cbdbaa620c64645$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $8cbdbaa620c64645$export$34b9dba7ce09269b; }, function (v) { return $8cbdbaa620c64645$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $8cbdbaa620c64645$export$25062201e9e25d76; }, function (v) { return $8cbdbaa620c64645$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8cbdbaa620c64645$export$ffb0004e005737fa;
var $8cbdbaa620c64645$export$34b9dba7ce09269b;
var $8cbdbaa620c64645$export$25062201e9e25d76;
'use strict';

var $kyXgS = parcelRequire("kyXgS");
var $8cbdbaa620c64645$var$k = Symbol.for("react.element"), $8cbdbaa620c64645$var$l = Symbol.for("react.fragment"), $8cbdbaa620c64645$var$m = Object.prototype.hasOwnProperty, $8cbdbaa620c64645$var$n = $kyXgS.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $8cbdbaa620c64645$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $8cbdbaa620c64645$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$8cbdbaa620c64645$var$m.call(a, b) && !$8cbdbaa620c64645$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $8cbdbaa620c64645$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $8cbdbaa620c64645$var$n.current
    };
}
$8cbdbaa620c64645$export$ffb0004e005737fa = $8cbdbaa620c64645$var$l;
$8cbdbaa620c64645$export$34b9dba7ce09269b = $8cbdbaa620c64645$var$q;
$8cbdbaa620c64645$export$25062201e9e25d76 = $8cbdbaa620c64645$var$q;

});
parcelRegister("kyXgS", function(module, exports) {
'use strict';

module.exports = (parcelRequire("25qxa"));

});
parcelRegister("25qxa", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $1850a17b8f9b13ae$export$dca3b0875bd9a954; }, function (v) { return $1850a17b8f9b13ae$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $1850a17b8f9b13ae$export$16fa2f45be04daa8; }, function (v) { return $1850a17b8f9b13ae$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $1850a17b8f9b13ae$export$ffb0004e005737fa; }, function (v) { return $1850a17b8f9b13ae$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $1850a17b8f9b13ae$export$e2c29f18771995cb; }, function (v) { return $1850a17b8f9b13ae$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $1850a17b8f9b13ae$export$221d75b3f55bb0bd; }, function (v) { return $1850a17b8f9b13ae$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $1850a17b8f9b13ae$export$5f8d39834fd61797; }, function (v) { return $1850a17b8f9b13ae$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $1850a17b8f9b13ae$export$74bf444e3cd11ea5; }, function (v) { return $1850a17b8f9b13ae$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $1850a17b8f9b13ae$export$ae55be85d98224ed; }, function (v) { return $1850a17b8f9b13ae$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $1850a17b8f9b13ae$export$3ba232387fd5d6dd; }, function (v) { return $1850a17b8f9b13ae$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $1850a17b8f9b13ae$export$e530037191fcd5d7; }, function (v) { return $1850a17b8f9b13ae$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $1850a17b8f9b13ae$export$fd42f52fd3ae1109; }, function (v) { return $1850a17b8f9b13ae$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $1850a17b8f9b13ae$export$c8a8987d4410bf2d; }, function (v) { return $1850a17b8f9b13ae$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $1850a17b8f9b13ae$export$d38cd72104c1f0e9; }, function (v) { return $1850a17b8f9b13ae$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $1850a17b8f9b13ae$export$7d1e3a5e95ceca43; }, function (v) { return $1850a17b8f9b13ae$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $1850a17b8f9b13ae$export$257a8862b851cb5b; }, function (v) { return $1850a17b8f9b13ae$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $1850a17b8f9b13ae$export$a8257692ac88316c; }, function (v) { return $1850a17b8f9b13ae$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $1850a17b8f9b13ae$export$488013bae63b21da; }, function (v) { return $1850a17b8f9b13ae$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $1850a17b8f9b13ae$export$7c73462e0d25e514; }, function (v) { return $1850a17b8f9b13ae$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $1850a17b8f9b13ae$export$7568632d0d33d16d; }, function (v) { return $1850a17b8f9b13ae$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $1850a17b8f9b13ae$export$88948ce120ea2619; }, function (v) { return $1850a17b8f9b13ae$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $1850a17b8f9b13ae$export$35808ee640e87ca7; }, function (v) { return $1850a17b8f9b13ae$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $1850a17b8f9b13ae$export$fae74005e78b1a27; }, function (v) { return $1850a17b8f9b13ae$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $1850a17b8f9b13ae$export$dc8fbce3eb94dc1e; }, function (v) { return $1850a17b8f9b13ae$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $1850a17b8f9b13ae$export$6a7bc4e911dc01cf; }, function (v) { return $1850a17b8f9b13ae$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $1850a17b8f9b13ae$export$6d9c69b0de29b591; }, function (v) { return $1850a17b8f9b13ae$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $1850a17b8f9b13ae$export$f680877a34711e37; }, function (v) { return $1850a17b8f9b13ae$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $1850a17b8f9b13ae$export$d5a552a76deda3c2; }, function (v) { return $1850a17b8f9b13ae$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $1850a17b8f9b13ae$export$aaabe4eda9ed9969; }, function (v) { return $1850a17b8f9b13ae$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $1850a17b8f9b13ae$export$e5c5a5f917a5871c; }, function (v) { return $1850a17b8f9b13ae$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $1850a17b8f9b13ae$export$1538c33de8887b59; }, function (v) { return $1850a17b8f9b13ae$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $1850a17b8f9b13ae$export$13e3392192263954; }, function (v) { return $1850a17b8f9b13ae$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $1850a17b8f9b13ae$export$b8f5890fc79d6aca; }, function (v) { return $1850a17b8f9b13ae$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $1850a17b8f9b13ae$export$60241385465d0a34; }, function (v) { return $1850a17b8f9b13ae$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $1850a17b8f9b13ae$export$306c0aa65ff9ec16; }, function (v) { return $1850a17b8f9b13ae$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $1850a17b8f9b13ae$export$7b286972b8d8ccbf; }, function (v) { return $1850a17b8f9b13ae$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $1850a17b8f9b13ae$export$83d89fbfd8236492; }, function (v) { return $1850a17b8f9b13ae$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1850a17b8f9b13ae$export$dca3b0875bd9a954;
var $1850a17b8f9b13ae$export$16fa2f45be04daa8;
var $1850a17b8f9b13ae$export$ffb0004e005737fa;
var $1850a17b8f9b13ae$export$e2c29f18771995cb;
var $1850a17b8f9b13ae$export$221d75b3f55bb0bd;
var $1850a17b8f9b13ae$export$5f8d39834fd61797;
var $1850a17b8f9b13ae$export$74bf444e3cd11ea5;
var $1850a17b8f9b13ae$export$ae55be85d98224ed;
var $1850a17b8f9b13ae$export$3ba232387fd5d6dd;
var $1850a17b8f9b13ae$export$e530037191fcd5d7;
var $1850a17b8f9b13ae$export$fd42f52fd3ae1109;
var $1850a17b8f9b13ae$export$c8a8987d4410bf2d;
var $1850a17b8f9b13ae$export$d38cd72104c1f0e9;
var $1850a17b8f9b13ae$export$7d1e3a5e95ceca43;
var $1850a17b8f9b13ae$export$257a8862b851cb5b;
var $1850a17b8f9b13ae$export$a8257692ac88316c;
var $1850a17b8f9b13ae$export$488013bae63b21da;
var $1850a17b8f9b13ae$export$7c73462e0d25e514;
var $1850a17b8f9b13ae$export$7568632d0d33d16d;
var $1850a17b8f9b13ae$export$88948ce120ea2619;
var $1850a17b8f9b13ae$export$35808ee640e87ca7;
var $1850a17b8f9b13ae$export$fae74005e78b1a27;
var $1850a17b8f9b13ae$export$dc8fbce3eb94dc1e;
var $1850a17b8f9b13ae$export$6a7bc4e911dc01cf;
var $1850a17b8f9b13ae$export$6d9c69b0de29b591;
var $1850a17b8f9b13ae$export$f680877a34711e37;
var $1850a17b8f9b13ae$export$d5a552a76deda3c2;
var $1850a17b8f9b13ae$export$aaabe4eda9ed9969;
var $1850a17b8f9b13ae$export$e5c5a5f917a5871c;
var $1850a17b8f9b13ae$export$1538c33de8887b59;
var $1850a17b8f9b13ae$export$13e3392192263954;
var $1850a17b8f9b13ae$export$b8f5890fc79d6aca;
var $1850a17b8f9b13ae$export$60241385465d0a34;
var $1850a17b8f9b13ae$export$306c0aa65ff9ec16;
var $1850a17b8f9b13ae$export$7b286972b8d8ccbf;
var $1850a17b8f9b13ae$export$83d89fbfd8236492;
'use strict';
var $1850a17b8f9b13ae$var$l = Symbol.for("react.element"), $1850a17b8f9b13ae$var$n = Symbol.for("react.portal"), $1850a17b8f9b13ae$var$p = Symbol.for("react.fragment"), $1850a17b8f9b13ae$var$q = Symbol.for("react.strict_mode"), $1850a17b8f9b13ae$var$r = Symbol.for("react.profiler"), $1850a17b8f9b13ae$var$t = Symbol.for("react.provider"), $1850a17b8f9b13ae$var$u = Symbol.for("react.context"), $1850a17b8f9b13ae$var$v = Symbol.for("react.forward_ref"), $1850a17b8f9b13ae$var$w = Symbol.for("react.suspense"), $1850a17b8f9b13ae$var$x = Symbol.for("react.memo"), $1850a17b8f9b13ae$var$y = Symbol.for("react.lazy"), $1850a17b8f9b13ae$var$z = Symbol.iterator;
function $1850a17b8f9b13ae$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1850a17b8f9b13ae$var$z && a[$1850a17b8f9b13ae$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1850a17b8f9b13ae$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1850a17b8f9b13ae$var$C = Object.assign, $1850a17b8f9b13ae$var$D = {};
function $1850a17b8f9b13ae$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1850a17b8f9b13ae$var$D;
    this.updater = e || $1850a17b8f9b13ae$var$B;
}
$1850a17b8f9b13ae$var$E.prototype.isReactComponent = {};
$1850a17b8f9b13ae$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1850a17b8f9b13ae$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1850a17b8f9b13ae$var$F() {}
$1850a17b8f9b13ae$var$F.prototype = $1850a17b8f9b13ae$var$E.prototype;
function $1850a17b8f9b13ae$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1850a17b8f9b13ae$var$D;
    this.updater = e || $1850a17b8f9b13ae$var$B;
}
var $1850a17b8f9b13ae$var$H = $1850a17b8f9b13ae$var$G.prototype = new $1850a17b8f9b13ae$var$F;
$1850a17b8f9b13ae$var$H.constructor = $1850a17b8f9b13ae$var$G;
$1850a17b8f9b13ae$var$C($1850a17b8f9b13ae$var$H, $1850a17b8f9b13ae$var$E.prototype);
$1850a17b8f9b13ae$var$H.isPureReactComponent = !0;
var $1850a17b8f9b13ae$var$I = Array.isArray, $1850a17b8f9b13ae$var$J = Object.prototype.hasOwnProperty, $1850a17b8f9b13ae$var$K = {
    current: null
}, $1850a17b8f9b13ae$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1850a17b8f9b13ae$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1850a17b8f9b13ae$var$J.call(b, d) && !$1850a17b8f9b13ae$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1850a17b8f9b13ae$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1850a17b8f9b13ae$var$K.current
    };
}
function $1850a17b8f9b13ae$var$N(a, b) {
    return {
        $$typeof: $1850a17b8f9b13ae$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1850a17b8f9b13ae$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1850a17b8f9b13ae$var$l;
}
function $1850a17b8f9b13ae$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1850a17b8f9b13ae$var$P = /\/+/g;
function $1850a17b8f9b13ae$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1850a17b8f9b13ae$var$escape("" + a.key) : b.toString(36);
}
function $1850a17b8f9b13ae$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1850a17b8f9b13ae$var$l:
                case $1850a17b8f9b13ae$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1850a17b8f9b13ae$var$Q(h, 0) : d, $1850a17b8f9b13ae$var$I(c) ? (e = "", null != a && (e = a.replace($1850a17b8f9b13ae$var$P, "$&/") + "/"), $1850a17b8f9b13ae$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1850a17b8f9b13ae$var$O(c) && (c = $1850a17b8f9b13ae$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1850a17b8f9b13ae$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1850a17b8f9b13ae$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1850a17b8f9b13ae$var$Q(k, g);
        h += $1850a17b8f9b13ae$var$R(k, b, e, f, c);
    }
    else if (f = $1850a17b8f9b13ae$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1850a17b8f9b13ae$var$Q(k, g++), h += $1850a17b8f9b13ae$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1850a17b8f9b13ae$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1850a17b8f9b13ae$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1850a17b8f9b13ae$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1850a17b8f9b13ae$var$U = {
    current: null
}, $1850a17b8f9b13ae$var$V = {
    transition: null
}, $1850a17b8f9b13ae$var$W = {
    ReactCurrentDispatcher: $1850a17b8f9b13ae$var$U,
    ReactCurrentBatchConfig: $1850a17b8f9b13ae$var$V,
    ReactCurrentOwner: $1850a17b8f9b13ae$var$K
};
function $1850a17b8f9b13ae$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1850a17b8f9b13ae$export$dca3b0875bd9a954 = {
    map: $1850a17b8f9b13ae$var$S,
    forEach: function(a, b, e) {
        $1850a17b8f9b13ae$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1850a17b8f9b13ae$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1850a17b8f9b13ae$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1850a17b8f9b13ae$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1850a17b8f9b13ae$export$16fa2f45be04daa8 = $1850a17b8f9b13ae$var$E;
$1850a17b8f9b13ae$export$ffb0004e005737fa = $1850a17b8f9b13ae$var$p;
$1850a17b8f9b13ae$export$e2c29f18771995cb = $1850a17b8f9b13ae$var$r;
$1850a17b8f9b13ae$export$221d75b3f55bb0bd = $1850a17b8f9b13ae$var$G;
$1850a17b8f9b13ae$export$5f8d39834fd61797 = $1850a17b8f9b13ae$var$q;
$1850a17b8f9b13ae$export$74bf444e3cd11ea5 = $1850a17b8f9b13ae$var$w;
$1850a17b8f9b13ae$export$ae55be85d98224ed = $1850a17b8f9b13ae$var$W;
$1850a17b8f9b13ae$export$3ba232387fd5d6dd = $1850a17b8f9b13ae$var$X;
$1850a17b8f9b13ae$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1850a17b8f9b13ae$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1850a17b8f9b13ae$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1850a17b8f9b13ae$var$J.call(b, f) && !$1850a17b8f9b13ae$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1850a17b8f9b13ae$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1850a17b8f9b13ae$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1850a17b8f9b13ae$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1850a17b8f9b13ae$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1850a17b8f9b13ae$export$c8a8987d4410bf2d = $1850a17b8f9b13ae$var$M;
$1850a17b8f9b13ae$export$d38cd72104c1f0e9 = function(a) {
    var b = $1850a17b8f9b13ae$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1850a17b8f9b13ae$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1850a17b8f9b13ae$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1850a17b8f9b13ae$var$v,
        render: a
    };
};
$1850a17b8f9b13ae$export$a8257692ac88316c = $1850a17b8f9b13ae$var$O;
$1850a17b8f9b13ae$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1850a17b8f9b13ae$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1850a17b8f9b13ae$var$T
    };
};
$1850a17b8f9b13ae$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1850a17b8f9b13ae$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1850a17b8f9b13ae$export$7568632d0d33d16d = function(a) {
    var b = $1850a17b8f9b13ae$var$V.transition;
    $1850a17b8f9b13ae$var$V.transition = {};
    try {
        a();
    } finally{
        $1850a17b8f9b13ae$var$V.transition = b;
    }
};
$1850a17b8f9b13ae$export$88948ce120ea2619 = $1850a17b8f9b13ae$var$X;
$1850a17b8f9b13ae$export$35808ee640e87ca7 = function(a, b) {
    return $1850a17b8f9b13ae$var$U.current.useCallback(a, b);
};
$1850a17b8f9b13ae$export$fae74005e78b1a27 = function(a) {
    return $1850a17b8f9b13ae$var$U.current.useContext(a);
};
$1850a17b8f9b13ae$export$dc8fbce3eb94dc1e = function() {};
$1850a17b8f9b13ae$export$6a7bc4e911dc01cf = function(a) {
    return $1850a17b8f9b13ae$var$U.current.useDeferredValue(a);
};
$1850a17b8f9b13ae$export$6d9c69b0de29b591 = function(a, b) {
    return $1850a17b8f9b13ae$var$U.current.useEffect(a, b);
};
$1850a17b8f9b13ae$export$f680877a34711e37 = function() {
    return $1850a17b8f9b13ae$var$U.current.useId();
};
$1850a17b8f9b13ae$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1850a17b8f9b13ae$var$U.current.useImperativeHandle(a, b, e);
};
$1850a17b8f9b13ae$export$aaabe4eda9ed9969 = function(a, b) {
    return $1850a17b8f9b13ae$var$U.current.useInsertionEffect(a, b);
};
$1850a17b8f9b13ae$export$e5c5a5f917a5871c = function(a, b) {
    return $1850a17b8f9b13ae$var$U.current.useLayoutEffect(a, b);
};
$1850a17b8f9b13ae$export$1538c33de8887b59 = function(a, b) {
    return $1850a17b8f9b13ae$var$U.current.useMemo(a, b);
};
$1850a17b8f9b13ae$export$13e3392192263954 = function(a, b, e) {
    return $1850a17b8f9b13ae$var$U.current.useReducer(a, b, e);
};
$1850a17b8f9b13ae$export$b8f5890fc79d6aca = function(a) {
    return $1850a17b8f9b13ae$var$U.current.useRef(a);
};
$1850a17b8f9b13ae$export$60241385465d0a34 = function(a) {
    return $1850a17b8f9b13ae$var$U.current.useState(a);
};
$1850a17b8f9b13ae$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1850a17b8f9b13ae$var$U.current.useSyncExternalStore(a, b, e);
};
$1850a17b8f9b13ae$export$7b286972b8d8ccbf = function() {
    return $1850a17b8f9b13ae$var$U.current.useTransition();
};
$1850a17b8f9b13ae$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("3Y7La", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $2e3cfe9ab16332fa$export$ae55be85d98224ed; }, function (v) { return $2e3cfe9ab16332fa$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $2e3cfe9ab16332fa$export$d39a5bbd09211389; }, function (v) { return $2e3cfe9ab16332fa$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $2e3cfe9ab16332fa$export$882461b6382ed46c; }, function (v) { return $2e3cfe9ab16332fa$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $2e3cfe9ab16332fa$export$466bfc07425424d5; }, function (v) { return $2e3cfe9ab16332fa$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $2e3cfe9ab16332fa$export$cd75ccfd720a3cd4; }, function (v) { return $2e3cfe9ab16332fa$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $2e3cfe9ab16332fa$export$fa8d919ba61d84db; }, function (v) { return $2e3cfe9ab16332fa$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $2e3cfe9ab16332fa$export$757ceba2d55c277e; }, function (v) { return $2e3cfe9ab16332fa$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $2e3cfe9ab16332fa$export$b3890eb0ae9dca99; }, function (v) { return $2e3cfe9ab16332fa$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $2e3cfe9ab16332fa$export$502457920280e6be; }, function (v) { return $2e3cfe9ab16332fa$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $2e3cfe9ab16332fa$export$c78a37762a8d58e1; }, function (v) { return $2e3cfe9ab16332fa$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $2e3cfe9ab16332fa$export$dc54d992c10e8a18; }, function (v) { return $2e3cfe9ab16332fa$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $2e3cfe9ab16332fa$export$83d89fbfd8236492; }, function (v) { return $2e3cfe9ab16332fa$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $2e3cfe9ab16332fa$export$ae55be85d98224ed;
var $2e3cfe9ab16332fa$export$d39a5bbd09211389;
var $2e3cfe9ab16332fa$export$882461b6382ed46c;
var $2e3cfe9ab16332fa$export$466bfc07425424d5;
var $2e3cfe9ab16332fa$export$cd75ccfd720a3cd4;
var $2e3cfe9ab16332fa$export$fa8d919ba61d84db;
var $2e3cfe9ab16332fa$export$757ceba2d55c277e;
var $2e3cfe9ab16332fa$export$b3890eb0ae9dca99;
var $2e3cfe9ab16332fa$export$502457920280e6be;
var $2e3cfe9ab16332fa$export$c78a37762a8d58e1;
var $2e3cfe9ab16332fa$export$dc54d992c10e8a18;
var $2e3cfe9ab16332fa$export$83d89fbfd8236492;
'use strict';

var $kyXgS = parcelRequire("kyXgS");

var $8NIXl = parcelRequire("8NIXl");
function $2e3cfe9ab16332fa$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $2e3cfe9ab16332fa$var$da = new Set, $2e3cfe9ab16332fa$var$ea = {};
function $2e3cfe9ab16332fa$var$fa(a, b) {
    $2e3cfe9ab16332fa$var$ha(a, b);
    $2e3cfe9ab16332fa$var$ha(a + "Capture", b);
}
function $2e3cfe9ab16332fa$var$ha(a, b) {
    $2e3cfe9ab16332fa$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$2e3cfe9ab16332fa$var$da.add(b[a]);
}
var $2e3cfe9ab16332fa$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $2e3cfe9ab16332fa$var$ja = Object.prototype.hasOwnProperty, $2e3cfe9ab16332fa$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $2e3cfe9ab16332fa$var$la = {}, $2e3cfe9ab16332fa$var$ma = {};
function $2e3cfe9ab16332fa$var$oa(a) {
    if ($2e3cfe9ab16332fa$var$ja.call($2e3cfe9ab16332fa$var$ma, a)) return !0;
    if ($2e3cfe9ab16332fa$var$ja.call($2e3cfe9ab16332fa$var$la, a)) return !1;
    if ($2e3cfe9ab16332fa$var$ka.test(a)) return $2e3cfe9ab16332fa$var$ma[a] = !0;
    $2e3cfe9ab16332fa$var$la[a] = !0;
    return !1;
}
function $2e3cfe9ab16332fa$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $2e3cfe9ab16332fa$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $2e3cfe9ab16332fa$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $2e3cfe9ab16332fa$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $2e3cfe9ab16332fa$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $2e3cfe9ab16332fa$var$z[a] = new $2e3cfe9ab16332fa$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $2e3cfe9ab16332fa$var$z[b] = new $2e3cfe9ab16332fa$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $2e3cfe9ab16332fa$var$z[a] = new $2e3cfe9ab16332fa$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $2e3cfe9ab16332fa$var$z[a] = new $2e3cfe9ab16332fa$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $2e3cfe9ab16332fa$var$z[a] = new $2e3cfe9ab16332fa$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $2e3cfe9ab16332fa$var$z[a] = new $2e3cfe9ab16332fa$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $2e3cfe9ab16332fa$var$z[a] = new $2e3cfe9ab16332fa$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $2e3cfe9ab16332fa$var$z[a] = new $2e3cfe9ab16332fa$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $2e3cfe9ab16332fa$var$z[a] = new $2e3cfe9ab16332fa$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $2e3cfe9ab16332fa$var$ra = /[\-:]([a-z])/g;
function $2e3cfe9ab16332fa$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($2e3cfe9ab16332fa$var$ra, $2e3cfe9ab16332fa$var$sa);
    $2e3cfe9ab16332fa$var$z[b] = new $2e3cfe9ab16332fa$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($2e3cfe9ab16332fa$var$ra, $2e3cfe9ab16332fa$var$sa);
    $2e3cfe9ab16332fa$var$z[b] = new $2e3cfe9ab16332fa$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($2e3cfe9ab16332fa$var$ra, $2e3cfe9ab16332fa$var$sa);
    $2e3cfe9ab16332fa$var$z[b] = new $2e3cfe9ab16332fa$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $2e3cfe9ab16332fa$var$z[a] = new $2e3cfe9ab16332fa$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$2e3cfe9ab16332fa$var$z.xlinkHref = new $2e3cfe9ab16332fa$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $2e3cfe9ab16332fa$var$z[a] = new $2e3cfe9ab16332fa$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $2e3cfe9ab16332fa$var$ta(a, b, c, d) {
    var e = $2e3cfe9ab16332fa$var$z.hasOwnProperty(b) ? $2e3cfe9ab16332fa$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $2e3cfe9ab16332fa$var$qa(b, c, e, d) && (c = null), d || null === e ? $2e3cfe9ab16332fa$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $2e3cfe9ab16332fa$var$ua = $kyXgS.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $2e3cfe9ab16332fa$var$va = Symbol.for("react.element"), $2e3cfe9ab16332fa$var$wa = Symbol.for("react.portal"), $2e3cfe9ab16332fa$var$ya = Symbol.for("react.fragment"), $2e3cfe9ab16332fa$var$za = Symbol.for("react.strict_mode"), $2e3cfe9ab16332fa$var$Aa = Symbol.for("react.profiler"), $2e3cfe9ab16332fa$var$Ba = Symbol.for("react.provider"), $2e3cfe9ab16332fa$var$Ca = Symbol.for("react.context"), $2e3cfe9ab16332fa$var$Da = Symbol.for("react.forward_ref"), $2e3cfe9ab16332fa$var$Ea = Symbol.for("react.suspense"), $2e3cfe9ab16332fa$var$Fa = Symbol.for("react.suspense_list"), $2e3cfe9ab16332fa$var$Ga = Symbol.for("react.memo"), $2e3cfe9ab16332fa$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $2e3cfe9ab16332fa$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $2e3cfe9ab16332fa$var$Ja = Symbol.iterator;
function $2e3cfe9ab16332fa$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $2e3cfe9ab16332fa$var$Ja && a[$2e3cfe9ab16332fa$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $2e3cfe9ab16332fa$var$A = Object.assign, $2e3cfe9ab16332fa$var$La;
function $2e3cfe9ab16332fa$var$Ma(a) {
    if (void 0 === $2e3cfe9ab16332fa$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $2e3cfe9ab16332fa$var$La = b && b[1] || "";
    }
    return "\n" + $2e3cfe9ab16332fa$var$La + a;
}
var $2e3cfe9ab16332fa$var$Na = !1;
function $2e3cfe9ab16332fa$var$Oa(a, b) {
    if (!a || $2e3cfe9ab16332fa$var$Na) return "";
    $2e3cfe9ab16332fa$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $2e3cfe9ab16332fa$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $2e3cfe9ab16332fa$var$Ma(a) : "";
}
function $2e3cfe9ab16332fa$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $2e3cfe9ab16332fa$var$Ma(a.type);
        case 16:
            return $2e3cfe9ab16332fa$var$Ma("Lazy");
        case 13:
            return $2e3cfe9ab16332fa$var$Ma("Suspense");
        case 19:
            return $2e3cfe9ab16332fa$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $2e3cfe9ab16332fa$var$Oa(a.type, !1), a;
        case 11:
            return a = $2e3cfe9ab16332fa$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $2e3cfe9ab16332fa$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $2e3cfe9ab16332fa$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $2e3cfe9ab16332fa$var$ya:
            return "Fragment";
        case $2e3cfe9ab16332fa$var$wa:
            return "Portal";
        case $2e3cfe9ab16332fa$var$Aa:
            return "Profiler";
        case $2e3cfe9ab16332fa$var$za:
            return "StrictMode";
        case $2e3cfe9ab16332fa$var$Ea:
            return "Suspense";
        case $2e3cfe9ab16332fa$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $2e3cfe9ab16332fa$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $2e3cfe9ab16332fa$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $2e3cfe9ab16332fa$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $2e3cfe9ab16332fa$var$Ga:
            return b = a.displayName || null, null !== b ? b : $2e3cfe9ab16332fa$var$Qa(a.type) || "Memo";
        case $2e3cfe9ab16332fa$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $2e3cfe9ab16332fa$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $2e3cfe9ab16332fa$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $2e3cfe9ab16332fa$var$Qa(b);
        case 8:
            return b === $2e3cfe9ab16332fa$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $2e3cfe9ab16332fa$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $2e3cfe9ab16332fa$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $2e3cfe9ab16332fa$var$Ua(a) {
    var b = $2e3cfe9ab16332fa$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $2e3cfe9ab16332fa$var$Va(a) {
    a._valueTracker || (a._valueTracker = $2e3cfe9ab16332fa$var$Ua(a));
}
function $2e3cfe9ab16332fa$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $2e3cfe9ab16332fa$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $2e3cfe9ab16332fa$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $2e3cfe9ab16332fa$var$Ya(a, b) {
    var c = b.checked;
    return $2e3cfe9ab16332fa$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $2e3cfe9ab16332fa$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $2e3cfe9ab16332fa$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $2e3cfe9ab16332fa$var$ab(a, b) {
    b = b.checked;
    null != b && $2e3cfe9ab16332fa$var$ta(a, "checked", b, !1);
}
function $2e3cfe9ab16332fa$var$bb(a, b) {
    $2e3cfe9ab16332fa$var$ab(a, b);
    var c = $2e3cfe9ab16332fa$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $2e3cfe9ab16332fa$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $2e3cfe9ab16332fa$var$cb(a, b.type, $2e3cfe9ab16332fa$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $2e3cfe9ab16332fa$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $2e3cfe9ab16332fa$var$cb(a, b, c) {
    if ("number" !== b || $2e3cfe9ab16332fa$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $2e3cfe9ab16332fa$var$eb = Array.isArray;
function $2e3cfe9ab16332fa$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $2e3cfe9ab16332fa$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $2e3cfe9ab16332fa$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($2e3cfe9ab16332fa$var$p(91));
    return $2e3cfe9ab16332fa$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $2e3cfe9ab16332fa$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($2e3cfe9ab16332fa$var$p(92));
            if ($2e3cfe9ab16332fa$var$eb(c)) {
                if (1 < c.length) throw Error($2e3cfe9ab16332fa$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $2e3cfe9ab16332fa$var$Sa(c)
    };
}
function $2e3cfe9ab16332fa$var$ib(a, b) {
    var c = $2e3cfe9ab16332fa$var$Sa(b.value), d = $2e3cfe9ab16332fa$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $2e3cfe9ab16332fa$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $2e3cfe9ab16332fa$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $2e3cfe9ab16332fa$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $2e3cfe9ab16332fa$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $2e3cfe9ab16332fa$var$mb, $2e3cfe9ab16332fa$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $2e3cfe9ab16332fa$var$mb = $2e3cfe9ab16332fa$var$mb || document.createElement("div");
        $2e3cfe9ab16332fa$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $2e3cfe9ab16332fa$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $2e3cfe9ab16332fa$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $2e3cfe9ab16332fa$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $2e3cfe9ab16332fa$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($2e3cfe9ab16332fa$var$pb).forEach(function(a) {
    $2e3cfe9ab16332fa$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $2e3cfe9ab16332fa$var$pb[b] = $2e3cfe9ab16332fa$var$pb[a];
    });
});
function $2e3cfe9ab16332fa$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $2e3cfe9ab16332fa$var$pb.hasOwnProperty(a) && $2e3cfe9ab16332fa$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $2e3cfe9ab16332fa$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $2e3cfe9ab16332fa$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $2e3cfe9ab16332fa$var$tb = $2e3cfe9ab16332fa$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $2e3cfe9ab16332fa$var$ub(a, b) {
    if (b) {
        if ($2e3cfe9ab16332fa$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($2e3cfe9ab16332fa$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($2e3cfe9ab16332fa$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($2e3cfe9ab16332fa$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($2e3cfe9ab16332fa$var$p(62));
    }
}
function $2e3cfe9ab16332fa$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $2e3cfe9ab16332fa$var$wb = null;
function $2e3cfe9ab16332fa$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $2e3cfe9ab16332fa$var$yb = null, $2e3cfe9ab16332fa$var$zb = null, $2e3cfe9ab16332fa$var$Ab = null;
function $2e3cfe9ab16332fa$var$Bb(a) {
    if (a = $2e3cfe9ab16332fa$var$Cb(a)) {
        if ("function" !== typeof $2e3cfe9ab16332fa$var$yb) throw Error($2e3cfe9ab16332fa$var$p(280));
        var b = a.stateNode;
        b && (b = $2e3cfe9ab16332fa$var$Db(b), $2e3cfe9ab16332fa$var$yb(a.stateNode, a.type, b));
    }
}
function $2e3cfe9ab16332fa$var$Eb(a) {
    $2e3cfe9ab16332fa$var$zb ? $2e3cfe9ab16332fa$var$Ab ? $2e3cfe9ab16332fa$var$Ab.push(a) : $2e3cfe9ab16332fa$var$Ab = [
        a
    ] : $2e3cfe9ab16332fa$var$zb = a;
}
function $2e3cfe9ab16332fa$var$Fb() {
    if ($2e3cfe9ab16332fa$var$zb) {
        var a = $2e3cfe9ab16332fa$var$zb, b = $2e3cfe9ab16332fa$var$Ab;
        $2e3cfe9ab16332fa$var$Ab = $2e3cfe9ab16332fa$var$zb = null;
        $2e3cfe9ab16332fa$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$2e3cfe9ab16332fa$var$Bb(b[a]);
    }
}
function $2e3cfe9ab16332fa$var$Gb(a, b) {
    return a(b);
}
function $2e3cfe9ab16332fa$var$Hb() {}
var $2e3cfe9ab16332fa$var$Ib = !1;
function $2e3cfe9ab16332fa$var$Jb(a, b, c) {
    if ($2e3cfe9ab16332fa$var$Ib) return a(b, c);
    $2e3cfe9ab16332fa$var$Ib = !0;
    try {
        return $2e3cfe9ab16332fa$var$Gb(a, b, c);
    } finally{
        if ($2e3cfe9ab16332fa$var$Ib = !1, null !== $2e3cfe9ab16332fa$var$zb || null !== $2e3cfe9ab16332fa$var$Ab) $2e3cfe9ab16332fa$var$Hb(), $2e3cfe9ab16332fa$var$Fb();
    }
}
function $2e3cfe9ab16332fa$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $2e3cfe9ab16332fa$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($2e3cfe9ab16332fa$var$p(231, b, typeof c));
    return c;
}
var $2e3cfe9ab16332fa$var$Lb = !1;
if ($2e3cfe9ab16332fa$var$ia) try {
    var $2e3cfe9ab16332fa$var$Mb = {};
    Object.defineProperty($2e3cfe9ab16332fa$var$Mb, "passive", {
        get: function() {
            $2e3cfe9ab16332fa$var$Lb = !0;
        }
    });
    window.addEventListener("test", $2e3cfe9ab16332fa$var$Mb, $2e3cfe9ab16332fa$var$Mb);
    window.removeEventListener("test", $2e3cfe9ab16332fa$var$Mb, $2e3cfe9ab16332fa$var$Mb);
} catch (a) {
    $2e3cfe9ab16332fa$var$Lb = !1;
}
function $2e3cfe9ab16332fa$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $2e3cfe9ab16332fa$var$Ob = !1, $2e3cfe9ab16332fa$var$Pb = null, $2e3cfe9ab16332fa$var$Qb = !1, $2e3cfe9ab16332fa$var$Rb = null, $2e3cfe9ab16332fa$var$Sb = {
    onError: function(a) {
        $2e3cfe9ab16332fa$var$Ob = !0;
        $2e3cfe9ab16332fa$var$Pb = a;
    }
};
function $2e3cfe9ab16332fa$var$Tb(a, b, c, d, e, f, g, h, k) {
    $2e3cfe9ab16332fa$var$Ob = !1;
    $2e3cfe9ab16332fa$var$Pb = null;
    $2e3cfe9ab16332fa$var$Nb.apply($2e3cfe9ab16332fa$var$Sb, arguments);
}
function $2e3cfe9ab16332fa$var$Ub(a, b, c, d, e, f, g, h, k) {
    $2e3cfe9ab16332fa$var$Tb.apply(this, arguments);
    if ($2e3cfe9ab16332fa$var$Ob) {
        if ($2e3cfe9ab16332fa$var$Ob) {
            var l = $2e3cfe9ab16332fa$var$Pb;
            $2e3cfe9ab16332fa$var$Ob = !1;
            $2e3cfe9ab16332fa$var$Pb = null;
        } else throw Error($2e3cfe9ab16332fa$var$p(198));
        $2e3cfe9ab16332fa$var$Qb || ($2e3cfe9ab16332fa$var$Qb = !0, $2e3cfe9ab16332fa$var$Rb = l);
    }
}
function $2e3cfe9ab16332fa$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $2e3cfe9ab16332fa$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $2e3cfe9ab16332fa$var$Xb(a) {
    if ($2e3cfe9ab16332fa$var$Vb(a) !== a) throw Error($2e3cfe9ab16332fa$var$p(188));
}
function $2e3cfe9ab16332fa$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $2e3cfe9ab16332fa$var$Vb(a);
        if (null === b) throw Error($2e3cfe9ab16332fa$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $2e3cfe9ab16332fa$var$Xb(e), a;
                if (f === d) return $2e3cfe9ab16332fa$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($2e3cfe9ab16332fa$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($2e3cfe9ab16332fa$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($2e3cfe9ab16332fa$var$p(190));
    }
    if (3 !== c.tag) throw Error($2e3cfe9ab16332fa$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $2e3cfe9ab16332fa$var$Zb(a) {
    a = $2e3cfe9ab16332fa$var$Yb(a);
    return null !== a ? $2e3cfe9ab16332fa$var$$b(a) : null;
}
function $2e3cfe9ab16332fa$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $2e3cfe9ab16332fa$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $2e3cfe9ab16332fa$var$ac = $8NIXl.unstable_scheduleCallback, $2e3cfe9ab16332fa$var$bc = $8NIXl.unstable_cancelCallback, $2e3cfe9ab16332fa$var$cc = $8NIXl.unstable_shouldYield, $2e3cfe9ab16332fa$var$dc = $8NIXl.unstable_requestPaint, $2e3cfe9ab16332fa$var$B = $8NIXl.unstable_now, $2e3cfe9ab16332fa$var$ec = $8NIXl.unstable_getCurrentPriorityLevel, $2e3cfe9ab16332fa$var$fc = $8NIXl.unstable_ImmediatePriority, $2e3cfe9ab16332fa$var$gc = $8NIXl.unstable_UserBlockingPriority, $2e3cfe9ab16332fa$var$hc = $8NIXl.unstable_NormalPriority, $2e3cfe9ab16332fa$var$ic = $8NIXl.unstable_LowPriority, $2e3cfe9ab16332fa$var$jc = $8NIXl.unstable_IdlePriority, $2e3cfe9ab16332fa$var$kc = null, $2e3cfe9ab16332fa$var$lc = null;
function $2e3cfe9ab16332fa$var$mc(a) {
    if ($2e3cfe9ab16332fa$var$lc && "function" === typeof $2e3cfe9ab16332fa$var$lc.onCommitFiberRoot) try {
        $2e3cfe9ab16332fa$var$lc.onCommitFiberRoot($2e3cfe9ab16332fa$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $2e3cfe9ab16332fa$var$oc = Math.clz32 ? Math.clz32 : $2e3cfe9ab16332fa$var$nc, $2e3cfe9ab16332fa$var$pc = Math.log, $2e3cfe9ab16332fa$var$qc = Math.LN2;
function $2e3cfe9ab16332fa$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($2e3cfe9ab16332fa$var$pc(a) / $2e3cfe9ab16332fa$var$qc | 0) | 0;
}
var $2e3cfe9ab16332fa$var$rc = 64, $2e3cfe9ab16332fa$var$sc = 4194304;
function $2e3cfe9ab16332fa$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $2e3cfe9ab16332fa$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $2e3cfe9ab16332fa$var$tc(h) : (f &= g, 0 !== f && (d = $2e3cfe9ab16332fa$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $2e3cfe9ab16332fa$var$tc(g) : 0 !== f && (d = $2e3cfe9ab16332fa$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $2e3cfe9ab16332fa$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $2e3cfe9ab16332fa$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $2e3cfe9ab16332fa$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $2e3cfe9ab16332fa$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $2e3cfe9ab16332fa$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $2e3cfe9ab16332fa$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $2e3cfe9ab16332fa$var$yc() {
    var a = $2e3cfe9ab16332fa$var$rc;
    $2e3cfe9ab16332fa$var$rc <<= 1;
    0 === ($2e3cfe9ab16332fa$var$rc & 4194240) && ($2e3cfe9ab16332fa$var$rc = 64);
    return a;
}
function $2e3cfe9ab16332fa$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $2e3cfe9ab16332fa$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $2e3cfe9ab16332fa$var$oc(b);
    a[b] = c;
}
function $2e3cfe9ab16332fa$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $2e3cfe9ab16332fa$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $2e3cfe9ab16332fa$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $2e3cfe9ab16332fa$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $2e3cfe9ab16332fa$var$C = 0;
function $2e3cfe9ab16332fa$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $2e3cfe9ab16332fa$var$Ec, $2e3cfe9ab16332fa$var$Fc, $2e3cfe9ab16332fa$var$Gc, $2e3cfe9ab16332fa$var$Hc, $2e3cfe9ab16332fa$var$Ic, $2e3cfe9ab16332fa$var$Jc = !1, $2e3cfe9ab16332fa$var$Kc = [], $2e3cfe9ab16332fa$var$Lc = null, $2e3cfe9ab16332fa$var$Mc = null, $2e3cfe9ab16332fa$var$Nc = null, $2e3cfe9ab16332fa$var$Oc = new Map, $2e3cfe9ab16332fa$var$Pc = new Map, $2e3cfe9ab16332fa$var$Qc = [], $2e3cfe9ab16332fa$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $2e3cfe9ab16332fa$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $2e3cfe9ab16332fa$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $2e3cfe9ab16332fa$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $2e3cfe9ab16332fa$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $2e3cfe9ab16332fa$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $2e3cfe9ab16332fa$var$Pc.delete(b.pointerId);
    }
}
function $2e3cfe9ab16332fa$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $2e3cfe9ab16332fa$var$Cb(b), null !== b && $2e3cfe9ab16332fa$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $2e3cfe9ab16332fa$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $2e3cfe9ab16332fa$var$Lc = $2e3cfe9ab16332fa$var$Tc($2e3cfe9ab16332fa$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $2e3cfe9ab16332fa$var$Mc = $2e3cfe9ab16332fa$var$Tc($2e3cfe9ab16332fa$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $2e3cfe9ab16332fa$var$Nc = $2e3cfe9ab16332fa$var$Tc($2e3cfe9ab16332fa$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $2e3cfe9ab16332fa$var$Oc.set(f, $2e3cfe9ab16332fa$var$Tc($2e3cfe9ab16332fa$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $2e3cfe9ab16332fa$var$Pc.set(f, $2e3cfe9ab16332fa$var$Tc($2e3cfe9ab16332fa$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $2e3cfe9ab16332fa$var$Vc(a) {
    var b = $2e3cfe9ab16332fa$var$Wc(a.target);
    if (null !== b) {
        var c = $2e3cfe9ab16332fa$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $2e3cfe9ab16332fa$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $2e3cfe9ab16332fa$var$Ic(a.priority, function() {
                        $2e3cfe9ab16332fa$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $2e3cfe9ab16332fa$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $2e3cfe9ab16332fa$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $2e3cfe9ab16332fa$var$wb = d;
            c.target.dispatchEvent(d);
            $2e3cfe9ab16332fa$var$wb = null;
        } else return b = $2e3cfe9ab16332fa$var$Cb(c), null !== b && $2e3cfe9ab16332fa$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $2e3cfe9ab16332fa$var$Zc(a, b, c) {
    $2e3cfe9ab16332fa$var$Xc(a) && c.delete(b);
}
function $2e3cfe9ab16332fa$var$$c() {
    $2e3cfe9ab16332fa$var$Jc = !1;
    null !== $2e3cfe9ab16332fa$var$Lc && $2e3cfe9ab16332fa$var$Xc($2e3cfe9ab16332fa$var$Lc) && ($2e3cfe9ab16332fa$var$Lc = null);
    null !== $2e3cfe9ab16332fa$var$Mc && $2e3cfe9ab16332fa$var$Xc($2e3cfe9ab16332fa$var$Mc) && ($2e3cfe9ab16332fa$var$Mc = null);
    null !== $2e3cfe9ab16332fa$var$Nc && $2e3cfe9ab16332fa$var$Xc($2e3cfe9ab16332fa$var$Nc) && ($2e3cfe9ab16332fa$var$Nc = null);
    $2e3cfe9ab16332fa$var$Oc.forEach($2e3cfe9ab16332fa$var$Zc);
    $2e3cfe9ab16332fa$var$Pc.forEach($2e3cfe9ab16332fa$var$Zc);
}
function $2e3cfe9ab16332fa$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $2e3cfe9ab16332fa$var$Jc || ($2e3cfe9ab16332fa$var$Jc = !0, $8NIXl.unstable_scheduleCallback($8NIXl.unstable_NormalPriority, $2e3cfe9ab16332fa$var$$c)));
}
function $2e3cfe9ab16332fa$var$bd(a) {
    function b(b) {
        return $2e3cfe9ab16332fa$var$ad(b, a);
    }
    if (0 < $2e3cfe9ab16332fa$var$Kc.length) {
        $2e3cfe9ab16332fa$var$ad($2e3cfe9ab16332fa$var$Kc[0], a);
        for(var c = 1; c < $2e3cfe9ab16332fa$var$Kc.length; c++){
            var d = $2e3cfe9ab16332fa$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $2e3cfe9ab16332fa$var$Lc && $2e3cfe9ab16332fa$var$ad($2e3cfe9ab16332fa$var$Lc, a);
    null !== $2e3cfe9ab16332fa$var$Mc && $2e3cfe9ab16332fa$var$ad($2e3cfe9ab16332fa$var$Mc, a);
    null !== $2e3cfe9ab16332fa$var$Nc && $2e3cfe9ab16332fa$var$ad($2e3cfe9ab16332fa$var$Nc, a);
    $2e3cfe9ab16332fa$var$Oc.forEach(b);
    $2e3cfe9ab16332fa$var$Pc.forEach(b);
    for(c = 0; c < $2e3cfe9ab16332fa$var$Qc.length; c++)d = $2e3cfe9ab16332fa$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $2e3cfe9ab16332fa$var$Qc.length && (c = $2e3cfe9ab16332fa$var$Qc[0], null === c.blockedOn);)$2e3cfe9ab16332fa$var$Vc(c), null === c.blockedOn && $2e3cfe9ab16332fa$var$Qc.shift();
}
var $2e3cfe9ab16332fa$var$cd = $2e3cfe9ab16332fa$var$ua.ReactCurrentBatchConfig, $2e3cfe9ab16332fa$var$dd = !0;
function $2e3cfe9ab16332fa$var$ed(a, b, c, d) {
    var e = $2e3cfe9ab16332fa$var$C, f = $2e3cfe9ab16332fa$var$cd.transition;
    $2e3cfe9ab16332fa$var$cd.transition = null;
    try {
        $2e3cfe9ab16332fa$var$C = 1, $2e3cfe9ab16332fa$var$fd(a, b, c, d);
    } finally{
        $2e3cfe9ab16332fa$var$C = e, $2e3cfe9ab16332fa$var$cd.transition = f;
    }
}
function $2e3cfe9ab16332fa$var$gd(a, b, c, d) {
    var e = $2e3cfe9ab16332fa$var$C, f = $2e3cfe9ab16332fa$var$cd.transition;
    $2e3cfe9ab16332fa$var$cd.transition = null;
    try {
        $2e3cfe9ab16332fa$var$C = 4, $2e3cfe9ab16332fa$var$fd(a, b, c, d);
    } finally{
        $2e3cfe9ab16332fa$var$C = e, $2e3cfe9ab16332fa$var$cd.transition = f;
    }
}
function $2e3cfe9ab16332fa$var$fd(a, b, c, d) {
    if ($2e3cfe9ab16332fa$var$dd) {
        var e = $2e3cfe9ab16332fa$var$Yc(a, b, c, d);
        if (null === e) $2e3cfe9ab16332fa$var$hd(a, b, d, $2e3cfe9ab16332fa$var$id, c), $2e3cfe9ab16332fa$var$Sc(a, d);
        else if ($2e3cfe9ab16332fa$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($2e3cfe9ab16332fa$var$Sc(a, d), b & 4 && -1 < $2e3cfe9ab16332fa$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $2e3cfe9ab16332fa$var$Cb(e);
                null !== f && $2e3cfe9ab16332fa$var$Ec(f);
                f = $2e3cfe9ab16332fa$var$Yc(a, b, c, d);
                null === f && $2e3cfe9ab16332fa$var$hd(a, b, d, $2e3cfe9ab16332fa$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $2e3cfe9ab16332fa$var$hd(a, b, d, null, c);
    }
}
var $2e3cfe9ab16332fa$var$id = null;
function $2e3cfe9ab16332fa$var$Yc(a, b, c, d) {
    $2e3cfe9ab16332fa$var$id = null;
    a = $2e3cfe9ab16332fa$var$xb(d);
    a = $2e3cfe9ab16332fa$var$Wc(a);
    if (null !== a) {
        if (b = $2e3cfe9ab16332fa$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $2e3cfe9ab16332fa$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $2e3cfe9ab16332fa$var$id = a;
    return null;
}
function $2e3cfe9ab16332fa$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($2e3cfe9ab16332fa$var$ec()){
                case $2e3cfe9ab16332fa$var$fc:
                    return 1;
                case $2e3cfe9ab16332fa$var$gc:
                    return 4;
                case $2e3cfe9ab16332fa$var$hc:
                case $2e3cfe9ab16332fa$var$ic:
                    return 16;
                case $2e3cfe9ab16332fa$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $2e3cfe9ab16332fa$var$kd = null, $2e3cfe9ab16332fa$var$ld = null, $2e3cfe9ab16332fa$var$md = null;
function $2e3cfe9ab16332fa$var$nd() {
    if ($2e3cfe9ab16332fa$var$md) return $2e3cfe9ab16332fa$var$md;
    var a, b = $2e3cfe9ab16332fa$var$ld, c = b.length, d, e = "value" in $2e3cfe9ab16332fa$var$kd ? $2e3cfe9ab16332fa$var$kd.value : $2e3cfe9ab16332fa$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $2e3cfe9ab16332fa$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $2e3cfe9ab16332fa$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $2e3cfe9ab16332fa$var$pd() {
    return !0;
}
function $2e3cfe9ab16332fa$var$qd() {
    return !1;
}
function $2e3cfe9ab16332fa$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $2e3cfe9ab16332fa$var$pd : $2e3cfe9ab16332fa$var$qd;
        this.isPropagationStopped = $2e3cfe9ab16332fa$var$qd;
        return this;
    }
    $2e3cfe9ab16332fa$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $2e3cfe9ab16332fa$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $2e3cfe9ab16332fa$var$pd);
        },
        persist: function() {},
        isPersistent: $2e3cfe9ab16332fa$var$pd
    });
    return b;
}
var $2e3cfe9ab16332fa$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $2e3cfe9ab16332fa$var$td = $2e3cfe9ab16332fa$var$rd($2e3cfe9ab16332fa$var$sd), $2e3cfe9ab16332fa$var$ud = $2e3cfe9ab16332fa$var$A({}, $2e3cfe9ab16332fa$var$sd, {
    view: 0,
    detail: 0
}), $2e3cfe9ab16332fa$var$vd = $2e3cfe9ab16332fa$var$rd($2e3cfe9ab16332fa$var$ud), $2e3cfe9ab16332fa$var$wd, $2e3cfe9ab16332fa$var$xd, $2e3cfe9ab16332fa$var$yd, $2e3cfe9ab16332fa$var$Ad = $2e3cfe9ab16332fa$var$A({}, $2e3cfe9ab16332fa$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $2e3cfe9ab16332fa$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $2e3cfe9ab16332fa$var$yd && ($2e3cfe9ab16332fa$var$yd && "mousemove" === a.type ? ($2e3cfe9ab16332fa$var$wd = a.screenX - $2e3cfe9ab16332fa$var$yd.screenX, $2e3cfe9ab16332fa$var$xd = a.screenY - $2e3cfe9ab16332fa$var$yd.screenY) : $2e3cfe9ab16332fa$var$xd = $2e3cfe9ab16332fa$var$wd = 0, $2e3cfe9ab16332fa$var$yd = a);
        return $2e3cfe9ab16332fa$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $2e3cfe9ab16332fa$var$xd;
    }
}), $2e3cfe9ab16332fa$var$Bd = $2e3cfe9ab16332fa$var$rd($2e3cfe9ab16332fa$var$Ad), $2e3cfe9ab16332fa$var$Cd = $2e3cfe9ab16332fa$var$A({}, $2e3cfe9ab16332fa$var$Ad, {
    dataTransfer: 0
}), $2e3cfe9ab16332fa$var$Dd = $2e3cfe9ab16332fa$var$rd($2e3cfe9ab16332fa$var$Cd), $2e3cfe9ab16332fa$var$Ed = $2e3cfe9ab16332fa$var$A({}, $2e3cfe9ab16332fa$var$ud, {
    relatedTarget: 0
}), $2e3cfe9ab16332fa$var$Fd = $2e3cfe9ab16332fa$var$rd($2e3cfe9ab16332fa$var$Ed), $2e3cfe9ab16332fa$var$Gd = $2e3cfe9ab16332fa$var$A({}, $2e3cfe9ab16332fa$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2e3cfe9ab16332fa$var$Hd = $2e3cfe9ab16332fa$var$rd($2e3cfe9ab16332fa$var$Gd), $2e3cfe9ab16332fa$var$Id = $2e3cfe9ab16332fa$var$A({}, $2e3cfe9ab16332fa$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $2e3cfe9ab16332fa$var$Jd = $2e3cfe9ab16332fa$var$rd($2e3cfe9ab16332fa$var$Id), $2e3cfe9ab16332fa$var$Kd = $2e3cfe9ab16332fa$var$A({}, $2e3cfe9ab16332fa$var$sd, {
    data: 0
}), $2e3cfe9ab16332fa$var$Ld = $2e3cfe9ab16332fa$var$rd($2e3cfe9ab16332fa$var$Kd), $2e3cfe9ab16332fa$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $2e3cfe9ab16332fa$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $2e3cfe9ab16332fa$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $2e3cfe9ab16332fa$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $2e3cfe9ab16332fa$var$Od[a]) ? !!b[a] : !1;
}
function $2e3cfe9ab16332fa$var$zd() {
    return $2e3cfe9ab16332fa$var$Pd;
}
var $2e3cfe9ab16332fa$var$Qd = $2e3cfe9ab16332fa$var$A({}, $2e3cfe9ab16332fa$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $2e3cfe9ab16332fa$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $2e3cfe9ab16332fa$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $2e3cfe9ab16332fa$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $2e3cfe9ab16332fa$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $2e3cfe9ab16332fa$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $2e3cfe9ab16332fa$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $2e3cfe9ab16332fa$var$Rd = $2e3cfe9ab16332fa$var$rd($2e3cfe9ab16332fa$var$Qd), $2e3cfe9ab16332fa$var$Sd = $2e3cfe9ab16332fa$var$A({}, $2e3cfe9ab16332fa$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $2e3cfe9ab16332fa$var$Td = $2e3cfe9ab16332fa$var$rd($2e3cfe9ab16332fa$var$Sd), $2e3cfe9ab16332fa$var$Ud = $2e3cfe9ab16332fa$var$A({}, $2e3cfe9ab16332fa$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $2e3cfe9ab16332fa$var$zd
}), $2e3cfe9ab16332fa$var$Vd = $2e3cfe9ab16332fa$var$rd($2e3cfe9ab16332fa$var$Ud), $2e3cfe9ab16332fa$var$Wd = $2e3cfe9ab16332fa$var$A({}, $2e3cfe9ab16332fa$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2e3cfe9ab16332fa$var$Xd = $2e3cfe9ab16332fa$var$rd($2e3cfe9ab16332fa$var$Wd), $2e3cfe9ab16332fa$var$Yd = $2e3cfe9ab16332fa$var$A({}, $2e3cfe9ab16332fa$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $2e3cfe9ab16332fa$var$Zd = $2e3cfe9ab16332fa$var$rd($2e3cfe9ab16332fa$var$Yd), $2e3cfe9ab16332fa$var$$d = [
    9,
    13,
    27,
    32
], $2e3cfe9ab16332fa$var$ae = $2e3cfe9ab16332fa$var$ia && "CompositionEvent" in window, $2e3cfe9ab16332fa$var$be = null;
$2e3cfe9ab16332fa$var$ia && "documentMode" in document && ($2e3cfe9ab16332fa$var$be = document.documentMode);
var $2e3cfe9ab16332fa$var$ce = $2e3cfe9ab16332fa$var$ia && "TextEvent" in window && !$2e3cfe9ab16332fa$var$be, $2e3cfe9ab16332fa$var$de = $2e3cfe9ab16332fa$var$ia && (!$2e3cfe9ab16332fa$var$ae || $2e3cfe9ab16332fa$var$be && 8 < $2e3cfe9ab16332fa$var$be && 11 >= $2e3cfe9ab16332fa$var$be), $2e3cfe9ab16332fa$var$ee = String.fromCharCode(32), $2e3cfe9ab16332fa$var$fe = !1;
function $2e3cfe9ab16332fa$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $2e3cfe9ab16332fa$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $2e3cfe9ab16332fa$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $2e3cfe9ab16332fa$var$ie = !1;
function $2e3cfe9ab16332fa$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $2e3cfe9ab16332fa$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $2e3cfe9ab16332fa$var$fe = !0;
            return $2e3cfe9ab16332fa$var$ee;
        case "textInput":
            return a = b.data, a === $2e3cfe9ab16332fa$var$ee && $2e3cfe9ab16332fa$var$fe ? null : a;
        default:
            return null;
    }
}
function $2e3cfe9ab16332fa$var$ke(a, b) {
    if ($2e3cfe9ab16332fa$var$ie) return "compositionend" === a || !$2e3cfe9ab16332fa$var$ae && $2e3cfe9ab16332fa$var$ge(a, b) ? (a = $2e3cfe9ab16332fa$var$nd(), $2e3cfe9ab16332fa$var$md = $2e3cfe9ab16332fa$var$ld = $2e3cfe9ab16332fa$var$kd = null, $2e3cfe9ab16332fa$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $2e3cfe9ab16332fa$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $2e3cfe9ab16332fa$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $2e3cfe9ab16332fa$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$2e3cfe9ab16332fa$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $2e3cfe9ab16332fa$var$ne(a, b, c, d) {
    $2e3cfe9ab16332fa$var$Eb(d);
    b = $2e3cfe9ab16332fa$var$oe(b, "onChange");
    0 < b.length && (c = new $2e3cfe9ab16332fa$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $2e3cfe9ab16332fa$var$pe = null, $2e3cfe9ab16332fa$var$qe = null;
function $2e3cfe9ab16332fa$var$re(a) {
    $2e3cfe9ab16332fa$var$se(a, 0);
}
function $2e3cfe9ab16332fa$var$te(a) {
    var b = $2e3cfe9ab16332fa$var$ue(a);
    if ($2e3cfe9ab16332fa$var$Wa(b)) return a;
}
function $2e3cfe9ab16332fa$var$ve(a, b) {
    if ("change" === a) return b;
}
var $2e3cfe9ab16332fa$var$we = !1;
if ($2e3cfe9ab16332fa$var$ia) {
    var $2e3cfe9ab16332fa$var$xe;
    if ($2e3cfe9ab16332fa$var$ia) {
        var $2e3cfe9ab16332fa$var$ye = "oninput" in document;
        if (!$2e3cfe9ab16332fa$var$ye) {
            var $2e3cfe9ab16332fa$var$ze = document.createElement("div");
            $2e3cfe9ab16332fa$var$ze.setAttribute("oninput", "return;");
            $2e3cfe9ab16332fa$var$ye = "function" === typeof $2e3cfe9ab16332fa$var$ze.oninput;
        }
        $2e3cfe9ab16332fa$var$xe = $2e3cfe9ab16332fa$var$ye;
    } else $2e3cfe9ab16332fa$var$xe = !1;
    $2e3cfe9ab16332fa$var$we = $2e3cfe9ab16332fa$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $2e3cfe9ab16332fa$var$Ae() {
    $2e3cfe9ab16332fa$var$pe && ($2e3cfe9ab16332fa$var$pe.detachEvent("onpropertychange", $2e3cfe9ab16332fa$var$Be), $2e3cfe9ab16332fa$var$qe = $2e3cfe9ab16332fa$var$pe = null);
}
function $2e3cfe9ab16332fa$var$Be(a) {
    if ("value" === a.propertyName && $2e3cfe9ab16332fa$var$te($2e3cfe9ab16332fa$var$qe)) {
        var b = [];
        $2e3cfe9ab16332fa$var$ne(b, $2e3cfe9ab16332fa$var$qe, a, $2e3cfe9ab16332fa$var$xb(a));
        $2e3cfe9ab16332fa$var$Jb($2e3cfe9ab16332fa$var$re, b);
    }
}
function $2e3cfe9ab16332fa$var$Ce(a, b, c) {
    "focusin" === a ? ($2e3cfe9ab16332fa$var$Ae(), $2e3cfe9ab16332fa$var$pe = b, $2e3cfe9ab16332fa$var$qe = c, $2e3cfe9ab16332fa$var$pe.attachEvent("onpropertychange", $2e3cfe9ab16332fa$var$Be)) : "focusout" === a && $2e3cfe9ab16332fa$var$Ae();
}
function $2e3cfe9ab16332fa$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $2e3cfe9ab16332fa$var$te($2e3cfe9ab16332fa$var$qe);
}
function $2e3cfe9ab16332fa$var$Ee(a, b) {
    if ("click" === a) return $2e3cfe9ab16332fa$var$te(b);
}
function $2e3cfe9ab16332fa$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $2e3cfe9ab16332fa$var$te(b);
}
function $2e3cfe9ab16332fa$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2e3cfe9ab16332fa$var$He = "function" === typeof Object.is ? Object.is : $2e3cfe9ab16332fa$var$Ge;
function $2e3cfe9ab16332fa$var$Ie(a, b) {
    if ($2e3cfe9ab16332fa$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$2e3cfe9ab16332fa$var$ja.call(b, e) || !$2e3cfe9ab16332fa$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $2e3cfe9ab16332fa$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $2e3cfe9ab16332fa$var$Ke(a, b) {
    var c = $2e3cfe9ab16332fa$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $2e3cfe9ab16332fa$var$Je(c);
    }
}
function $2e3cfe9ab16332fa$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $2e3cfe9ab16332fa$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $2e3cfe9ab16332fa$var$Me() {
    for(var a = window, b = $2e3cfe9ab16332fa$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $2e3cfe9ab16332fa$var$Xa(a.document);
    }
    return b;
}
function $2e3cfe9ab16332fa$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $2e3cfe9ab16332fa$var$Oe(a) {
    var b = $2e3cfe9ab16332fa$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $2e3cfe9ab16332fa$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $2e3cfe9ab16332fa$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $2e3cfe9ab16332fa$var$Ke(c, f);
                var g = $2e3cfe9ab16332fa$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $2e3cfe9ab16332fa$var$Pe = $2e3cfe9ab16332fa$var$ia && "documentMode" in document && 11 >= document.documentMode, $2e3cfe9ab16332fa$var$Qe = null, $2e3cfe9ab16332fa$var$Re = null, $2e3cfe9ab16332fa$var$Se = null, $2e3cfe9ab16332fa$var$Te = !1;
function $2e3cfe9ab16332fa$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $2e3cfe9ab16332fa$var$Te || null == $2e3cfe9ab16332fa$var$Qe || $2e3cfe9ab16332fa$var$Qe !== $2e3cfe9ab16332fa$var$Xa(d) || (d = $2e3cfe9ab16332fa$var$Qe, "selectionStart" in d && $2e3cfe9ab16332fa$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $2e3cfe9ab16332fa$var$Se && $2e3cfe9ab16332fa$var$Ie($2e3cfe9ab16332fa$var$Se, d) || ($2e3cfe9ab16332fa$var$Se = d, d = $2e3cfe9ab16332fa$var$oe($2e3cfe9ab16332fa$var$Re, "onSelect"), 0 < d.length && (b = new $2e3cfe9ab16332fa$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $2e3cfe9ab16332fa$var$Qe)));
}
function $2e3cfe9ab16332fa$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $2e3cfe9ab16332fa$var$We = {
    animationend: $2e3cfe9ab16332fa$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $2e3cfe9ab16332fa$var$Ve("Animation", "AnimationIteration"),
    animationstart: $2e3cfe9ab16332fa$var$Ve("Animation", "AnimationStart"),
    transitionend: $2e3cfe9ab16332fa$var$Ve("Transition", "TransitionEnd")
}, $2e3cfe9ab16332fa$var$Xe = {}, $2e3cfe9ab16332fa$var$Ye = {};
$2e3cfe9ab16332fa$var$ia && ($2e3cfe9ab16332fa$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $2e3cfe9ab16332fa$var$We.animationend.animation, delete $2e3cfe9ab16332fa$var$We.animationiteration.animation, delete $2e3cfe9ab16332fa$var$We.animationstart.animation), "TransitionEvent" in window || delete $2e3cfe9ab16332fa$var$We.transitionend.transition);
function $2e3cfe9ab16332fa$var$Ze(a) {
    if ($2e3cfe9ab16332fa$var$Xe[a]) return $2e3cfe9ab16332fa$var$Xe[a];
    if (!$2e3cfe9ab16332fa$var$We[a]) return a;
    var b = $2e3cfe9ab16332fa$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $2e3cfe9ab16332fa$var$Ye) return $2e3cfe9ab16332fa$var$Xe[a] = b[c];
    return a;
}
var $2e3cfe9ab16332fa$var$$e = $2e3cfe9ab16332fa$var$Ze("animationend"), $2e3cfe9ab16332fa$var$af = $2e3cfe9ab16332fa$var$Ze("animationiteration"), $2e3cfe9ab16332fa$var$bf = $2e3cfe9ab16332fa$var$Ze("animationstart"), $2e3cfe9ab16332fa$var$cf = $2e3cfe9ab16332fa$var$Ze("transitionend"), $2e3cfe9ab16332fa$var$df = new Map, $2e3cfe9ab16332fa$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $2e3cfe9ab16332fa$var$ff(a, b) {
    $2e3cfe9ab16332fa$var$df.set(a, b);
    $2e3cfe9ab16332fa$var$fa(b, [
        a
    ]);
}
for(var $2e3cfe9ab16332fa$var$gf = 0; $2e3cfe9ab16332fa$var$gf < $2e3cfe9ab16332fa$var$ef.length; $2e3cfe9ab16332fa$var$gf++){
    var $2e3cfe9ab16332fa$var$hf = $2e3cfe9ab16332fa$var$ef[$2e3cfe9ab16332fa$var$gf], $2e3cfe9ab16332fa$var$jf = $2e3cfe9ab16332fa$var$hf.toLowerCase(), $2e3cfe9ab16332fa$var$kf = $2e3cfe9ab16332fa$var$hf[0].toUpperCase() + $2e3cfe9ab16332fa$var$hf.slice(1);
    $2e3cfe9ab16332fa$var$ff($2e3cfe9ab16332fa$var$jf, "on" + $2e3cfe9ab16332fa$var$kf);
}
$2e3cfe9ab16332fa$var$ff($2e3cfe9ab16332fa$var$$e, "onAnimationEnd");
$2e3cfe9ab16332fa$var$ff($2e3cfe9ab16332fa$var$af, "onAnimationIteration");
$2e3cfe9ab16332fa$var$ff($2e3cfe9ab16332fa$var$bf, "onAnimationStart");
$2e3cfe9ab16332fa$var$ff("dblclick", "onDoubleClick");
$2e3cfe9ab16332fa$var$ff("focusin", "onFocus");
$2e3cfe9ab16332fa$var$ff("focusout", "onBlur");
$2e3cfe9ab16332fa$var$ff($2e3cfe9ab16332fa$var$cf, "onTransitionEnd");
$2e3cfe9ab16332fa$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$2e3cfe9ab16332fa$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$2e3cfe9ab16332fa$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$2e3cfe9ab16332fa$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$2e3cfe9ab16332fa$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$2e3cfe9ab16332fa$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$2e3cfe9ab16332fa$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$2e3cfe9ab16332fa$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$2e3cfe9ab16332fa$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$2e3cfe9ab16332fa$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $2e3cfe9ab16332fa$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $2e3cfe9ab16332fa$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($2e3cfe9ab16332fa$var$lf));
function $2e3cfe9ab16332fa$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $2e3cfe9ab16332fa$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $2e3cfe9ab16332fa$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $2e3cfe9ab16332fa$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $2e3cfe9ab16332fa$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($2e3cfe9ab16332fa$var$Qb) throw a = $2e3cfe9ab16332fa$var$Rb, $2e3cfe9ab16332fa$var$Qb = !1, $2e3cfe9ab16332fa$var$Rb = null, a;
}
function $2e3cfe9ab16332fa$var$D(a, b) {
    var c = b[$2e3cfe9ab16332fa$var$of];
    void 0 === c && (c = b[$2e3cfe9ab16332fa$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($2e3cfe9ab16332fa$var$pf(b, a, 2, !1), c.add(d));
}
function $2e3cfe9ab16332fa$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $2e3cfe9ab16332fa$var$pf(c, a, d, b);
}
var $2e3cfe9ab16332fa$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $2e3cfe9ab16332fa$var$sf(a) {
    if (!a[$2e3cfe9ab16332fa$var$rf]) {
        a[$2e3cfe9ab16332fa$var$rf] = !0;
        $2e3cfe9ab16332fa$var$da.forEach(function(b) {
            "selectionchange" !== b && ($2e3cfe9ab16332fa$var$mf.has(b) || $2e3cfe9ab16332fa$var$qf(b, !1, a), $2e3cfe9ab16332fa$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$2e3cfe9ab16332fa$var$rf] || (b[$2e3cfe9ab16332fa$var$rf] = !0, $2e3cfe9ab16332fa$var$qf("selectionchange", !1, b));
    }
}
function $2e3cfe9ab16332fa$var$pf(a, b, c, d) {
    switch($2e3cfe9ab16332fa$var$jd(b)){
        case 1:
            var e = $2e3cfe9ab16332fa$var$ed;
            break;
        case 4:
            e = $2e3cfe9ab16332fa$var$gd;
            break;
        default:
            e = $2e3cfe9ab16332fa$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$2e3cfe9ab16332fa$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $2e3cfe9ab16332fa$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $2e3cfe9ab16332fa$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $2e3cfe9ab16332fa$var$Jb(function() {
        var d = f, e = $2e3cfe9ab16332fa$var$xb(c), g = [];
        a: {
            var h = $2e3cfe9ab16332fa$var$df.get(a);
            if (void 0 !== h) {
                var k = $2e3cfe9ab16332fa$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $2e3cfe9ab16332fa$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $2e3cfe9ab16332fa$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $2e3cfe9ab16332fa$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $2e3cfe9ab16332fa$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $2e3cfe9ab16332fa$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $2e3cfe9ab16332fa$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $2e3cfe9ab16332fa$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $2e3cfe9ab16332fa$var$Vd;
                        break;
                    case $2e3cfe9ab16332fa$var$$e:
                    case $2e3cfe9ab16332fa$var$af:
                    case $2e3cfe9ab16332fa$var$bf:
                        k = $2e3cfe9ab16332fa$var$Hd;
                        break;
                    case $2e3cfe9ab16332fa$var$cf:
                        k = $2e3cfe9ab16332fa$var$Xd;
                        break;
                    case "scroll":
                        k = $2e3cfe9ab16332fa$var$vd;
                        break;
                    case "wheel":
                        k = $2e3cfe9ab16332fa$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $2e3cfe9ab16332fa$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $2e3cfe9ab16332fa$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $2e3cfe9ab16332fa$var$Kb(w, x), null != F && t.push($2e3cfe9ab16332fa$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $2e3cfe9ab16332fa$var$wb && (n = c.relatedTarget || c.fromElement) && ($2e3cfe9ab16332fa$var$Wc(n) || n[$2e3cfe9ab16332fa$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $2e3cfe9ab16332fa$var$Wc(n) : null, null !== n && (J = $2e3cfe9ab16332fa$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $2e3cfe9ab16332fa$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $2e3cfe9ab16332fa$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $2e3cfe9ab16332fa$var$ue(k);
                        u = null == n ? h : $2e3cfe9ab16332fa$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $2e3cfe9ab16332fa$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $2e3cfe9ab16332fa$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $2e3cfe9ab16332fa$var$vf(F))u++;
                            for(; 0 < w - u;)t = $2e3cfe9ab16332fa$var$vf(t), w--;
                            for(; 0 < u - w;)x = $2e3cfe9ab16332fa$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $2e3cfe9ab16332fa$var$vf(t);
                                x = $2e3cfe9ab16332fa$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $2e3cfe9ab16332fa$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $2e3cfe9ab16332fa$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $2e3cfe9ab16332fa$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $2e3cfe9ab16332fa$var$ve;
                else if ($2e3cfe9ab16332fa$var$me(h)) {
                    if ($2e3cfe9ab16332fa$var$we) na = $2e3cfe9ab16332fa$var$Fe;
                    else {
                        na = $2e3cfe9ab16332fa$var$De;
                        var xa = $2e3cfe9ab16332fa$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $2e3cfe9ab16332fa$var$Ee);
                if (na && (na = na(a, d))) {
                    $2e3cfe9ab16332fa$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $2e3cfe9ab16332fa$var$cb(h, "number", h.value);
            }
            xa = d ? $2e3cfe9ab16332fa$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($2e3cfe9ab16332fa$var$me(xa) || "true" === xa.contentEditable) $2e3cfe9ab16332fa$var$Qe = xa, $2e3cfe9ab16332fa$var$Re = d, $2e3cfe9ab16332fa$var$Se = null;
                    break;
                case "focusout":
                    $2e3cfe9ab16332fa$var$Se = $2e3cfe9ab16332fa$var$Re = $2e3cfe9ab16332fa$var$Qe = null;
                    break;
                case "mousedown":
                    $2e3cfe9ab16332fa$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $2e3cfe9ab16332fa$var$Te = !1;
                    $2e3cfe9ab16332fa$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($2e3cfe9ab16332fa$var$Pe) break;
                case "keydown":
                case "keyup":
                    $2e3cfe9ab16332fa$var$Ue(g, c, e);
            }
            var $a;
            if ($2e3cfe9ab16332fa$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $2e3cfe9ab16332fa$var$ie ? $2e3cfe9ab16332fa$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($2e3cfe9ab16332fa$var$de && "ko" !== c.locale && ($2e3cfe9ab16332fa$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $2e3cfe9ab16332fa$var$ie && ($a = $2e3cfe9ab16332fa$var$nd()) : ($2e3cfe9ab16332fa$var$kd = e, $2e3cfe9ab16332fa$var$ld = "value" in $2e3cfe9ab16332fa$var$kd ? $2e3cfe9ab16332fa$var$kd.value : $2e3cfe9ab16332fa$var$kd.textContent, $2e3cfe9ab16332fa$var$ie = !0)), xa = $2e3cfe9ab16332fa$var$oe(d, ba), 0 < xa.length && (ba = new $2e3cfe9ab16332fa$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $2e3cfe9ab16332fa$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $2e3cfe9ab16332fa$var$ce ? $2e3cfe9ab16332fa$var$je(a, c) : $2e3cfe9ab16332fa$var$ke(a, c)) d = $2e3cfe9ab16332fa$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $2e3cfe9ab16332fa$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $2e3cfe9ab16332fa$var$se(g, b);
    });
}
function $2e3cfe9ab16332fa$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $2e3cfe9ab16332fa$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $2e3cfe9ab16332fa$var$Kb(a, c), null != f && d.unshift($2e3cfe9ab16332fa$var$tf(a, f, e)), f = $2e3cfe9ab16332fa$var$Kb(a, b), null != f && d.push($2e3cfe9ab16332fa$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $2e3cfe9ab16332fa$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $2e3cfe9ab16332fa$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $2e3cfe9ab16332fa$var$Kb(c, f), null != k && g.unshift($2e3cfe9ab16332fa$var$tf(c, k, h))) : e || (k = $2e3cfe9ab16332fa$var$Kb(c, f), null != k && g.push($2e3cfe9ab16332fa$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $2e3cfe9ab16332fa$var$xf = /\r\n?/g, $2e3cfe9ab16332fa$var$yf = /\u0000|\uFFFD/g;
function $2e3cfe9ab16332fa$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($2e3cfe9ab16332fa$var$xf, "\n").replace($2e3cfe9ab16332fa$var$yf, "");
}
function $2e3cfe9ab16332fa$var$Af(a, b, c) {
    b = $2e3cfe9ab16332fa$var$zf(b);
    if ($2e3cfe9ab16332fa$var$zf(a) !== b && c) throw Error($2e3cfe9ab16332fa$var$p(425));
}
function $2e3cfe9ab16332fa$var$Bf() {}
var $2e3cfe9ab16332fa$var$Cf = null, $2e3cfe9ab16332fa$var$Df = null;
function $2e3cfe9ab16332fa$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $2e3cfe9ab16332fa$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $2e3cfe9ab16332fa$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $2e3cfe9ab16332fa$var$Hf = "function" === typeof Promise ? Promise : void 0, $2e3cfe9ab16332fa$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $2e3cfe9ab16332fa$var$Hf ? function(a) {
    return $2e3cfe9ab16332fa$var$Hf.resolve(null).then(a).catch($2e3cfe9ab16332fa$var$If);
} : $2e3cfe9ab16332fa$var$Ff;
function $2e3cfe9ab16332fa$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $2e3cfe9ab16332fa$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $2e3cfe9ab16332fa$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $2e3cfe9ab16332fa$var$bd(b);
}
function $2e3cfe9ab16332fa$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $2e3cfe9ab16332fa$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $2e3cfe9ab16332fa$var$Nf = Math.random().toString(36).slice(2), $2e3cfe9ab16332fa$var$Of = "__reactFiber$" + $2e3cfe9ab16332fa$var$Nf, $2e3cfe9ab16332fa$var$Pf = "__reactProps$" + $2e3cfe9ab16332fa$var$Nf, $2e3cfe9ab16332fa$var$uf = "__reactContainer$" + $2e3cfe9ab16332fa$var$Nf, $2e3cfe9ab16332fa$var$of = "__reactEvents$" + $2e3cfe9ab16332fa$var$Nf, $2e3cfe9ab16332fa$var$Qf = "__reactListeners$" + $2e3cfe9ab16332fa$var$Nf, $2e3cfe9ab16332fa$var$Rf = "__reactHandles$" + $2e3cfe9ab16332fa$var$Nf;
function $2e3cfe9ab16332fa$var$Wc(a) {
    var b = a[$2e3cfe9ab16332fa$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$2e3cfe9ab16332fa$var$uf] || c[$2e3cfe9ab16332fa$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $2e3cfe9ab16332fa$var$Mf(a); null !== a;){
                if (c = a[$2e3cfe9ab16332fa$var$Of]) return c;
                a = $2e3cfe9ab16332fa$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $2e3cfe9ab16332fa$var$Cb(a) {
    a = a[$2e3cfe9ab16332fa$var$Of] || a[$2e3cfe9ab16332fa$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $2e3cfe9ab16332fa$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($2e3cfe9ab16332fa$var$p(33));
}
function $2e3cfe9ab16332fa$var$Db(a) {
    return a[$2e3cfe9ab16332fa$var$Pf] || null;
}
var $2e3cfe9ab16332fa$var$Sf = [], $2e3cfe9ab16332fa$var$Tf = -1;
function $2e3cfe9ab16332fa$var$Uf(a) {
    return {
        current: a
    };
}
function $2e3cfe9ab16332fa$var$E(a) {
    0 > $2e3cfe9ab16332fa$var$Tf || (a.current = $2e3cfe9ab16332fa$var$Sf[$2e3cfe9ab16332fa$var$Tf], $2e3cfe9ab16332fa$var$Sf[$2e3cfe9ab16332fa$var$Tf] = null, $2e3cfe9ab16332fa$var$Tf--);
}
function $2e3cfe9ab16332fa$var$G(a, b) {
    $2e3cfe9ab16332fa$var$Tf++;
    $2e3cfe9ab16332fa$var$Sf[$2e3cfe9ab16332fa$var$Tf] = a.current;
    a.current = b;
}
var $2e3cfe9ab16332fa$var$Vf = {}, $2e3cfe9ab16332fa$var$H = $2e3cfe9ab16332fa$var$Uf($2e3cfe9ab16332fa$var$Vf), $2e3cfe9ab16332fa$var$Wf = $2e3cfe9ab16332fa$var$Uf(!1), $2e3cfe9ab16332fa$var$Xf = $2e3cfe9ab16332fa$var$Vf;
function $2e3cfe9ab16332fa$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $2e3cfe9ab16332fa$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $2e3cfe9ab16332fa$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $2e3cfe9ab16332fa$var$$f() {
    $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$Wf);
    $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$H);
}
function $2e3cfe9ab16332fa$var$ag(a, b, c) {
    if ($2e3cfe9ab16332fa$var$H.current !== $2e3cfe9ab16332fa$var$Vf) throw Error($2e3cfe9ab16332fa$var$p(168));
    $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$H, b);
    $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$Wf, c);
}
function $2e3cfe9ab16332fa$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($2e3cfe9ab16332fa$var$p(108, $2e3cfe9ab16332fa$var$Ra(a) || "Unknown", e));
    return $2e3cfe9ab16332fa$var$A({}, c, d);
}
function $2e3cfe9ab16332fa$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $2e3cfe9ab16332fa$var$Vf;
    $2e3cfe9ab16332fa$var$Xf = $2e3cfe9ab16332fa$var$H.current;
    $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$H, a);
    $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$Wf, $2e3cfe9ab16332fa$var$Wf.current);
    return !0;
}
function $2e3cfe9ab16332fa$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($2e3cfe9ab16332fa$var$p(169));
    c ? (a = $2e3cfe9ab16332fa$var$bg(a, b, $2e3cfe9ab16332fa$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$Wf), $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$H), $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$H, a)) : $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$Wf);
    $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$Wf, c);
}
var $2e3cfe9ab16332fa$var$eg = null, $2e3cfe9ab16332fa$var$fg = !1, $2e3cfe9ab16332fa$var$gg = !1;
function $2e3cfe9ab16332fa$var$hg(a) {
    null === $2e3cfe9ab16332fa$var$eg ? $2e3cfe9ab16332fa$var$eg = [
        a
    ] : $2e3cfe9ab16332fa$var$eg.push(a);
}
function $2e3cfe9ab16332fa$var$ig(a) {
    $2e3cfe9ab16332fa$var$fg = !0;
    $2e3cfe9ab16332fa$var$hg(a);
}
function $2e3cfe9ab16332fa$var$jg() {
    if (!$2e3cfe9ab16332fa$var$gg && null !== $2e3cfe9ab16332fa$var$eg) {
        $2e3cfe9ab16332fa$var$gg = !0;
        var a = 0, b = $2e3cfe9ab16332fa$var$C;
        try {
            var c = $2e3cfe9ab16332fa$var$eg;
            for($2e3cfe9ab16332fa$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $2e3cfe9ab16332fa$var$eg = null;
            $2e3cfe9ab16332fa$var$fg = !1;
        } catch (e) {
            throw null !== $2e3cfe9ab16332fa$var$eg && ($2e3cfe9ab16332fa$var$eg = $2e3cfe9ab16332fa$var$eg.slice(a + 1)), $2e3cfe9ab16332fa$var$ac($2e3cfe9ab16332fa$var$fc, $2e3cfe9ab16332fa$var$jg), e;
        } finally{
            $2e3cfe9ab16332fa$var$C = b, $2e3cfe9ab16332fa$var$gg = !1;
        }
    }
    return null;
}
var $2e3cfe9ab16332fa$var$kg = [], $2e3cfe9ab16332fa$var$lg = 0, $2e3cfe9ab16332fa$var$mg = null, $2e3cfe9ab16332fa$var$ng = 0, $2e3cfe9ab16332fa$var$og = [], $2e3cfe9ab16332fa$var$pg = 0, $2e3cfe9ab16332fa$var$qg = null, $2e3cfe9ab16332fa$var$rg = 1, $2e3cfe9ab16332fa$var$sg = "";
function $2e3cfe9ab16332fa$var$tg(a, b) {
    $2e3cfe9ab16332fa$var$kg[$2e3cfe9ab16332fa$var$lg++] = $2e3cfe9ab16332fa$var$ng;
    $2e3cfe9ab16332fa$var$kg[$2e3cfe9ab16332fa$var$lg++] = $2e3cfe9ab16332fa$var$mg;
    $2e3cfe9ab16332fa$var$mg = a;
    $2e3cfe9ab16332fa$var$ng = b;
}
function $2e3cfe9ab16332fa$var$ug(a, b, c) {
    $2e3cfe9ab16332fa$var$og[$2e3cfe9ab16332fa$var$pg++] = $2e3cfe9ab16332fa$var$rg;
    $2e3cfe9ab16332fa$var$og[$2e3cfe9ab16332fa$var$pg++] = $2e3cfe9ab16332fa$var$sg;
    $2e3cfe9ab16332fa$var$og[$2e3cfe9ab16332fa$var$pg++] = $2e3cfe9ab16332fa$var$qg;
    $2e3cfe9ab16332fa$var$qg = a;
    var d = $2e3cfe9ab16332fa$var$rg;
    a = $2e3cfe9ab16332fa$var$sg;
    var e = 32 - $2e3cfe9ab16332fa$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $2e3cfe9ab16332fa$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $2e3cfe9ab16332fa$var$rg = 1 << 32 - $2e3cfe9ab16332fa$var$oc(b) + e | c << e | d;
        $2e3cfe9ab16332fa$var$sg = f + a;
    } else $2e3cfe9ab16332fa$var$rg = 1 << f | c << e | d, $2e3cfe9ab16332fa$var$sg = a;
}
function $2e3cfe9ab16332fa$var$vg(a) {
    null !== a.return && ($2e3cfe9ab16332fa$var$tg(a, 1), $2e3cfe9ab16332fa$var$ug(a, 1, 0));
}
function $2e3cfe9ab16332fa$var$wg(a) {
    for(; a === $2e3cfe9ab16332fa$var$mg;)$2e3cfe9ab16332fa$var$mg = $2e3cfe9ab16332fa$var$kg[--$2e3cfe9ab16332fa$var$lg], $2e3cfe9ab16332fa$var$kg[$2e3cfe9ab16332fa$var$lg] = null, $2e3cfe9ab16332fa$var$ng = $2e3cfe9ab16332fa$var$kg[--$2e3cfe9ab16332fa$var$lg], $2e3cfe9ab16332fa$var$kg[$2e3cfe9ab16332fa$var$lg] = null;
    for(; a === $2e3cfe9ab16332fa$var$qg;)$2e3cfe9ab16332fa$var$qg = $2e3cfe9ab16332fa$var$og[--$2e3cfe9ab16332fa$var$pg], $2e3cfe9ab16332fa$var$og[$2e3cfe9ab16332fa$var$pg] = null, $2e3cfe9ab16332fa$var$sg = $2e3cfe9ab16332fa$var$og[--$2e3cfe9ab16332fa$var$pg], $2e3cfe9ab16332fa$var$og[$2e3cfe9ab16332fa$var$pg] = null, $2e3cfe9ab16332fa$var$rg = $2e3cfe9ab16332fa$var$og[--$2e3cfe9ab16332fa$var$pg], $2e3cfe9ab16332fa$var$og[$2e3cfe9ab16332fa$var$pg] = null;
}
var $2e3cfe9ab16332fa$var$xg = null, $2e3cfe9ab16332fa$var$yg = null, $2e3cfe9ab16332fa$var$I = !1, $2e3cfe9ab16332fa$var$zg = null;
function $2e3cfe9ab16332fa$var$Ag(a, b) {
    var c = $2e3cfe9ab16332fa$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $2e3cfe9ab16332fa$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $2e3cfe9ab16332fa$var$xg = a, $2e3cfe9ab16332fa$var$yg = $2e3cfe9ab16332fa$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $2e3cfe9ab16332fa$var$xg = a, $2e3cfe9ab16332fa$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $2e3cfe9ab16332fa$var$qg ? {
                id: $2e3cfe9ab16332fa$var$rg,
                overflow: $2e3cfe9ab16332fa$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $2e3cfe9ab16332fa$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $2e3cfe9ab16332fa$var$xg = a, $2e3cfe9ab16332fa$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $2e3cfe9ab16332fa$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $2e3cfe9ab16332fa$var$Eg(a) {
    if ($2e3cfe9ab16332fa$var$I) {
        var b = $2e3cfe9ab16332fa$var$yg;
        if (b) {
            var c = b;
            if (!$2e3cfe9ab16332fa$var$Cg(a, b)) {
                if ($2e3cfe9ab16332fa$var$Dg(a)) throw Error($2e3cfe9ab16332fa$var$p(418));
                b = $2e3cfe9ab16332fa$var$Lf(c.nextSibling);
                var d = $2e3cfe9ab16332fa$var$xg;
                b && $2e3cfe9ab16332fa$var$Cg(a, b) ? $2e3cfe9ab16332fa$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $2e3cfe9ab16332fa$var$I = !1, $2e3cfe9ab16332fa$var$xg = a);
            }
        } else {
            if ($2e3cfe9ab16332fa$var$Dg(a)) throw Error($2e3cfe9ab16332fa$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $2e3cfe9ab16332fa$var$I = !1;
            $2e3cfe9ab16332fa$var$xg = a;
        }
    }
}
function $2e3cfe9ab16332fa$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $2e3cfe9ab16332fa$var$xg = a;
}
function $2e3cfe9ab16332fa$var$Gg(a) {
    if (a !== $2e3cfe9ab16332fa$var$xg) return !1;
    if (!$2e3cfe9ab16332fa$var$I) return $2e3cfe9ab16332fa$var$Fg(a), $2e3cfe9ab16332fa$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$2e3cfe9ab16332fa$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $2e3cfe9ab16332fa$var$yg)) {
        if ($2e3cfe9ab16332fa$var$Dg(a)) throw $2e3cfe9ab16332fa$var$Hg(), Error($2e3cfe9ab16332fa$var$p(418));
        for(; b;)$2e3cfe9ab16332fa$var$Ag(a, b), b = $2e3cfe9ab16332fa$var$Lf(b.nextSibling);
    }
    $2e3cfe9ab16332fa$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($2e3cfe9ab16332fa$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $2e3cfe9ab16332fa$var$yg = $2e3cfe9ab16332fa$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $2e3cfe9ab16332fa$var$yg = null;
        }
    } else $2e3cfe9ab16332fa$var$yg = $2e3cfe9ab16332fa$var$xg ? $2e3cfe9ab16332fa$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $2e3cfe9ab16332fa$var$Hg() {
    for(var a = $2e3cfe9ab16332fa$var$yg; a;)a = $2e3cfe9ab16332fa$var$Lf(a.nextSibling);
}
function $2e3cfe9ab16332fa$var$Ig() {
    $2e3cfe9ab16332fa$var$yg = $2e3cfe9ab16332fa$var$xg = null;
    $2e3cfe9ab16332fa$var$I = !1;
}
function $2e3cfe9ab16332fa$var$Jg(a) {
    null === $2e3cfe9ab16332fa$var$zg ? $2e3cfe9ab16332fa$var$zg = [
        a
    ] : $2e3cfe9ab16332fa$var$zg.push(a);
}
var $2e3cfe9ab16332fa$var$Kg = $2e3cfe9ab16332fa$var$ua.ReactCurrentBatchConfig;
function $2e3cfe9ab16332fa$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($2e3cfe9ab16332fa$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($2e3cfe9ab16332fa$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($2e3cfe9ab16332fa$var$p(284));
        if (!c._owner) throw Error($2e3cfe9ab16332fa$var$p(290, a));
    }
    return a;
}
function $2e3cfe9ab16332fa$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($2e3cfe9ab16332fa$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $2e3cfe9ab16332fa$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $2e3cfe9ab16332fa$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $2e3cfe9ab16332fa$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $2e3cfe9ab16332fa$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $2e3cfe9ab16332fa$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $2e3cfe9ab16332fa$var$Ha && $2e3cfe9ab16332fa$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $2e3cfe9ab16332fa$var$Lg(a, b, c), d.return = a, d;
        d = $2e3cfe9ab16332fa$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $2e3cfe9ab16332fa$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $2e3cfe9ab16332fa$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $2e3cfe9ab16332fa$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $2e3cfe9ab16332fa$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $2e3cfe9ab16332fa$var$va:
                    return c = $2e3cfe9ab16332fa$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $2e3cfe9ab16332fa$var$Lg(a, null, b), c.return = a, c;
                case $2e3cfe9ab16332fa$var$wa:
                    return b = $2e3cfe9ab16332fa$var$Sg(b, a.mode, c), b.return = a, b;
                case $2e3cfe9ab16332fa$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($2e3cfe9ab16332fa$var$eb(b) || $2e3cfe9ab16332fa$var$Ka(b)) return b = $2e3cfe9ab16332fa$var$Tg(b, a.mode, c, null), b.return = a, b;
            $2e3cfe9ab16332fa$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $2e3cfe9ab16332fa$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $2e3cfe9ab16332fa$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $2e3cfe9ab16332fa$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($2e3cfe9ab16332fa$var$eb(c) || $2e3cfe9ab16332fa$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $2e3cfe9ab16332fa$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $2e3cfe9ab16332fa$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $2e3cfe9ab16332fa$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $2e3cfe9ab16332fa$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($2e3cfe9ab16332fa$var$eb(d) || $2e3cfe9ab16332fa$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $2e3cfe9ab16332fa$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $2e3cfe9ab16332fa$var$I && $2e3cfe9ab16332fa$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $2e3cfe9ab16332fa$var$I && $2e3cfe9ab16332fa$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $2e3cfe9ab16332fa$var$I && $2e3cfe9ab16332fa$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $2e3cfe9ab16332fa$var$Ka(h);
        if ("function" !== typeof l) throw Error($2e3cfe9ab16332fa$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($2e3cfe9ab16332fa$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $2e3cfe9ab16332fa$var$I && $2e3cfe9ab16332fa$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $2e3cfe9ab16332fa$var$I && $2e3cfe9ab16332fa$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $2e3cfe9ab16332fa$var$I && $2e3cfe9ab16332fa$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $2e3cfe9ab16332fa$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $2e3cfe9ab16332fa$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $2e3cfe9ab16332fa$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $2e3cfe9ab16332fa$var$Ha && $2e3cfe9ab16332fa$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $2e3cfe9ab16332fa$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $2e3cfe9ab16332fa$var$ya ? (d = $2e3cfe9ab16332fa$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $2e3cfe9ab16332fa$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $2e3cfe9ab16332fa$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $2e3cfe9ab16332fa$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $2e3cfe9ab16332fa$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $2e3cfe9ab16332fa$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($2e3cfe9ab16332fa$var$eb(f)) return n(a, d, f, h);
            if ($2e3cfe9ab16332fa$var$Ka(f)) return t(a, d, f, h);
            $2e3cfe9ab16332fa$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $2e3cfe9ab16332fa$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $2e3cfe9ab16332fa$var$Ug = $2e3cfe9ab16332fa$var$Og(!0), $2e3cfe9ab16332fa$var$Vg = $2e3cfe9ab16332fa$var$Og(!1), $2e3cfe9ab16332fa$var$Wg = $2e3cfe9ab16332fa$var$Uf(null), $2e3cfe9ab16332fa$var$Xg = null, $2e3cfe9ab16332fa$var$Yg = null, $2e3cfe9ab16332fa$var$Zg = null;
function $2e3cfe9ab16332fa$var$$g() {
    $2e3cfe9ab16332fa$var$Zg = $2e3cfe9ab16332fa$var$Yg = $2e3cfe9ab16332fa$var$Xg = null;
}
function $2e3cfe9ab16332fa$var$ah(a) {
    var b = $2e3cfe9ab16332fa$var$Wg.current;
    $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$Wg);
    a._currentValue = b;
}
function $2e3cfe9ab16332fa$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $2e3cfe9ab16332fa$var$ch(a, b) {
    $2e3cfe9ab16332fa$var$Xg = a;
    $2e3cfe9ab16332fa$var$Zg = $2e3cfe9ab16332fa$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($2e3cfe9ab16332fa$var$dh = !0), a.firstContext = null);
}
function $2e3cfe9ab16332fa$var$eh(a) {
    var b = a._currentValue;
    if ($2e3cfe9ab16332fa$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $2e3cfe9ab16332fa$var$Yg) {
            if (null === $2e3cfe9ab16332fa$var$Xg) throw Error($2e3cfe9ab16332fa$var$p(308));
            $2e3cfe9ab16332fa$var$Yg = a;
            $2e3cfe9ab16332fa$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $2e3cfe9ab16332fa$var$Yg = $2e3cfe9ab16332fa$var$Yg.next = a;
    }
    return b;
}
var $2e3cfe9ab16332fa$var$fh = null;
function $2e3cfe9ab16332fa$var$gh(a) {
    null === $2e3cfe9ab16332fa$var$fh ? $2e3cfe9ab16332fa$var$fh = [
        a
    ] : $2e3cfe9ab16332fa$var$fh.push(a);
}
function $2e3cfe9ab16332fa$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $2e3cfe9ab16332fa$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $2e3cfe9ab16332fa$var$ih(a, d);
}
function $2e3cfe9ab16332fa$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $2e3cfe9ab16332fa$var$jh = !1;
function $2e3cfe9ab16332fa$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $2e3cfe9ab16332fa$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $2e3cfe9ab16332fa$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $2e3cfe9ab16332fa$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($2e3cfe9ab16332fa$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $2e3cfe9ab16332fa$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $2e3cfe9ab16332fa$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $2e3cfe9ab16332fa$var$ih(a, c);
}
function $2e3cfe9ab16332fa$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $2e3cfe9ab16332fa$var$Cc(a, c);
    }
}
function $2e3cfe9ab16332fa$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $2e3cfe9ab16332fa$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $2e3cfe9ab16332fa$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $2e3cfe9ab16332fa$var$A({}, q, r);
                            break a;
                        case 2:
                            $2e3cfe9ab16332fa$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $2e3cfe9ab16332fa$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $2e3cfe9ab16332fa$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($2e3cfe9ab16332fa$var$p(191, e));
            e.call(d);
        }
    }
}
var $2e3cfe9ab16332fa$var$th = {}, $2e3cfe9ab16332fa$var$uh = $2e3cfe9ab16332fa$var$Uf($2e3cfe9ab16332fa$var$th), $2e3cfe9ab16332fa$var$vh = $2e3cfe9ab16332fa$var$Uf($2e3cfe9ab16332fa$var$th), $2e3cfe9ab16332fa$var$wh = $2e3cfe9ab16332fa$var$Uf($2e3cfe9ab16332fa$var$th);
function $2e3cfe9ab16332fa$var$xh(a) {
    if (a === $2e3cfe9ab16332fa$var$th) throw Error($2e3cfe9ab16332fa$var$p(174));
    return a;
}
function $2e3cfe9ab16332fa$var$yh(a, b) {
    $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$wh, b);
    $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$vh, a);
    $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$uh, $2e3cfe9ab16332fa$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $2e3cfe9ab16332fa$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $2e3cfe9ab16332fa$var$lb(b, a);
    }
    $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$uh);
    $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$uh, b);
}
function $2e3cfe9ab16332fa$var$zh() {
    $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$uh);
    $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$vh);
    $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$wh);
}
function $2e3cfe9ab16332fa$var$Ah(a) {
    $2e3cfe9ab16332fa$var$xh($2e3cfe9ab16332fa$var$wh.current);
    var b = $2e3cfe9ab16332fa$var$xh($2e3cfe9ab16332fa$var$uh.current);
    var c = $2e3cfe9ab16332fa$var$lb(b, a.type);
    b !== c && ($2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$vh, a), $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$uh, c));
}
function $2e3cfe9ab16332fa$var$Bh(a) {
    $2e3cfe9ab16332fa$var$vh.current === a && ($2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$uh), $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$vh));
}
var $2e3cfe9ab16332fa$var$L = $2e3cfe9ab16332fa$var$Uf(0);
function $2e3cfe9ab16332fa$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $2e3cfe9ab16332fa$var$Dh = [];
function $2e3cfe9ab16332fa$var$Eh() {
    for(var a = 0; a < $2e3cfe9ab16332fa$var$Dh.length; a++)$2e3cfe9ab16332fa$var$Dh[a]._workInProgressVersionPrimary = null;
    $2e3cfe9ab16332fa$var$Dh.length = 0;
}
var $2e3cfe9ab16332fa$var$Fh = $2e3cfe9ab16332fa$var$ua.ReactCurrentDispatcher, $2e3cfe9ab16332fa$var$Gh = $2e3cfe9ab16332fa$var$ua.ReactCurrentBatchConfig, $2e3cfe9ab16332fa$var$Hh = 0, $2e3cfe9ab16332fa$var$M = null, $2e3cfe9ab16332fa$var$N = null, $2e3cfe9ab16332fa$var$O = null, $2e3cfe9ab16332fa$var$Ih = !1, $2e3cfe9ab16332fa$var$Jh = !1, $2e3cfe9ab16332fa$var$Kh = 0, $2e3cfe9ab16332fa$var$Lh = 0;
function $2e3cfe9ab16332fa$var$P() {
    throw Error($2e3cfe9ab16332fa$var$p(321));
}
function $2e3cfe9ab16332fa$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$2e3cfe9ab16332fa$var$He(a[c], b[c])) return !1;
    return !0;
}
function $2e3cfe9ab16332fa$var$Nh(a, b, c, d, e, f) {
    $2e3cfe9ab16332fa$var$Hh = f;
    $2e3cfe9ab16332fa$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $2e3cfe9ab16332fa$var$Fh.current = null === a || null === a.memoizedState ? $2e3cfe9ab16332fa$var$Oh : $2e3cfe9ab16332fa$var$Ph;
    a = c(d, e);
    if ($2e3cfe9ab16332fa$var$Jh) {
        f = 0;
        do {
            $2e3cfe9ab16332fa$var$Jh = !1;
            $2e3cfe9ab16332fa$var$Kh = 0;
            if (25 <= f) throw Error($2e3cfe9ab16332fa$var$p(301));
            f += 1;
            $2e3cfe9ab16332fa$var$O = $2e3cfe9ab16332fa$var$N = null;
            b.updateQueue = null;
            $2e3cfe9ab16332fa$var$Fh.current = $2e3cfe9ab16332fa$var$Qh;
            a = c(d, e);
        }while ($2e3cfe9ab16332fa$var$Jh);
    }
    $2e3cfe9ab16332fa$var$Fh.current = $2e3cfe9ab16332fa$var$Rh;
    b = null !== $2e3cfe9ab16332fa$var$N && null !== $2e3cfe9ab16332fa$var$N.next;
    $2e3cfe9ab16332fa$var$Hh = 0;
    $2e3cfe9ab16332fa$var$O = $2e3cfe9ab16332fa$var$N = $2e3cfe9ab16332fa$var$M = null;
    $2e3cfe9ab16332fa$var$Ih = !1;
    if (b) throw Error($2e3cfe9ab16332fa$var$p(300));
    return a;
}
function $2e3cfe9ab16332fa$var$Sh() {
    var a = 0 !== $2e3cfe9ab16332fa$var$Kh;
    $2e3cfe9ab16332fa$var$Kh = 0;
    return a;
}
function $2e3cfe9ab16332fa$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $2e3cfe9ab16332fa$var$O ? $2e3cfe9ab16332fa$var$M.memoizedState = $2e3cfe9ab16332fa$var$O = a : $2e3cfe9ab16332fa$var$O = $2e3cfe9ab16332fa$var$O.next = a;
    return $2e3cfe9ab16332fa$var$O;
}
function $2e3cfe9ab16332fa$var$Uh() {
    if (null === $2e3cfe9ab16332fa$var$N) {
        var a = $2e3cfe9ab16332fa$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $2e3cfe9ab16332fa$var$N.next;
    var b = null === $2e3cfe9ab16332fa$var$O ? $2e3cfe9ab16332fa$var$M.memoizedState : $2e3cfe9ab16332fa$var$O.next;
    if (null !== b) $2e3cfe9ab16332fa$var$O = b, $2e3cfe9ab16332fa$var$N = a;
    else {
        if (null === a) throw Error($2e3cfe9ab16332fa$var$p(310));
        $2e3cfe9ab16332fa$var$N = a;
        a = {
            memoizedState: $2e3cfe9ab16332fa$var$N.memoizedState,
            baseState: $2e3cfe9ab16332fa$var$N.baseState,
            baseQueue: $2e3cfe9ab16332fa$var$N.baseQueue,
            queue: $2e3cfe9ab16332fa$var$N.queue,
            next: null
        };
        null === $2e3cfe9ab16332fa$var$O ? $2e3cfe9ab16332fa$var$M.memoizedState = $2e3cfe9ab16332fa$var$O = a : $2e3cfe9ab16332fa$var$O = $2e3cfe9ab16332fa$var$O.next = a;
    }
    return $2e3cfe9ab16332fa$var$O;
}
function $2e3cfe9ab16332fa$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $2e3cfe9ab16332fa$var$Wh(a) {
    var b = $2e3cfe9ab16332fa$var$Uh(), c = b.queue;
    if (null === c) throw Error($2e3cfe9ab16332fa$var$p(311));
    c.lastRenderedReducer = a;
    var d = $2e3cfe9ab16332fa$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($2e3cfe9ab16332fa$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $2e3cfe9ab16332fa$var$M.lanes |= m;
                $2e3cfe9ab16332fa$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $2e3cfe9ab16332fa$var$He(d, b.memoizedState) || ($2e3cfe9ab16332fa$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $2e3cfe9ab16332fa$var$M.lanes |= f, $2e3cfe9ab16332fa$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $2e3cfe9ab16332fa$var$Xh(a) {
    var b = $2e3cfe9ab16332fa$var$Uh(), c = b.queue;
    if (null === c) throw Error($2e3cfe9ab16332fa$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $2e3cfe9ab16332fa$var$He(f, b.memoizedState) || ($2e3cfe9ab16332fa$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $2e3cfe9ab16332fa$var$Yh() {}
function $2e3cfe9ab16332fa$var$Zh(a, b) {
    var c = $2e3cfe9ab16332fa$var$M, d = $2e3cfe9ab16332fa$var$Uh(), e = b(), f = !$2e3cfe9ab16332fa$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $2e3cfe9ab16332fa$var$dh = !0);
    d = d.queue;
    $2e3cfe9ab16332fa$var$$h($2e3cfe9ab16332fa$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $2e3cfe9ab16332fa$var$O && $2e3cfe9ab16332fa$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $2e3cfe9ab16332fa$var$bi(9, $2e3cfe9ab16332fa$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $2e3cfe9ab16332fa$var$Q) throw Error($2e3cfe9ab16332fa$var$p(349));
        0 !== ($2e3cfe9ab16332fa$var$Hh & 30) || $2e3cfe9ab16332fa$var$di(c, b, e);
    }
    return e;
}
function $2e3cfe9ab16332fa$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $2e3cfe9ab16332fa$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $2e3cfe9ab16332fa$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $2e3cfe9ab16332fa$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $2e3cfe9ab16332fa$var$ei(b) && $2e3cfe9ab16332fa$var$fi(a);
}
function $2e3cfe9ab16332fa$var$ai(a, b, c) {
    return c(function() {
        $2e3cfe9ab16332fa$var$ei(b) && $2e3cfe9ab16332fa$var$fi(a);
    });
}
function $2e3cfe9ab16332fa$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$2e3cfe9ab16332fa$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $2e3cfe9ab16332fa$var$fi(a) {
    var b = $2e3cfe9ab16332fa$var$ih(a, 1);
    null !== b && $2e3cfe9ab16332fa$var$gi(b, a, 1, -1);
}
function $2e3cfe9ab16332fa$var$hi(a) {
    var b = $2e3cfe9ab16332fa$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2e3cfe9ab16332fa$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $2e3cfe9ab16332fa$var$ii.bind(null, $2e3cfe9ab16332fa$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $2e3cfe9ab16332fa$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $2e3cfe9ab16332fa$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $2e3cfe9ab16332fa$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $2e3cfe9ab16332fa$var$ji() {
    return $2e3cfe9ab16332fa$var$Uh().memoizedState;
}
function $2e3cfe9ab16332fa$var$ki(a, b, c, d) {
    var e = $2e3cfe9ab16332fa$var$Th();
    $2e3cfe9ab16332fa$var$M.flags |= a;
    e.memoizedState = $2e3cfe9ab16332fa$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $2e3cfe9ab16332fa$var$li(a, b, c, d) {
    var e = $2e3cfe9ab16332fa$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $2e3cfe9ab16332fa$var$N) {
        var g = $2e3cfe9ab16332fa$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $2e3cfe9ab16332fa$var$Mh(d, g.deps)) {
            e.memoizedState = $2e3cfe9ab16332fa$var$bi(b, c, f, d);
            return;
        }
    }
    $2e3cfe9ab16332fa$var$M.flags |= a;
    e.memoizedState = $2e3cfe9ab16332fa$var$bi(1 | b, c, f, d);
}
function $2e3cfe9ab16332fa$var$mi(a, b) {
    return $2e3cfe9ab16332fa$var$ki(8390656, 8, a, b);
}
function $2e3cfe9ab16332fa$var$$h(a, b) {
    return $2e3cfe9ab16332fa$var$li(2048, 8, a, b);
}
function $2e3cfe9ab16332fa$var$ni(a, b) {
    return $2e3cfe9ab16332fa$var$li(4, 2, a, b);
}
function $2e3cfe9ab16332fa$var$oi(a, b) {
    return $2e3cfe9ab16332fa$var$li(4, 4, a, b);
}
function $2e3cfe9ab16332fa$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $2e3cfe9ab16332fa$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $2e3cfe9ab16332fa$var$li(4, 4, $2e3cfe9ab16332fa$var$pi.bind(null, b, a), c);
}
function $2e3cfe9ab16332fa$var$ri() {}
function $2e3cfe9ab16332fa$var$si(a, b) {
    var c = $2e3cfe9ab16332fa$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $2e3cfe9ab16332fa$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $2e3cfe9ab16332fa$var$ti(a, b) {
    var c = $2e3cfe9ab16332fa$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $2e3cfe9ab16332fa$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $2e3cfe9ab16332fa$var$ui(a, b, c) {
    if (0 === ($2e3cfe9ab16332fa$var$Hh & 21)) return a.baseState && (a.baseState = !1, $2e3cfe9ab16332fa$var$dh = !0), a.memoizedState = c;
    $2e3cfe9ab16332fa$var$He(c, b) || (c = $2e3cfe9ab16332fa$var$yc(), $2e3cfe9ab16332fa$var$M.lanes |= c, $2e3cfe9ab16332fa$var$rh |= c, a.baseState = !0);
    return b;
}
function $2e3cfe9ab16332fa$var$vi(a, b) {
    var c = $2e3cfe9ab16332fa$var$C;
    $2e3cfe9ab16332fa$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $2e3cfe9ab16332fa$var$Gh.transition;
    $2e3cfe9ab16332fa$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $2e3cfe9ab16332fa$var$C = c, $2e3cfe9ab16332fa$var$Gh.transition = d;
    }
}
function $2e3cfe9ab16332fa$var$wi() {
    return $2e3cfe9ab16332fa$var$Uh().memoizedState;
}
function $2e3cfe9ab16332fa$var$xi(a, b, c) {
    var d = $2e3cfe9ab16332fa$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2e3cfe9ab16332fa$var$zi(a)) $2e3cfe9ab16332fa$var$Ai(b, c);
    else if (c = $2e3cfe9ab16332fa$var$hh(a, b, c, d), null !== c) {
        var e = $2e3cfe9ab16332fa$var$R();
        $2e3cfe9ab16332fa$var$gi(c, a, d, e);
        $2e3cfe9ab16332fa$var$Bi(c, b, d);
    }
}
function $2e3cfe9ab16332fa$var$ii(a, b, c) {
    var d = $2e3cfe9ab16332fa$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2e3cfe9ab16332fa$var$zi(a)) $2e3cfe9ab16332fa$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($2e3cfe9ab16332fa$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $2e3cfe9ab16332fa$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $2e3cfe9ab16332fa$var$hh(a, b, e, d);
        null !== c && (e = $2e3cfe9ab16332fa$var$R(), $2e3cfe9ab16332fa$var$gi(c, a, d, e), $2e3cfe9ab16332fa$var$Bi(c, b, d));
    }
}
function $2e3cfe9ab16332fa$var$zi(a) {
    var b = a.alternate;
    return a === $2e3cfe9ab16332fa$var$M || null !== b && b === $2e3cfe9ab16332fa$var$M;
}
function $2e3cfe9ab16332fa$var$Ai(a, b) {
    $2e3cfe9ab16332fa$var$Jh = $2e3cfe9ab16332fa$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $2e3cfe9ab16332fa$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $2e3cfe9ab16332fa$var$Cc(a, c);
    }
}
var $2e3cfe9ab16332fa$var$Rh = {
    readContext: $2e3cfe9ab16332fa$var$eh,
    useCallback: $2e3cfe9ab16332fa$var$P,
    useContext: $2e3cfe9ab16332fa$var$P,
    useEffect: $2e3cfe9ab16332fa$var$P,
    useImperativeHandle: $2e3cfe9ab16332fa$var$P,
    useInsertionEffect: $2e3cfe9ab16332fa$var$P,
    useLayoutEffect: $2e3cfe9ab16332fa$var$P,
    useMemo: $2e3cfe9ab16332fa$var$P,
    useReducer: $2e3cfe9ab16332fa$var$P,
    useRef: $2e3cfe9ab16332fa$var$P,
    useState: $2e3cfe9ab16332fa$var$P,
    useDebugValue: $2e3cfe9ab16332fa$var$P,
    useDeferredValue: $2e3cfe9ab16332fa$var$P,
    useTransition: $2e3cfe9ab16332fa$var$P,
    useMutableSource: $2e3cfe9ab16332fa$var$P,
    useSyncExternalStore: $2e3cfe9ab16332fa$var$P,
    useId: $2e3cfe9ab16332fa$var$P,
    unstable_isNewReconciler: !1
}, $2e3cfe9ab16332fa$var$Oh = {
    readContext: $2e3cfe9ab16332fa$var$eh,
    useCallback: function(a, b) {
        $2e3cfe9ab16332fa$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $2e3cfe9ab16332fa$var$eh,
    useEffect: $2e3cfe9ab16332fa$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $2e3cfe9ab16332fa$var$ki(4194308, 4, $2e3cfe9ab16332fa$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $2e3cfe9ab16332fa$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $2e3cfe9ab16332fa$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $2e3cfe9ab16332fa$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $2e3cfe9ab16332fa$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $2e3cfe9ab16332fa$var$xi.bind(null, $2e3cfe9ab16332fa$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $2e3cfe9ab16332fa$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $2e3cfe9ab16332fa$var$hi,
    useDebugValue: $2e3cfe9ab16332fa$var$ri,
    useDeferredValue: function(a) {
        return $2e3cfe9ab16332fa$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $2e3cfe9ab16332fa$var$hi(!1), b = a[0];
        a = $2e3cfe9ab16332fa$var$vi.bind(null, a[1]);
        $2e3cfe9ab16332fa$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $2e3cfe9ab16332fa$var$M, e = $2e3cfe9ab16332fa$var$Th();
        if ($2e3cfe9ab16332fa$var$I) {
            if (void 0 === c) throw Error($2e3cfe9ab16332fa$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $2e3cfe9ab16332fa$var$Q) throw Error($2e3cfe9ab16332fa$var$p(349));
            0 !== ($2e3cfe9ab16332fa$var$Hh & 30) || $2e3cfe9ab16332fa$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $2e3cfe9ab16332fa$var$mi($2e3cfe9ab16332fa$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $2e3cfe9ab16332fa$var$bi(9, $2e3cfe9ab16332fa$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $2e3cfe9ab16332fa$var$Th(), b = $2e3cfe9ab16332fa$var$Q.identifierPrefix;
        if ($2e3cfe9ab16332fa$var$I) {
            var c = $2e3cfe9ab16332fa$var$sg;
            var d = $2e3cfe9ab16332fa$var$rg;
            c = (d & ~(1 << 32 - $2e3cfe9ab16332fa$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $2e3cfe9ab16332fa$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $2e3cfe9ab16332fa$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $2e3cfe9ab16332fa$var$Ph = {
    readContext: $2e3cfe9ab16332fa$var$eh,
    useCallback: $2e3cfe9ab16332fa$var$si,
    useContext: $2e3cfe9ab16332fa$var$eh,
    useEffect: $2e3cfe9ab16332fa$var$$h,
    useImperativeHandle: $2e3cfe9ab16332fa$var$qi,
    useInsertionEffect: $2e3cfe9ab16332fa$var$ni,
    useLayoutEffect: $2e3cfe9ab16332fa$var$oi,
    useMemo: $2e3cfe9ab16332fa$var$ti,
    useReducer: $2e3cfe9ab16332fa$var$Wh,
    useRef: $2e3cfe9ab16332fa$var$ji,
    useState: function() {
        return $2e3cfe9ab16332fa$var$Wh($2e3cfe9ab16332fa$var$Vh);
    },
    useDebugValue: $2e3cfe9ab16332fa$var$ri,
    useDeferredValue: function(a) {
        var b = $2e3cfe9ab16332fa$var$Uh();
        return $2e3cfe9ab16332fa$var$ui(b, $2e3cfe9ab16332fa$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $2e3cfe9ab16332fa$var$Wh($2e3cfe9ab16332fa$var$Vh)[0], b = $2e3cfe9ab16332fa$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $2e3cfe9ab16332fa$var$Yh,
    useSyncExternalStore: $2e3cfe9ab16332fa$var$Zh,
    useId: $2e3cfe9ab16332fa$var$wi,
    unstable_isNewReconciler: !1
}, $2e3cfe9ab16332fa$var$Qh = {
    readContext: $2e3cfe9ab16332fa$var$eh,
    useCallback: $2e3cfe9ab16332fa$var$si,
    useContext: $2e3cfe9ab16332fa$var$eh,
    useEffect: $2e3cfe9ab16332fa$var$$h,
    useImperativeHandle: $2e3cfe9ab16332fa$var$qi,
    useInsertionEffect: $2e3cfe9ab16332fa$var$ni,
    useLayoutEffect: $2e3cfe9ab16332fa$var$oi,
    useMemo: $2e3cfe9ab16332fa$var$ti,
    useReducer: $2e3cfe9ab16332fa$var$Xh,
    useRef: $2e3cfe9ab16332fa$var$ji,
    useState: function() {
        return $2e3cfe9ab16332fa$var$Xh($2e3cfe9ab16332fa$var$Vh);
    },
    useDebugValue: $2e3cfe9ab16332fa$var$ri,
    useDeferredValue: function(a) {
        var b = $2e3cfe9ab16332fa$var$Uh();
        return null === $2e3cfe9ab16332fa$var$N ? b.memoizedState = a : $2e3cfe9ab16332fa$var$ui(b, $2e3cfe9ab16332fa$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $2e3cfe9ab16332fa$var$Xh($2e3cfe9ab16332fa$var$Vh)[0], b = $2e3cfe9ab16332fa$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $2e3cfe9ab16332fa$var$Yh,
    useSyncExternalStore: $2e3cfe9ab16332fa$var$Zh,
    useId: $2e3cfe9ab16332fa$var$wi,
    unstable_isNewReconciler: !1
};
function $2e3cfe9ab16332fa$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $2e3cfe9ab16332fa$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $2e3cfe9ab16332fa$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $2e3cfe9ab16332fa$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $2e3cfe9ab16332fa$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $2e3cfe9ab16332fa$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $2e3cfe9ab16332fa$var$R(), e = $2e3cfe9ab16332fa$var$yi(a), f = $2e3cfe9ab16332fa$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $2e3cfe9ab16332fa$var$nh(a, f, e);
        null !== b && ($2e3cfe9ab16332fa$var$gi(b, a, e, d), $2e3cfe9ab16332fa$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $2e3cfe9ab16332fa$var$R(), e = $2e3cfe9ab16332fa$var$yi(a), f = $2e3cfe9ab16332fa$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $2e3cfe9ab16332fa$var$nh(a, f, e);
        null !== b && ($2e3cfe9ab16332fa$var$gi(b, a, e, d), $2e3cfe9ab16332fa$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $2e3cfe9ab16332fa$var$R(), d = $2e3cfe9ab16332fa$var$yi(a), e = $2e3cfe9ab16332fa$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $2e3cfe9ab16332fa$var$nh(a, e, d);
        null !== b && ($2e3cfe9ab16332fa$var$gi(b, a, d, c), $2e3cfe9ab16332fa$var$oh(b, a, d));
    }
};
function $2e3cfe9ab16332fa$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$2e3cfe9ab16332fa$var$Ie(c, d) || !$2e3cfe9ab16332fa$var$Ie(e, f) : !0;
}
function $2e3cfe9ab16332fa$var$Gi(a, b, c) {
    var d = !1, e = $2e3cfe9ab16332fa$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $2e3cfe9ab16332fa$var$eh(f) : (e = $2e3cfe9ab16332fa$var$Zf(b) ? $2e3cfe9ab16332fa$var$Xf : $2e3cfe9ab16332fa$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $2e3cfe9ab16332fa$var$Yf(a, e) : $2e3cfe9ab16332fa$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $2e3cfe9ab16332fa$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $2e3cfe9ab16332fa$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $2e3cfe9ab16332fa$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $2e3cfe9ab16332fa$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $2e3cfe9ab16332fa$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $2e3cfe9ab16332fa$var$eh(f) : (f = $2e3cfe9ab16332fa$var$Zf(b) ? $2e3cfe9ab16332fa$var$Xf : $2e3cfe9ab16332fa$var$H.current, e.context = $2e3cfe9ab16332fa$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($2e3cfe9ab16332fa$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $2e3cfe9ab16332fa$var$Ei.enqueueReplaceState(e, e.state, null), $2e3cfe9ab16332fa$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $2e3cfe9ab16332fa$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $2e3cfe9ab16332fa$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $2e3cfe9ab16332fa$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $2e3cfe9ab16332fa$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $2e3cfe9ab16332fa$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $2e3cfe9ab16332fa$var$Ni(a, b, c) {
    c = $2e3cfe9ab16332fa$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $2e3cfe9ab16332fa$var$Oi || ($2e3cfe9ab16332fa$var$Oi = !0, $2e3cfe9ab16332fa$var$Pi = d);
        $2e3cfe9ab16332fa$var$Li(a, b);
    };
    return c;
}
function $2e3cfe9ab16332fa$var$Qi(a, b, c) {
    c = $2e3cfe9ab16332fa$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $2e3cfe9ab16332fa$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $2e3cfe9ab16332fa$var$Li(a, b);
        "function" !== typeof d && (null === $2e3cfe9ab16332fa$var$Ri ? $2e3cfe9ab16332fa$var$Ri = new Set([
            this
        ]) : $2e3cfe9ab16332fa$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $2e3cfe9ab16332fa$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $2e3cfe9ab16332fa$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $2e3cfe9ab16332fa$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $2e3cfe9ab16332fa$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $2e3cfe9ab16332fa$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $2e3cfe9ab16332fa$var$mh(-1, 1), b.tag = 2, $2e3cfe9ab16332fa$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $2e3cfe9ab16332fa$var$Wi = $2e3cfe9ab16332fa$var$ua.ReactCurrentOwner, $2e3cfe9ab16332fa$var$dh = !1;
function $2e3cfe9ab16332fa$var$Xi(a, b, c, d) {
    b.child = null === a ? $2e3cfe9ab16332fa$var$Vg(b, null, c, d) : $2e3cfe9ab16332fa$var$Ug(b, a.child, c, d);
}
function $2e3cfe9ab16332fa$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $2e3cfe9ab16332fa$var$ch(b, e);
    d = $2e3cfe9ab16332fa$var$Nh(a, b, c, d, f, e);
    c = $2e3cfe9ab16332fa$var$Sh();
    if (null !== a && !$2e3cfe9ab16332fa$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $2e3cfe9ab16332fa$var$Zi(a, b, e);
    $2e3cfe9ab16332fa$var$I && c && $2e3cfe9ab16332fa$var$vg(b);
    b.flags |= 1;
    $2e3cfe9ab16332fa$var$Xi(a, b, d, e);
    return b.child;
}
function $2e3cfe9ab16332fa$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$2e3cfe9ab16332fa$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $2e3cfe9ab16332fa$var$bj(a, b, f, d, e);
        a = $2e3cfe9ab16332fa$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $2e3cfe9ab16332fa$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $2e3cfe9ab16332fa$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $2e3cfe9ab16332fa$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $2e3cfe9ab16332fa$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($2e3cfe9ab16332fa$var$Ie(f, d) && a.ref === b.ref) {
            if ($2e3cfe9ab16332fa$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($2e3cfe9ab16332fa$var$dh = !0);
            else return b.lanes = a.lanes, $2e3cfe9ab16332fa$var$Zi(a, b, e);
        }
    }
    return $2e3cfe9ab16332fa$var$cj(a, b, c, d, e);
}
function $2e3cfe9ab16332fa$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$ej, $2e3cfe9ab16332fa$var$fj), $2e3cfe9ab16332fa$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$ej, $2e3cfe9ab16332fa$var$fj), $2e3cfe9ab16332fa$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$ej, $2e3cfe9ab16332fa$var$fj);
            $2e3cfe9ab16332fa$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$ej, $2e3cfe9ab16332fa$var$fj), $2e3cfe9ab16332fa$var$fj |= d;
    $2e3cfe9ab16332fa$var$Xi(a, b, e, c);
    return b.child;
}
function $2e3cfe9ab16332fa$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $2e3cfe9ab16332fa$var$cj(a, b, c, d, e) {
    var f = $2e3cfe9ab16332fa$var$Zf(c) ? $2e3cfe9ab16332fa$var$Xf : $2e3cfe9ab16332fa$var$H.current;
    f = $2e3cfe9ab16332fa$var$Yf(b, f);
    $2e3cfe9ab16332fa$var$ch(b, e);
    c = $2e3cfe9ab16332fa$var$Nh(a, b, c, d, f, e);
    d = $2e3cfe9ab16332fa$var$Sh();
    if (null !== a && !$2e3cfe9ab16332fa$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $2e3cfe9ab16332fa$var$Zi(a, b, e);
    $2e3cfe9ab16332fa$var$I && d && $2e3cfe9ab16332fa$var$vg(b);
    b.flags |= 1;
    $2e3cfe9ab16332fa$var$Xi(a, b, c, e);
    return b.child;
}
function $2e3cfe9ab16332fa$var$hj(a, b, c, d, e) {
    if ($2e3cfe9ab16332fa$var$Zf(c)) {
        var f = !0;
        $2e3cfe9ab16332fa$var$cg(b);
    } else f = !1;
    $2e3cfe9ab16332fa$var$ch(b, e);
    if (null === b.stateNode) $2e3cfe9ab16332fa$var$ij(a, b), $2e3cfe9ab16332fa$var$Gi(b, c, d), $2e3cfe9ab16332fa$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $2e3cfe9ab16332fa$var$eh(l) : (l = $2e3cfe9ab16332fa$var$Zf(c) ? $2e3cfe9ab16332fa$var$Xf : $2e3cfe9ab16332fa$var$H.current, l = $2e3cfe9ab16332fa$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $2e3cfe9ab16332fa$var$Hi(b, g, d, l);
        $2e3cfe9ab16332fa$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $2e3cfe9ab16332fa$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $2e3cfe9ab16332fa$var$Wf.current || $2e3cfe9ab16332fa$var$jh ? ("function" === typeof m && ($2e3cfe9ab16332fa$var$Di(b, c, m, d), k = b.memoizedState), (h = $2e3cfe9ab16332fa$var$jh || $2e3cfe9ab16332fa$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $2e3cfe9ab16332fa$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $2e3cfe9ab16332fa$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $2e3cfe9ab16332fa$var$eh(k) : (k = $2e3cfe9ab16332fa$var$Zf(c) ? $2e3cfe9ab16332fa$var$Xf : $2e3cfe9ab16332fa$var$H.current, k = $2e3cfe9ab16332fa$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $2e3cfe9ab16332fa$var$Hi(b, g, d, k);
        $2e3cfe9ab16332fa$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $2e3cfe9ab16332fa$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $2e3cfe9ab16332fa$var$Wf.current || $2e3cfe9ab16332fa$var$jh ? ("function" === typeof y && ($2e3cfe9ab16332fa$var$Di(b, c, y, d), n = b.memoizedState), (l = $2e3cfe9ab16332fa$var$jh || $2e3cfe9ab16332fa$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $2e3cfe9ab16332fa$var$jj(a, b, c, d, f, e);
}
function $2e3cfe9ab16332fa$var$jj(a, b, c, d, e, f) {
    $2e3cfe9ab16332fa$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $2e3cfe9ab16332fa$var$dg(b, c, !1), $2e3cfe9ab16332fa$var$Zi(a, b, f);
    d = b.stateNode;
    $2e3cfe9ab16332fa$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $2e3cfe9ab16332fa$var$Ug(b, a.child, null, f), b.child = $2e3cfe9ab16332fa$var$Ug(b, null, h, f)) : $2e3cfe9ab16332fa$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $2e3cfe9ab16332fa$var$dg(b, c, !0);
    return b.child;
}
function $2e3cfe9ab16332fa$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $2e3cfe9ab16332fa$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $2e3cfe9ab16332fa$var$ag(a, b.context, !1);
    $2e3cfe9ab16332fa$var$yh(a, b.containerInfo);
}
function $2e3cfe9ab16332fa$var$lj(a, b, c, d, e) {
    $2e3cfe9ab16332fa$var$Ig();
    $2e3cfe9ab16332fa$var$Jg(e);
    b.flags |= 256;
    $2e3cfe9ab16332fa$var$Xi(a, b, c, d);
    return b.child;
}
var $2e3cfe9ab16332fa$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $2e3cfe9ab16332fa$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $2e3cfe9ab16332fa$var$oj(a, b, c) {
    var d = b.pendingProps, e = $2e3cfe9ab16332fa$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$L, e & 1);
    if (null === a) {
        $2e3cfe9ab16332fa$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $2e3cfe9ab16332fa$var$pj(g, d, 0, null), a = $2e3cfe9ab16332fa$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $2e3cfe9ab16332fa$var$nj(c), b.memoizedState = $2e3cfe9ab16332fa$var$mj, a) : $2e3cfe9ab16332fa$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $2e3cfe9ab16332fa$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $2e3cfe9ab16332fa$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $2e3cfe9ab16332fa$var$Pg(h, f) : (f = $2e3cfe9ab16332fa$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $2e3cfe9ab16332fa$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $2e3cfe9ab16332fa$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $2e3cfe9ab16332fa$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $2e3cfe9ab16332fa$var$qj(a, b) {
    b = $2e3cfe9ab16332fa$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $2e3cfe9ab16332fa$var$sj(a, b, c, d) {
    null !== d && $2e3cfe9ab16332fa$var$Jg(d);
    $2e3cfe9ab16332fa$var$Ug(b, a.child, null, c);
    a = $2e3cfe9ab16332fa$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $2e3cfe9ab16332fa$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $2e3cfe9ab16332fa$var$Ki(Error($2e3cfe9ab16332fa$var$p(422))), $2e3cfe9ab16332fa$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $2e3cfe9ab16332fa$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $2e3cfe9ab16332fa$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $2e3cfe9ab16332fa$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $2e3cfe9ab16332fa$var$nj(g);
        b.memoizedState = $2e3cfe9ab16332fa$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $2e3cfe9ab16332fa$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($2e3cfe9ab16332fa$var$p(419));
        d = $2e3cfe9ab16332fa$var$Ki(f, d, void 0);
        return $2e3cfe9ab16332fa$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($2e3cfe9ab16332fa$var$dh || h) {
        d = $2e3cfe9ab16332fa$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $2e3cfe9ab16332fa$var$ih(a, e), $2e3cfe9ab16332fa$var$gi(d, a, e, -1));
        }
        $2e3cfe9ab16332fa$var$tj();
        d = $2e3cfe9ab16332fa$var$Ki(Error($2e3cfe9ab16332fa$var$p(421)));
        return $2e3cfe9ab16332fa$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $2e3cfe9ab16332fa$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $2e3cfe9ab16332fa$var$yg = $2e3cfe9ab16332fa$var$Lf(e.nextSibling);
    $2e3cfe9ab16332fa$var$xg = b;
    $2e3cfe9ab16332fa$var$I = !0;
    $2e3cfe9ab16332fa$var$zg = null;
    null !== a && ($2e3cfe9ab16332fa$var$og[$2e3cfe9ab16332fa$var$pg++] = $2e3cfe9ab16332fa$var$rg, $2e3cfe9ab16332fa$var$og[$2e3cfe9ab16332fa$var$pg++] = $2e3cfe9ab16332fa$var$sg, $2e3cfe9ab16332fa$var$og[$2e3cfe9ab16332fa$var$pg++] = $2e3cfe9ab16332fa$var$qg, $2e3cfe9ab16332fa$var$rg = a.id, $2e3cfe9ab16332fa$var$sg = a.overflow, $2e3cfe9ab16332fa$var$qg = b);
    b = $2e3cfe9ab16332fa$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $2e3cfe9ab16332fa$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $2e3cfe9ab16332fa$var$bh(a.return, b, c);
}
function $2e3cfe9ab16332fa$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $2e3cfe9ab16332fa$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $2e3cfe9ab16332fa$var$Xi(a, b, d.children, c);
    d = $2e3cfe9ab16332fa$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $2e3cfe9ab16332fa$var$vj(a, c, b);
            else if (19 === a.tag) $2e3cfe9ab16332fa$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $2e3cfe9ab16332fa$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $2e3cfe9ab16332fa$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $2e3cfe9ab16332fa$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $2e3cfe9ab16332fa$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $2e3cfe9ab16332fa$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $2e3cfe9ab16332fa$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $2e3cfe9ab16332fa$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $2e3cfe9ab16332fa$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($2e3cfe9ab16332fa$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $2e3cfe9ab16332fa$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $2e3cfe9ab16332fa$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $2e3cfe9ab16332fa$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $2e3cfe9ab16332fa$var$kj(b);
            $2e3cfe9ab16332fa$var$Ig();
            break;
        case 5:
            $2e3cfe9ab16332fa$var$Ah(b);
            break;
        case 1:
            $2e3cfe9ab16332fa$var$Zf(b.type) && $2e3cfe9ab16332fa$var$cg(b);
            break;
        case 4:
            $2e3cfe9ab16332fa$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$L, $2e3cfe9ab16332fa$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $2e3cfe9ab16332fa$var$oj(a, b, c);
                $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$L, $2e3cfe9ab16332fa$var$L.current & 1);
                a = $2e3cfe9ab16332fa$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$L, $2e3cfe9ab16332fa$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $2e3cfe9ab16332fa$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$L, $2e3cfe9ab16332fa$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $2e3cfe9ab16332fa$var$dj(a, b, c);
    }
    return $2e3cfe9ab16332fa$var$Zi(a, b, c);
}
var $2e3cfe9ab16332fa$var$zj, $2e3cfe9ab16332fa$var$Aj, $2e3cfe9ab16332fa$var$Bj, $2e3cfe9ab16332fa$var$Cj;
$2e3cfe9ab16332fa$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$2e3cfe9ab16332fa$var$Aj = function() {};
$2e3cfe9ab16332fa$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $2e3cfe9ab16332fa$var$xh($2e3cfe9ab16332fa$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $2e3cfe9ab16332fa$var$Ya(a, e);
                d = $2e3cfe9ab16332fa$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $2e3cfe9ab16332fa$var$A({}, e, {
                    value: void 0
                });
                d = $2e3cfe9ab16332fa$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $2e3cfe9ab16332fa$var$gb(a, e);
                d = $2e3cfe9ab16332fa$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $2e3cfe9ab16332fa$var$Bf);
        }
        $2e3cfe9ab16332fa$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($2e3cfe9ab16332fa$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($2e3cfe9ab16332fa$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $2e3cfe9ab16332fa$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$2e3cfe9ab16332fa$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $2e3cfe9ab16332fa$var$Dj(a, b) {
    if (!$2e3cfe9ab16332fa$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $2e3cfe9ab16332fa$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $2e3cfe9ab16332fa$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $2e3cfe9ab16332fa$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $2e3cfe9ab16332fa$var$S(b), null;
        case 1:
            return $2e3cfe9ab16332fa$var$Zf(b.type) && $2e3cfe9ab16332fa$var$$f(), $2e3cfe9ab16332fa$var$S(b), null;
        case 3:
            d = b.stateNode;
            $2e3cfe9ab16332fa$var$zh();
            $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$Wf);
            $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$H);
            $2e3cfe9ab16332fa$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $2e3cfe9ab16332fa$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $2e3cfe9ab16332fa$var$zg && ($2e3cfe9ab16332fa$var$Fj($2e3cfe9ab16332fa$var$zg), $2e3cfe9ab16332fa$var$zg = null));
            $2e3cfe9ab16332fa$var$Aj(a, b);
            $2e3cfe9ab16332fa$var$S(b);
            return null;
        case 5:
            $2e3cfe9ab16332fa$var$Bh(b);
            var e = $2e3cfe9ab16332fa$var$xh($2e3cfe9ab16332fa$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $2e3cfe9ab16332fa$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($2e3cfe9ab16332fa$var$p(166));
                    $2e3cfe9ab16332fa$var$S(b);
                    return null;
                }
                a = $2e3cfe9ab16332fa$var$xh($2e3cfe9ab16332fa$var$uh.current);
                if ($2e3cfe9ab16332fa$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$2e3cfe9ab16332fa$var$Of] = b;
                    d[$2e3cfe9ab16332fa$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $2e3cfe9ab16332fa$var$D("cancel", d);
                            $2e3cfe9ab16332fa$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $2e3cfe9ab16332fa$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $2e3cfe9ab16332fa$var$lf.length; e++)$2e3cfe9ab16332fa$var$D($2e3cfe9ab16332fa$var$lf[e], d);
                            break;
                        case "source":
                            $2e3cfe9ab16332fa$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $2e3cfe9ab16332fa$var$D("error", d);
                            $2e3cfe9ab16332fa$var$D("load", d);
                            break;
                        case "details":
                            $2e3cfe9ab16332fa$var$D("toggle", d);
                            break;
                        case "input":
                            $2e3cfe9ab16332fa$var$Za(d, f);
                            $2e3cfe9ab16332fa$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $2e3cfe9ab16332fa$var$D("invalid", d);
                            break;
                        case "textarea":
                            $2e3cfe9ab16332fa$var$hb(d, f), $2e3cfe9ab16332fa$var$D("invalid", d);
                    }
                    $2e3cfe9ab16332fa$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $2e3cfe9ab16332fa$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $2e3cfe9ab16332fa$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $2e3cfe9ab16332fa$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $2e3cfe9ab16332fa$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $2e3cfe9ab16332fa$var$Va(d);
                            $2e3cfe9ab16332fa$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $2e3cfe9ab16332fa$var$Va(d);
                            $2e3cfe9ab16332fa$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $2e3cfe9ab16332fa$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $2e3cfe9ab16332fa$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$2e3cfe9ab16332fa$var$Of] = b;
                    a[$2e3cfe9ab16332fa$var$Pf] = d;
                    $2e3cfe9ab16332fa$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $2e3cfe9ab16332fa$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $2e3cfe9ab16332fa$var$D("cancel", a);
                                $2e3cfe9ab16332fa$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $2e3cfe9ab16332fa$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $2e3cfe9ab16332fa$var$lf.length; e++)$2e3cfe9ab16332fa$var$D($2e3cfe9ab16332fa$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $2e3cfe9ab16332fa$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $2e3cfe9ab16332fa$var$D("error", a);
                                $2e3cfe9ab16332fa$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $2e3cfe9ab16332fa$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $2e3cfe9ab16332fa$var$Za(a, d);
                                e = $2e3cfe9ab16332fa$var$Ya(a, d);
                                $2e3cfe9ab16332fa$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $2e3cfe9ab16332fa$var$A({}, d, {
                                    value: void 0
                                });
                                $2e3cfe9ab16332fa$var$D("invalid", a);
                                break;
                            case "textarea":
                                $2e3cfe9ab16332fa$var$hb(a, d);
                                e = $2e3cfe9ab16332fa$var$gb(a, d);
                                $2e3cfe9ab16332fa$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $2e3cfe9ab16332fa$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $2e3cfe9ab16332fa$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $2e3cfe9ab16332fa$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $2e3cfe9ab16332fa$var$ob(a, k) : "number" === typeof k && $2e3cfe9ab16332fa$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($2e3cfe9ab16332fa$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $2e3cfe9ab16332fa$var$D("scroll", a) : null != k && $2e3cfe9ab16332fa$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $2e3cfe9ab16332fa$var$Va(a);
                                $2e3cfe9ab16332fa$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $2e3cfe9ab16332fa$var$Va(a);
                                $2e3cfe9ab16332fa$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $2e3cfe9ab16332fa$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $2e3cfe9ab16332fa$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $2e3cfe9ab16332fa$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $2e3cfe9ab16332fa$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $2e3cfe9ab16332fa$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $2e3cfe9ab16332fa$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($2e3cfe9ab16332fa$var$p(166));
                c = $2e3cfe9ab16332fa$var$xh($2e3cfe9ab16332fa$var$wh.current);
                $2e3cfe9ab16332fa$var$xh($2e3cfe9ab16332fa$var$uh.current);
                if ($2e3cfe9ab16332fa$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$2e3cfe9ab16332fa$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $2e3cfe9ab16332fa$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $2e3cfe9ab16332fa$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $2e3cfe9ab16332fa$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$2e3cfe9ab16332fa$var$Of] = b, b.stateNode = d;
            }
            $2e3cfe9ab16332fa$var$S(b);
            return null;
        case 13:
            $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($2e3cfe9ab16332fa$var$I && null !== $2e3cfe9ab16332fa$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $2e3cfe9ab16332fa$var$Hg(), $2e3cfe9ab16332fa$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $2e3cfe9ab16332fa$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($2e3cfe9ab16332fa$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($2e3cfe9ab16332fa$var$p(317));
                        f[$2e3cfe9ab16332fa$var$Of] = b;
                    } else $2e3cfe9ab16332fa$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $2e3cfe9ab16332fa$var$S(b);
                    f = !1;
                } else null !== $2e3cfe9ab16332fa$var$zg && ($2e3cfe9ab16332fa$var$Fj($2e3cfe9ab16332fa$var$zg), $2e3cfe9ab16332fa$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($2e3cfe9ab16332fa$var$L.current & 1) ? 0 === $2e3cfe9ab16332fa$var$T && ($2e3cfe9ab16332fa$var$T = 3) : $2e3cfe9ab16332fa$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $2e3cfe9ab16332fa$var$S(b);
            return null;
        case 4:
            return $2e3cfe9ab16332fa$var$zh(), $2e3cfe9ab16332fa$var$Aj(a, b), null === a && $2e3cfe9ab16332fa$var$sf(b.stateNode.containerInfo), $2e3cfe9ab16332fa$var$S(b), null;
        case 10:
            return $2e3cfe9ab16332fa$var$ah(b.type._context), $2e3cfe9ab16332fa$var$S(b), null;
        case 17:
            return $2e3cfe9ab16332fa$var$Zf(b.type) && $2e3cfe9ab16332fa$var$$f(), $2e3cfe9ab16332fa$var$S(b), null;
        case 19:
            $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$L);
            f = b.memoizedState;
            if (null === f) return $2e3cfe9ab16332fa$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $2e3cfe9ab16332fa$var$Dj(f, !1);
                else {
                    if (0 !== $2e3cfe9ab16332fa$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $2e3cfe9ab16332fa$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $2e3cfe9ab16332fa$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$L, $2e3cfe9ab16332fa$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $2e3cfe9ab16332fa$var$B() > $2e3cfe9ab16332fa$var$Gj && (b.flags |= 128, d = !0, $2e3cfe9ab16332fa$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $2e3cfe9ab16332fa$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $2e3cfe9ab16332fa$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$2e3cfe9ab16332fa$var$I) return $2e3cfe9ab16332fa$var$S(b), null;
                    } else 2 * $2e3cfe9ab16332fa$var$B() - f.renderingStartTime > $2e3cfe9ab16332fa$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $2e3cfe9ab16332fa$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $2e3cfe9ab16332fa$var$B(), b.sibling = null, c = $2e3cfe9ab16332fa$var$L.current, $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$L, d ? c & 1 | 2 : c & 1), b;
            $2e3cfe9ab16332fa$var$S(b);
            return null;
        case 22:
        case 23:
            return $2e3cfe9ab16332fa$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($2e3cfe9ab16332fa$var$fj & 1073741824) && ($2e3cfe9ab16332fa$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $2e3cfe9ab16332fa$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($2e3cfe9ab16332fa$var$p(156, b.tag));
}
function $2e3cfe9ab16332fa$var$Ij(a, b) {
    $2e3cfe9ab16332fa$var$wg(b);
    switch(b.tag){
        case 1:
            return $2e3cfe9ab16332fa$var$Zf(b.type) && $2e3cfe9ab16332fa$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $2e3cfe9ab16332fa$var$zh(), $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$Wf), $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$H), $2e3cfe9ab16332fa$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $2e3cfe9ab16332fa$var$Bh(b), null;
        case 13:
            $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($2e3cfe9ab16332fa$var$p(340));
                $2e3cfe9ab16332fa$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$L), null;
        case 4:
            return $2e3cfe9ab16332fa$var$zh(), null;
        case 10:
            return $2e3cfe9ab16332fa$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $2e3cfe9ab16332fa$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $2e3cfe9ab16332fa$var$Jj = !1, $2e3cfe9ab16332fa$var$U = !1, $2e3cfe9ab16332fa$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $2e3cfe9ab16332fa$var$V = null;
function $2e3cfe9ab16332fa$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $2e3cfe9ab16332fa$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $2e3cfe9ab16332fa$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $2e3cfe9ab16332fa$var$W(a, b, d);
    }
}
var $2e3cfe9ab16332fa$var$Nj = !1;
function $2e3cfe9ab16332fa$var$Oj(a, b) {
    $2e3cfe9ab16332fa$var$Cf = $2e3cfe9ab16332fa$var$dd;
    a = $2e3cfe9ab16332fa$var$Me();
    if ($2e3cfe9ab16332fa$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $2e3cfe9ab16332fa$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $2e3cfe9ab16332fa$var$dd = !1;
    for($2e3cfe9ab16332fa$var$V = b; null !== $2e3cfe9ab16332fa$var$V;)if (b = $2e3cfe9ab16332fa$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $2e3cfe9ab16332fa$var$V = a;
    else for(; null !== $2e3cfe9ab16332fa$var$V;){
        b = $2e3cfe9ab16332fa$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $2e3cfe9ab16332fa$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($2e3cfe9ab16332fa$var$p(163));
            }
        } catch (F) {
            $2e3cfe9ab16332fa$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $2e3cfe9ab16332fa$var$V = a;
            break;
        }
        $2e3cfe9ab16332fa$var$V = b.return;
    }
    n = $2e3cfe9ab16332fa$var$Nj;
    $2e3cfe9ab16332fa$var$Nj = !1;
    return n;
}
function $2e3cfe9ab16332fa$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $2e3cfe9ab16332fa$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $2e3cfe9ab16332fa$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $2e3cfe9ab16332fa$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $2e3cfe9ab16332fa$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $2e3cfe9ab16332fa$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$2e3cfe9ab16332fa$var$Of], delete b[$2e3cfe9ab16332fa$var$Pf], delete b[$2e3cfe9ab16332fa$var$of], delete b[$2e3cfe9ab16332fa$var$Qf], delete b[$2e3cfe9ab16332fa$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $2e3cfe9ab16332fa$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $2e3cfe9ab16332fa$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $2e3cfe9ab16332fa$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $2e3cfe9ab16332fa$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $2e3cfe9ab16332fa$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($2e3cfe9ab16332fa$var$Vj(a, b, c), a = a.sibling; null !== a;)$2e3cfe9ab16332fa$var$Vj(a, b, c), a = a.sibling;
}
function $2e3cfe9ab16332fa$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($2e3cfe9ab16332fa$var$Wj(a, b, c), a = a.sibling; null !== a;)$2e3cfe9ab16332fa$var$Wj(a, b, c), a = a.sibling;
}
var $2e3cfe9ab16332fa$var$X = null, $2e3cfe9ab16332fa$var$Xj = !1;
function $2e3cfe9ab16332fa$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$2e3cfe9ab16332fa$var$Zj(a, b, c), c = c.sibling;
}
function $2e3cfe9ab16332fa$var$Zj(a, b, c) {
    if ($2e3cfe9ab16332fa$var$lc && "function" === typeof $2e3cfe9ab16332fa$var$lc.onCommitFiberUnmount) try {
        $2e3cfe9ab16332fa$var$lc.onCommitFiberUnmount($2e3cfe9ab16332fa$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $2e3cfe9ab16332fa$var$U || $2e3cfe9ab16332fa$var$Lj(c, b);
        case 6:
            var d = $2e3cfe9ab16332fa$var$X, e = $2e3cfe9ab16332fa$var$Xj;
            $2e3cfe9ab16332fa$var$X = null;
            $2e3cfe9ab16332fa$var$Yj(a, b, c);
            $2e3cfe9ab16332fa$var$X = d;
            $2e3cfe9ab16332fa$var$Xj = e;
            null !== $2e3cfe9ab16332fa$var$X && ($2e3cfe9ab16332fa$var$Xj ? (a = $2e3cfe9ab16332fa$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $2e3cfe9ab16332fa$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $2e3cfe9ab16332fa$var$X && ($2e3cfe9ab16332fa$var$Xj ? (a = $2e3cfe9ab16332fa$var$X, c = c.stateNode, 8 === a.nodeType ? $2e3cfe9ab16332fa$var$Kf(a.parentNode, c) : 1 === a.nodeType && $2e3cfe9ab16332fa$var$Kf(a, c), $2e3cfe9ab16332fa$var$bd(a)) : $2e3cfe9ab16332fa$var$Kf($2e3cfe9ab16332fa$var$X, c.stateNode));
            break;
        case 4:
            d = $2e3cfe9ab16332fa$var$X;
            e = $2e3cfe9ab16332fa$var$Xj;
            $2e3cfe9ab16332fa$var$X = c.stateNode.containerInfo;
            $2e3cfe9ab16332fa$var$Xj = !0;
            $2e3cfe9ab16332fa$var$Yj(a, b, c);
            $2e3cfe9ab16332fa$var$X = d;
            $2e3cfe9ab16332fa$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$2e3cfe9ab16332fa$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $2e3cfe9ab16332fa$var$Mj(c, b, g) : 0 !== (f & 4) && $2e3cfe9ab16332fa$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $2e3cfe9ab16332fa$var$Yj(a, b, c);
            break;
        case 1:
            if (!$2e3cfe9ab16332fa$var$U && ($2e3cfe9ab16332fa$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $2e3cfe9ab16332fa$var$W(c, b, h);
            }
            $2e3cfe9ab16332fa$var$Yj(a, b, c);
            break;
        case 21:
            $2e3cfe9ab16332fa$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($2e3cfe9ab16332fa$var$U = (d = $2e3cfe9ab16332fa$var$U) || null !== c.memoizedState, $2e3cfe9ab16332fa$var$Yj(a, b, c), $2e3cfe9ab16332fa$var$U = d) : $2e3cfe9ab16332fa$var$Yj(a, b, c);
            break;
        default:
            $2e3cfe9ab16332fa$var$Yj(a, b, c);
    }
}
function $2e3cfe9ab16332fa$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $2e3cfe9ab16332fa$var$Kj);
        b.forEach(function(b) {
            var d = $2e3cfe9ab16332fa$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $2e3cfe9ab16332fa$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $2e3cfe9ab16332fa$var$X = h.stateNode;
                        $2e3cfe9ab16332fa$var$Xj = !1;
                        break a;
                    case 3:
                        $2e3cfe9ab16332fa$var$X = h.stateNode.containerInfo;
                        $2e3cfe9ab16332fa$var$Xj = !0;
                        break a;
                    case 4:
                        $2e3cfe9ab16332fa$var$X = h.stateNode.containerInfo;
                        $2e3cfe9ab16332fa$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $2e3cfe9ab16332fa$var$X) throw Error($2e3cfe9ab16332fa$var$p(160));
            $2e3cfe9ab16332fa$var$Zj(f, g, e);
            $2e3cfe9ab16332fa$var$X = null;
            $2e3cfe9ab16332fa$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $2e3cfe9ab16332fa$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$2e3cfe9ab16332fa$var$dk(b, a), b = b.sibling;
}
function $2e3cfe9ab16332fa$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $2e3cfe9ab16332fa$var$ck(b, a);
            $2e3cfe9ab16332fa$var$ek(a);
            if (d & 4) {
                try {
                    $2e3cfe9ab16332fa$var$Pj(3, a, a.return), $2e3cfe9ab16332fa$var$Qj(3, a);
                } catch (t) {
                    $2e3cfe9ab16332fa$var$W(a, a.return, t);
                }
                try {
                    $2e3cfe9ab16332fa$var$Pj(5, a, a.return);
                } catch (t) {
                    $2e3cfe9ab16332fa$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $2e3cfe9ab16332fa$var$ck(b, a);
            $2e3cfe9ab16332fa$var$ek(a);
            d & 512 && null !== c && $2e3cfe9ab16332fa$var$Lj(c, c.return);
            break;
        case 5:
            $2e3cfe9ab16332fa$var$ck(b, a);
            $2e3cfe9ab16332fa$var$ek(a);
            d & 512 && null !== c && $2e3cfe9ab16332fa$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $2e3cfe9ab16332fa$var$ob(e, "");
                } catch (t) {
                    $2e3cfe9ab16332fa$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $2e3cfe9ab16332fa$var$ab(e, f);
                    $2e3cfe9ab16332fa$var$vb(h, g);
                    var l = $2e3cfe9ab16332fa$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $2e3cfe9ab16332fa$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $2e3cfe9ab16332fa$var$nb(e, q) : "children" === m ? $2e3cfe9ab16332fa$var$ob(e, q) : $2e3cfe9ab16332fa$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $2e3cfe9ab16332fa$var$bb(e, f);
                            break;
                        case "textarea":
                            $2e3cfe9ab16332fa$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $2e3cfe9ab16332fa$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $2e3cfe9ab16332fa$var$fb(e, !!f.multiple, f.defaultValue, !0) : $2e3cfe9ab16332fa$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$2e3cfe9ab16332fa$var$Pf] = f;
                } catch (t) {
                    $2e3cfe9ab16332fa$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $2e3cfe9ab16332fa$var$ck(b, a);
            $2e3cfe9ab16332fa$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($2e3cfe9ab16332fa$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $2e3cfe9ab16332fa$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $2e3cfe9ab16332fa$var$ck(b, a);
            $2e3cfe9ab16332fa$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $2e3cfe9ab16332fa$var$bd(b.containerInfo);
            } catch (t) {
                $2e3cfe9ab16332fa$var$W(a, a.return, t);
            }
            break;
        case 4:
            $2e3cfe9ab16332fa$var$ck(b, a);
            $2e3cfe9ab16332fa$var$ek(a);
            break;
        case 13:
            $2e3cfe9ab16332fa$var$ck(b, a);
            $2e3cfe9ab16332fa$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($2e3cfe9ab16332fa$var$fk = $2e3cfe9ab16332fa$var$B()));
            d & 4 && $2e3cfe9ab16332fa$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($2e3cfe9ab16332fa$var$U = (l = $2e3cfe9ab16332fa$var$U) || m, $2e3cfe9ab16332fa$var$ck(b, a), $2e3cfe9ab16332fa$var$U = l) : $2e3cfe9ab16332fa$var$ck(b, a);
            $2e3cfe9ab16332fa$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($2e3cfe9ab16332fa$var$V = a, m = a.child; null !== m;){
                    for(q = $2e3cfe9ab16332fa$var$V = m; null !== $2e3cfe9ab16332fa$var$V;){
                        r = $2e3cfe9ab16332fa$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $2e3cfe9ab16332fa$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $2e3cfe9ab16332fa$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $2e3cfe9ab16332fa$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $2e3cfe9ab16332fa$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $2e3cfe9ab16332fa$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $2e3cfe9ab16332fa$var$V = y) : $2e3cfe9ab16332fa$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $2e3cfe9ab16332fa$var$rb("display", g));
                            } catch (t) {
                                $2e3cfe9ab16332fa$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $2e3cfe9ab16332fa$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $2e3cfe9ab16332fa$var$ck(b, a);
            $2e3cfe9ab16332fa$var$ek(a);
            d & 4 && $2e3cfe9ab16332fa$var$ak(a);
            break;
        case 21:
            break;
        default:
            $2e3cfe9ab16332fa$var$ck(b, a), $2e3cfe9ab16332fa$var$ek(a);
    }
}
function $2e3cfe9ab16332fa$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($2e3cfe9ab16332fa$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($2e3cfe9ab16332fa$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($2e3cfe9ab16332fa$var$ob(e, ""), d.flags &= -33);
                    var f = $2e3cfe9ab16332fa$var$Uj(a);
                    $2e3cfe9ab16332fa$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $2e3cfe9ab16332fa$var$Uj(a);
                    $2e3cfe9ab16332fa$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($2e3cfe9ab16332fa$var$p(161));
            }
        } catch (k) {
            $2e3cfe9ab16332fa$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $2e3cfe9ab16332fa$var$hk(a, b, c) {
    $2e3cfe9ab16332fa$var$V = a;
    $2e3cfe9ab16332fa$var$ik(a, b, c);
}
function $2e3cfe9ab16332fa$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $2e3cfe9ab16332fa$var$V;){
        var e = $2e3cfe9ab16332fa$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $2e3cfe9ab16332fa$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $2e3cfe9ab16332fa$var$U;
                h = $2e3cfe9ab16332fa$var$Jj;
                var l = $2e3cfe9ab16332fa$var$U;
                $2e3cfe9ab16332fa$var$Jj = g;
                if (($2e3cfe9ab16332fa$var$U = k) && !l) for($2e3cfe9ab16332fa$var$V = e; null !== $2e3cfe9ab16332fa$var$V;)g = $2e3cfe9ab16332fa$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $2e3cfe9ab16332fa$var$jk(e) : null !== k ? (k.return = g, $2e3cfe9ab16332fa$var$V = k) : $2e3cfe9ab16332fa$var$jk(e);
                for(; null !== f;)$2e3cfe9ab16332fa$var$V = f, $2e3cfe9ab16332fa$var$ik(f, b, c), f = f.sibling;
                $2e3cfe9ab16332fa$var$V = e;
                $2e3cfe9ab16332fa$var$Jj = h;
                $2e3cfe9ab16332fa$var$U = l;
            }
            $2e3cfe9ab16332fa$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $2e3cfe9ab16332fa$var$V = f) : $2e3cfe9ab16332fa$var$kk(a, b, c);
    }
}
function $2e3cfe9ab16332fa$var$kk(a) {
    for(; null !== $2e3cfe9ab16332fa$var$V;){
        var b = $2e3cfe9ab16332fa$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $2e3cfe9ab16332fa$var$U || $2e3cfe9ab16332fa$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$2e3cfe9ab16332fa$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $2e3cfe9ab16332fa$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $2e3cfe9ab16332fa$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $2e3cfe9ab16332fa$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $2e3cfe9ab16332fa$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($2e3cfe9ab16332fa$var$p(163));
                }
                $2e3cfe9ab16332fa$var$U || b.flags & 512 && $2e3cfe9ab16332fa$var$Rj(b);
            } catch (r) {
                $2e3cfe9ab16332fa$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $2e3cfe9ab16332fa$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $2e3cfe9ab16332fa$var$V = c;
            break;
        }
        $2e3cfe9ab16332fa$var$V = b.return;
    }
}
function $2e3cfe9ab16332fa$var$gk(a) {
    for(; null !== $2e3cfe9ab16332fa$var$V;){
        var b = $2e3cfe9ab16332fa$var$V;
        if (b === a) {
            $2e3cfe9ab16332fa$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $2e3cfe9ab16332fa$var$V = c;
            break;
        }
        $2e3cfe9ab16332fa$var$V = b.return;
    }
}
function $2e3cfe9ab16332fa$var$jk(a) {
    for(; null !== $2e3cfe9ab16332fa$var$V;){
        var b = $2e3cfe9ab16332fa$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $2e3cfe9ab16332fa$var$Qj(4, b);
                    } catch (k) {
                        $2e3cfe9ab16332fa$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $2e3cfe9ab16332fa$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $2e3cfe9ab16332fa$var$Rj(b);
                    } catch (k) {
                        $2e3cfe9ab16332fa$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $2e3cfe9ab16332fa$var$Rj(b);
                    } catch (k) {
                        $2e3cfe9ab16332fa$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $2e3cfe9ab16332fa$var$W(b, b.return, k);
        }
        if (b === a) {
            $2e3cfe9ab16332fa$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $2e3cfe9ab16332fa$var$V = h;
            break;
        }
        $2e3cfe9ab16332fa$var$V = b.return;
    }
}
var $2e3cfe9ab16332fa$var$lk = Math.ceil, $2e3cfe9ab16332fa$var$mk = $2e3cfe9ab16332fa$var$ua.ReactCurrentDispatcher, $2e3cfe9ab16332fa$var$nk = $2e3cfe9ab16332fa$var$ua.ReactCurrentOwner, $2e3cfe9ab16332fa$var$ok = $2e3cfe9ab16332fa$var$ua.ReactCurrentBatchConfig, $2e3cfe9ab16332fa$var$K = 0, $2e3cfe9ab16332fa$var$Q = null, $2e3cfe9ab16332fa$var$Y = null, $2e3cfe9ab16332fa$var$Z = 0, $2e3cfe9ab16332fa$var$fj = 0, $2e3cfe9ab16332fa$var$ej = $2e3cfe9ab16332fa$var$Uf(0), $2e3cfe9ab16332fa$var$T = 0, $2e3cfe9ab16332fa$var$pk = null, $2e3cfe9ab16332fa$var$rh = 0, $2e3cfe9ab16332fa$var$qk = 0, $2e3cfe9ab16332fa$var$rk = 0, $2e3cfe9ab16332fa$var$sk = null, $2e3cfe9ab16332fa$var$tk = null, $2e3cfe9ab16332fa$var$fk = 0, $2e3cfe9ab16332fa$var$Gj = Infinity, $2e3cfe9ab16332fa$var$uk = null, $2e3cfe9ab16332fa$var$Oi = !1, $2e3cfe9ab16332fa$var$Pi = null, $2e3cfe9ab16332fa$var$Ri = null, $2e3cfe9ab16332fa$var$vk = !1, $2e3cfe9ab16332fa$var$wk = null, $2e3cfe9ab16332fa$var$xk = 0, $2e3cfe9ab16332fa$var$yk = 0, $2e3cfe9ab16332fa$var$zk = null, $2e3cfe9ab16332fa$var$Ak = -1, $2e3cfe9ab16332fa$var$Bk = 0;
function $2e3cfe9ab16332fa$var$R() {
    return 0 !== ($2e3cfe9ab16332fa$var$K & 6) ? $2e3cfe9ab16332fa$var$B() : -1 !== $2e3cfe9ab16332fa$var$Ak ? $2e3cfe9ab16332fa$var$Ak : $2e3cfe9ab16332fa$var$Ak = $2e3cfe9ab16332fa$var$B();
}
function $2e3cfe9ab16332fa$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($2e3cfe9ab16332fa$var$K & 2) && 0 !== $2e3cfe9ab16332fa$var$Z) return $2e3cfe9ab16332fa$var$Z & -$2e3cfe9ab16332fa$var$Z;
    if (null !== $2e3cfe9ab16332fa$var$Kg.transition) return 0 === $2e3cfe9ab16332fa$var$Bk && ($2e3cfe9ab16332fa$var$Bk = $2e3cfe9ab16332fa$var$yc()), $2e3cfe9ab16332fa$var$Bk;
    a = $2e3cfe9ab16332fa$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $2e3cfe9ab16332fa$var$jd(a.type);
    return a;
}
function $2e3cfe9ab16332fa$var$gi(a, b, c, d) {
    if (50 < $2e3cfe9ab16332fa$var$yk) throw $2e3cfe9ab16332fa$var$yk = 0, $2e3cfe9ab16332fa$var$zk = null, Error($2e3cfe9ab16332fa$var$p(185));
    $2e3cfe9ab16332fa$var$Ac(a, c, d);
    if (0 === ($2e3cfe9ab16332fa$var$K & 2) || a !== $2e3cfe9ab16332fa$var$Q) a === $2e3cfe9ab16332fa$var$Q && (0 === ($2e3cfe9ab16332fa$var$K & 2) && ($2e3cfe9ab16332fa$var$qk |= c), 4 === $2e3cfe9ab16332fa$var$T && $2e3cfe9ab16332fa$var$Ck(a, $2e3cfe9ab16332fa$var$Z)), $2e3cfe9ab16332fa$var$Dk(a, d), 1 === c && 0 === $2e3cfe9ab16332fa$var$K && 0 === (b.mode & 1) && ($2e3cfe9ab16332fa$var$Gj = $2e3cfe9ab16332fa$var$B() + 500, $2e3cfe9ab16332fa$var$fg && $2e3cfe9ab16332fa$var$jg());
}
function $2e3cfe9ab16332fa$var$Dk(a, b) {
    var c = a.callbackNode;
    $2e3cfe9ab16332fa$var$wc(a, b);
    var d = $2e3cfe9ab16332fa$var$uc(a, a === $2e3cfe9ab16332fa$var$Q ? $2e3cfe9ab16332fa$var$Z : 0);
    if (0 === d) null !== c && $2e3cfe9ab16332fa$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $2e3cfe9ab16332fa$var$bc(c);
        if (1 === b) 0 === a.tag ? $2e3cfe9ab16332fa$var$ig($2e3cfe9ab16332fa$var$Ek.bind(null, a)) : $2e3cfe9ab16332fa$var$hg($2e3cfe9ab16332fa$var$Ek.bind(null, a)), $2e3cfe9ab16332fa$var$Jf(function() {
            0 === ($2e3cfe9ab16332fa$var$K & 6) && $2e3cfe9ab16332fa$var$jg();
        }), c = null;
        else {
            switch($2e3cfe9ab16332fa$var$Dc(d)){
                case 1:
                    c = $2e3cfe9ab16332fa$var$fc;
                    break;
                case 4:
                    c = $2e3cfe9ab16332fa$var$gc;
                    break;
                case 16:
                    c = $2e3cfe9ab16332fa$var$hc;
                    break;
                case 536870912:
                    c = $2e3cfe9ab16332fa$var$jc;
                    break;
                default:
                    c = $2e3cfe9ab16332fa$var$hc;
            }
            c = $2e3cfe9ab16332fa$var$Fk(c, $2e3cfe9ab16332fa$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $2e3cfe9ab16332fa$var$Gk(a, b) {
    $2e3cfe9ab16332fa$var$Ak = -1;
    $2e3cfe9ab16332fa$var$Bk = 0;
    if (0 !== ($2e3cfe9ab16332fa$var$K & 6)) throw Error($2e3cfe9ab16332fa$var$p(327));
    var c = a.callbackNode;
    if ($2e3cfe9ab16332fa$var$Hk() && a.callbackNode !== c) return null;
    var d = $2e3cfe9ab16332fa$var$uc(a, a === $2e3cfe9ab16332fa$var$Q ? $2e3cfe9ab16332fa$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $2e3cfe9ab16332fa$var$Ik(a, d);
    else {
        b = d;
        var e = $2e3cfe9ab16332fa$var$K;
        $2e3cfe9ab16332fa$var$K |= 2;
        var f = $2e3cfe9ab16332fa$var$Jk();
        if ($2e3cfe9ab16332fa$var$Q !== a || $2e3cfe9ab16332fa$var$Z !== b) $2e3cfe9ab16332fa$var$uk = null, $2e3cfe9ab16332fa$var$Gj = $2e3cfe9ab16332fa$var$B() + 500, $2e3cfe9ab16332fa$var$Kk(a, b);
        for(;;)try {
            $2e3cfe9ab16332fa$var$Lk();
            break;
        } catch (h) {
            $2e3cfe9ab16332fa$var$Mk(a, h);
        }
        $2e3cfe9ab16332fa$var$$g();
        $2e3cfe9ab16332fa$var$mk.current = f;
        $2e3cfe9ab16332fa$var$K = e;
        null !== $2e3cfe9ab16332fa$var$Y ? b = 0 : ($2e3cfe9ab16332fa$var$Q = null, $2e3cfe9ab16332fa$var$Z = 0, b = $2e3cfe9ab16332fa$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $2e3cfe9ab16332fa$var$xc(a), 0 !== e && (d = e, b = $2e3cfe9ab16332fa$var$Nk(a, e)));
        if (1 === b) throw c = $2e3cfe9ab16332fa$var$pk, $2e3cfe9ab16332fa$var$Kk(a, 0), $2e3cfe9ab16332fa$var$Ck(a, d), $2e3cfe9ab16332fa$var$Dk(a, $2e3cfe9ab16332fa$var$B()), c;
        if (6 === b) $2e3cfe9ab16332fa$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$2e3cfe9ab16332fa$var$Ok(e) && (b = $2e3cfe9ab16332fa$var$Ik(a, d), 2 === b && (f = $2e3cfe9ab16332fa$var$xc(a), 0 !== f && (d = f, b = $2e3cfe9ab16332fa$var$Nk(a, f))), 1 === b)) throw c = $2e3cfe9ab16332fa$var$pk, $2e3cfe9ab16332fa$var$Kk(a, 0), $2e3cfe9ab16332fa$var$Ck(a, d), $2e3cfe9ab16332fa$var$Dk(a, $2e3cfe9ab16332fa$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($2e3cfe9ab16332fa$var$p(345));
                case 2:
                    $2e3cfe9ab16332fa$var$Pk(a, $2e3cfe9ab16332fa$var$tk, $2e3cfe9ab16332fa$var$uk);
                    break;
                case 3:
                    $2e3cfe9ab16332fa$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $2e3cfe9ab16332fa$var$fk + 500 - $2e3cfe9ab16332fa$var$B(), 10 < b)) {
                        if (0 !== $2e3cfe9ab16332fa$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $2e3cfe9ab16332fa$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $2e3cfe9ab16332fa$var$Ff($2e3cfe9ab16332fa$var$Pk.bind(null, a, $2e3cfe9ab16332fa$var$tk, $2e3cfe9ab16332fa$var$uk), b);
                        break;
                    }
                    $2e3cfe9ab16332fa$var$Pk(a, $2e3cfe9ab16332fa$var$tk, $2e3cfe9ab16332fa$var$uk);
                    break;
                case 4:
                    $2e3cfe9ab16332fa$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $2e3cfe9ab16332fa$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $2e3cfe9ab16332fa$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $2e3cfe9ab16332fa$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $2e3cfe9ab16332fa$var$Ff($2e3cfe9ab16332fa$var$Pk.bind(null, a, $2e3cfe9ab16332fa$var$tk, $2e3cfe9ab16332fa$var$uk), d);
                        break;
                    }
                    $2e3cfe9ab16332fa$var$Pk(a, $2e3cfe9ab16332fa$var$tk, $2e3cfe9ab16332fa$var$uk);
                    break;
                case 5:
                    $2e3cfe9ab16332fa$var$Pk(a, $2e3cfe9ab16332fa$var$tk, $2e3cfe9ab16332fa$var$uk);
                    break;
                default:
                    throw Error($2e3cfe9ab16332fa$var$p(329));
            }
        }
    }
    $2e3cfe9ab16332fa$var$Dk(a, $2e3cfe9ab16332fa$var$B());
    return a.callbackNode === c ? $2e3cfe9ab16332fa$var$Gk.bind(null, a) : null;
}
function $2e3cfe9ab16332fa$var$Nk(a, b) {
    var c = $2e3cfe9ab16332fa$var$sk;
    a.current.memoizedState.isDehydrated && ($2e3cfe9ab16332fa$var$Kk(a, b).flags |= 256);
    a = $2e3cfe9ab16332fa$var$Ik(a, b);
    2 !== a && (b = $2e3cfe9ab16332fa$var$tk, $2e3cfe9ab16332fa$var$tk = c, null !== b && $2e3cfe9ab16332fa$var$Fj(b));
    return a;
}
function $2e3cfe9ab16332fa$var$Fj(a) {
    null === $2e3cfe9ab16332fa$var$tk ? $2e3cfe9ab16332fa$var$tk = a : $2e3cfe9ab16332fa$var$tk.push.apply($2e3cfe9ab16332fa$var$tk, a);
}
function $2e3cfe9ab16332fa$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$2e3cfe9ab16332fa$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $2e3cfe9ab16332fa$var$Ck(a, b) {
    b &= ~$2e3cfe9ab16332fa$var$rk;
    b &= ~$2e3cfe9ab16332fa$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $2e3cfe9ab16332fa$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $2e3cfe9ab16332fa$var$Ek(a) {
    if (0 !== ($2e3cfe9ab16332fa$var$K & 6)) throw Error($2e3cfe9ab16332fa$var$p(327));
    $2e3cfe9ab16332fa$var$Hk();
    var b = $2e3cfe9ab16332fa$var$uc(a, 0);
    if (0 === (b & 1)) return $2e3cfe9ab16332fa$var$Dk(a, $2e3cfe9ab16332fa$var$B()), null;
    var c = $2e3cfe9ab16332fa$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $2e3cfe9ab16332fa$var$xc(a);
        0 !== d && (b = d, c = $2e3cfe9ab16332fa$var$Nk(a, d));
    }
    if (1 === c) throw c = $2e3cfe9ab16332fa$var$pk, $2e3cfe9ab16332fa$var$Kk(a, 0), $2e3cfe9ab16332fa$var$Ck(a, b), $2e3cfe9ab16332fa$var$Dk(a, $2e3cfe9ab16332fa$var$B()), c;
    if (6 === c) throw Error($2e3cfe9ab16332fa$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $2e3cfe9ab16332fa$var$Pk(a, $2e3cfe9ab16332fa$var$tk, $2e3cfe9ab16332fa$var$uk);
    $2e3cfe9ab16332fa$var$Dk(a, $2e3cfe9ab16332fa$var$B());
    return null;
}
function $2e3cfe9ab16332fa$var$Qk(a, b) {
    var c = $2e3cfe9ab16332fa$var$K;
    $2e3cfe9ab16332fa$var$K |= 1;
    try {
        return a(b);
    } finally{
        $2e3cfe9ab16332fa$var$K = c, 0 === $2e3cfe9ab16332fa$var$K && ($2e3cfe9ab16332fa$var$Gj = $2e3cfe9ab16332fa$var$B() + 500, $2e3cfe9ab16332fa$var$fg && $2e3cfe9ab16332fa$var$jg());
    }
}
function $2e3cfe9ab16332fa$var$Rk(a) {
    null !== $2e3cfe9ab16332fa$var$wk && 0 === $2e3cfe9ab16332fa$var$wk.tag && 0 === ($2e3cfe9ab16332fa$var$K & 6) && $2e3cfe9ab16332fa$var$Hk();
    var b = $2e3cfe9ab16332fa$var$K;
    $2e3cfe9ab16332fa$var$K |= 1;
    var c = $2e3cfe9ab16332fa$var$ok.transition, d = $2e3cfe9ab16332fa$var$C;
    try {
        if ($2e3cfe9ab16332fa$var$ok.transition = null, $2e3cfe9ab16332fa$var$C = 1, a) return a();
    } finally{
        $2e3cfe9ab16332fa$var$C = d, $2e3cfe9ab16332fa$var$ok.transition = c, $2e3cfe9ab16332fa$var$K = b, 0 === ($2e3cfe9ab16332fa$var$K & 6) && $2e3cfe9ab16332fa$var$jg();
    }
}
function $2e3cfe9ab16332fa$var$Hj() {
    $2e3cfe9ab16332fa$var$fj = $2e3cfe9ab16332fa$var$ej.current;
    $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$ej);
}
function $2e3cfe9ab16332fa$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $2e3cfe9ab16332fa$var$Gf(c));
    if (null !== $2e3cfe9ab16332fa$var$Y) for(c = $2e3cfe9ab16332fa$var$Y.return; null !== c;){
        var d = c;
        $2e3cfe9ab16332fa$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $2e3cfe9ab16332fa$var$$f();
                break;
            case 3:
                $2e3cfe9ab16332fa$var$zh();
                $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$Wf);
                $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$H);
                $2e3cfe9ab16332fa$var$Eh();
                break;
            case 5:
                $2e3cfe9ab16332fa$var$Bh(d);
                break;
            case 4:
                $2e3cfe9ab16332fa$var$zh();
                break;
            case 13:
                $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$L);
                break;
            case 19:
                $2e3cfe9ab16332fa$var$E($2e3cfe9ab16332fa$var$L);
                break;
            case 10:
                $2e3cfe9ab16332fa$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $2e3cfe9ab16332fa$var$Hj();
        }
        c = c.return;
    }
    $2e3cfe9ab16332fa$var$Q = a;
    $2e3cfe9ab16332fa$var$Y = a = $2e3cfe9ab16332fa$var$Pg(a.current, null);
    $2e3cfe9ab16332fa$var$Z = $2e3cfe9ab16332fa$var$fj = b;
    $2e3cfe9ab16332fa$var$T = 0;
    $2e3cfe9ab16332fa$var$pk = null;
    $2e3cfe9ab16332fa$var$rk = $2e3cfe9ab16332fa$var$qk = $2e3cfe9ab16332fa$var$rh = 0;
    $2e3cfe9ab16332fa$var$tk = $2e3cfe9ab16332fa$var$sk = null;
    if (null !== $2e3cfe9ab16332fa$var$fh) {
        for(b = 0; b < $2e3cfe9ab16332fa$var$fh.length; b++)if (c = $2e3cfe9ab16332fa$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $2e3cfe9ab16332fa$var$fh = null;
    }
    return a;
}
function $2e3cfe9ab16332fa$var$Mk(a, b) {
    do {
        var c = $2e3cfe9ab16332fa$var$Y;
        try {
            $2e3cfe9ab16332fa$var$$g();
            $2e3cfe9ab16332fa$var$Fh.current = $2e3cfe9ab16332fa$var$Rh;
            if ($2e3cfe9ab16332fa$var$Ih) {
                for(var d = $2e3cfe9ab16332fa$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $2e3cfe9ab16332fa$var$Ih = !1;
            }
            $2e3cfe9ab16332fa$var$Hh = 0;
            $2e3cfe9ab16332fa$var$O = $2e3cfe9ab16332fa$var$N = $2e3cfe9ab16332fa$var$M = null;
            $2e3cfe9ab16332fa$var$Jh = !1;
            $2e3cfe9ab16332fa$var$Kh = 0;
            $2e3cfe9ab16332fa$var$nk.current = null;
            if (null === c || null === c.return) {
                $2e3cfe9ab16332fa$var$T = 1;
                $2e3cfe9ab16332fa$var$pk = b;
                $2e3cfe9ab16332fa$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $2e3cfe9ab16332fa$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $2e3cfe9ab16332fa$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $2e3cfe9ab16332fa$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $2e3cfe9ab16332fa$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $2e3cfe9ab16332fa$var$Si(f, l, b);
                            $2e3cfe9ab16332fa$var$tj();
                            break a;
                        }
                        k = Error($2e3cfe9ab16332fa$var$p(426));
                    }
                } else if ($2e3cfe9ab16332fa$var$I && h.mode & 1) {
                    var J = $2e3cfe9ab16332fa$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $2e3cfe9ab16332fa$var$Vi(J, g, h, f, b);
                        $2e3cfe9ab16332fa$var$Jg($2e3cfe9ab16332fa$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $2e3cfe9ab16332fa$var$Ji(k, h);
                4 !== $2e3cfe9ab16332fa$var$T && ($2e3cfe9ab16332fa$var$T = 2);
                null === $2e3cfe9ab16332fa$var$sk ? $2e3cfe9ab16332fa$var$sk = [
                    f
                ] : $2e3cfe9ab16332fa$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $2e3cfe9ab16332fa$var$Ni(f, k, b);
                            $2e3cfe9ab16332fa$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $2e3cfe9ab16332fa$var$Ri || !$2e3cfe9ab16332fa$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $2e3cfe9ab16332fa$var$Qi(f, h, b);
                                $2e3cfe9ab16332fa$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $2e3cfe9ab16332fa$var$Sk(c);
        } catch (na) {
            b = na;
            $2e3cfe9ab16332fa$var$Y === c && null !== c && ($2e3cfe9ab16332fa$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $2e3cfe9ab16332fa$var$Jk() {
    var a = $2e3cfe9ab16332fa$var$mk.current;
    $2e3cfe9ab16332fa$var$mk.current = $2e3cfe9ab16332fa$var$Rh;
    return null === a ? $2e3cfe9ab16332fa$var$Rh : a;
}
function $2e3cfe9ab16332fa$var$tj() {
    if (0 === $2e3cfe9ab16332fa$var$T || 3 === $2e3cfe9ab16332fa$var$T || 2 === $2e3cfe9ab16332fa$var$T) $2e3cfe9ab16332fa$var$T = 4;
    null === $2e3cfe9ab16332fa$var$Q || 0 === ($2e3cfe9ab16332fa$var$rh & 268435455) && 0 === ($2e3cfe9ab16332fa$var$qk & 268435455) || $2e3cfe9ab16332fa$var$Ck($2e3cfe9ab16332fa$var$Q, $2e3cfe9ab16332fa$var$Z);
}
function $2e3cfe9ab16332fa$var$Ik(a, b) {
    var c = $2e3cfe9ab16332fa$var$K;
    $2e3cfe9ab16332fa$var$K |= 2;
    var d = $2e3cfe9ab16332fa$var$Jk();
    if ($2e3cfe9ab16332fa$var$Q !== a || $2e3cfe9ab16332fa$var$Z !== b) $2e3cfe9ab16332fa$var$uk = null, $2e3cfe9ab16332fa$var$Kk(a, b);
    for(;;)try {
        $2e3cfe9ab16332fa$var$Tk();
        break;
    } catch (e) {
        $2e3cfe9ab16332fa$var$Mk(a, e);
    }
    $2e3cfe9ab16332fa$var$$g();
    $2e3cfe9ab16332fa$var$K = c;
    $2e3cfe9ab16332fa$var$mk.current = d;
    if (null !== $2e3cfe9ab16332fa$var$Y) throw Error($2e3cfe9ab16332fa$var$p(261));
    $2e3cfe9ab16332fa$var$Q = null;
    $2e3cfe9ab16332fa$var$Z = 0;
    return $2e3cfe9ab16332fa$var$T;
}
function $2e3cfe9ab16332fa$var$Tk() {
    for(; null !== $2e3cfe9ab16332fa$var$Y;)$2e3cfe9ab16332fa$var$Uk($2e3cfe9ab16332fa$var$Y);
}
function $2e3cfe9ab16332fa$var$Lk() {
    for(; null !== $2e3cfe9ab16332fa$var$Y && !$2e3cfe9ab16332fa$var$cc();)$2e3cfe9ab16332fa$var$Uk($2e3cfe9ab16332fa$var$Y);
}
function $2e3cfe9ab16332fa$var$Uk(a) {
    var b = $2e3cfe9ab16332fa$var$Vk(a.alternate, a, $2e3cfe9ab16332fa$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $2e3cfe9ab16332fa$var$Sk(a) : $2e3cfe9ab16332fa$var$Y = b;
    $2e3cfe9ab16332fa$var$nk.current = null;
}
function $2e3cfe9ab16332fa$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $2e3cfe9ab16332fa$var$Ej(c, b, $2e3cfe9ab16332fa$var$fj), null !== c) {
                $2e3cfe9ab16332fa$var$Y = c;
                return;
            }
        } else {
            c = $2e3cfe9ab16332fa$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $2e3cfe9ab16332fa$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $2e3cfe9ab16332fa$var$T = 6;
                $2e3cfe9ab16332fa$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $2e3cfe9ab16332fa$var$Y = b;
            return;
        }
        $2e3cfe9ab16332fa$var$Y = b = a;
    }while (null !== b);
    0 === $2e3cfe9ab16332fa$var$T && ($2e3cfe9ab16332fa$var$T = 5);
}
function $2e3cfe9ab16332fa$var$Pk(a, b, c) {
    var d = $2e3cfe9ab16332fa$var$C, e = $2e3cfe9ab16332fa$var$ok.transition;
    try {
        $2e3cfe9ab16332fa$var$ok.transition = null, $2e3cfe9ab16332fa$var$C = 1, $2e3cfe9ab16332fa$var$Wk(a, b, c, d);
    } finally{
        $2e3cfe9ab16332fa$var$ok.transition = e, $2e3cfe9ab16332fa$var$C = d;
    }
    return null;
}
function $2e3cfe9ab16332fa$var$Wk(a, b, c, d) {
    do $2e3cfe9ab16332fa$var$Hk();
    while (null !== $2e3cfe9ab16332fa$var$wk);
    if (0 !== ($2e3cfe9ab16332fa$var$K & 6)) throw Error($2e3cfe9ab16332fa$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($2e3cfe9ab16332fa$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $2e3cfe9ab16332fa$var$Bc(a, f);
    a === $2e3cfe9ab16332fa$var$Q && ($2e3cfe9ab16332fa$var$Y = $2e3cfe9ab16332fa$var$Q = null, $2e3cfe9ab16332fa$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $2e3cfe9ab16332fa$var$vk || ($2e3cfe9ab16332fa$var$vk = !0, $2e3cfe9ab16332fa$var$Fk($2e3cfe9ab16332fa$var$hc, function() {
        $2e3cfe9ab16332fa$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $2e3cfe9ab16332fa$var$ok.transition;
        $2e3cfe9ab16332fa$var$ok.transition = null;
        var g = $2e3cfe9ab16332fa$var$C;
        $2e3cfe9ab16332fa$var$C = 1;
        var h = $2e3cfe9ab16332fa$var$K;
        $2e3cfe9ab16332fa$var$K |= 4;
        $2e3cfe9ab16332fa$var$nk.current = null;
        $2e3cfe9ab16332fa$var$Oj(a, c);
        $2e3cfe9ab16332fa$var$dk(c, a);
        $2e3cfe9ab16332fa$var$Oe($2e3cfe9ab16332fa$var$Df);
        $2e3cfe9ab16332fa$var$dd = !!$2e3cfe9ab16332fa$var$Cf;
        $2e3cfe9ab16332fa$var$Df = $2e3cfe9ab16332fa$var$Cf = null;
        a.current = c;
        $2e3cfe9ab16332fa$var$hk(c, a, e);
        $2e3cfe9ab16332fa$var$dc();
        $2e3cfe9ab16332fa$var$K = h;
        $2e3cfe9ab16332fa$var$C = g;
        $2e3cfe9ab16332fa$var$ok.transition = f;
    } else a.current = c;
    $2e3cfe9ab16332fa$var$vk && ($2e3cfe9ab16332fa$var$vk = !1, $2e3cfe9ab16332fa$var$wk = a, $2e3cfe9ab16332fa$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($2e3cfe9ab16332fa$var$Ri = null);
    $2e3cfe9ab16332fa$var$mc(c.stateNode, d);
    $2e3cfe9ab16332fa$var$Dk(a, $2e3cfe9ab16332fa$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($2e3cfe9ab16332fa$var$Oi) throw $2e3cfe9ab16332fa$var$Oi = !1, a = $2e3cfe9ab16332fa$var$Pi, $2e3cfe9ab16332fa$var$Pi = null, a;
    0 !== ($2e3cfe9ab16332fa$var$xk & 1) && 0 !== a.tag && $2e3cfe9ab16332fa$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $2e3cfe9ab16332fa$var$zk ? $2e3cfe9ab16332fa$var$yk++ : ($2e3cfe9ab16332fa$var$yk = 0, $2e3cfe9ab16332fa$var$zk = a) : $2e3cfe9ab16332fa$var$yk = 0;
    $2e3cfe9ab16332fa$var$jg();
    return null;
}
function $2e3cfe9ab16332fa$var$Hk() {
    if (null !== $2e3cfe9ab16332fa$var$wk) {
        var a = $2e3cfe9ab16332fa$var$Dc($2e3cfe9ab16332fa$var$xk), b = $2e3cfe9ab16332fa$var$ok.transition, c = $2e3cfe9ab16332fa$var$C;
        try {
            $2e3cfe9ab16332fa$var$ok.transition = null;
            $2e3cfe9ab16332fa$var$C = 16 > a ? 16 : a;
            if (null === $2e3cfe9ab16332fa$var$wk) var d = !1;
            else {
                a = $2e3cfe9ab16332fa$var$wk;
                $2e3cfe9ab16332fa$var$wk = null;
                $2e3cfe9ab16332fa$var$xk = 0;
                if (0 !== ($2e3cfe9ab16332fa$var$K & 6)) throw Error($2e3cfe9ab16332fa$var$p(331));
                var e = $2e3cfe9ab16332fa$var$K;
                $2e3cfe9ab16332fa$var$K |= 4;
                for($2e3cfe9ab16332fa$var$V = a.current; null !== $2e3cfe9ab16332fa$var$V;){
                    var f = $2e3cfe9ab16332fa$var$V, g = f.child;
                    if (0 !== ($2e3cfe9ab16332fa$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($2e3cfe9ab16332fa$var$V = l; null !== $2e3cfe9ab16332fa$var$V;){
                                    var m = $2e3cfe9ab16332fa$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $2e3cfe9ab16332fa$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $2e3cfe9ab16332fa$var$V = q;
                                    else for(; null !== $2e3cfe9ab16332fa$var$V;){
                                        m = $2e3cfe9ab16332fa$var$V;
                                        var r = m.sibling, y = m.return;
                                        $2e3cfe9ab16332fa$var$Sj(m);
                                        if (m === l) {
                                            $2e3cfe9ab16332fa$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $2e3cfe9ab16332fa$var$V = r;
                                            break;
                                        }
                                        $2e3cfe9ab16332fa$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $2e3cfe9ab16332fa$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $2e3cfe9ab16332fa$var$V = g;
                    else b: for(; null !== $2e3cfe9ab16332fa$var$V;){
                        f = $2e3cfe9ab16332fa$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $2e3cfe9ab16332fa$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $2e3cfe9ab16332fa$var$V = x;
                            break b;
                        }
                        $2e3cfe9ab16332fa$var$V = f.return;
                    }
                }
                var w = a.current;
                for($2e3cfe9ab16332fa$var$V = w; null !== $2e3cfe9ab16332fa$var$V;){
                    g = $2e3cfe9ab16332fa$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $2e3cfe9ab16332fa$var$V = u;
                    else b: for(g = w; null !== $2e3cfe9ab16332fa$var$V;){
                        h = $2e3cfe9ab16332fa$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $2e3cfe9ab16332fa$var$Qj(9, h);
                            }
                        } catch (na) {
                            $2e3cfe9ab16332fa$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $2e3cfe9ab16332fa$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $2e3cfe9ab16332fa$var$V = F;
                            break b;
                        }
                        $2e3cfe9ab16332fa$var$V = h.return;
                    }
                }
                $2e3cfe9ab16332fa$var$K = e;
                $2e3cfe9ab16332fa$var$jg();
                if ($2e3cfe9ab16332fa$var$lc && "function" === typeof $2e3cfe9ab16332fa$var$lc.onPostCommitFiberRoot) try {
                    $2e3cfe9ab16332fa$var$lc.onPostCommitFiberRoot($2e3cfe9ab16332fa$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $2e3cfe9ab16332fa$var$C = c, $2e3cfe9ab16332fa$var$ok.transition = b;
        }
    }
    return !1;
}
function $2e3cfe9ab16332fa$var$Xk(a, b, c) {
    b = $2e3cfe9ab16332fa$var$Ji(c, b);
    b = $2e3cfe9ab16332fa$var$Ni(a, b, 1);
    a = $2e3cfe9ab16332fa$var$nh(a, b, 1);
    b = $2e3cfe9ab16332fa$var$R();
    null !== a && ($2e3cfe9ab16332fa$var$Ac(a, 1, b), $2e3cfe9ab16332fa$var$Dk(a, b));
}
function $2e3cfe9ab16332fa$var$W(a, b, c) {
    if (3 === a.tag) $2e3cfe9ab16332fa$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $2e3cfe9ab16332fa$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $2e3cfe9ab16332fa$var$Ri || !$2e3cfe9ab16332fa$var$Ri.has(d))) {
                a = $2e3cfe9ab16332fa$var$Ji(c, a);
                a = $2e3cfe9ab16332fa$var$Qi(b, a, 1);
                b = $2e3cfe9ab16332fa$var$nh(b, a, 1);
                a = $2e3cfe9ab16332fa$var$R();
                null !== b && ($2e3cfe9ab16332fa$var$Ac(b, 1, a), $2e3cfe9ab16332fa$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $2e3cfe9ab16332fa$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $2e3cfe9ab16332fa$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $2e3cfe9ab16332fa$var$Q === a && ($2e3cfe9ab16332fa$var$Z & c) === c && (4 === $2e3cfe9ab16332fa$var$T || 3 === $2e3cfe9ab16332fa$var$T && ($2e3cfe9ab16332fa$var$Z & 130023424) === $2e3cfe9ab16332fa$var$Z && 500 > $2e3cfe9ab16332fa$var$B() - $2e3cfe9ab16332fa$var$fk ? $2e3cfe9ab16332fa$var$Kk(a, 0) : $2e3cfe9ab16332fa$var$rk |= c);
    $2e3cfe9ab16332fa$var$Dk(a, b);
}
function $2e3cfe9ab16332fa$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $2e3cfe9ab16332fa$var$sc, $2e3cfe9ab16332fa$var$sc <<= 1, 0 === ($2e3cfe9ab16332fa$var$sc & 130023424) && ($2e3cfe9ab16332fa$var$sc = 4194304)));
    var c = $2e3cfe9ab16332fa$var$R();
    a = $2e3cfe9ab16332fa$var$ih(a, b);
    null !== a && ($2e3cfe9ab16332fa$var$Ac(a, b, c), $2e3cfe9ab16332fa$var$Dk(a, c));
}
function $2e3cfe9ab16332fa$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $2e3cfe9ab16332fa$var$Yk(a, c);
}
function $2e3cfe9ab16332fa$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($2e3cfe9ab16332fa$var$p(314));
    }
    null !== d && d.delete(b);
    $2e3cfe9ab16332fa$var$Yk(a, c);
}
var $2e3cfe9ab16332fa$var$Vk;
$2e3cfe9ab16332fa$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $2e3cfe9ab16332fa$var$Wf.current) $2e3cfe9ab16332fa$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $2e3cfe9ab16332fa$var$dh = !1, $2e3cfe9ab16332fa$var$yj(a, b, c);
            $2e3cfe9ab16332fa$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $2e3cfe9ab16332fa$var$dh = !1, $2e3cfe9ab16332fa$var$I && 0 !== (b.flags & 1048576) && $2e3cfe9ab16332fa$var$ug(b, $2e3cfe9ab16332fa$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $2e3cfe9ab16332fa$var$ij(a, b);
            a = b.pendingProps;
            var e = $2e3cfe9ab16332fa$var$Yf(b, $2e3cfe9ab16332fa$var$H.current);
            $2e3cfe9ab16332fa$var$ch(b, c);
            e = $2e3cfe9ab16332fa$var$Nh(null, b, d, a, e, c);
            var f = $2e3cfe9ab16332fa$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $2e3cfe9ab16332fa$var$Zf(d) ? (f = !0, $2e3cfe9ab16332fa$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $2e3cfe9ab16332fa$var$kh(b), e.updater = $2e3cfe9ab16332fa$var$Ei, b.stateNode = e, e._reactInternals = b, $2e3cfe9ab16332fa$var$Ii(b, d, a, c), b = $2e3cfe9ab16332fa$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $2e3cfe9ab16332fa$var$I && f && $2e3cfe9ab16332fa$var$vg(b), $2e3cfe9ab16332fa$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $2e3cfe9ab16332fa$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $2e3cfe9ab16332fa$var$Zk(d);
                a = $2e3cfe9ab16332fa$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $2e3cfe9ab16332fa$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $2e3cfe9ab16332fa$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $2e3cfe9ab16332fa$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $2e3cfe9ab16332fa$var$$i(null, b, d, $2e3cfe9ab16332fa$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($2e3cfe9ab16332fa$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2e3cfe9ab16332fa$var$Ci(d, e), $2e3cfe9ab16332fa$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2e3cfe9ab16332fa$var$Ci(d, e), $2e3cfe9ab16332fa$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $2e3cfe9ab16332fa$var$kj(b);
                if (null === a) throw Error($2e3cfe9ab16332fa$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $2e3cfe9ab16332fa$var$lh(a, b);
                $2e3cfe9ab16332fa$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $2e3cfe9ab16332fa$var$Ji(Error($2e3cfe9ab16332fa$var$p(423)), b);
                        b = $2e3cfe9ab16332fa$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $2e3cfe9ab16332fa$var$Ji(Error($2e3cfe9ab16332fa$var$p(424)), b);
                        b = $2e3cfe9ab16332fa$var$lj(a, b, d, c, e);
                        break a;
                    } else for($2e3cfe9ab16332fa$var$yg = $2e3cfe9ab16332fa$var$Lf(b.stateNode.containerInfo.firstChild), $2e3cfe9ab16332fa$var$xg = b, $2e3cfe9ab16332fa$var$I = !0, $2e3cfe9ab16332fa$var$zg = null, c = $2e3cfe9ab16332fa$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $2e3cfe9ab16332fa$var$Ig();
                    if (d === e) {
                        b = $2e3cfe9ab16332fa$var$Zi(a, b, c);
                        break a;
                    }
                    $2e3cfe9ab16332fa$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $2e3cfe9ab16332fa$var$Ah(b), null === a && $2e3cfe9ab16332fa$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $2e3cfe9ab16332fa$var$Ef(d, e) ? g = null : null !== f && $2e3cfe9ab16332fa$var$Ef(d, f) && (b.flags |= 32), $2e3cfe9ab16332fa$var$gj(a, b), $2e3cfe9ab16332fa$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $2e3cfe9ab16332fa$var$Eg(b), null;
        case 13:
            return $2e3cfe9ab16332fa$var$oj(a, b, c);
        case 4:
            return $2e3cfe9ab16332fa$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $2e3cfe9ab16332fa$var$Ug(b, null, d, c) : $2e3cfe9ab16332fa$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2e3cfe9ab16332fa$var$Ci(d, e), $2e3cfe9ab16332fa$var$Yi(a, b, d, e, c);
        case 7:
            return $2e3cfe9ab16332fa$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $2e3cfe9ab16332fa$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $2e3cfe9ab16332fa$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $2e3cfe9ab16332fa$var$G($2e3cfe9ab16332fa$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($2e3cfe9ab16332fa$var$He(f.value, g)) {
                        if (f.children === e.children && !$2e3cfe9ab16332fa$var$Wf.current) {
                            b = $2e3cfe9ab16332fa$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $2e3cfe9ab16332fa$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $2e3cfe9ab16332fa$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($2e3cfe9ab16332fa$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $2e3cfe9ab16332fa$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $2e3cfe9ab16332fa$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $2e3cfe9ab16332fa$var$ch(b, c), e = $2e3cfe9ab16332fa$var$eh(e), d = d(e), b.flags |= 1, $2e3cfe9ab16332fa$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $2e3cfe9ab16332fa$var$Ci(d, b.pendingProps), e = $2e3cfe9ab16332fa$var$Ci(d.type, e), $2e3cfe9ab16332fa$var$$i(a, b, d, e, c);
        case 15:
            return $2e3cfe9ab16332fa$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2e3cfe9ab16332fa$var$Ci(d, e), $2e3cfe9ab16332fa$var$ij(a, b), b.tag = 1, $2e3cfe9ab16332fa$var$Zf(d) ? (a = !0, $2e3cfe9ab16332fa$var$cg(b)) : a = !1, $2e3cfe9ab16332fa$var$ch(b, c), $2e3cfe9ab16332fa$var$Gi(b, d, e), $2e3cfe9ab16332fa$var$Ii(b, d, e, c), $2e3cfe9ab16332fa$var$jj(null, b, d, !0, a, c);
        case 19:
            return $2e3cfe9ab16332fa$var$xj(a, b, c);
        case 22:
            return $2e3cfe9ab16332fa$var$dj(a, b, c);
    }
    throw Error($2e3cfe9ab16332fa$var$p(156, b.tag));
};
function $2e3cfe9ab16332fa$var$Fk(a, b) {
    return $2e3cfe9ab16332fa$var$ac(a, b);
}
function $2e3cfe9ab16332fa$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $2e3cfe9ab16332fa$var$Bg(a, b, c, d) {
    return new $2e3cfe9ab16332fa$var$$k(a, b, c, d);
}
function $2e3cfe9ab16332fa$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $2e3cfe9ab16332fa$var$Zk(a) {
    if ("function" === typeof a) return $2e3cfe9ab16332fa$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $2e3cfe9ab16332fa$var$Da) return 11;
        if (a === $2e3cfe9ab16332fa$var$Ga) return 14;
    }
    return 2;
}
function $2e3cfe9ab16332fa$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $2e3cfe9ab16332fa$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $2e3cfe9ab16332fa$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $2e3cfe9ab16332fa$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $2e3cfe9ab16332fa$var$ya:
            return $2e3cfe9ab16332fa$var$Tg(c.children, e, f, b);
        case $2e3cfe9ab16332fa$var$za:
            g = 8;
            e |= 8;
            break;
        case $2e3cfe9ab16332fa$var$Aa:
            return a = $2e3cfe9ab16332fa$var$Bg(12, c, b, e | 2), a.elementType = $2e3cfe9ab16332fa$var$Aa, a.lanes = f, a;
        case $2e3cfe9ab16332fa$var$Ea:
            return a = $2e3cfe9ab16332fa$var$Bg(13, c, b, e), a.elementType = $2e3cfe9ab16332fa$var$Ea, a.lanes = f, a;
        case $2e3cfe9ab16332fa$var$Fa:
            return a = $2e3cfe9ab16332fa$var$Bg(19, c, b, e), a.elementType = $2e3cfe9ab16332fa$var$Fa, a.lanes = f, a;
        case $2e3cfe9ab16332fa$var$Ia:
            return $2e3cfe9ab16332fa$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $2e3cfe9ab16332fa$var$Ba:
                    g = 10;
                    break a;
                case $2e3cfe9ab16332fa$var$Ca:
                    g = 9;
                    break a;
                case $2e3cfe9ab16332fa$var$Da:
                    g = 11;
                    break a;
                case $2e3cfe9ab16332fa$var$Ga:
                    g = 14;
                    break a;
                case $2e3cfe9ab16332fa$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($2e3cfe9ab16332fa$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $2e3cfe9ab16332fa$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $2e3cfe9ab16332fa$var$Tg(a, b, c, d) {
    a = $2e3cfe9ab16332fa$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $2e3cfe9ab16332fa$var$pj(a, b, c, d) {
    a = $2e3cfe9ab16332fa$var$Bg(22, a, d, b);
    a.elementType = $2e3cfe9ab16332fa$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $2e3cfe9ab16332fa$var$Qg(a, b, c) {
    a = $2e3cfe9ab16332fa$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $2e3cfe9ab16332fa$var$Sg(a, b, c) {
    b = $2e3cfe9ab16332fa$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $2e3cfe9ab16332fa$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $2e3cfe9ab16332fa$var$zc(0);
    this.expirationTimes = $2e3cfe9ab16332fa$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $2e3cfe9ab16332fa$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $2e3cfe9ab16332fa$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $2e3cfe9ab16332fa$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $2e3cfe9ab16332fa$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $2e3cfe9ab16332fa$var$kh(f);
    return a;
}
function $2e3cfe9ab16332fa$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $2e3cfe9ab16332fa$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $2e3cfe9ab16332fa$var$dl(a) {
    if (!a) return $2e3cfe9ab16332fa$var$Vf;
    a = a._reactInternals;
    a: {
        if ($2e3cfe9ab16332fa$var$Vb(a) !== a || 1 !== a.tag) throw Error($2e3cfe9ab16332fa$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($2e3cfe9ab16332fa$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($2e3cfe9ab16332fa$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($2e3cfe9ab16332fa$var$Zf(c)) return $2e3cfe9ab16332fa$var$bg(a, c, b);
    }
    return b;
}
function $2e3cfe9ab16332fa$var$el(a, b, c, d, e, f, g, h, k) {
    a = $2e3cfe9ab16332fa$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $2e3cfe9ab16332fa$var$dl(null);
    c = a.current;
    d = $2e3cfe9ab16332fa$var$R();
    e = $2e3cfe9ab16332fa$var$yi(c);
    f = $2e3cfe9ab16332fa$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $2e3cfe9ab16332fa$var$nh(c, f, e);
    a.current.lanes = e;
    $2e3cfe9ab16332fa$var$Ac(a, e, d);
    $2e3cfe9ab16332fa$var$Dk(a, d);
    return a;
}
function $2e3cfe9ab16332fa$var$fl(a, b, c, d) {
    var e = b.current, f = $2e3cfe9ab16332fa$var$R(), g = $2e3cfe9ab16332fa$var$yi(e);
    c = $2e3cfe9ab16332fa$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $2e3cfe9ab16332fa$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $2e3cfe9ab16332fa$var$nh(e, b, g);
    null !== a && ($2e3cfe9ab16332fa$var$gi(a, e, g, f), $2e3cfe9ab16332fa$var$oh(a, e, g));
    return g;
}
function $2e3cfe9ab16332fa$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $2e3cfe9ab16332fa$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $2e3cfe9ab16332fa$var$il(a, b) {
    $2e3cfe9ab16332fa$var$hl(a, b);
    (a = a.alternate) && $2e3cfe9ab16332fa$var$hl(a, b);
}
function $2e3cfe9ab16332fa$var$jl() {
    return null;
}
var $2e3cfe9ab16332fa$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $2e3cfe9ab16332fa$var$ll(a) {
    this._internalRoot = a;
}
$2e3cfe9ab16332fa$var$ml.prototype.render = $2e3cfe9ab16332fa$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($2e3cfe9ab16332fa$var$p(409));
    $2e3cfe9ab16332fa$var$fl(a, b, null, null);
};
$2e3cfe9ab16332fa$var$ml.prototype.unmount = $2e3cfe9ab16332fa$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $2e3cfe9ab16332fa$var$Rk(function() {
            $2e3cfe9ab16332fa$var$fl(null, a, null, null);
        });
        b[$2e3cfe9ab16332fa$var$uf] = null;
    }
};
function $2e3cfe9ab16332fa$var$ml(a) {
    this._internalRoot = a;
}
$2e3cfe9ab16332fa$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $2e3cfe9ab16332fa$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $2e3cfe9ab16332fa$var$Qc.length && 0 !== b && b < $2e3cfe9ab16332fa$var$Qc[c].priority; c++);
        $2e3cfe9ab16332fa$var$Qc.splice(c, 0, a);
        0 === c && $2e3cfe9ab16332fa$var$Vc(a);
    }
};
function $2e3cfe9ab16332fa$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $2e3cfe9ab16332fa$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $2e3cfe9ab16332fa$var$pl() {}
function $2e3cfe9ab16332fa$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $2e3cfe9ab16332fa$var$gl(g);
                f.call(a);
            };
        }
        var g = $2e3cfe9ab16332fa$var$el(b, d, a, 0, null, !1, !1, "", $2e3cfe9ab16332fa$var$pl);
        a._reactRootContainer = g;
        a[$2e3cfe9ab16332fa$var$uf] = g.current;
        $2e3cfe9ab16332fa$var$sf(8 === a.nodeType ? a.parentNode : a);
        $2e3cfe9ab16332fa$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $2e3cfe9ab16332fa$var$gl(k);
            h.call(a);
        };
    }
    var k = $2e3cfe9ab16332fa$var$bl(a, 0, !1, null, null, !1, !1, "", $2e3cfe9ab16332fa$var$pl);
    a._reactRootContainer = k;
    a[$2e3cfe9ab16332fa$var$uf] = k.current;
    $2e3cfe9ab16332fa$var$sf(8 === a.nodeType ? a.parentNode : a);
    $2e3cfe9ab16332fa$var$Rk(function() {
        $2e3cfe9ab16332fa$var$fl(b, k, c, d);
    });
    return k;
}
function $2e3cfe9ab16332fa$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $2e3cfe9ab16332fa$var$gl(g);
                h.call(a);
            };
        }
        $2e3cfe9ab16332fa$var$fl(b, g, a, e);
    } else g = $2e3cfe9ab16332fa$var$ql(c, b, a, e, d);
    return $2e3cfe9ab16332fa$var$gl(g);
}
$2e3cfe9ab16332fa$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $2e3cfe9ab16332fa$var$tc(b.pendingLanes);
                0 !== c && ($2e3cfe9ab16332fa$var$Cc(b, c | 1), $2e3cfe9ab16332fa$var$Dk(b, $2e3cfe9ab16332fa$var$B()), 0 === ($2e3cfe9ab16332fa$var$K & 6) && ($2e3cfe9ab16332fa$var$Gj = $2e3cfe9ab16332fa$var$B() + 500, $2e3cfe9ab16332fa$var$jg()));
            }
            break;
        case 13:
            $2e3cfe9ab16332fa$var$Rk(function() {
                var b = $2e3cfe9ab16332fa$var$ih(a, 1);
                if (null !== b) {
                    var c = $2e3cfe9ab16332fa$var$R();
                    $2e3cfe9ab16332fa$var$gi(b, a, 1, c);
                }
            }), $2e3cfe9ab16332fa$var$il(a, 1);
    }
};
$2e3cfe9ab16332fa$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $2e3cfe9ab16332fa$var$ih(a, 134217728);
        if (null !== b) {
            var c = $2e3cfe9ab16332fa$var$R();
            $2e3cfe9ab16332fa$var$gi(b, a, 134217728, c);
        }
        $2e3cfe9ab16332fa$var$il(a, 134217728);
    }
};
$2e3cfe9ab16332fa$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $2e3cfe9ab16332fa$var$yi(a), c = $2e3cfe9ab16332fa$var$ih(a, b);
        if (null !== c) {
            var d = $2e3cfe9ab16332fa$var$R();
            $2e3cfe9ab16332fa$var$gi(c, a, b, d);
        }
        $2e3cfe9ab16332fa$var$il(a, b);
    }
};
$2e3cfe9ab16332fa$var$Hc = function() {
    return $2e3cfe9ab16332fa$var$C;
};
$2e3cfe9ab16332fa$var$Ic = function(a, b) {
    var c = $2e3cfe9ab16332fa$var$C;
    try {
        return $2e3cfe9ab16332fa$var$C = a, b();
    } finally{
        $2e3cfe9ab16332fa$var$C = c;
    }
};
$2e3cfe9ab16332fa$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $2e3cfe9ab16332fa$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $2e3cfe9ab16332fa$var$Db(d);
                        if (!e) throw Error($2e3cfe9ab16332fa$var$p(90));
                        $2e3cfe9ab16332fa$var$Wa(d);
                        $2e3cfe9ab16332fa$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $2e3cfe9ab16332fa$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $2e3cfe9ab16332fa$var$fb(a, !!c.multiple, b, !1);
    }
};
$2e3cfe9ab16332fa$var$Gb = $2e3cfe9ab16332fa$var$Qk;
$2e3cfe9ab16332fa$var$Hb = $2e3cfe9ab16332fa$var$Rk;
var $2e3cfe9ab16332fa$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $2e3cfe9ab16332fa$var$Cb,
        $2e3cfe9ab16332fa$var$ue,
        $2e3cfe9ab16332fa$var$Db,
        $2e3cfe9ab16332fa$var$Eb,
        $2e3cfe9ab16332fa$var$Fb,
        $2e3cfe9ab16332fa$var$Qk
    ]
}, $2e3cfe9ab16332fa$var$tl = {
    findFiberByHostInstance: $2e3cfe9ab16332fa$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $2e3cfe9ab16332fa$var$ul = {
    bundleType: $2e3cfe9ab16332fa$var$tl.bundleType,
    version: $2e3cfe9ab16332fa$var$tl.version,
    rendererPackageName: $2e3cfe9ab16332fa$var$tl.rendererPackageName,
    rendererConfig: $2e3cfe9ab16332fa$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $2e3cfe9ab16332fa$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $2e3cfe9ab16332fa$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $2e3cfe9ab16332fa$var$tl.findFiberByHostInstance || $2e3cfe9ab16332fa$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $2e3cfe9ab16332fa$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$2e3cfe9ab16332fa$var$vl.isDisabled && $2e3cfe9ab16332fa$var$vl.supportsFiber) try {
        $2e3cfe9ab16332fa$var$kc = $2e3cfe9ab16332fa$var$vl.inject($2e3cfe9ab16332fa$var$ul), $2e3cfe9ab16332fa$var$lc = $2e3cfe9ab16332fa$var$vl;
    } catch (a) {}
}
$2e3cfe9ab16332fa$export$ae55be85d98224ed = $2e3cfe9ab16332fa$var$sl;
$2e3cfe9ab16332fa$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$2e3cfe9ab16332fa$var$nl(b)) throw Error($2e3cfe9ab16332fa$var$p(200));
    return $2e3cfe9ab16332fa$var$cl(a, b, null, c);
};
$2e3cfe9ab16332fa$export$882461b6382ed46c = function(a, b) {
    if (!$2e3cfe9ab16332fa$var$nl(a)) throw Error($2e3cfe9ab16332fa$var$p(299));
    var c = !1, d = "", e = $2e3cfe9ab16332fa$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $2e3cfe9ab16332fa$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$2e3cfe9ab16332fa$var$uf] = b.current;
    $2e3cfe9ab16332fa$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $2e3cfe9ab16332fa$var$ll(b);
};
$2e3cfe9ab16332fa$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($2e3cfe9ab16332fa$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($2e3cfe9ab16332fa$var$p(268, a));
    }
    a = $2e3cfe9ab16332fa$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$2e3cfe9ab16332fa$export$cd75ccfd720a3cd4 = function(a) {
    return $2e3cfe9ab16332fa$var$Rk(a);
};
$2e3cfe9ab16332fa$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$2e3cfe9ab16332fa$var$ol(b)) throw Error($2e3cfe9ab16332fa$var$p(200));
    return $2e3cfe9ab16332fa$var$rl(null, a, b, !0, c);
};
$2e3cfe9ab16332fa$export$757ceba2d55c277e = function(a, b, c) {
    if (!$2e3cfe9ab16332fa$var$nl(a)) throw Error($2e3cfe9ab16332fa$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $2e3cfe9ab16332fa$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $2e3cfe9ab16332fa$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$2e3cfe9ab16332fa$var$uf] = b.current;
    $2e3cfe9ab16332fa$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $2e3cfe9ab16332fa$var$ml(b);
};
$2e3cfe9ab16332fa$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$2e3cfe9ab16332fa$var$ol(b)) throw Error($2e3cfe9ab16332fa$var$p(200));
    return $2e3cfe9ab16332fa$var$rl(null, a, b, !1, c);
};
$2e3cfe9ab16332fa$export$502457920280e6be = function(a) {
    if (!$2e3cfe9ab16332fa$var$ol(a)) throw Error($2e3cfe9ab16332fa$var$p(40));
    return a._reactRootContainer ? ($2e3cfe9ab16332fa$var$Rk(function() {
        $2e3cfe9ab16332fa$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$2e3cfe9ab16332fa$var$uf] = null;
        });
    }), !0) : !1;
};
$2e3cfe9ab16332fa$export$c78a37762a8d58e1 = $2e3cfe9ab16332fa$var$Qk;
$2e3cfe9ab16332fa$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$2e3cfe9ab16332fa$var$ol(c)) throw Error($2e3cfe9ab16332fa$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($2e3cfe9ab16332fa$var$p(38));
    return $2e3cfe9ab16332fa$var$rl(a, b, c, !1, d);
};
$2e3cfe9ab16332fa$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("8NIXl", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lP0RR"));

});
parcelRegister("lP0RR", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $fe2f08b00b50cda6$export$c4744153514ff05d; }, function (v) { return $fe2f08b00b50cda6$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $fe2f08b00b50cda6$export$3e506c1ccc9cc1a7; }, function (v) { return $fe2f08b00b50cda6$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $fe2f08b00b50cda6$export$e26fe2ed2fa76875; }, function (v) { return $fe2f08b00b50cda6$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $fe2f08b00b50cda6$export$502329bbf4b505b1; }, function (v) { return $fe2f08b00b50cda6$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $fe2f08b00b50cda6$export$6e3807111c4874c4; }, function (v) { return $fe2f08b00b50cda6$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $fe2f08b00b50cda6$export$c27134553091fb3a; }, function (v) { return $fe2f08b00b50cda6$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $fe2f08b00b50cda6$export$33ee1acdc04fd2a2; }, function (v) { return $fe2f08b00b50cda6$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $fe2f08b00b50cda6$export$b00a404bbd5edef2; }, function (v) { return $fe2f08b00b50cda6$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $fe2f08b00b50cda6$export$8352ce38b91d0c62; }, function (v) { return $fe2f08b00b50cda6$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $fe2f08b00b50cda6$export$d66a1c1c77bd778b; }, function (v) { return $fe2f08b00b50cda6$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $fe2f08b00b50cda6$export$d3dfb8e4810cb555; }, function (v) { return $fe2f08b00b50cda6$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $fe2f08b00b50cda6$export$839f9183b0465a69; }, function (v) { return $fe2f08b00b50cda6$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $fe2f08b00b50cda6$export$72fdf0e06517287b; }, function (v) { return $fe2f08b00b50cda6$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $fe2f08b00b50cda6$export$4b844e58a3e414b4; }, function (v) { return $fe2f08b00b50cda6$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $fe2f08b00b50cda6$export$816d2913ae6b83b1; }, function (v) { return $fe2f08b00b50cda6$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $fe2f08b00b50cda6$export$61bcfe829111a1d0; }, function (v) { return $fe2f08b00b50cda6$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $fe2f08b00b50cda6$export$7ee8c9beb337bc3f; }, function (v) { return $fe2f08b00b50cda6$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $fe2f08b00b50cda6$export$b5836b71941fa3ed; }, function (v) { return $fe2f08b00b50cda6$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $fe2f08b00b50cda6$export$cf845f2c119da08a; }, function (v) { return $fe2f08b00b50cda6$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fe2f08b00b50cda6$export$c4744153514ff05d;
var $fe2f08b00b50cda6$export$3e506c1ccc9cc1a7;
var $fe2f08b00b50cda6$export$e26fe2ed2fa76875;
var $fe2f08b00b50cda6$export$502329bbf4b505b1;
var $fe2f08b00b50cda6$export$6e3807111c4874c4;
var $fe2f08b00b50cda6$export$c27134553091fb3a;
var $fe2f08b00b50cda6$export$33ee1acdc04fd2a2;
var $fe2f08b00b50cda6$export$b00a404bbd5edef2;
var $fe2f08b00b50cda6$export$8352ce38b91d0c62;
var $fe2f08b00b50cda6$export$d66a1c1c77bd778b;
var $fe2f08b00b50cda6$export$d3dfb8e4810cb555;
var $fe2f08b00b50cda6$export$839f9183b0465a69;
var $fe2f08b00b50cda6$export$72fdf0e06517287b;
var $fe2f08b00b50cda6$export$4b844e58a3e414b4;
var $fe2f08b00b50cda6$export$816d2913ae6b83b1;
var $fe2f08b00b50cda6$export$61bcfe829111a1d0;
var $fe2f08b00b50cda6$export$7ee8c9beb337bc3f;
var $fe2f08b00b50cda6$export$b5836b71941fa3ed;
var $fe2f08b00b50cda6$export$cf845f2c119da08a;
'use strict';
function $fe2f08b00b50cda6$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $fe2f08b00b50cda6$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $fe2f08b00b50cda6$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $fe2f08b00b50cda6$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $fe2f08b00b50cda6$var$g(C, c)) n < e && 0 > $fe2f08b00b50cda6$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $fe2f08b00b50cda6$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $fe2f08b00b50cda6$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $fe2f08b00b50cda6$var$l = performance;
    $fe2f08b00b50cda6$export$c4744153514ff05d = function() {
        return $fe2f08b00b50cda6$var$l.now();
    };
} else {
    var $fe2f08b00b50cda6$var$p = Date, $fe2f08b00b50cda6$var$q = $fe2f08b00b50cda6$var$p.now();
    $fe2f08b00b50cda6$export$c4744153514ff05d = function() {
        return $fe2f08b00b50cda6$var$p.now() - $fe2f08b00b50cda6$var$q;
    };
}
var $fe2f08b00b50cda6$var$r = [], $fe2f08b00b50cda6$var$t = [], $fe2f08b00b50cda6$var$u = 1, $fe2f08b00b50cda6$var$v = null, $fe2f08b00b50cda6$var$y = 3, $fe2f08b00b50cda6$var$z = !1, $fe2f08b00b50cda6$var$A = !1, $fe2f08b00b50cda6$var$B = !1, $fe2f08b00b50cda6$var$D = "function" === typeof setTimeout ? setTimeout : null, $fe2f08b00b50cda6$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $fe2f08b00b50cda6$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $fe2f08b00b50cda6$var$G(a) {
    for(var b = $fe2f08b00b50cda6$var$h($fe2f08b00b50cda6$var$t); null !== b;){
        if (null === b.callback) $fe2f08b00b50cda6$var$k($fe2f08b00b50cda6$var$t);
        else if (b.startTime <= a) $fe2f08b00b50cda6$var$k($fe2f08b00b50cda6$var$t), b.sortIndex = b.expirationTime, $fe2f08b00b50cda6$var$f($fe2f08b00b50cda6$var$r, b);
        else break;
        b = $fe2f08b00b50cda6$var$h($fe2f08b00b50cda6$var$t);
    }
}
function $fe2f08b00b50cda6$var$H(a) {
    $fe2f08b00b50cda6$var$B = !1;
    $fe2f08b00b50cda6$var$G(a);
    if (!$fe2f08b00b50cda6$var$A) {
        if (null !== $fe2f08b00b50cda6$var$h($fe2f08b00b50cda6$var$r)) $fe2f08b00b50cda6$var$A = !0, $fe2f08b00b50cda6$var$I($fe2f08b00b50cda6$var$J);
        else {
            var b = $fe2f08b00b50cda6$var$h($fe2f08b00b50cda6$var$t);
            null !== b && $fe2f08b00b50cda6$var$K($fe2f08b00b50cda6$var$H, b.startTime - a);
        }
    }
}
function $fe2f08b00b50cda6$var$J(a, b) {
    $fe2f08b00b50cda6$var$A = !1;
    $fe2f08b00b50cda6$var$B && ($fe2f08b00b50cda6$var$B = !1, $fe2f08b00b50cda6$var$E($fe2f08b00b50cda6$var$L), $fe2f08b00b50cda6$var$L = -1);
    $fe2f08b00b50cda6$var$z = !0;
    var c = $fe2f08b00b50cda6$var$y;
    try {
        $fe2f08b00b50cda6$var$G(b);
        for($fe2f08b00b50cda6$var$v = $fe2f08b00b50cda6$var$h($fe2f08b00b50cda6$var$r); null !== $fe2f08b00b50cda6$var$v && (!($fe2f08b00b50cda6$var$v.expirationTime > b) || a && !$fe2f08b00b50cda6$var$M());){
            var d = $fe2f08b00b50cda6$var$v.callback;
            if ("function" === typeof d) {
                $fe2f08b00b50cda6$var$v.callback = null;
                $fe2f08b00b50cda6$var$y = $fe2f08b00b50cda6$var$v.priorityLevel;
                var e = d($fe2f08b00b50cda6$var$v.expirationTime <= b);
                b = $fe2f08b00b50cda6$export$c4744153514ff05d();
                "function" === typeof e ? $fe2f08b00b50cda6$var$v.callback = e : $fe2f08b00b50cda6$var$v === $fe2f08b00b50cda6$var$h($fe2f08b00b50cda6$var$r) && $fe2f08b00b50cda6$var$k($fe2f08b00b50cda6$var$r);
                $fe2f08b00b50cda6$var$G(b);
            } else $fe2f08b00b50cda6$var$k($fe2f08b00b50cda6$var$r);
            $fe2f08b00b50cda6$var$v = $fe2f08b00b50cda6$var$h($fe2f08b00b50cda6$var$r);
        }
        if (null !== $fe2f08b00b50cda6$var$v) var w = !0;
        else {
            var m = $fe2f08b00b50cda6$var$h($fe2f08b00b50cda6$var$t);
            null !== m && $fe2f08b00b50cda6$var$K($fe2f08b00b50cda6$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $fe2f08b00b50cda6$var$v = null, $fe2f08b00b50cda6$var$y = c, $fe2f08b00b50cda6$var$z = !1;
    }
}
var $fe2f08b00b50cda6$var$N = !1, $fe2f08b00b50cda6$var$O = null, $fe2f08b00b50cda6$var$L = -1, $fe2f08b00b50cda6$var$P = 5, $fe2f08b00b50cda6$var$Q = -1;
function $fe2f08b00b50cda6$var$M() {
    return $fe2f08b00b50cda6$export$c4744153514ff05d() - $fe2f08b00b50cda6$var$Q < $fe2f08b00b50cda6$var$P ? !1 : !0;
}
function $fe2f08b00b50cda6$var$R() {
    if (null !== $fe2f08b00b50cda6$var$O) {
        var a = $fe2f08b00b50cda6$export$c4744153514ff05d();
        $fe2f08b00b50cda6$var$Q = a;
        var b = !0;
        try {
            b = $fe2f08b00b50cda6$var$O(!0, a);
        } finally{
            b ? $fe2f08b00b50cda6$var$S() : ($fe2f08b00b50cda6$var$N = !1, $fe2f08b00b50cda6$var$O = null);
        }
    } else $fe2f08b00b50cda6$var$N = !1;
}
var $fe2f08b00b50cda6$var$S;
if ("function" === typeof $fe2f08b00b50cda6$var$F) $fe2f08b00b50cda6$var$S = function() {
    $fe2f08b00b50cda6$var$F($fe2f08b00b50cda6$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $fe2f08b00b50cda6$var$T = new MessageChannel, $fe2f08b00b50cda6$var$U = $fe2f08b00b50cda6$var$T.port2;
    $fe2f08b00b50cda6$var$T.port1.onmessage = $fe2f08b00b50cda6$var$R;
    $fe2f08b00b50cda6$var$S = function() {
        $fe2f08b00b50cda6$var$U.postMessage(null);
    };
} else $fe2f08b00b50cda6$var$S = function() {
    $fe2f08b00b50cda6$var$D($fe2f08b00b50cda6$var$R, 0);
};
function $fe2f08b00b50cda6$var$I(a) {
    $fe2f08b00b50cda6$var$O = a;
    $fe2f08b00b50cda6$var$N || ($fe2f08b00b50cda6$var$N = !0, $fe2f08b00b50cda6$var$S());
}
function $fe2f08b00b50cda6$var$K(a, b) {
    $fe2f08b00b50cda6$var$L = $fe2f08b00b50cda6$var$D(function() {
        a($fe2f08b00b50cda6$export$c4744153514ff05d());
    }, b);
}
$fe2f08b00b50cda6$export$3e506c1ccc9cc1a7 = 5;
$fe2f08b00b50cda6$export$e26fe2ed2fa76875 = 1;
$fe2f08b00b50cda6$export$502329bbf4b505b1 = 4;
$fe2f08b00b50cda6$export$6e3807111c4874c4 = 3;
$fe2f08b00b50cda6$export$c27134553091fb3a = null;
$fe2f08b00b50cda6$export$33ee1acdc04fd2a2 = 2;
$fe2f08b00b50cda6$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$fe2f08b00b50cda6$export$8352ce38b91d0c62 = function() {
    $fe2f08b00b50cda6$var$A || $fe2f08b00b50cda6$var$z || ($fe2f08b00b50cda6$var$A = !0, $fe2f08b00b50cda6$var$I($fe2f08b00b50cda6$var$J));
};
$fe2f08b00b50cda6$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $fe2f08b00b50cda6$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$fe2f08b00b50cda6$export$d3dfb8e4810cb555 = function() {
    return $fe2f08b00b50cda6$var$y;
};
$fe2f08b00b50cda6$export$839f9183b0465a69 = function() {
    return $fe2f08b00b50cda6$var$h($fe2f08b00b50cda6$var$r);
};
$fe2f08b00b50cda6$export$72fdf0e06517287b = function(a) {
    switch($fe2f08b00b50cda6$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $fe2f08b00b50cda6$var$y;
    }
    var c = $fe2f08b00b50cda6$var$y;
    $fe2f08b00b50cda6$var$y = b;
    try {
        return a();
    } finally{
        $fe2f08b00b50cda6$var$y = c;
    }
};
$fe2f08b00b50cda6$export$4b844e58a3e414b4 = function() {};
$fe2f08b00b50cda6$export$816d2913ae6b83b1 = function() {};
$fe2f08b00b50cda6$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $fe2f08b00b50cda6$var$y;
    $fe2f08b00b50cda6$var$y = a;
    try {
        return b();
    } finally{
        $fe2f08b00b50cda6$var$y = c;
    }
};
$fe2f08b00b50cda6$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $fe2f08b00b50cda6$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $fe2f08b00b50cda6$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $fe2f08b00b50cda6$var$f($fe2f08b00b50cda6$var$t, a), null === $fe2f08b00b50cda6$var$h($fe2f08b00b50cda6$var$r) && a === $fe2f08b00b50cda6$var$h($fe2f08b00b50cda6$var$t) && ($fe2f08b00b50cda6$var$B ? ($fe2f08b00b50cda6$var$E($fe2f08b00b50cda6$var$L), $fe2f08b00b50cda6$var$L = -1) : $fe2f08b00b50cda6$var$B = !0, $fe2f08b00b50cda6$var$K($fe2f08b00b50cda6$var$H, c - d))) : (a.sortIndex = e, $fe2f08b00b50cda6$var$f($fe2f08b00b50cda6$var$r, a), $fe2f08b00b50cda6$var$A || $fe2f08b00b50cda6$var$z || ($fe2f08b00b50cda6$var$A = !0, $fe2f08b00b50cda6$var$I($fe2f08b00b50cda6$var$J)));
    return a;
};
$fe2f08b00b50cda6$export$b5836b71941fa3ed = $fe2f08b00b50cda6$var$M;
$fe2f08b00b50cda6$export$cf845f2c119da08a = function(a) {
    var b = $fe2f08b00b50cda6$var$y;
    return function() {
        var c = $fe2f08b00b50cda6$var$y;
        $fe2f08b00b50cda6$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $fe2f08b00b50cda6$var$y = c;
        }
    };
};

});



parcelRegister("89oZb", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $5ef28baa6a790880$export$bf730a2d8bf68b42; }, function (v) { return $5ef28baa6a790880$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef28baa6a790880$export$bf730a2d8bf68b42;
"use strict";

var $kyXgS = parcelRequire("kyXgS");

var $czH3s = parcelRequire("czH3s");
function $5ef28baa6a790880$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $5ef28baa6a790880$var$objectIs = "function" === typeof Object.is ? Object.is : $5ef28baa6a790880$var$is, $5ef28baa6a790880$var$useSyncExternalStore = $czH3s.useSyncExternalStore, $5ef28baa6a790880$var$useRef = $kyXgS.useRef, $5ef28baa6a790880$var$useEffect = $kyXgS.useEffect, $5ef28baa6a790880$var$useMemo = $kyXgS.useMemo, $5ef28baa6a790880$var$useDebugValue = $kyXgS.useDebugValue;
$5ef28baa6a790880$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $5ef28baa6a790880$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $5ef28baa6a790880$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($5ef28baa6a790880$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $5ef28baa6a790880$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $5ef28baa6a790880$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $5ef28baa6a790880$var$useDebugValue(value);
    return value;
};

});
parcelRegister("czH3s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5074Q"));

});
parcelRegister("5074Q", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $3a42712ffc3cebd9$export$306c0aa65ff9ec16; }, function (v) { return $3a42712ffc3cebd9$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3a42712ffc3cebd9$export$306c0aa65ff9ec16;
"use strict";

var $kyXgS = parcelRequire("kyXgS");
function $3a42712ffc3cebd9$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $3a42712ffc3cebd9$var$objectIs = "function" === typeof Object.is ? Object.is : $3a42712ffc3cebd9$var$is, $3a42712ffc3cebd9$var$useState = $kyXgS.useState, $3a42712ffc3cebd9$var$useEffect = $kyXgS.useEffect, $3a42712ffc3cebd9$var$useLayoutEffect = $kyXgS.useLayoutEffect, $3a42712ffc3cebd9$var$useDebugValue = $kyXgS.useDebugValue;
function $3a42712ffc3cebd9$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $3a42712ffc3cebd9$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $3a42712ffc3cebd9$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $3a42712ffc3cebd9$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $3a42712ffc3cebd9$var$useEffect(function() {
        $3a42712ffc3cebd9$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $3a42712ffc3cebd9$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $3a42712ffc3cebd9$var$useDebugValue(value);
    return value;
}
function $3a42712ffc3cebd9$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$3a42712ffc3cebd9$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $3a42712ffc3cebd9$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $3a42712ffc3cebd9$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $3a42712ffc3cebd9$var$useSyncExternalStore$1 : $3a42712ffc3cebd9$var$useSyncExternalStore$2;
$3a42712ffc3cebd9$export$306c0aa65ff9ec16 = void 0 !== $kyXgS.useSyncExternalStore ? $kyXgS.useSyncExternalStore : $3a42712ffc3cebd9$var$shim;

});



parcelRegister("i6beJ", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $95MRT = parcelRequire("95MRT");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $95MRT.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $95MRT.default)(Rgb, rgb, (0, $95MRT.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $95MRT.default)(Hsl, hsl, (0, $95MRT.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("95MRT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69ea7ce69b76d3f4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $69ea7ce69b76d3f4$export$8b58be045bf06082; });
function $69ea7ce69b76d3f4$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $69ea7ce69b76d3f4$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


var $09d47804029b6d46$exports = {};
'use strict';

$09d47804029b6d46$exports = (parcelRequire("c5a1G"));


parcelRequire("kyXgS");
var $680d651e8a11cc7a$export$882461b6382ed46c;
var $680d651e8a11cc7a$export$757ceba2d55c277e;
'use strict';
var $58bbac072954e0a3$exports = {};
'use strict';
function $58bbac072954e0a3$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($58bbac072954e0a3$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$58bbac072954e0a3$var$checkDCE();

$58bbac072954e0a3$exports = (parcelRequire("3Y7La"));


var $680d651e8a11cc7a$var$i;
$680d651e8a11cc7a$export$882461b6382ed46c = $58bbac072954e0a3$exports.createRoot;
$680d651e8a11cc7a$export$757ceba2d55c277e = $58bbac072954e0a3$exports.hydrateRoot;




parcelRequire("kyXgS");

var $kyXgS = parcelRequire("kyXgS");
function $611d9e3cbd014da4$export$2e2bcd8739ae039(names) {
    if (typeof names === "string" || typeof names === "number") return "" + names;
    let out = "";
    if (Array.isArray(names)) {
        for(let i = 0, tmp; i < names.length; i++)if ((tmp = $611d9e3cbd014da4$export$2e2bcd8739ae039(names[i])) !== "") out += (out && " ") + tmp;
    } else {
        for(let k in names)if (names[k]) out += (out && " ") + k;
    }
    return out;
}


var $cc7fb5eb30111903$export$c883e057baa24e24;
var $cc7fb5eb30111903$export$2951cba41945c0c8;
'use strict';

var $kyXgS = parcelRequire("kyXgS");
var $50f9bf37ab03c23b$exports = {};
'use strict';

$50f9bf37ab03c23b$exports = (parcelRequire("89oZb"));


var $1328c18d8fb4d6c6$exports = {};
'use strict';
var $1328c18d8fb4d6c6$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $1328c18d8fb4d6c6$var$createStore = function createStore(createState) {
    return createState ? $1328c18d8fb4d6c6$var$createStoreImpl(createState) : $1328c18d8fb4d6c6$var$createStoreImpl;
};
var $1328c18d8fb4d6c6$var$vanilla = function(createState) {
    return $1328c18d8fb4d6c6$var$createStore(createState);
};
$1328c18d8fb4d6c6$exports.createStore = $1328c18d8fb4d6c6$var$createStore;
$1328c18d8fb4d6c6$exports.default = $1328c18d8fb4d6c6$var$vanilla;
$1328c18d8fb4d6c6$exports = $1328c18d8fb4d6c6$var$vanilla;
$1328c18d8fb4d6c6$exports.createStore = $1328c18d8fb4d6c6$var$createStore;
$1328c18d8fb4d6c6$exports.default = $1328c18d8fb4d6c6$exports;


var $cc7fb5eb30111903$var$useDebugValue = $kyXgS.useDebugValue;
var $cc7fb5eb30111903$var$useSyncExternalStoreWithSelector = $50f9bf37ab03c23b$exports.useSyncExternalStoreWithSelector;
var $cc7fb5eb30111903$var$identity = function identity(arg) {
    return arg;
};
function $cc7fb5eb30111903$var$useStoreWithEqualityFn(api, selector, equalityFn) {
    if (selector === void 0) selector = $cc7fb5eb30111903$var$identity;
    var slice = $cc7fb5eb30111903$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $cc7fb5eb30111903$var$useDebugValue(slice);
    return slice;
}
var $cc7fb5eb30111903$var$createWithEqualityFnImpl = function createWithEqualityFnImpl(createState, defaultEqualityFn) {
    var api = $1328c18d8fb4d6c6$exports.createStore(createState);
    var useBoundStoreWithEqualityFn = function useBoundStoreWithEqualityFn(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = defaultEqualityFn;
        return $cc7fb5eb30111903$var$useStoreWithEqualityFn(api, selector, equalityFn);
    };
    Object.assign(useBoundStoreWithEqualityFn, api);
    return useBoundStoreWithEqualityFn;
};
var $cc7fb5eb30111903$var$createWithEqualityFn = function createWithEqualityFn(createState, defaultEqualityFn) {
    return createState ? $cc7fb5eb30111903$var$createWithEqualityFnImpl(createState, defaultEqualityFn) : $cc7fb5eb30111903$var$createWithEqualityFnImpl;
};
$cc7fb5eb30111903$export$c883e057baa24e24 = $cc7fb5eb30111903$var$createWithEqualityFn;
$cc7fb5eb30111903$export$2951cba41945c0c8 = $cc7fb5eb30111903$var$useStoreWithEqualityFn;


var $5b95e8cf664b5dbd$exports = {};
'use strict';
function $5b95e8cf664b5dbd$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5b95e8cf664b5dbd$var$_createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = $5b95e8cf664b5dbd$var$_unsupportedIterableToArray(r)) || e) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5b95e8cf664b5dbd$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5b95e8cf664b5dbd$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5b95e8cf664b5dbd$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5b95e8cf664b5dbd$var$shallow$1(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for(var _iterator = $5b95e8cf664b5dbd$var$_createForOfIteratorHelperLoose(objA), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (!Object.is(value, objB.get(key))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for(var _iterator2 = $5b95e8cf664b5dbd$var$_createForOfIteratorHelperLoose(objA), _step2; !(_step2 = _iterator2()).done;){
            var _value = _step2.value;
            if (!objB.has(_value)) return false;
        }
        return true;
    }
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var _i = 0, _keysA = keysA; _i < _keysA.length; _i++){
        var keyA = _keysA[_i];
        if (!Object.prototype.hasOwnProperty.call(objB, keyA) || !Object.is(objA[keyA], objB[keyA])) return false;
    }
    return true;
}
var $5b95e8cf664b5dbd$var$shallow = function(objA, objB) {
    return $5b95e8cf664b5dbd$var$shallow$1(objA, objB);
};
$5b95e8cf664b5dbd$exports.default = $5b95e8cf664b5dbd$var$shallow;
$5b95e8cf664b5dbd$exports.shallow = $5b95e8cf664b5dbd$var$shallow$1;
$5b95e8cf664b5dbd$exports = $5b95e8cf664b5dbd$var$shallow;
$5b95e8cf664b5dbd$exports.shallow = $5b95e8cf664b5dbd$var$shallow$1;
$5b95e8cf664b5dbd$exports.default = $5b95e8cf664b5dbd$exports;


var $700b83146b11ea4e$var$noop = {
    value: ()=>{}
};
function $700b83146b11ea4e$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $700b83146b11ea4e$var$Dispatch(_);
}
function $700b83146b11ea4e$var$Dispatch(_) {
    this._ = _;
}
function $700b83146b11ea4e$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$700b83146b11ea4e$var$Dispatch.prototype = $700b83146b11ea4e$var$dispatch.prototype = {
    constructor: $700b83146b11ea4e$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $700b83146b11ea4e$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $700b83146b11ea4e$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $700b83146b11ea4e$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $700b83146b11ea4e$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $700b83146b11ea4e$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $700b83146b11ea4e$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $700b83146b11ea4e$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $700b83146b11ea4e$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $700b83146b11ea4e$export$2e2bcd8739ae039 = $700b83146b11ea4e$var$dispatch;



function $eca546d4b3334fc1$var$none() {}
function $eca546d4b3334fc1$export$2e2bcd8739ae039(selector) {
    return selector == null ? $eca546d4b3334fc1$var$none : function() {
        return this.querySelector(selector);
    };
}


function $f48f15a32683a1f3$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $eca546d4b3334fc1$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $9511f366ebfc494c$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $151d427a83b5c5f4$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $6768a41baa0c5eba$var$empty() {
    return [];
}
function $6768a41baa0c5eba$export$2e2bcd8739ae039(selector) {
    return selector == null ? $6768a41baa0c5eba$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $0190f70f3c893397$var$arrayAll(select) {
    return function() {
        return (0, $151d427a83b5c5f4$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $0190f70f3c893397$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $0190f70f3c893397$var$arrayAll(select);
    else select = (0, $6768a41baa0c5eba$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $9511f366ebfc494c$export$52baac22726c72bf)(subgroups, parents);
}


function $91bc5344b5357b96$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $91bc5344b5357b96$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $99d1f049bdd837a9$var$find = Array.prototype.find;
function $99d1f049bdd837a9$var$childFind(match) {
    return function() {
        return $99d1f049bdd837a9$var$find.call(this.children, match);
    };
}
function $99d1f049bdd837a9$var$childFirst() {
    return this.firstElementChild;
}
function $99d1f049bdd837a9$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $99d1f049bdd837a9$var$childFirst : $99d1f049bdd837a9$var$childFind(typeof match === "function" ? match : (0, $91bc5344b5357b96$export$90c2759c036528)(match)));
}



var $82fd2049bd66c472$var$filter = Array.prototype.filter;
function $82fd2049bd66c472$var$children() {
    return Array.from(this.children);
}
function $82fd2049bd66c472$var$childrenFilter(match) {
    return function() {
        return $82fd2049bd66c472$var$filter.call(this.children, match);
    };
}
function $82fd2049bd66c472$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $82fd2049bd66c472$var$children : $82fd2049bd66c472$var$childrenFilter(typeof match === "function" ? match : (0, $91bc5344b5357b96$export$90c2759c036528)(match)));
}




function $507ee4e0c64ffdd1$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $91bc5344b5357b96$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $9511f366ebfc494c$export$52baac22726c72bf)(subgroups, this._parents);
}



function $068aafe0b571ec38$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $dbf7e07181e5ff7d$export$2e2bcd8739ae039() {
    return new (0, $9511f366ebfc494c$export$52baac22726c72bf)(this._enter || this._groups.map((0, $068aafe0b571ec38$export$2e2bcd8739ae039)), this._parents);
}
function $dbf7e07181e5ff7d$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$dbf7e07181e5ff7d$export$67b01759a14cf6a4.prototype = {
    constructor: $dbf7e07181e5ff7d$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $46ae3f4cd64b8202$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $5bb3964205826b91$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $dbf7e07181e5ff7d$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $5bb3964205826b91$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $dbf7e07181e5ff7d$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $5bb3964205826b91$var$datum(node) {
    return node.__data__;
}
function $5bb3964205826b91$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $5bb3964205826b91$var$datum);
    var bind = key ? $5bb3964205826b91$var$bindKey : $5bb3964205826b91$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $46ae3f4cd64b8202$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $5bb3964205826b91$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $9511f366ebfc494c$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $5bb3964205826b91$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $215861a650f081b6$export$2e2bcd8739ae039() {
    return new (0, $9511f366ebfc494c$export$52baac22726c72bf)(this._exit || this._groups.map((0, $068aafe0b571ec38$export$2e2bcd8739ae039)), this._parents);
}


function $2f22306627cfd0e6$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $e6c0094c1f8c3fab$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $9511f366ebfc494c$export$52baac22726c72bf)(merges, this._parents);
}


function $593e5b1784fd5b42$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $63cc236fc9ad8890$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $63cc236fc9ad8890$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $9511f366ebfc494c$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $63cc236fc9ad8890$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $396c6daed542c033$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $3055df140ba277ad$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $587fe0a08a880e78$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $dbead6feb6f69940$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $1aeb2d5899baf5b6$export$2e2bcd8739ae039() {
    return !this.node();
}


function $c955dd14f554eac7$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $f63b789bc5970a63$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $f63b789bc5970a63$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $f63b789bc5970a63$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $157d4e61df359085$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $f63b789bc5970a63$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $f63b789bc5970a63$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $86b1d0d0fbd092d5$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $86b1d0d0fbd092d5$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $86b1d0d0fbd092d5$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $86b1d0d0fbd092d5$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $86b1d0d0fbd092d5$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $86b1d0d0fbd092d5$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $86b1d0d0fbd092d5$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $157d4e61df359085$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $86b1d0d0fbd092d5$var$attrRemoveNS : $86b1d0d0fbd092d5$var$attrRemove : typeof value === "function" ? fullname.local ? $86b1d0d0fbd092d5$var$attrFunctionNS : $86b1d0d0fbd092d5$var$attrFunction : fullname.local ? $86b1d0d0fbd092d5$var$attrConstantNS : $86b1d0d0fbd092d5$var$attrConstant)(fullname, value));
}


function $d8747d748acd89fb$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $eb8d48cf547ae266$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $eb8d48cf547ae266$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $eb8d48cf547ae266$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $eb8d48cf547ae266$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $eb8d48cf547ae266$var$styleRemove : typeof value === "function" ? $eb8d48cf547ae266$var$styleFunction : $eb8d48cf547ae266$var$styleConstant)(name, value, priority == null ? "" : priority)) : $eb8d48cf547ae266$export$5e3cec964f0b5efd(this.node(), name);
}
function $eb8d48cf547ae266$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $d8747d748acd89fb$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $a0caf8abe2725998$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $a0caf8abe2725998$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $a0caf8abe2725998$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $a0caf8abe2725998$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $a0caf8abe2725998$var$propertyRemove : typeof value === "function" ? $a0caf8abe2725998$var$propertyFunction : $a0caf8abe2725998$var$propertyConstant)(name, value)) : this.node()[name];
}


function $346abd8829aedd02$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $346abd8829aedd02$var$classList(node) {
    return node.classList || new $346abd8829aedd02$var$ClassList(node);
}
function $346abd8829aedd02$var$ClassList(node) {
    this._node = node;
    this._names = $346abd8829aedd02$var$classArray(node.getAttribute("class") || "");
}
$346abd8829aedd02$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $346abd8829aedd02$var$classedAdd(node, names) {
    var list = $346abd8829aedd02$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $346abd8829aedd02$var$classedRemove(node, names) {
    var list = $346abd8829aedd02$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $346abd8829aedd02$var$classedTrue(names) {
    return function() {
        $346abd8829aedd02$var$classedAdd(this, names);
    };
}
function $346abd8829aedd02$var$classedFalse(names) {
    return function() {
        $346abd8829aedd02$var$classedRemove(this, names);
    };
}
function $346abd8829aedd02$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $346abd8829aedd02$var$classedAdd : $346abd8829aedd02$var$classedRemove)(this, names);
    };
}
function $346abd8829aedd02$export$2e2bcd8739ae039(name, value) {
    var names = $346abd8829aedd02$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $346abd8829aedd02$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $346abd8829aedd02$var$classedFunction : value ? $346abd8829aedd02$var$classedTrue : $346abd8829aedd02$var$classedFalse)(names, value));
}


function $e9a9bdfea6f4ee8d$var$textRemove() {
    this.textContent = "";
}
function $e9a9bdfea6f4ee8d$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $e9a9bdfea6f4ee8d$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $e9a9bdfea6f4ee8d$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $e9a9bdfea6f4ee8d$var$textRemove : (typeof value === "function" ? $e9a9bdfea6f4ee8d$var$textFunction : $e9a9bdfea6f4ee8d$var$textConstant)(value)) : this.node().textContent;
}


function $1fb5162d50f739ec$var$htmlRemove() {
    this.innerHTML = "";
}
function $1fb5162d50f739ec$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $1fb5162d50f739ec$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $1fb5162d50f739ec$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $1fb5162d50f739ec$var$htmlRemove : (typeof value === "function" ? $1fb5162d50f739ec$var$htmlFunction : $1fb5162d50f739ec$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $b6484c35ce8a87d4$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $b6484c35ce8a87d4$export$2e2bcd8739ae039() {
    return this.each($b6484c35ce8a87d4$var$raise);
}


function $d7d08781caedd704$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $d7d08781caedd704$export$2e2bcd8739ae039() {
    return this.each($d7d08781caedd704$var$lower);
}




function $7fdd518eef3f1cab$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $f63b789bc5970a63$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $f63b789bc5970a63$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $7fdd518eef3f1cab$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $7fdd518eef3f1cab$export$2e2bcd8739ae039(name) {
    var fullname = (0, $157d4e61df359085$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $7fdd518eef3f1cab$var$creatorFixed : $7fdd518eef3f1cab$var$creatorInherit)(fullname);
}


function $45a0d9971bb43dcf$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $7fdd518eef3f1cab$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $7adecc8d6a60039c$var$constantNull() {
    return null;
}
function $7adecc8d6a60039c$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $7fdd518eef3f1cab$export$2e2bcd8739ae039)(name), select = before == null ? $7adecc8d6a60039c$var$constantNull : typeof before === "function" ? before : (0, $eca546d4b3334fc1$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $c5a600e656921aec$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $c5a600e656921aec$export$2e2bcd8739ae039() {
    return this.each($c5a600e656921aec$var$remove);
}


function $735283042047d2b6$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $735283042047d2b6$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $735283042047d2b6$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $735283042047d2b6$var$selection_cloneDeep : $735283042047d2b6$var$selection_cloneShallow);
}


function $586309892a555f21$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $f011d67d47e7a8e1$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $f011d67d47e7a8e1$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $f011d67d47e7a8e1$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $f011d67d47e7a8e1$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $f011d67d47e7a8e1$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $f011d67d47e7a8e1$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $f011d67d47e7a8e1$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $f011d67d47e7a8e1$var$onAdd : $f011d67d47e7a8e1$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $cd3713aa9bcd43b7$var$dispatchEvent(node, type, params) {
    var window = (0, $d8747d748acd89fb$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $cd3713aa9bcd43b7$var$dispatchConstant(type, params) {
    return function() {
        return $cd3713aa9bcd43b7$var$dispatchEvent(this, type, params);
    };
}
function $cd3713aa9bcd43b7$var$dispatchFunction(type, params) {
    return function() {
        return $cd3713aa9bcd43b7$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $cd3713aa9bcd43b7$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $cd3713aa9bcd43b7$var$dispatchFunction : $cd3713aa9bcd43b7$var$dispatchConstant)(type, params));
}


function* $365a592af75e1a5b$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $9511f366ebfc494c$export$e8e78c978b129247 = [
    null
];
function $9511f366ebfc494c$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $9511f366ebfc494c$var$selection() {
    return new $9511f366ebfc494c$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $9511f366ebfc494c$export$e8e78c978b129247);
}
function $9511f366ebfc494c$var$selection_selection() {
    return this;
}
$9511f366ebfc494c$export$52baac22726c72bf.prototype = $9511f366ebfc494c$var$selection.prototype = {
    constructor: $9511f366ebfc494c$export$52baac22726c72bf,
    select: (0, $f48f15a32683a1f3$export$2e2bcd8739ae039),
    selectAll: (0, $0190f70f3c893397$export$2e2bcd8739ae039),
    selectChild: (0, $99d1f049bdd837a9$export$2e2bcd8739ae039),
    selectChildren: (0, $82fd2049bd66c472$export$2e2bcd8739ae039),
    filter: (0, $507ee4e0c64ffdd1$export$2e2bcd8739ae039),
    data: (0, $5bb3964205826b91$export$2e2bcd8739ae039),
    enter: (0, $dbf7e07181e5ff7d$export$2e2bcd8739ae039),
    exit: (0, $215861a650f081b6$export$2e2bcd8739ae039),
    join: (0, $2f22306627cfd0e6$export$2e2bcd8739ae039),
    merge: (0, $e6c0094c1f8c3fab$export$2e2bcd8739ae039),
    selection: $9511f366ebfc494c$var$selection_selection,
    order: (0, $593e5b1784fd5b42$export$2e2bcd8739ae039),
    sort: (0, $63cc236fc9ad8890$export$2e2bcd8739ae039),
    call: (0, $396c6daed542c033$export$2e2bcd8739ae039),
    nodes: (0, $3055df140ba277ad$export$2e2bcd8739ae039),
    node: (0, $587fe0a08a880e78$export$2e2bcd8739ae039),
    size: (0, $dbead6feb6f69940$export$2e2bcd8739ae039),
    empty: (0, $1aeb2d5899baf5b6$export$2e2bcd8739ae039),
    each: (0, $c955dd14f554eac7$export$2e2bcd8739ae039),
    attr: (0, $86b1d0d0fbd092d5$export$2e2bcd8739ae039),
    style: (0, $eb8d48cf547ae266$export$2e2bcd8739ae039),
    property: (0, $a0caf8abe2725998$export$2e2bcd8739ae039),
    classed: (0, $346abd8829aedd02$export$2e2bcd8739ae039),
    text: (0, $e9a9bdfea6f4ee8d$export$2e2bcd8739ae039),
    html: (0, $1fb5162d50f739ec$export$2e2bcd8739ae039),
    raise: (0, $b6484c35ce8a87d4$export$2e2bcd8739ae039),
    lower: (0, $d7d08781caedd704$export$2e2bcd8739ae039),
    append: (0, $45a0d9971bb43dcf$export$2e2bcd8739ae039),
    insert: (0, $7adecc8d6a60039c$export$2e2bcd8739ae039),
    remove: (0, $c5a600e656921aec$export$2e2bcd8739ae039),
    clone: (0, $735283042047d2b6$export$2e2bcd8739ae039),
    datum: (0, $586309892a555f21$export$2e2bcd8739ae039),
    on: (0, $f011d67d47e7a8e1$export$2e2bcd8739ae039),
    dispatch: (0, $cd3713aa9bcd43b7$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $365a592af75e1a5b$export$2e2bcd8739ae039)
};
var $9511f366ebfc494c$export$2e2bcd8739ae039 = $9511f366ebfc494c$var$selection;


function $b0b9e4430a128489$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $9511f366ebfc494c$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $9511f366ebfc494c$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $9511f366ebfc494c$export$e8e78c978b129247));
}


// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $557db5f547e3f182$export$524615cd03e458cc = {
    passive: false
};
const $557db5f547e3f182$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $557db5f547e3f182$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $557db5f547e3f182$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


function $f9d15445eefa1a13$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $b0b9e4430a128489$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $557db5f547e3f182$export$2e2bcd8739ae039), (0, $557db5f547e3f182$export$35431a0e47022de1));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $557db5f547e3f182$export$2e2bcd8739ae039), (0, $557db5f547e3f182$export$35431a0e47022de1));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $f9d15445eefa1a13$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $b0b9e4430a128489$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $557db5f547e3f182$export$2e2bcd8739ae039), (0, $557db5f547e3f182$export$35431a0e47022de1));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}


var $6dbfec3e79ede065$var$epsilon2 = 1e-12;
function $6dbfec3e79ede065$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $6dbfec3e79ede065$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $6dbfec3e79ede065$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $6dbfec3e79ede065$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $6dbfec3e79ede065$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $6dbfec3e79ede065$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $6dbfec3e79ede065$var$tanh(rho * s + r0) - $6dbfec3e79ede065$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $6dbfec3e79ede065$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);


function $caa835a0a7b28830$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}


function $77a090e639ecc3fa$export$2e2bcd8739ae039(event, node) {
    event = (0, $caa835a0a7b28830$export$2e2bcd8739ae039)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}




var $a03549fddfaa7235$var$frame = 0, $a03549fddfaa7235$var$timeout = 0, $a03549fddfaa7235$var$interval = 0, $a03549fddfaa7235$var$pokeDelay = 1000, $a03549fddfaa7235$var$taskHead, $a03549fddfaa7235$var$taskTail, $a03549fddfaa7235$var$clockLast = 0, $a03549fddfaa7235$var$clockNow = 0, $a03549fddfaa7235$var$clockSkew = 0, $a03549fddfaa7235$var$clock = typeof performance === "object" && performance.now ? performance : Date, $a03549fddfaa7235$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $a03549fddfaa7235$export$461939dd4422153() {
    return $a03549fddfaa7235$var$clockNow || ($a03549fddfaa7235$var$setFrame($a03549fddfaa7235$var$clearNow), $a03549fddfaa7235$var$clockNow = $a03549fddfaa7235$var$clock.now() + $a03549fddfaa7235$var$clockSkew);
}
function $a03549fddfaa7235$var$clearNow() {
    $a03549fddfaa7235$var$clockNow = 0;
}
function $a03549fddfaa7235$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$a03549fddfaa7235$export$c57e9b2d8b9e4de.prototype = $a03549fddfaa7235$export$9dc4ecf953986f04.prototype = {
    constructor: $a03549fddfaa7235$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $a03549fddfaa7235$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $a03549fddfaa7235$var$taskTail !== this) {
            if ($a03549fddfaa7235$var$taskTail) $a03549fddfaa7235$var$taskTail._next = this;
            else $a03549fddfaa7235$var$taskHead = this;
            $a03549fddfaa7235$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $a03549fddfaa7235$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $a03549fddfaa7235$var$sleep();
        }
    }
};
function $a03549fddfaa7235$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $a03549fddfaa7235$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $a03549fddfaa7235$export$d60154c1d7f3990e() {
    $a03549fddfaa7235$export$461939dd4422153(); // Get the current time, if not already set.
    ++$a03549fddfaa7235$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $a03549fddfaa7235$var$taskHead, e;
    while(t){
        if ((e = $a03549fddfaa7235$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$a03549fddfaa7235$var$frame;
}
function $a03549fddfaa7235$var$wake() {
    $a03549fddfaa7235$var$clockNow = ($a03549fddfaa7235$var$clockLast = $a03549fddfaa7235$var$clock.now()) + $a03549fddfaa7235$var$clockSkew;
    $a03549fddfaa7235$var$frame = $a03549fddfaa7235$var$timeout = 0;
    try {
        $a03549fddfaa7235$export$d60154c1d7f3990e();
    } finally{
        $a03549fddfaa7235$var$frame = 0;
        $a03549fddfaa7235$var$nap();
        $a03549fddfaa7235$var$clockNow = 0;
    }
}
function $a03549fddfaa7235$var$poke() {
    var now = $a03549fddfaa7235$var$clock.now(), delay = now - $a03549fddfaa7235$var$clockLast;
    if (delay > $a03549fddfaa7235$var$pokeDelay) $a03549fddfaa7235$var$clockSkew -= delay, $a03549fddfaa7235$var$clockLast = now;
}
function $a03549fddfaa7235$var$nap() {
    var t0, t1 = $a03549fddfaa7235$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $a03549fddfaa7235$var$taskHead = t2;
    }
    $a03549fddfaa7235$var$taskTail = t0;
    $a03549fddfaa7235$var$sleep(time);
}
function $a03549fddfaa7235$var$sleep(time) {
    if ($a03549fddfaa7235$var$frame) return; // Soonest alarm already set, or will be.
    if ($a03549fddfaa7235$var$timeout) $a03549fddfaa7235$var$timeout = clearTimeout($a03549fddfaa7235$var$timeout);
    var delay = time - $a03549fddfaa7235$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $a03549fddfaa7235$var$timeout = setTimeout($a03549fddfaa7235$var$wake, time - $a03549fddfaa7235$var$clock.now() - $a03549fddfaa7235$var$clockSkew);
        if ($a03549fddfaa7235$var$interval) $a03549fddfaa7235$var$interval = clearInterval($a03549fddfaa7235$var$interval);
    } else {
        if (!$a03549fddfaa7235$var$interval) $a03549fddfaa7235$var$clockLast = $a03549fddfaa7235$var$clock.now(), $a03549fddfaa7235$var$interval = setInterval($a03549fddfaa7235$var$poke, $a03549fddfaa7235$var$pokeDelay);
        $a03549fddfaa7235$var$frame = 1, $a03549fddfaa7235$var$setFrame($a03549fddfaa7235$var$wake);
    }
}


function $105b03ee00d8a18e$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $a03549fddfaa7235$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $96c795a7c07acaad$var$emptyOn = (0, $700b83146b11ea4e$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $96c795a7c07acaad$var$emptyTween = [];
var $96c795a7c07acaad$export$ff39ebd4bb12b718 = 0;
var $96c795a7c07acaad$export$584530fe98d14a84 = 1;
var $96c795a7c07acaad$export$a5d151aee16efd42 = 2;
var $96c795a7c07acaad$export$fb935ab5849a0db9 = 3;
var $96c795a7c07acaad$export$1573e22b087389af = 4;
var $96c795a7c07acaad$export$a2e792214ded83b2 = 5;
var $96c795a7c07acaad$export$9d38167254403955 = 6;
function $96c795a7c07acaad$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $96c795a7c07acaad$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $96c795a7c07acaad$var$emptyOn,
        tween: $96c795a7c07acaad$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $96c795a7c07acaad$export$ff39ebd4bb12b718
    });
}
function $96c795a7c07acaad$export$2cd8252107eb640b(node, id) {
    var schedule = $96c795a7c07acaad$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $96c795a7c07acaad$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $96c795a7c07acaad$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $96c795a7c07acaad$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $96c795a7c07acaad$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $96c795a7c07acaad$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $96c795a7c07acaad$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $a03549fddfaa7235$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $96c795a7c07acaad$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $96c795a7c07acaad$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $96c795a7c07acaad$export$fb935ab5849a0db9) return (0, $105b03ee00d8a18e$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $96c795a7c07acaad$export$1573e22b087389af) {
                o.state = $96c795a7c07acaad$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $96c795a7c07acaad$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $105b03ee00d8a18e$export$2e2bcd8739ae039)(function() {
            if (self.state === $96c795a7c07acaad$export$fb935ab5849a0db9) {
                self.state = $96c795a7c07acaad$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $96c795a7c07acaad$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $96c795a7c07acaad$export$a5d151aee16efd42) return; // interrupted
        self.state = $96c795a7c07acaad$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $96c795a7c07acaad$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $96c795a7c07acaad$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $96c795a7c07acaad$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $387ba6453574f3a2$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $96c795a7c07acaad$export$a5d151aee16efd42) && schedule.state < (0, $96c795a7c07acaad$export$a2e792214ded83b2);
        schedule.state = (0, $96c795a7c07acaad$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $12a1c6cfaa5157fe$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $387ba6453574f3a2$export$2e2bcd8739ae039)(this, name);
    });
}



function $4ea88c859b1b181e$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}


var $f3148b8368452941$var$degrees = 180 / Math.PI;
var $f3148b8368452941$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $f3148b8368452941$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $f3148b8368452941$var$degrees,
        skewX: Math.atan(skewX) * $f3148b8368452941$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $0c36df248f0a20be$var$svgNode;
function $0c36df248f0a20be$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $f3148b8368452941$export$f0954fd7d5368655) : (0, $f3148b8368452941$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $0c36df248f0a20be$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $f3148b8368452941$export$f0954fd7d5368655;
    if (!$0c36df248f0a20be$var$svgNode) $0c36df248f0a20be$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $0c36df248f0a20be$var$svgNode.setAttribute("transform", value);
    if (!(value = $0c36df248f0a20be$var$svgNode.transform.baseVal.consolidate())) return 0, $f3148b8368452941$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $f3148b8368452941$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $7dfc6c93428ebac4$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $4ea88c859b1b181e$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $4ea88c859b1b181e$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $4ea88c859b1b181e$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $4ea88c859b1b181e$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $4ea88c859b1b181e$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $4ea88c859b1b181e$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $7dfc6c93428ebac4$export$56bec7123bb3589a = $7dfc6c93428ebac4$var$interpolateTransform((0, $0c36df248f0a20be$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $7dfc6c93428ebac4$export$da8cba906d64c082 = $7dfc6c93428ebac4$var$interpolateTransform((0, $0c36df248f0a20be$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $02c4650ab0d9095d$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $96c795a7c07acaad$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $02c4650ab0d9095d$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $96c795a7c07acaad$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $02c4650ab0d9095d$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $96c795a7c07acaad$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $02c4650ab0d9095d$var$tweenRemove : $02c4650ab0d9095d$var$tweenFunction)(id, name, value));
}
function $02c4650ab0d9095d$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $96c795a7c07acaad$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $96c795a7c07acaad$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $i6beJ = parcelRequire("i6beJ");

var $i6beJ = parcelRequire("i6beJ");
function $b8d57e9973d64343$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $b8d57e9973d64343$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $b8d57e9973d64343$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $86d4bf6607ed4eaa$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $b8d57e9973d64343$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $812dabbf680fe8f8$export$2e2bcd8739ae039 = (x)=>()=>x;


function $5843efa629450042$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $5843efa629450042$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $5843efa629450042$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $5843efa629450042$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $812dabbf680fe8f8$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $5843efa629450042$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $5843efa629450042$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $5843efa629450042$var$exponential(a, b, y) : (0, $812dabbf680fe8f8$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $5843efa629450042$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $5843efa629450042$var$linear(a, d) : (0, $812dabbf680fe8f8$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $f729b406421249bc$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $5843efa629450042$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $i6beJ.rgb)(start)).r, (end = (0, $i6beJ.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $5843efa629450042$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $f729b406421249bc$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $i6beJ.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $f729b406421249bc$export$2c0e28f2e2852d3f = $f729b406421249bc$var$rgbSpline((0, $b8d57e9973d64343$export$2e2bcd8739ae039));
var $f729b406421249bc$export$53d5214f625ccd4c = $f729b406421249bc$var$rgbSpline((0, $86d4bf6607ed4eaa$export$2e2bcd8739ae039));


var $0e967ede4d0b3768$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $0e967ede4d0b3768$var$reB = new RegExp($0e967ede4d0b3768$var$reA.source, "g");
function $0e967ede4d0b3768$var$zero(b) {
    return function() {
        return b;
    };
}
function $0e967ede4d0b3768$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $0e967ede4d0b3768$export$2e2bcd8739ae039(a, b) {
    var bi = $0e967ede4d0b3768$var$reA.lastIndex = $0e967ede4d0b3768$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $0e967ede4d0b3768$var$reA.exec(a)) && (bm = $0e967ede4d0b3768$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $4ea88c859b1b181e$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $0e967ede4d0b3768$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $0e967ede4d0b3768$var$one(q[0].x) : $0e967ede4d0b3768$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}


function $fbe8efb8e7e3b9c5$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $4ea88c859b1b181e$export$2e2bcd8739ae039) : b instanceof (0, $i6beJ.default) ? (0, $f729b406421249bc$export$2e2bcd8739ae039) : (c = (0, $i6beJ.default)(b)) ? (b = c, $f729b406421249bc$export$2e2bcd8739ae039) : (0, $0e967ede4d0b3768$export$2e2bcd8739ae039))(a, b);
}


function $d4c54cd3dcd0a92d$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $d4c54cd3dcd0a92d$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $d4c54cd3dcd0a92d$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $d4c54cd3dcd0a92d$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $d4c54cd3dcd0a92d$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $d4c54cd3dcd0a92d$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $d4c54cd3dcd0a92d$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $157d4e61df359085$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $7dfc6c93428ebac4$export$da8cba906d64c082) : (0, $fbe8efb8e7e3b9c5$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $d4c54cd3dcd0a92d$var$attrFunctionNS : $d4c54cd3dcd0a92d$var$attrFunction)(fullname, i, (0, $02c4650ab0d9095d$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $d4c54cd3dcd0a92d$var$attrRemoveNS : $d4c54cd3dcd0a92d$var$attrRemove)(fullname) : (fullname.local ? $d4c54cd3dcd0a92d$var$attrConstantNS : $d4c54cd3dcd0a92d$var$attrConstant)(fullname, i, value));
}



function $a4ce47c5dd567b8f$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $a4ce47c5dd567b8f$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $a4ce47c5dd567b8f$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $a4ce47c5dd567b8f$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $a4ce47c5dd567b8f$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $a4ce47c5dd567b8f$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $a4ce47c5dd567b8f$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $157d4e61df359085$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $a4ce47c5dd567b8f$var$attrTweenNS : $a4ce47c5dd567b8f$var$attrTween)(fullname, value));
}



function $190b52bcbba867af$var$delayFunction(id, value) {
    return function() {
        (0, $96c795a7c07acaad$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $190b52bcbba867af$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $96c795a7c07acaad$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $190b52bcbba867af$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $190b52bcbba867af$var$delayFunction : $190b52bcbba867af$var$delayConstant)(id, value)) : (0, $96c795a7c07acaad$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $b3b0cb76d0f2dddf$var$durationFunction(id, value) {
    return function() {
        (0, $96c795a7c07acaad$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $b3b0cb76d0f2dddf$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $96c795a7c07acaad$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $b3b0cb76d0f2dddf$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $b3b0cb76d0f2dddf$var$durationFunction : $b3b0cb76d0f2dddf$var$durationConstant)(id, value)) : (0, $96c795a7c07acaad$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $2061ddae89f6d121$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $96c795a7c07acaad$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $2061ddae89f6d121$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($2061ddae89f6d121$var$easeConstant(id, value)) : (0, $96c795a7c07acaad$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $f4102dd2cbb419d4$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $96c795a7c07acaad$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $f4102dd2cbb419d4$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($f4102dd2cbb419d4$var$easeVarying(this._id, value));
}




function $b3d9c8c81804c5bf$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $91bc5344b5357b96$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $15439e45aa0c8bcf$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $6162b5154e2435f3$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $15439e45aa0c8bcf$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $4de6bb81e3924330$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $4de6bb81e3924330$var$onFunction(id, name, listener) {
    var on0, on1, sit = $4de6bb81e3924330$var$start(name) ? (0, $96c795a7c07acaad$export$2cd8252107eb640b) : (0, $96c795a7c07acaad$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $4de6bb81e3924330$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $96c795a7c07acaad$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($4de6bb81e3924330$var$onFunction(id, name, listener));
}


function $309ea70f8da3a1e3$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $309ea70f8da3a1e3$export$2e2bcd8739ae039() {
    return this.on("end.remove", $309ea70f8da3a1e3$var$removeFunction(this._id));
}





function $241b6fb6a63a2fbc$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $eca546d4b3334fc1$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $96c795a7c07acaad$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $96c795a7c07acaad$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $15439e45aa0c8bcf$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $86d7e5d9fea5827f$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $6768a41baa0c5eba$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $96c795a7c07acaad$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $96c795a7c07acaad$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $15439e45aa0c8bcf$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $bc04cc0adbd273e0$var$Selection = (0, $9511f366ebfc494c$export$2e2bcd8739ae039).prototype.constructor;
function $bc04cc0adbd273e0$export$2e2bcd8739ae039() {
    return new $bc04cc0adbd273e0$var$Selection(this._groups, this._parents);
}







function $4fa344880da5055b$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $eb8d48cf547ae266$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $eb8d48cf547ae266$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $4fa344880da5055b$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $4fa344880da5055b$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $eb8d48cf547ae266$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $4fa344880da5055b$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $eb8d48cf547ae266$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $eb8d48cf547ae266$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $4fa344880da5055b$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $96c795a7c07acaad$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $4fa344880da5055b$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $4fa344880da5055b$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $7dfc6c93428ebac4$export$56bec7123bb3589a) : (0, $fbe8efb8e7e3b9c5$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $4fa344880da5055b$var$styleNull(name, i)).on("end.style." + name, $4fa344880da5055b$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $4fa344880da5055b$var$styleFunction(name, i, (0, $02c4650ab0d9095d$export$f78ce6ab10405d82)(this, "style." + name, value))).each($4fa344880da5055b$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $4fa344880da5055b$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $81b2bbcfb53b058e$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $81b2bbcfb53b058e$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $81b2bbcfb53b058e$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $81b2bbcfb53b058e$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $81b2bbcfb53b058e$var$styleTween(name, value, priority == null ? "" : priority));
}



function $97f4a355bf4bf123$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $97f4a355bf4bf123$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $97f4a355bf4bf123$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $97f4a355bf4bf123$var$textFunction((0, $02c4650ab0d9095d$export$f78ce6ab10405d82)(this, "text", value)) : $97f4a355bf4bf123$var$textConstant(value == null ? "" : value + ""));
}


function $f76304fabb44033f$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $f76304fabb44033f$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $f76304fabb44033f$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $f76304fabb44033f$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $f76304fabb44033f$var$textTween(value));
}




function $109bab1c488a36d4$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $15439e45aa0c8bcf$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $96c795a7c07acaad$export$3988ae62b71be9a3)(node, id0);
            (0, $96c795a7c07acaad$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $15439e45aa0c8bcf$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $48c003cc213f103e$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $96c795a7c07acaad$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $15439e45aa0c8bcf$var$id = 0;
function $15439e45aa0c8bcf$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $15439e45aa0c8bcf$export$2e2bcd8739ae039(name) {
    return (0, $9511f366ebfc494c$export$2e2bcd8739ae039)().transition(name);
}
function $15439e45aa0c8bcf$export$9ffd10a3fbdc175b() {
    return ++$15439e45aa0c8bcf$var$id;
}
var $15439e45aa0c8bcf$var$selection_prototype = (0, $9511f366ebfc494c$export$2e2bcd8739ae039).prototype;
$15439e45aa0c8bcf$export$be58926105124dd4.prototype = $15439e45aa0c8bcf$export$2e2bcd8739ae039.prototype = {
    constructor: $15439e45aa0c8bcf$export$be58926105124dd4,
    select: (0, $241b6fb6a63a2fbc$export$2e2bcd8739ae039),
    selectAll: (0, $86d7e5d9fea5827f$export$2e2bcd8739ae039),
    selectChild: $15439e45aa0c8bcf$var$selection_prototype.selectChild,
    selectChildren: $15439e45aa0c8bcf$var$selection_prototype.selectChildren,
    filter: (0, $b3d9c8c81804c5bf$export$2e2bcd8739ae039),
    merge: (0, $6162b5154e2435f3$export$2e2bcd8739ae039),
    selection: (0, $bc04cc0adbd273e0$export$2e2bcd8739ae039),
    transition: (0, $109bab1c488a36d4$export$2e2bcd8739ae039),
    call: $15439e45aa0c8bcf$var$selection_prototype.call,
    nodes: $15439e45aa0c8bcf$var$selection_prototype.nodes,
    node: $15439e45aa0c8bcf$var$selection_prototype.node,
    size: $15439e45aa0c8bcf$var$selection_prototype.size,
    empty: $15439e45aa0c8bcf$var$selection_prototype.empty,
    each: $15439e45aa0c8bcf$var$selection_prototype.each,
    on: (0, $4de6bb81e3924330$export$2e2bcd8739ae039),
    attr: (0, $d4c54cd3dcd0a92d$export$2e2bcd8739ae039),
    attrTween: (0, $a4ce47c5dd567b8f$export$2e2bcd8739ae039),
    style: (0, $4fa344880da5055b$export$2e2bcd8739ae039),
    styleTween: (0, $81b2bbcfb53b058e$export$2e2bcd8739ae039),
    text: (0, $97f4a355bf4bf123$export$2e2bcd8739ae039),
    textTween: (0, $f76304fabb44033f$export$2e2bcd8739ae039),
    remove: (0, $309ea70f8da3a1e3$export$2e2bcd8739ae039),
    tween: (0, $02c4650ab0d9095d$export$2e2bcd8739ae039),
    delay: (0, $190b52bcbba867af$export$2e2bcd8739ae039),
    duration: (0, $b3b0cb76d0f2dddf$export$2e2bcd8739ae039),
    ease: (0, $2061ddae89f6d121$export$2e2bcd8739ae039),
    easeVarying: (0, $f4102dd2cbb419d4$export$2e2bcd8739ae039),
    end: (0, $48c003cc213f103e$export$2e2bcd8739ae039),
    [Symbol.iterator]: $15439e45aa0c8bcf$var$selection_prototype[Symbol.iterator]
};



function $33a1d651d19dc08f$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $33a1d651d19dc08f$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $33a1d651d19dc08f$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $76e26b8e44fb8bdd$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $33a1d651d19dc08f$export$89238d3bc79d3ada)
};
function $76e26b8e44fb8bdd$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $76e26b8e44fb8bdd$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $15439e45aa0c8bcf$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $15439e45aa0c8bcf$export$9ffd10a3fbdc175b)(), (timing = $76e26b8e44fb8bdd$var$defaultTiming).time = (0, $a03549fddfaa7235$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $96c795a7c07acaad$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $76e26b8e44fb8bdd$var$inherit(node, id));
    }
    return new (0, $15439e45aa0c8bcf$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $9511f366ebfc494c$export$2e2bcd8739ae039).prototype.interrupt = (0, $12a1c6cfaa5157fe$export$2e2bcd8739ae039);
(0, $9511f366ebfc494c$export$2e2bcd8739ae039).prototype.transition = (0, $76e26b8e44fb8bdd$export$2e2bcd8739ae039);







var $8c4d8ed5d78ebdf9$export$2e2bcd8739ae039 = (x)=>()=>x;


function $2b7857d71a5aa776$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $56c130654380f82b$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$56c130654380f82b$export$563a914cafbdc389.prototype = {
    constructor: $56c130654380f82b$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $56c130654380f82b$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $56c130654380f82b$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $56c130654380f82b$export$f0954fd7d5368655 = new $56c130654380f82b$export$563a914cafbdc389(1, 0, 0);
$56c130654380f82b$export$2e2bcd8739ae039.prototype = $56c130654380f82b$export$563a914cafbdc389.prototype;
function $56c130654380f82b$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $56c130654380f82b$export$f0954fd7d5368655;
    return node.__zoom;
}


function $85c22b3186a3efdc$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $85c22b3186a3efdc$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $617ef72b275b25a1$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $617ef72b275b25a1$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $617ef72b275b25a1$var$defaultTransform() {
    return this.__zoom || (0, $56c130654380f82b$export$f0954fd7d5368655);
}
function $617ef72b275b25a1$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $617ef72b275b25a1$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $617ef72b275b25a1$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $617ef72b275b25a1$export$2e2bcd8739ae039() {
    var filter = $617ef72b275b25a1$var$defaultFilter, extent = $617ef72b275b25a1$var$defaultExtent, constrain = $617ef72b275b25a1$var$defaultConstrain, wheelDelta = $617ef72b275b25a1$var$defaultWheelDelta, touchable = $617ef72b275b25a1$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $6dbfec3e79ede065$export$2e2bcd8739ae039), listeners = (0, $700b83146b11ea4e$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $617ef72b275b25a1$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $617ef72b275b25a1$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $56c130654380f82b$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $56c130654380f82b$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $56c130654380f82b$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $56c130654380f82b$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $b0b9e4430a128489$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $2b7857d71a5aa776$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $77a090e639ecc3fa$export$2e2bcd8739ae039)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $387ba6453574f3a2$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $85c22b3186a3efdc$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $b0b9e4430a128489$export$2e2bcd8739ae039)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $77a090e639ecc3fa$export$2e2bcd8739ae039)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $f9d15445eefa1a13$export$2e2bcd8739ae039)(event.view);
        (0, $85c22b3186a3efdc$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $387ba6453574f3a2$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved(event) {
            (0, $85c22b3186a3efdc$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $77a090e639ecc3fa$export$2e2bcd8739ae039)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $f9d15445eefa1a13$export$833237748009e1e1)(event.view, g.moved);
            (0, $85c22b3186a3efdc$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $77a090e639ecc3fa$export$2e2bcd8739ae039)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $85c22b3186a3efdc$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $b0b9e4430a128489$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $b0b9e4430a128489$export$2e2bcd8739ae039)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $85c22b3186a3efdc$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $77a090e639ecc3fa$export$2e2bcd8739ae039)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $387ba6453574f3a2$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $85c22b3186a3efdc$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $77a090e639ecc3fa$export$2e2bcd8739ae039)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $85c22b3186a3efdc$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $77a090e639ecc3fa$export$2e2bcd8739ae039)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $b0b9e4430a128489$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $8c4d8ed5d78ebdf9$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $8c4d8ed5d78ebdf9$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $8c4d8ed5d78ebdf9$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $8c4d8ed5d78ebdf9$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}










var $fbf326dd4c1d3420$export$2e2bcd8739ae039 = (x)=>()=>x;


function $2b5eae26da1c0bec$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, subject: subject, target: target, identifier: identifier, active: active, x: x, y: y, dx: dx, dy: dy, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
$2b5eae26da1c0bec$export$2e2bcd8739ae039.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};


// Ignore right-click, since that should open the context menu.
function $060ef0f969b66d1e$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $060ef0f969b66d1e$var$defaultContainer() {
    return this.parentNode;
}
function $060ef0f969b66d1e$var$defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function $060ef0f969b66d1e$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $060ef0f969b66d1e$export$2e2bcd8739ae039() {
    var filter = $060ef0f969b66d1e$var$defaultFilter, container = $060ef0f969b66d1e$var$defaultContainer, subject = $060ef0f969b66d1e$var$defaultSubject, touchable = $060ef0f969b66d1e$var$defaultTouchable, gestures = {}, listeners = (0, $700b83146b11ea4e$export$2e2bcd8739ae039)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
    function drag(selection) {
        selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, (0, $557db5f547e3f182$export$524615cd03e458cc)).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function mousedowned(event, d) {
        if (touchending || !filter.call(this, event, d)) return;
        var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
        if (!gesture) return;
        (0, $b0b9e4430a128489$export$2e2bcd8739ae039)(event.view).on("mousemove.drag", mousemoved, (0, $557db5f547e3f182$export$35431a0e47022de1)).on("mouseup.drag", mouseupped, (0, $557db5f547e3f182$export$35431a0e47022de1));
        (0, $f9d15445eefa1a13$export$2e2bcd8739ae039)(event.view);
        (0, $557db5f547e3f182$export$2e2561858db9bf47)(event);
        mousemoving = false;
        mousedownx = event.clientX;
        mousedowny = event.clientY;
        gesture("start", event);
    }
    function mousemoved(event) {
        (0, $557db5f547e3f182$export$2e2bcd8739ae039)(event);
        if (!mousemoving) {
            var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
        }
        gestures.mouse("drag", event);
    }
    function mouseupped(event) {
        (0, $b0b9e4430a128489$export$2e2bcd8739ae039)(event.view).on("mousemove.drag mouseup.drag", null);
        (0, $f9d15445eefa1a13$export$833237748009e1e1)(event.view, mousemoving);
        (0, $557db5f547e3f182$export$2e2bcd8739ae039)(event);
        gestures.mouse("end", event);
    }
    function touchstarted(event, d) {
        if (!filter.call(this, event, d)) return;
        var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
            (0, $557db5f547e3f182$export$2e2561858db9bf47)(event);
            gesture("start", event, touches[i]);
        }
    }
    function touchmoved(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $557db5f547e3f182$export$2e2bcd8739ae039)(event);
            gesture("drag", event, touches[i]);
        }
    }
    function touchended(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, 500); // Ghost clicks are delayed!
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $557db5f547e3f182$export$2e2561858db9bf47)(event);
            gesture("end", event, touches[i]);
        }
    }
    function beforestart(that, container, event, d, identifier, touch) {
        var dispatch = listeners.copy(), p = (0, $77a090e639ecc3fa$export$2e2bcd8739ae039)(touch || event, container), dx, dy, s;
        if ((s = subject.call(that, new (0, $2b5eae26da1c0bec$export$2e2bcd8739ae039)("beforestart", {
            sourceEvent: event,
            target: drag,
            identifier: identifier,
            active: active,
            x: p[0],
            y: p[1],
            dx: 0,
            dy: 0,
            dispatch: dispatch
        }), d)) == null) return;
        dx = s.x - p[0] || 0;
        dy = s.y - p[1] || 0;
        return function gesture(type, event, touch) {
            var p0 = p, n;
            switch(type){
                case "start":
                    gestures[identifier] = gesture, n = active++;
                    break;
                case "end":
                    delete gestures[identifier], --active; // falls through
                case "drag":
                    p = (0, $77a090e639ecc3fa$export$2e2bcd8739ae039)(touch || event, container), n = active;
                    break;
            }
            dispatch.call(type, that, new (0, $2b5eae26da1c0bec$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                subject: s,
                target: drag,
                identifier: identifier,
                active: n,
                x: p[0] + dx,
                y: p[1] + dy,
                dx: p[0] - p0[0],
                dy: p[1] - p0[1],
                dispatch: dispatch
            }), d);
        };
    }
    drag.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $fbf326dd4c1d3420$export$2e2bcd8739ae039)(!!_), drag) : filter;
    };
    drag.container = function(_) {
        return arguments.length ? (container = typeof _ === "function" ? _ : (0, $fbf326dd4c1d3420$export$2e2bcd8739ae039)(_), drag) : container;
    };
    drag.subject = function(_) {
        return arguments.length ? (subject = typeof _ === "function" ? _ : (0, $fbf326dd4c1d3420$export$2e2bcd8739ae039)(_), drag) : subject;
    };
    drag.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $fbf326dd4c1d3420$export$2e2bcd8739ae039)(!!_), drag) : touchable;
    };
    drag.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? drag : value;
    };
    drag.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
    };
    return drag;
}



const $b869bf1d00b93ac1$var$StoreContext = (0, $kyXgS.createContext)(null);
const $b869bf1d00b93ac1$var$Provider$1 = $b869bf1d00b93ac1$var$StoreContext.Provider;
const $b869bf1d00b93ac1$var$errorMessages = {
    error001: ()=>'[React Flow]: Seems like you have not used zustand provider as an ancestor. Help: https://reactflow.dev/error#001',
    error002: ()=>"It looks like you've created a new nodeTypes or edgeTypes object. If this wasn't on purpose please define the nodeTypes/edgeTypes outside of the component or memoize them.",
    error003: (nodeType)=>`Node type "${nodeType}" not found. Using fallback type "default".`,
    error004: ()=>'The React Flow parent container needs a width and a height to render the graph.',
    error005: ()=>'Only child nodes can use a parent extent.',
    error006: ()=>"Can't create edge. An edge needs a source and a target.",
    error007: (id)=>`The old edge with id=${id} does not exist.`,
    error009: (type)=>`Marker type "${type}" doesn't exist.`,
    error008: (sourceHandle, edge)=>`Couldn't create edge for ${!sourceHandle ? 'source' : 'target'} handle id: "${!sourceHandle ? edge.sourceHandle : edge.targetHandle}", edge id: ${edge.id}.`,
    error010: ()=>'Handle: No node id found. Make sure to only use a Handle inside a custom Node.',
    error011: (edgeType)=>`Edge type "${edgeType}" not found. Using fallback type "default".`,
    error012: (id)=>`Node with id "${id}" does not exist, it may have been removed. This can happen when a node is deleted before the "onNodeClick" handler is called.`
};
const $b869bf1d00b93ac1$var$zustandErrorMessage = $b869bf1d00b93ac1$var$errorMessages['error001']();
function $b869bf1d00b93ac1$export$6ccbb43953eebf8(selector, equalityFn) {
    const store = (0, $kyXgS.useContext)($b869bf1d00b93ac1$var$StoreContext);
    if (store === null) throw new Error($b869bf1d00b93ac1$var$zustandErrorMessage);
    return (0, $cc7fb5eb30111903$export$2951cba41945c0c8)(store, selector, equalityFn);
}
const $b869bf1d00b93ac1$export$d4cd09bdc073d04b = ()=>{
    const store = (0, $kyXgS.useContext)($b869bf1d00b93ac1$var$StoreContext);
    if (store === null) throw new Error($b869bf1d00b93ac1$var$zustandErrorMessage);
    return (0, $kyXgS.useMemo)(()=>({
            getState: store.getState,
            setState: store.setState,
            subscribe: store.subscribe,
            destroy: store.destroy
        }), [
        store
    ]);
};
const $b869bf1d00b93ac1$var$selector$g = (s)=>s.userSelectionActive ? 'none' : 'all';
function $b869bf1d00b93ac1$export$2ddb90ad54e5f587({ position: position, children: children, className: className, style: style, ...rest }) {
    const pointerEvents = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$g);
    const positionClasses = `${position}`.split('-');
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
        className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
            'react-flow__panel',
            className,
            ...positionClasses
        ]),
        style: {
            ...style,
            pointerEvents: pointerEvents
        },
        ...rest
    }, children);
}
function $b869bf1d00b93ac1$var$Attribution({ proOptions: proOptions, position: position = 'bottom-right' }) {
    if (proOptions?.hideAttribution) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$export$2ddb90ad54e5f587, {
        position: position,
        className: "react-flow__attribution",
        "data-message": "Please only hide this attribution when you are subscribed to React Flow Pro: https://reactflow.dev/pro"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("a", {
        href: "https://reactflow.dev",
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": "React Flow attribution"
    }, "React Flow"));
}
const $b869bf1d00b93ac1$var$EdgeText = ({ x: x, y: y, label: label, labelStyle: labelStyle = {}, labelShowBg: labelShowBg = true, labelBgStyle: labelBgStyle = {}, labelBgPadding: labelBgPadding = [
    2,
    4
], labelBgBorderRadius: labelBgBorderRadius = 2, children: children, className: className, ...rest })=>{
    const edgeRef = (0, $kyXgS.useRef)(null);
    const [edgeTextBbox, setEdgeTextBbox] = (0, $kyXgS.useState)({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    const edgeTextClasses = (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
        'react-flow__edge-textwrapper',
        className
    ]);
    (0, $kyXgS.useEffect)(()=>{
        if (edgeRef.current) {
            const textBbox = edgeRef.current.getBBox();
            setEdgeTextBbox({
                x: textBbox.x,
                y: textBbox.y,
                width: textBbox.width,
                height: textBbox.height
            });
        }
    }, [
        label
    ]);
    if (typeof label === 'undefined' || !label) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("g", {
        transform: `translate(${x - edgeTextBbox.width / 2} ${y - edgeTextBbox.height / 2})`,
        className: edgeTextClasses,
        visibility: edgeTextBbox.width ? 'visible' : 'hidden',
        ...rest
    }, labelShowBg && (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("rect", {
        width: edgeTextBbox.width + 2 * labelBgPadding[0],
        x: -labelBgPadding[0],
        y: -labelBgPadding[1],
        height: edgeTextBbox.height + 2 * labelBgPadding[1],
        className: "react-flow__edge-textbg",
        style: labelBgStyle,
        rx: labelBgBorderRadius,
        ry: labelBgBorderRadius
    }), (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("text", {
        className: "react-flow__edge-text",
        y: edgeTextBbox.height / 2,
        dy: "0.3em",
        ref: edgeRef,
        style: labelStyle
    }, label), children);
};
var $b869bf1d00b93ac1$export$bdefa43adfbd9351 = (0, $kyXgS.memo)($b869bf1d00b93ac1$var$EdgeText);
const $b869bf1d00b93ac1$var$getDimensions = (node)=>({
        width: node.offsetWidth,
        height: node.offsetHeight
    });
const $b869bf1d00b93ac1$export$7d15b64cf5a3a4c4 = (val, min = 0, max = 1)=>Math.min(Math.max(val, min), max);
const $b869bf1d00b93ac1$var$clampPosition = (position = {
    x: 0,
    y: 0
}, extent)=>({
        x: $b869bf1d00b93ac1$export$7d15b64cf5a3a4c4(position.x, extent[0][0], extent[1][0]),
        y: $b869bf1d00b93ac1$export$7d15b64cf5a3a4c4(position.y, extent[0][1], extent[1][1])
    });
// returns a number between 0 and 1 that represents the velocity of the movement
// when the mouse is close to the edge of the canvas
const $b869bf1d00b93ac1$var$calcAutoPanVelocity = (value, min, max)=>{
    if (value < min) return $b869bf1d00b93ac1$export$7d15b64cf5a3a4c4(Math.abs(value - min), 1, 50) / 50;
    else if (value > max) return -$b869bf1d00b93ac1$export$7d15b64cf5a3a4c4(Math.abs(value - max), 1, 50) / 50;
    return 0;
};
const $b869bf1d00b93ac1$var$calcAutoPan = (pos, bounds)=>{
    const xMovement = $b869bf1d00b93ac1$var$calcAutoPanVelocity(pos.x, 35, bounds.width - 35) * 20;
    const yMovement = $b869bf1d00b93ac1$var$calcAutoPanVelocity(pos.y, 35, bounds.height - 35) * 20;
    return [
        xMovement,
        yMovement
    ];
};
const $b869bf1d00b93ac1$var$getHostForElement = (element)=>element.getRootNode?.() || window?.document;
const $b869bf1d00b93ac1$var$getBoundsOfBoxes = (box1, box2)=>({
        x: Math.min(box1.x, box2.x),
        y: Math.min(box1.y, box2.y),
        x2: Math.max(box1.x2, box2.x2),
        y2: Math.max(box1.y2, box2.y2)
    });
const $b869bf1d00b93ac1$export$5497ab15485123ba = ({ x: x, y: y, width: width, height: height })=>({
        x: x,
        y: y,
        x2: x + width,
        y2: y + height
    });
const $b869bf1d00b93ac1$export$1315ec7b81a3b549 = ({ x: x, y: y, x2: x2, y2: y2 })=>({
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    });
const $b869bf1d00b93ac1$var$nodeToRect = (node)=>({
        ...node.positionAbsolute || {
            x: 0,
            y: 0
        },
        width: node.width || 0,
        height: node.height || 0
    });
const $b869bf1d00b93ac1$export$e8bafcabcad2e005 = (rect1, rect2)=>$b869bf1d00b93ac1$export$1315ec7b81a3b549($b869bf1d00b93ac1$var$getBoundsOfBoxes($b869bf1d00b93ac1$export$5497ab15485123ba(rect1), $b869bf1d00b93ac1$export$5497ab15485123ba(rect2)));
const $b869bf1d00b93ac1$var$getOverlappingArea = (rectA, rectB)=>{
    const xOverlap = Math.max(0, Math.min(rectA.x + rectA.width, rectB.x + rectB.width) - Math.max(rectA.x, rectB.x));
    const yOverlap = Math.max(0, Math.min(rectA.y + rectA.height, rectB.y + rectB.height) - Math.max(rectA.y, rectB.y));
    return Math.ceil(xOverlap * yOverlap);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b869bf1d00b93ac1$var$isRectObject = (obj)=>$b869bf1d00b93ac1$var$isNumeric(obj.width) && $b869bf1d00b93ac1$var$isNumeric(obj.height) && $b869bf1d00b93ac1$var$isNumeric(obj.x) && $b869bf1d00b93ac1$var$isNumeric(obj.y);
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */ const $b869bf1d00b93ac1$var$isNumeric = (n)=>!isNaN(n) && isFinite(n);
const $b869bf1d00b93ac1$export$90dfda29e9e20e50 = Symbol.for('internals');
// used for a11y key board controls for nodes and edges
const $b869bf1d00b93ac1$var$elementSelectionKeys = [
    'Enter',
    ' ',
    'Escape'
];
const $b869bf1d00b93ac1$var$devWarn = (id, message)=>{};
const $b869bf1d00b93ac1$var$isReactKeyboardEvent = (event)=>'nativeEvent' in event;
function $b869bf1d00b93ac1$var$isInputDOMNode(event) {
    const kbEvent = $b869bf1d00b93ac1$var$isReactKeyboardEvent(event) ? event.nativeEvent : event;
    // using composed path for handling shadow dom
    const target = kbEvent.composedPath?.()?.[0] || event.target;
    const isInput = [
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ].includes(target?.nodeName) || target?.hasAttribute('contenteditable');
    // when an input field is focused we don't want to trigger deletion or movement of nodes
    return isInput || !!target?.closest('.nokey');
}
const $b869bf1d00b93ac1$var$isMouseEvent = (event)=>'clientX' in event;
const $b869bf1d00b93ac1$var$getEventPosition = (event, bounds)=>{
    const isMouseTriggered = $b869bf1d00b93ac1$var$isMouseEvent(event);
    const evtX = isMouseTriggered ? event.clientX : event.touches?.[0].clientX;
    const evtY = isMouseTriggered ? event.clientY : event.touches?.[0].clientY;
    return {
        x: evtX - (bounds?.left ?? 0),
        y: evtY - (bounds?.top ?? 0)
    };
};
const $b869bf1d00b93ac1$var$isMacOs = ()=>typeof navigator !== 'undefined' && navigator?.userAgent?.indexOf('Mac') >= 0;
const $b869bf1d00b93ac1$export$b746b7c1be3cefa0 = ({ id: id, path: path, labelX: labelX, labelY: labelY, label: label, labelStyle: labelStyle, labelShowBg: labelShowBg, labelBgStyle: labelBgStyle, labelBgPadding: labelBgPadding, labelBgBorderRadius: labelBgBorderRadius, style: style, markerEnd: markerEnd, markerStart: markerStart, interactionWidth: interactionWidth = 20 })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("path", {
        id: id,
        style: style,
        d: path,
        fill: "none",
        className: "react-flow__edge-path",
        markerEnd: markerEnd,
        markerStart: markerStart
    }), interactionWidth && (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("path", {
        d: path,
        fill: "none",
        strokeOpacity: 0,
        strokeWidth: interactionWidth,
        className: "react-flow__edge-interaction"
    }), label && $b869bf1d00b93ac1$var$isNumeric(labelX) && $b869bf1d00b93ac1$var$isNumeric(labelY) ? (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$export$bdefa43adfbd9351, {
        x: labelX,
        y: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius
    }) : null);
};
$b869bf1d00b93ac1$export$b746b7c1be3cefa0.displayName = 'BaseEdge';
const $b869bf1d00b93ac1$export$ff4bab9585146bc2 = (markerType, markerEndId)=>{
    if (typeof markerEndId !== 'undefined' && markerEndId) return `url(#${markerEndId})`;
    return typeof markerType !== 'undefined' ? `url(#react-flow__${markerType})` : 'none';
};
function $b869bf1d00b93ac1$var$getMouseHandler$1(id, getState, handler) {
    return handler === undefined ? handler : (event)=>{
        const edge = getState().edges.find((e)=>e.id === id);
        if (edge) handler(event, {
            ...edge
        });
    };
}
// this is used for straight edges and simple smoothstep edges (LTR, RTL, BTT, TTB)
function $b869bf1d00b93ac1$var$getEdgeCenter({ sourceX: sourceX, sourceY: sourceY, targetX: targetX, targetY: targetY }) {
    const xOffset = Math.abs(targetX - sourceX) / 2;
    const centerX = targetX < sourceX ? targetX + xOffset : targetX - xOffset;
    const yOffset = Math.abs(targetY - sourceY) / 2;
    const centerY = targetY < sourceY ? targetY + yOffset : targetY - yOffset;
    return [
        centerX,
        centerY,
        xOffset,
        yOffset
    ];
}
function $b869bf1d00b93ac1$var$getBezierEdgeCenter({ sourceX: sourceX, sourceY: sourceY, targetX: targetX, targetY: targetY, sourceControlX: sourceControlX, sourceControlY: sourceControlY, targetControlX: targetControlX, targetControlY: targetControlY }) {
    // cubic bezier t=0.5 mid point, not the actual mid point, but easy to calculate
    // https://stackoverflow.com/questions/67516101/how-to-find-distance-mid-point-of-bezier-curve
    const centerX = sourceX * 0.125 + sourceControlX * 0.375 + targetControlX * 0.375 + targetX * 0.125;
    const centerY = sourceY * 0.125 + sourceControlY * 0.375 + targetControlY * 0.375 + targetY * 0.125;
    const offsetX = Math.abs(centerX - sourceX);
    const offsetY = Math.abs(centerY - sourceY);
    return [
        centerX,
        centerY,
        offsetX,
        offsetY
    ];
}
var $b869bf1d00b93ac1$export$37c58f76dbdd36f6;
(function(ConnectionMode) {
    ConnectionMode["Strict"] = "strict";
    ConnectionMode["Loose"] = "loose";
})($b869bf1d00b93ac1$export$37c58f76dbdd36f6 || ($b869bf1d00b93ac1$export$37c58f76dbdd36f6 = {}));
var $b869bf1d00b93ac1$export$5579ce9cc1808963;
(function(PanOnScrollMode) {
    PanOnScrollMode["Free"] = "free";
    PanOnScrollMode["Vertical"] = "vertical";
    PanOnScrollMode["Horizontal"] = "horizontal";
})($b869bf1d00b93ac1$export$5579ce9cc1808963 || ($b869bf1d00b93ac1$export$5579ce9cc1808963 = {}));
var $b869bf1d00b93ac1$export$91484609d16ec765;
(function(SelectionMode) {
    SelectionMode["Partial"] = "partial";
    SelectionMode["Full"] = "full";
})($b869bf1d00b93ac1$export$91484609d16ec765 || ($b869bf1d00b93ac1$export$91484609d16ec765 = {}));
var $b869bf1d00b93ac1$export$49e43009c370635d;
(function(ConnectionLineType) {
    ConnectionLineType["Bezier"] = "default";
    ConnectionLineType["Straight"] = "straight";
    ConnectionLineType["Step"] = "step";
    ConnectionLineType["SmoothStep"] = "smoothstep";
    ConnectionLineType["SimpleBezier"] = "simplebezier";
})($b869bf1d00b93ac1$export$49e43009c370635d || ($b869bf1d00b93ac1$export$49e43009c370635d = {}));
var $b869bf1d00b93ac1$export$196ed004c7fb0ef2;
(function(MarkerType) {
    MarkerType["Arrow"] = "arrow";
    MarkerType["ArrowClosed"] = "arrowclosed";
})($b869bf1d00b93ac1$export$196ed004c7fb0ef2 || ($b869bf1d00b93ac1$export$196ed004c7fb0ef2 = {}));
var $b869bf1d00b93ac1$export$13807d9ee5a34a42;
(function(Position) {
    Position["Left"] = "left";
    Position["Top"] = "top";
    Position["Right"] = "right";
    Position["Bottom"] = "bottom";
})($b869bf1d00b93ac1$export$13807d9ee5a34a42 || ($b869bf1d00b93ac1$export$13807d9ee5a34a42 = {}));
function $b869bf1d00b93ac1$var$getControl({ pos: pos, x1: x1, y1: y1, x2: x2, y2: y2 }) {
    if (pos === $b869bf1d00b93ac1$export$13807d9ee5a34a42.Left || pos === $b869bf1d00b93ac1$export$13807d9ee5a34a42.Right) return [
        0.5 * (x1 + x2),
        y1
    ];
    return [
        x1,
        0.5 * (y1 + y2)
    ];
}
function $b869bf1d00b93ac1$export$a597383ee13c36d4({ sourceX: sourceX, sourceY: sourceY, sourcePosition: sourcePosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom, targetX: targetX, targetY: targetY, targetPosition: targetPosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top }) {
    const [sourceControlX, sourceControlY] = $b869bf1d00b93ac1$var$getControl({
        pos: sourcePosition,
        x1: sourceX,
        y1: sourceY,
        x2: targetX,
        y2: targetY
    });
    const [targetControlX, targetControlY] = $b869bf1d00b93ac1$var$getControl({
        pos: targetPosition,
        x1: targetX,
        y1: targetY,
        x2: sourceX,
        y2: sourceY
    });
    const [labelX, labelY, offsetX, offsetY] = $b869bf1d00b93ac1$var$getBezierEdgeCenter({
        sourceX: sourceX,
        sourceY: sourceY,
        targetX: targetX,
        targetY: targetY,
        sourceControlX: sourceControlX,
        sourceControlY: sourceControlY,
        targetControlX: targetControlX,
        targetControlY: targetControlY
    });
    return [
        `M${sourceX},${sourceY} C${sourceControlX},${sourceControlY} ${targetControlX},${targetControlY} ${targetX},${targetY}`,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const $b869bf1d00b93ac1$export$b169c4f890f251a6 = (0, $kyXgS.memo)(({ sourceX: sourceX, sourceY: sourceY, targetX: targetX, targetY: targetY, sourcePosition: sourcePosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom, targetPosition: targetPosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top, label: label, labelStyle: labelStyle, labelShowBg: labelShowBg, labelBgStyle: labelBgStyle, labelBgPadding: labelBgPadding, labelBgBorderRadius: labelBgBorderRadius, style: style, markerEnd: markerEnd, markerStart: markerStart, interactionWidth: interactionWidth })=>{
    const [path, labelX, labelY] = $b869bf1d00b93ac1$export$a597383ee13c36d4({
        sourceX: sourceX,
        sourceY: sourceY,
        sourcePosition: sourcePosition,
        targetX: targetX,
        targetY: targetY,
        targetPosition: targetPosition
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$export$b746b7c1be3cefa0, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
$b869bf1d00b93ac1$export$b169c4f890f251a6.displayName = 'SimpleBezierEdge';
const $b869bf1d00b93ac1$var$handleDirections = {
    [$b869bf1d00b93ac1$export$13807d9ee5a34a42.Left]: {
        x: -1,
        y: 0
    },
    [$b869bf1d00b93ac1$export$13807d9ee5a34a42.Right]: {
        x: 1,
        y: 0
    },
    [$b869bf1d00b93ac1$export$13807d9ee5a34a42.Top]: {
        x: 0,
        y: -1
    },
    [$b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom]: {
        x: 0,
        y: 1
    }
};
const $b869bf1d00b93ac1$var$getDirection = ({ source: source, sourcePosition: sourcePosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom, target: target })=>{
    if (sourcePosition === $b869bf1d00b93ac1$export$13807d9ee5a34a42.Left || sourcePosition === $b869bf1d00b93ac1$export$13807d9ee5a34a42.Right) return source.x < target.x ? {
        x: 1,
        y: 0
    } : {
        x: -1,
        y: 0
    };
    return source.y < target.y ? {
        x: 0,
        y: 1
    } : {
        x: 0,
        y: -1
    };
};
const $b869bf1d00b93ac1$var$distance = (a, b)=>Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
// ith this function we try to mimic a orthogonal edge routing behaviour
// It's not as good as a real orthogonal edge routing but it's faster and good enough as a default for step and smooth step edges
function $b869bf1d00b93ac1$var$getPoints({ source: source, sourcePosition: sourcePosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom, target: target, targetPosition: targetPosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top, center: center, offset: offset }) {
    const sourceDir = $b869bf1d00b93ac1$var$handleDirections[sourcePosition];
    const targetDir = $b869bf1d00b93ac1$var$handleDirections[targetPosition];
    const sourceGapped = {
        x: source.x + sourceDir.x * offset,
        y: source.y + sourceDir.y * offset
    };
    const targetGapped = {
        x: target.x + targetDir.x * offset,
        y: target.y + targetDir.y * offset
    };
    const dir = $b869bf1d00b93ac1$var$getDirection({
        source: sourceGapped,
        sourcePosition: sourcePosition,
        target: targetGapped
    });
    const dirAccessor = dir.x !== 0 ? 'x' : 'y';
    const currDir = dir[dirAccessor];
    let points = [];
    let centerX, centerY;
    const sourceGapOffset = {
        x: 0,
        y: 0
    };
    const targetGapOffset = {
        x: 0,
        y: 0
    };
    const [defaultCenterX, defaultCenterY, defaultOffsetX, defaultOffsetY] = $b869bf1d00b93ac1$var$getEdgeCenter({
        sourceX: source.x,
        sourceY: source.y,
        targetX: target.x,
        targetY: target.y
    });
    // opposite handle positions, default case
    if (sourceDir[dirAccessor] * targetDir[dirAccessor] === -1) {
        centerX = center.x ?? defaultCenterX;
        centerY = center.y ?? defaultCenterY;
        //    --->
        //    |
        // >---
        const verticalSplit = [
            {
                x: centerX,
                y: sourceGapped.y
            },
            {
                x: centerX,
                y: targetGapped.y
            }
        ];
        //    |
        //  ---
        //  |
        const horizontalSplit = [
            {
                x: sourceGapped.x,
                y: centerY
            },
            {
                x: targetGapped.x,
                y: centerY
            }
        ];
        if (sourceDir[dirAccessor] === currDir) points = dirAccessor === 'x' ? verticalSplit : horizontalSplit;
        else points = dirAccessor === 'x' ? horizontalSplit : verticalSplit;
    } else {
        // sourceTarget means we take x from source and y from target, targetSource is the opposite
        const sourceTarget = [
            {
                x: sourceGapped.x,
                y: targetGapped.y
            }
        ];
        const targetSource = [
            {
                x: targetGapped.x,
                y: sourceGapped.y
            }
        ];
        // this handles edges with same handle positions
        if (dirAccessor === 'x') points = sourceDir.x === currDir ? targetSource : sourceTarget;
        else points = sourceDir.y === currDir ? sourceTarget : targetSource;
        if (sourcePosition === targetPosition) {
            const diff = Math.abs(source[dirAccessor] - target[dirAccessor]);
            // if an edge goes from right to right for example (sourcePosition === targetPosition) and the distance between source.x and target.x is less than the offset, the added point and the gapped source/target will overlap. This leads to a weird edge path. To avoid this we add a gapOffset to the source/target
            if (diff <= offset) {
                const gapOffset = Math.min(offset - 1, offset - diff);
                if (sourceDir[dirAccessor] === currDir) sourceGapOffset[dirAccessor] = (sourceGapped[dirAccessor] > source[dirAccessor] ? -1 : 1) * gapOffset;
                else targetGapOffset[dirAccessor] = (targetGapped[dirAccessor] > target[dirAccessor] ? -1 : 1) * gapOffset;
            }
        }
        // these are conditions for handling mixed handle positions like Right -> Bottom for example
        if (sourcePosition !== targetPosition) {
            const dirAccessorOpposite = dirAccessor === 'x' ? 'y' : 'x';
            const isSameDir = sourceDir[dirAccessor] === targetDir[dirAccessorOpposite];
            const sourceGtTargetOppo = sourceGapped[dirAccessorOpposite] > targetGapped[dirAccessorOpposite];
            const sourceLtTargetOppo = sourceGapped[dirAccessorOpposite] < targetGapped[dirAccessorOpposite];
            const flipSourceTarget = sourceDir[dirAccessor] === 1 && (!isSameDir && sourceGtTargetOppo || isSameDir && sourceLtTargetOppo) || sourceDir[dirAccessor] !== 1 && (!isSameDir && sourceLtTargetOppo || isSameDir && sourceGtTargetOppo);
            if (flipSourceTarget) points = dirAccessor === 'x' ? sourceTarget : targetSource;
        }
        const sourceGapPoint = {
            x: sourceGapped.x + sourceGapOffset.x,
            y: sourceGapped.y + sourceGapOffset.y
        };
        const targetGapPoint = {
            x: targetGapped.x + targetGapOffset.x,
            y: targetGapped.y + targetGapOffset.y
        };
        const maxXDistance = Math.max(Math.abs(sourceGapPoint.x - points[0].x), Math.abs(targetGapPoint.x - points[0].x));
        const maxYDistance = Math.max(Math.abs(sourceGapPoint.y - points[0].y), Math.abs(targetGapPoint.y - points[0].y));
        // we want to place the label on the longest segment of the edge
        if (maxXDistance >= maxYDistance) {
            centerX = (sourceGapPoint.x + targetGapPoint.x) / 2;
            centerY = points[0].y;
        } else {
            centerX = points[0].x;
            centerY = (sourceGapPoint.y + targetGapPoint.y) / 2;
        }
    }
    const pathPoints = [
        source,
        {
            x: sourceGapped.x + sourceGapOffset.x,
            y: sourceGapped.y + sourceGapOffset.y
        },
        ...points,
        {
            x: targetGapped.x + targetGapOffset.x,
            y: targetGapped.y + targetGapOffset.y
        },
        target
    ];
    return [
        pathPoints,
        centerX,
        centerY,
        defaultOffsetX,
        defaultOffsetY
    ];
}
function $b869bf1d00b93ac1$var$getBend(a, b, c, size) {
    const bendSize = Math.min($b869bf1d00b93ac1$var$distance(a, b) / 2, $b869bf1d00b93ac1$var$distance(b, c) / 2, size);
    const { x: x, y: y } = b;
    // no bend
    if (a.x === x && x === c.x || a.y === y && y === c.y) return `L${x} ${y}`;
    // first segment is horizontal
    if (a.y === y) {
        const xDir = a.x < c.x ? -1 : 1;
        const yDir = a.y < c.y ? 1 : -1;
        return `L ${x + bendSize * xDir},${y}Q ${x},${y} ${x},${y + bendSize * yDir}`;
    }
    const xDir = a.x < c.x ? 1 : -1;
    const yDir = a.y < c.y ? -1 : 1;
    return `L ${x},${y + bendSize * yDir}Q ${x},${y} ${x + bendSize * xDir},${y}`;
}
function $b869bf1d00b93ac1$export$a4b13b3fba17cda7({ sourceX: sourceX, sourceY: sourceY, sourcePosition: sourcePosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom, targetX: targetX, targetY: targetY, targetPosition: targetPosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top, borderRadius: borderRadius = 5, centerX: centerX, centerY: centerY, offset: offset = 20 }) {
    const [points, labelX, labelY, offsetX, offsetY] = $b869bf1d00b93ac1$var$getPoints({
        source: {
            x: sourceX,
            y: sourceY
        },
        sourcePosition: sourcePosition,
        target: {
            x: targetX,
            y: targetY
        },
        targetPosition: targetPosition,
        center: {
            x: centerX,
            y: centerY
        },
        offset: offset
    });
    const path = points.reduce((res, p, i)=>{
        let segment = '';
        if (i > 0 && i < points.length - 1) segment = $b869bf1d00b93ac1$var$getBend(points[i - 1], p, points[i + 1], borderRadius);
        else segment = `${i === 0 ? 'M' : 'L'}${p.x} ${p.y}`;
        res += segment;
        return res;
    }, '');
    return [
        path,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const $b869bf1d00b93ac1$export$5a9a9b2ccbc8cfc8 = (0, $kyXgS.memo)(({ sourceX: sourceX, sourceY: sourceY, targetX: targetX, targetY: targetY, label: label, labelStyle: labelStyle, labelShowBg: labelShowBg, labelBgStyle: labelBgStyle, labelBgPadding: labelBgPadding, labelBgBorderRadius: labelBgBorderRadius, style: style, sourcePosition: sourcePosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom, targetPosition: targetPosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top, markerEnd: markerEnd, markerStart: markerStart, pathOptions: pathOptions, interactionWidth: interactionWidth })=>{
    const [path, labelX, labelY] = $b869bf1d00b93ac1$export$a4b13b3fba17cda7({
        sourceX: sourceX,
        sourceY: sourceY,
        sourcePosition: sourcePosition,
        targetX: targetX,
        targetY: targetY,
        targetPosition: targetPosition,
        borderRadius: pathOptions?.borderRadius,
        offset: pathOptions?.offset
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$export$b746b7c1be3cefa0, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
$b869bf1d00b93ac1$export$5a9a9b2ccbc8cfc8.displayName = 'SmoothStepEdge';
const $b869bf1d00b93ac1$export$e27f63bd159868f = (0, $kyXgS.memo)((props)=>(0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$export$5a9a9b2ccbc8cfc8, {
        ...props,
        pathOptions: (0, $kyXgS.useMemo)(()=>({
                borderRadius: 0,
                offset: props.pathOptions?.offset
            }), [
            props.pathOptions?.offset
        ])
    }));
$b869bf1d00b93ac1$export$e27f63bd159868f.displayName = 'StepEdge';
function $b869bf1d00b93ac1$export$274aa1781d6a4525({ sourceX: sourceX, sourceY: sourceY, targetX: targetX, targetY: targetY }) {
    const [labelX, labelY, offsetX, offsetY] = $b869bf1d00b93ac1$var$getEdgeCenter({
        sourceX: sourceX,
        sourceY: sourceY,
        targetX: targetX,
        targetY: targetY
    });
    return [
        `M ${sourceX},${sourceY}L ${targetX},${targetY}`,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const $b869bf1d00b93ac1$export$39f45342fd1fc782 = (0, $kyXgS.memo)(({ sourceX: sourceX, sourceY: sourceY, targetX: targetX, targetY: targetY, label: label, labelStyle: labelStyle, labelShowBg: labelShowBg, labelBgStyle: labelBgStyle, labelBgPadding: labelBgPadding, labelBgBorderRadius: labelBgBorderRadius, style: style, markerEnd: markerEnd, markerStart: markerStart, interactionWidth: interactionWidth })=>{
    const [path, labelX, labelY] = $b869bf1d00b93ac1$export$274aa1781d6a4525({
        sourceX: sourceX,
        sourceY: sourceY,
        targetX: targetX,
        targetY: targetY
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$export$b746b7c1be3cefa0, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
$b869bf1d00b93ac1$export$39f45342fd1fc782.displayName = 'StraightEdge';
function $b869bf1d00b93ac1$var$calculateControlOffset(distance, curvature) {
    if (distance >= 0) return 0.5 * distance;
    return curvature * 25 * Math.sqrt(-distance);
}
function $b869bf1d00b93ac1$var$getControlWithCurvature({ pos: pos, x1: x1, y1: y1, x2: x2, y2: y2, c: c }) {
    switch(pos){
        case $b869bf1d00b93ac1$export$13807d9ee5a34a42.Left:
            return [
                x1 - $b869bf1d00b93ac1$var$calculateControlOffset(x1 - x2, c),
                y1
            ];
        case $b869bf1d00b93ac1$export$13807d9ee5a34a42.Right:
            return [
                x1 + $b869bf1d00b93ac1$var$calculateControlOffset(x2 - x1, c),
                y1
            ];
        case $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top:
            return [
                x1,
                y1 - $b869bf1d00b93ac1$var$calculateControlOffset(y1 - y2, c)
            ];
        case $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom:
            return [
                x1,
                y1 + $b869bf1d00b93ac1$var$calculateControlOffset(y2 - y1, c)
            ];
    }
}
function $b869bf1d00b93ac1$export$b2afe50f305285f6({ sourceX: sourceX, sourceY: sourceY, sourcePosition: sourcePosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom, targetX: targetX, targetY: targetY, targetPosition: targetPosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top, curvature: curvature = 0.25 }) {
    const [sourceControlX, sourceControlY] = $b869bf1d00b93ac1$var$getControlWithCurvature({
        pos: sourcePosition,
        x1: sourceX,
        y1: sourceY,
        x2: targetX,
        y2: targetY,
        c: curvature
    });
    const [targetControlX, targetControlY] = $b869bf1d00b93ac1$var$getControlWithCurvature({
        pos: targetPosition,
        x1: targetX,
        y1: targetY,
        x2: sourceX,
        y2: sourceY,
        c: curvature
    });
    const [labelX, labelY, offsetX, offsetY] = $b869bf1d00b93ac1$var$getBezierEdgeCenter({
        sourceX: sourceX,
        sourceY: sourceY,
        targetX: targetX,
        targetY: targetY,
        sourceControlX: sourceControlX,
        sourceControlY: sourceControlY,
        targetControlX: targetControlX,
        targetControlY: targetControlY
    });
    return [
        `M${sourceX},${sourceY} C${sourceControlX},${sourceControlY} ${targetControlX},${targetControlY} ${targetX},${targetY}`,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const $b869bf1d00b93ac1$export$f207ae4ec106d908 = (0, $kyXgS.memo)(({ sourceX: sourceX, sourceY: sourceY, targetX: targetX, targetY: targetY, sourcePosition: sourcePosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom, targetPosition: targetPosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top, label: label, labelStyle: labelStyle, labelShowBg: labelShowBg, labelBgStyle: labelBgStyle, labelBgPadding: labelBgPadding, labelBgBorderRadius: labelBgBorderRadius, style: style, markerEnd: markerEnd, markerStart: markerStart, pathOptions: pathOptions, interactionWidth: interactionWidth })=>{
    const [path, labelX, labelY] = $b869bf1d00b93ac1$export$b2afe50f305285f6({
        sourceX: sourceX,
        sourceY: sourceY,
        sourcePosition: sourcePosition,
        targetX: targetX,
        targetY: targetY,
        targetPosition: targetPosition,
        curvature: pathOptions?.curvature
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$export$b746b7c1be3cefa0, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
$b869bf1d00b93ac1$export$f207ae4ec106d908.displayName = 'BezierEdge';
const $b869bf1d00b93ac1$var$NodeIdContext = (0, $kyXgS.createContext)(null);
const $b869bf1d00b93ac1$var$Provider = $b869bf1d00b93ac1$var$NodeIdContext.Provider;
$b869bf1d00b93ac1$var$NodeIdContext.Consumer;
const $b869bf1d00b93ac1$export$5aa3743c980ed33f = ()=>{
    const nodeId = (0, $kyXgS.useContext)($b869bf1d00b93ac1$var$NodeIdContext);
    return nodeId;
};
const $b869bf1d00b93ac1$export$cac3980734d91fbe = (element)=>'id' in element && 'source' in element && 'target' in element;
const $b869bf1d00b93ac1$export$8ee0fc9ee280b4ee = (element)=>'id' in element && !('source' in element) && !('target' in element);
const $b869bf1d00b93ac1$export$6b8c777bd3b0e8db = (node, nodes, edges)=>{
    if (!$b869bf1d00b93ac1$export$8ee0fc9ee280b4ee(node)) return [];
    const outgoerIds = edges.filter((e)=>e.source === node.id).map((e)=>e.target);
    return nodes.filter((n)=>outgoerIds.includes(n.id));
};
const $b869bf1d00b93ac1$export$e4c80a26821ebc7e = (node, nodes, edges)=>{
    if (!$b869bf1d00b93ac1$export$8ee0fc9ee280b4ee(node)) return [];
    const incomersIds = edges.filter((e)=>e.target === node.id).map((e)=>e.source);
    return nodes.filter((n)=>incomersIds.includes(n.id));
};
const $b869bf1d00b93ac1$var$getEdgeId = ({ source: source, sourceHandle: sourceHandle, target: target, targetHandle: targetHandle })=>`reactflow__edge-${source}${sourceHandle || ''}-${target}${targetHandle || ''}`;
const $b869bf1d00b93ac1$var$getMarkerId = (marker, rfId)=>{
    if (typeof marker === 'undefined') return '';
    if (typeof marker === 'string') return marker;
    const idPrefix = rfId ? `${rfId}__` : '';
    return `${idPrefix}${Object.keys(marker).sort().map((key)=>`${key}=${marker[key]}`).join('&')}`;
};
const $b869bf1d00b93ac1$var$connectionExists = (edge, edges)=>{
    return edges.some((el)=>el.source === edge.source && el.target === edge.target && (el.sourceHandle === edge.sourceHandle || !el.sourceHandle && !edge.sourceHandle) && (el.targetHandle === edge.targetHandle || !el.targetHandle && !edge.targetHandle));
};
const $b869bf1d00b93ac1$export$3b35d6dc248b6d92 = (edgeParams, edges)=>{
    if (!edgeParams.source || !edgeParams.target) {
        $b869bf1d00b93ac1$var$devWarn('006', $b869bf1d00b93ac1$var$errorMessages['error006']());
        return edges;
    }
    let edge;
    if ($b869bf1d00b93ac1$export$cac3980734d91fbe(edgeParams)) edge = {
        ...edgeParams
    };
    else edge = {
        ...edgeParams,
        id: $b869bf1d00b93ac1$var$getEdgeId(edgeParams)
    };
    if ($b869bf1d00b93ac1$var$connectionExists(edge, edges)) return edges;
    return edges.concat(edge);
};
const $b869bf1d00b93ac1$export$a57ab3891df89472 = (oldEdge, newConnection, edges, options = {
    shouldReplaceId: true
})=>{
    const { id: oldEdgeId, ...rest } = oldEdge;
    if (!newConnection.source || !newConnection.target) {
        $b869bf1d00b93ac1$var$devWarn('006', $b869bf1d00b93ac1$var$errorMessages['error006']());
        return edges;
    }
    const foundEdge = edges.find((e)=>e.id === oldEdgeId);
    if (!foundEdge) {
        $b869bf1d00b93ac1$var$devWarn('007', $b869bf1d00b93ac1$var$errorMessages['error007'](oldEdgeId));
        return edges;
    }
    // Remove old edge and create the new edge with parameters of old edge.
    const edge = {
        ...rest,
        id: options.shouldReplaceId ? $b869bf1d00b93ac1$var$getEdgeId(newConnection) : oldEdgeId,
        source: newConnection.source,
        target: newConnection.target,
        sourceHandle: newConnection.sourceHandle,
        targetHandle: newConnection.targetHandle
    };
    return edges.filter((e)=>e.id !== oldEdgeId).concat(edge);
};
/**
 *
 * @deprecated Use `reconnectEdge` instead.
 */ const $b869bf1d00b93ac1$export$8fb6760b638329c6 = (oldEdge, newConnection, edges, options = {
    shouldReplaceId: true
})=>{
    console.warn('[DEPRECATED] `updateEdge` is deprecated. Instead use `reconnectEdge` https://reactflow.dev/api-reference/utils/reconnect-edge');
    return $b869bf1d00b93ac1$export$a57ab3891df89472(oldEdge, newConnection, edges, options);
};
const $b869bf1d00b93ac1$var$pointToRendererPoint = ({ x: x, y: y }, [tx, ty, tScale], snapToGrid, [snapX, snapY])=>{
    const position = {
        x: (x - tx) / tScale,
        y: (y - ty) / tScale
    };
    if (snapToGrid) return {
        x: snapX * Math.round(position.x / snapX),
        y: snapY * Math.round(position.y / snapY)
    };
    return position;
};
const $b869bf1d00b93ac1$var$rendererPointToPoint = ({ x: x, y: y }, [tx, ty, tScale])=>{
    return {
        x: x * tScale + tx,
        y: y * tScale + ty
    };
};
const $b869bf1d00b93ac1$export$72c5647f6be28a9c = (node, nodeOrigin = [
    0,
    0
])=>{
    if (!node) return {
        x: 0,
        y: 0,
        positionAbsolute: {
            x: 0,
            y: 0
        }
    };
    const offsetX = (node.width ?? 0) * nodeOrigin[0];
    const offsetY = (node.height ?? 0) * nodeOrigin[1];
    const position = {
        x: node.position.x - offsetX,
        y: node.position.y - offsetY
    };
    return {
        ...position,
        positionAbsolute: node.positionAbsolute ? {
            x: node.positionAbsolute.x - offsetX,
            y: node.positionAbsolute.y - offsetY
        } : position
    };
};
const $b869bf1d00b93ac1$export$d5a2bfe3c0f7d322 = (nodes, nodeOrigin = [
    0,
    0
])=>{
    if (nodes.length === 0) return {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    };
    const box = nodes.reduce((currBox, node)=>{
        const { x: x, y: y } = $b869bf1d00b93ac1$export$72c5647f6be28a9c(node, nodeOrigin).positionAbsolute;
        return $b869bf1d00b93ac1$var$getBoundsOfBoxes(currBox, $b869bf1d00b93ac1$export$5497ab15485123ba({
            x: x,
            y: y,
            width: node.width || 0,
            height: node.height || 0
        }));
    }, {
        x: Infinity,
        y: Infinity,
        x2: -Infinity,
        y2: -Infinity
    });
    return $b869bf1d00b93ac1$export$1315ec7b81a3b549(box);
};
// @deprecated Use `getNodesBounds`.
const $b869bf1d00b93ac1$export$b34899c2366fe3bd = (nodes, nodeOrigin = [
    0,
    0
])=>{
    console.warn('[DEPRECATED] `getRectOfNodes` is deprecated. Instead use `getNodesBounds` https://reactflow.dev/api-reference/utils/get-nodes-bounds.');
    return $b869bf1d00b93ac1$export$d5a2bfe3c0f7d322(nodes, nodeOrigin);
};
const $b869bf1d00b93ac1$var$getNodesInside = (nodeInternals, rect, [tx, ty, tScale] = [
    0,
    0,
    1
], partially = false, // set excludeNonSelectableNodes if you want to pay attention to the nodes "selectable" attribute
excludeNonSelectableNodes = false, nodeOrigin = [
    0,
    0
])=>{
    const paneRect = {
        x: (rect.x - tx) / tScale,
        y: (rect.y - ty) / tScale,
        width: rect.width / tScale,
        height: rect.height / tScale
    };
    const visibleNodes = [];
    nodeInternals.forEach((node)=>{
        const { width: width, height: height, selectable: selectable = true, hidden: hidden = false } = node;
        if (excludeNonSelectableNodes && !selectable || hidden) return false;
        const { positionAbsolute: positionAbsolute } = $b869bf1d00b93ac1$export$72c5647f6be28a9c(node, nodeOrigin);
        const nodeRect = {
            x: positionAbsolute.x,
            y: positionAbsolute.y,
            width: width || 0,
            height: height || 0
        };
        const overlappingArea = $b869bf1d00b93ac1$var$getOverlappingArea(paneRect, nodeRect);
        const notInitialized = typeof width === 'undefined' || typeof height === 'undefined' || width === null || height === null;
        const partiallyVisible = partially && overlappingArea > 0;
        const area = (width || 0) * (height || 0);
        const isVisible = notInitialized || partiallyVisible || overlappingArea >= area;
        if (isVisible || node.dragging) visibleNodes.push(node);
    });
    return visibleNodes;
};
const $b869bf1d00b93ac1$export$d21e19ffbf7ce542 = (nodes, edges)=>{
    const nodeIds = nodes.map((node)=>node.id);
    return edges.filter((edge)=>nodeIds.includes(edge.source) || nodeIds.includes(edge.target));
};
// @deprecated Use `getViewportForBounds`.
const $b869bf1d00b93ac1$export$5bae406c4a771dc8 = (bounds, width, height, minZoom, maxZoom, padding = 0.1)=>{
    const { x: x, y: y, zoom: zoom } = $b869bf1d00b93ac1$export$1ef7dc91ffb32547(bounds, width, height, minZoom, maxZoom, padding);
    console.warn('[DEPRECATED] `getTransformForBounds` is deprecated. Instead use `getViewportForBounds`. Beware that the return value is type Viewport (`{ x: number, y: number, zoom: number }`) instead of Transform (`[number, number, number]`). https://reactflow.dev/api-reference/utils/get-viewport-for-bounds');
    return [
        x,
        y,
        zoom
    ];
};
const $b869bf1d00b93ac1$export$1ef7dc91ffb32547 = (bounds, width, height, minZoom, maxZoom, padding = 0.1)=>{
    const xZoom = width / (bounds.width * (1 + padding));
    const yZoom = height / (bounds.height * (1 + padding));
    const zoom = Math.min(xZoom, yZoom);
    const clampedZoom = $b869bf1d00b93ac1$export$7d15b64cf5a3a4c4(zoom, minZoom, maxZoom);
    const boundsCenterX = bounds.x + bounds.width / 2;
    const boundsCenterY = bounds.y + bounds.height / 2;
    const x = width / 2 - boundsCenterX * clampedZoom;
    const y = height / 2 - boundsCenterY * clampedZoom;
    return {
        x: x,
        y: y,
        zoom: clampedZoom
    };
};
const $b869bf1d00b93ac1$var$getD3Transition = (selection, duration = 0)=>{
    return selection.transition().duration(duration);
};
// this functions collects all handles and adds an absolute position
// so that we can later find the closest handle to the mouse position
function $b869bf1d00b93ac1$var$getHandles(node, handleBounds, type, currentHandle) {
    return (handleBounds[type] || []).reduce((res, h)=>{
        if (`${node.id}-${h.id}-${type}` !== currentHandle) res.push({
            id: h.id || null,
            type: type,
            nodeId: node.id,
            x: (node.positionAbsolute?.x ?? 0) + h.x + h.width / 2,
            y: (node.positionAbsolute?.y ?? 0) + h.y + h.height / 2
        });
        return res;
    }, []);
}
function $b869bf1d00b93ac1$var$getClosestHandle(event, doc, pos, connectionRadius, handles, validator) {
    // we always want to prioritize the handle below the mouse cursor over the closest distance handle,
    // because it could be that the center of another handle is closer to the mouse pointer than the handle below the cursor
    const { x: x, y: y } = $b869bf1d00b93ac1$var$getEventPosition(event);
    const domNodes = doc.elementsFromPoint(x, y);
    const handleBelow = domNodes.find((el)=>el.classList.contains('react-flow__handle'));
    if (handleBelow) {
        const handleNodeId = handleBelow.getAttribute('data-nodeid');
        if (handleNodeId) {
            const handleType = $b869bf1d00b93ac1$var$getHandleType(undefined, handleBelow);
            const handleId = handleBelow.getAttribute('data-handleid');
            const validHandleResult = validator({
                nodeId: handleNodeId,
                id: handleId,
                type: handleType
            });
            if (validHandleResult) {
                const handle = handles.find((h)=>h.nodeId === handleNodeId && h.type === handleType && h.id === handleId);
                return {
                    handle: {
                        id: handleId,
                        type: handleType,
                        nodeId: handleNodeId,
                        x: handle?.x || pos.x,
                        y: handle?.y || pos.y
                    },
                    validHandleResult: validHandleResult
                };
            }
        }
    }
    // if we couldn't find a handle below the mouse cursor we look for the closest distance based on the connectionRadius
    let closestHandles = [];
    let minDistance = Infinity;
    handles.forEach((handle)=>{
        const distance = Math.sqrt((handle.x - pos.x) ** 2 + (handle.y - pos.y) ** 2);
        if (distance <= connectionRadius) {
            const validHandleResult = validator(handle);
            if (distance <= minDistance) {
                if (distance < minDistance) closestHandles = [
                    {
                        handle: handle,
                        validHandleResult: validHandleResult
                    }
                ];
                else if (distance === minDistance) // when multiple handles are on the same distance we collect all of them
                closestHandles.push({
                    handle: handle,
                    validHandleResult: validHandleResult
                });
                minDistance = distance;
            }
        }
    });
    if (!closestHandles.length) return {
        handle: null,
        validHandleResult: $b869bf1d00b93ac1$var$defaultResult()
    };
    if (closestHandles.length === 1) return closestHandles[0];
    const hasValidHandle = closestHandles.some(({ validHandleResult: validHandleResult })=>validHandleResult.isValid);
    const hasTargetHandle = closestHandles.some(({ handle: handle })=>handle.type === 'target');
    // if multiple handles are layouted on top of each other we prefer the one with type = target and the one that is valid
    return closestHandles.find(({ handle: handle, validHandleResult: validHandleResult })=>hasTargetHandle ? handle.type === 'target' : hasValidHandle ? validHandleResult.isValid : true) || closestHandles[0];
}
const $b869bf1d00b93ac1$var$nullConnection = {
    source: null,
    target: null,
    sourceHandle: null,
    targetHandle: null
};
const $b869bf1d00b93ac1$var$defaultResult = ()=>({
        handleDomNode: null,
        isValid: false,
        connection: $b869bf1d00b93ac1$var$nullConnection,
        endHandle: null
    });
// checks if  and returns connection in fom of an object { source: 123, target: 312 }
function $b869bf1d00b93ac1$var$isValidHandle(handle, connectionMode, fromNodeId, fromHandleId, fromType, isValidConnection, doc) {
    const isTarget = fromType === 'target';
    const handleToCheck = doc.querySelector(`.react-flow__handle[data-id="${handle?.nodeId}-${handle?.id}-${handle?.type}"]`);
    const result = {
        ...$b869bf1d00b93ac1$var$defaultResult(),
        handleDomNode: handleToCheck
    };
    if (handleToCheck) {
        const handleType = $b869bf1d00b93ac1$var$getHandleType(undefined, handleToCheck);
        const handleNodeId = handleToCheck.getAttribute('data-nodeid');
        const handleId = handleToCheck.getAttribute('data-handleid');
        const connectable = handleToCheck.classList.contains('connectable');
        const connectableEnd = handleToCheck.classList.contains('connectableend');
        const connection = {
            source: isTarget ? handleNodeId : fromNodeId,
            sourceHandle: isTarget ? handleId : fromHandleId,
            target: isTarget ? fromNodeId : handleNodeId,
            targetHandle: isTarget ? fromHandleId : handleId
        };
        result.connection = connection;
        const isConnectable = connectable && connectableEnd;
        // in strict mode we don't allow target to target or source to source connections
        const isValid = isConnectable && (connectionMode === $b869bf1d00b93ac1$export$37c58f76dbdd36f6.Strict ? isTarget && handleType === 'source' || !isTarget && handleType === 'target' : handleNodeId !== fromNodeId || handleId !== fromHandleId);
        if (isValid) {
            result.endHandle = {
                nodeId: handleNodeId,
                handleId: handleId,
                type: handleType
            };
            result.isValid = isValidConnection(connection);
        }
    }
    return result;
}
function $b869bf1d00b93ac1$var$getHandleLookup({ nodes: nodes, nodeId: nodeId, handleId: handleId, handleType: handleType }) {
    return nodes.reduce((res, node)=>{
        if (node[$b869bf1d00b93ac1$export$90dfda29e9e20e50]) {
            const { handleBounds: handleBounds } = node[$b869bf1d00b93ac1$export$90dfda29e9e20e50];
            let sourceHandles = [];
            let targetHandles = [];
            if (handleBounds) {
                sourceHandles = $b869bf1d00b93ac1$var$getHandles(node, handleBounds, 'source', `${nodeId}-${handleId}-${handleType}`);
                targetHandles = $b869bf1d00b93ac1$var$getHandles(node, handleBounds, 'target', `${nodeId}-${handleId}-${handleType}`);
            }
            res.push(...sourceHandles, ...targetHandles);
        }
        return res;
    }, []);
}
function $b869bf1d00b93ac1$var$getHandleType(edgeUpdaterType, handleDomNode) {
    if (edgeUpdaterType) return edgeUpdaterType;
    else if (handleDomNode?.classList.contains('target')) return 'target';
    else if (handleDomNode?.classList.contains('source')) return 'source';
    return null;
}
function $b869bf1d00b93ac1$var$resetRecentHandle(handleDomNode) {
    handleDomNode?.classList.remove('valid', 'connecting', 'react-flow__handle-valid', 'react-flow__handle-connecting');
}
function $b869bf1d00b93ac1$var$getConnectionStatus(isInsideConnectionRadius, isHandleValid) {
    let connectionStatus = null;
    if (isHandleValid) connectionStatus = 'valid';
    else if (isInsideConnectionRadius && !isHandleValid) connectionStatus = 'invalid';
    return connectionStatus;
}
function $b869bf1d00b93ac1$var$handlePointerDown({ event: event, handleId: handleId, nodeId: nodeId, onConnect: onConnect, isTarget: isTarget, getState: getState, setState: setState, isValidConnection: isValidConnection, edgeUpdaterType: edgeUpdaterType, onReconnectEnd: onReconnectEnd }) {
    // when react-flow is used inside a shadow root we can't use document
    const doc = $b869bf1d00b93ac1$var$getHostForElement(event.target);
    const { connectionMode: connectionMode, domNode: domNode, autoPanOnConnect: autoPanOnConnect, connectionRadius: connectionRadius, onConnectStart: onConnectStart, panBy: panBy, getNodes: getNodes, cancelConnection: cancelConnection } = getState();
    let autoPanId = 0;
    let closestHandle;
    const { x: x, y: y } = $b869bf1d00b93ac1$var$getEventPosition(event);
    const clickedHandle = doc?.elementFromPoint(x, y);
    const handleType = $b869bf1d00b93ac1$var$getHandleType(edgeUpdaterType, clickedHandle);
    const containerBounds = domNode?.getBoundingClientRect();
    if (!containerBounds || !handleType) return;
    let prevActiveHandle;
    let connectionPosition = $b869bf1d00b93ac1$var$getEventPosition(event, containerBounds);
    let autoPanStarted = false;
    let connection = null;
    let isValid = false;
    let handleDomNode = null;
    const handleLookup = $b869bf1d00b93ac1$var$getHandleLookup({
        nodes: getNodes(),
        nodeId: nodeId,
        handleId: handleId,
        handleType: handleType
    });
    // when the user is moving the mouse close to the edge of the canvas while connecting we move the canvas
    const autoPan = ()=>{
        if (!autoPanOnConnect) return;
        const [xMovement, yMovement] = $b869bf1d00b93ac1$var$calcAutoPan(connectionPosition, containerBounds);
        panBy({
            x: xMovement,
            y: yMovement
        });
        autoPanId = requestAnimationFrame(autoPan);
    };
    setState({
        connectionPosition: connectionPosition,
        connectionStatus: null,
        // connectionNodeId etc will be removed in the next major in favor of connectionStartHandle
        connectionNodeId: nodeId,
        connectionHandleId: handleId,
        connectionHandleType: handleType,
        connectionStartHandle: {
            nodeId: nodeId,
            handleId: handleId,
            type: handleType
        },
        connectionEndHandle: null
    });
    onConnectStart?.(event, {
        nodeId: nodeId,
        handleId: handleId,
        handleType: handleType
    });
    function onPointerMove(event) {
        const { transform: transform } = getState();
        connectionPosition = $b869bf1d00b93ac1$var$getEventPosition(event, containerBounds);
        const { handle: handle, validHandleResult: validHandleResult } = $b869bf1d00b93ac1$var$getClosestHandle(event, doc, $b869bf1d00b93ac1$var$pointToRendererPoint(connectionPosition, transform, false, [
            1,
            1
        ]), connectionRadius, handleLookup, (handle)=>$b869bf1d00b93ac1$var$isValidHandle(handle, connectionMode, nodeId, handleId, isTarget ? 'target' : 'source', isValidConnection, doc));
        closestHandle = handle;
        if (!autoPanStarted) {
            autoPan();
            autoPanStarted = true;
        }
        handleDomNode = validHandleResult.handleDomNode;
        connection = validHandleResult.connection;
        isValid = validHandleResult.isValid;
        setState({
            connectionPosition: closestHandle && isValid ? $b869bf1d00b93ac1$var$rendererPointToPoint({
                x: closestHandle.x,
                y: closestHandle.y
            }, transform) : connectionPosition,
            connectionStatus: $b869bf1d00b93ac1$var$getConnectionStatus(!!closestHandle, isValid),
            connectionEndHandle: validHandleResult.endHandle
        });
        if (!closestHandle && !isValid && !handleDomNode) return $b869bf1d00b93ac1$var$resetRecentHandle(prevActiveHandle);
        if (connection.source !== connection.target && handleDomNode) {
            $b869bf1d00b93ac1$var$resetRecentHandle(prevActiveHandle);
            prevActiveHandle = handleDomNode;
            // @todo: remove the old class names "react-flow__handle-" in the next major version
            handleDomNode.classList.add('connecting', 'react-flow__handle-connecting');
            handleDomNode.classList.toggle('valid', isValid);
            handleDomNode.classList.toggle('react-flow__handle-valid', isValid);
        }
    }
    function onPointerUp(event) {
        if ((closestHandle || handleDomNode) && connection && isValid) onConnect?.(connection);
        // it's important to get a fresh reference from the store here
        // in order to get the latest state of onConnectEnd
        getState().onConnectEnd?.(event);
        if (edgeUpdaterType) onReconnectEnd?.(event);
        $b869bf1d00b93ac1$var$resetRecentHandle(prevActiveHandle);
        cancelConnection();
        cancelAnimationFrame(autoPanId);
        autoPanStarted = false;
        isValid = false;
        connection = null;
        handleDomNode = null;
        doc.removeEventListener('mousemove', onPointerMove);
        doc.removeEventListener('mouseup', onPointerUp);
        doc.removeEventListener('touchmove', onPointerMove);
        doc.removeEventListener('touchend', onPointerUp);
    }
    doc.addEventListener('mousemove', onPointerMove);
    doc.addEventListener('mouseup', onPointerUp);
    doc.addEventListener('touchmove', onPointerMove);
    doc.addEventListener('touchend', onPointerUp);
}
const $b869bf1d00b93ac1$var$alwaysValid = ()=>true;
const $b869bf1d00b93ac1$var$selector$f = (s)=>({
        connectionStartHandle: s.connectionStartHandle,
        connectOnClick: s.connectOnClick,
        noPanClassName: s.noPanClassName
    });
const $b869bf1d00b93ac1$var$connectingSelector = (nodeId, handleId, type)=>(state)=>{
        const { connectionStartHandle: startHandle, connectionEndHandle: endHandle, connectionClickStartHandle: clickHandle } = state;
        return {
            connecting: startHandle?.nodeId === nodeId && startHandle?.handleId === handleId && startHandle?.type === type || endHandle?.nodeId === nodeId && endHandle?.handleId === handleId && endHandle?.type === type,
            clickConnecting: clickHandle?.nodeId === nodeId && clickHandle?.handleId === handleId && clickHandle?.type === type
        };
    };
const $b869bf1d00b93ac1$var$Handle = (0, $kyXgS.forwardRef)(({ type: type = 'source', position: position = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top, isValidConnection: isValidConnection, isConnectable: isConnectable = true, isConnectableStart: isConnectableStart = true, isConnectableEnd: isConnectableEnd = true, id: id, onConnect: onConnect, children: children, className: className, onMouseDown: onMouseDown, onTouchStart: onTouchStart, ...rest }, ref)=>{
    const handleId = id || null;
    const isTarget = type === 'target';
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    const nodeId = $b869bf1d00b93ac1$export$5aa3743c980ed33f();
    const { connectOnClick: connectOnClick, noPanClassName: noPanClassName } = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$f, (0, $5b95e8cf664b5dbd$exports.shallow));
    const { connecting: connecting, clickConnecting: clickConnecting } = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$connectingSelector(nodeId, handleId, type), (0, $5b95e8cf664b5dbd$exports.shallow));
    if (!nodeId) store.getState().onError?.('010', $b869bf1d00b93ac1$var$errorMessages['error010']());
    const onConnectExtended = (params)=>{
        const { defaultEdgeOptions: defaultEdgeOptions, onConnect: onConnectAction, hasDefaultEdges: hasDefaultEdges } = store.getState();
        const edgeParams = {
            ...defaultEdgeOptions,
            ...params
        };
        if (hasDefaultEdges) {
            const { edges: edges, setEdges: setEdges } = store.getState();
            setEdges($b869bf1d00b93ac1$export$3b35d6dc248b6d92(edgeParams, edges));
        }
        onConnectAction?.(edgeParams);
        onConnect?.(edgeParams);
    };
    const onPointerDown = (event)=>{
        if (!nodeId) return;
        const isMouseTriggered = $b869bf1d00b93ac1$var$isMouseEvent(event);
        if (isConnectableStart && (isMouseTriggered && event.button === 0 || !isMouseTriggered)) $b869bf1d00b93ac1$var$handlePointerDown({
            event: event,
            handleId: handleId,
            nodeId: nodeId,
            onConnect: onConnectExtended,
            isTarget: isTarget,
            getState: store.getState,
            setState: store.setState,
            isValidConnection: isValidConnection || store.getState().isValidConnection || $b869bf1d00b93ac1$var$alwaysValid
        });
        if (isMouseTriggered) onMouseDown?.(event);
        else onTouchStart?.(event);
    };
    const onClick = (event)=>{
        const { onClickConnectStart: onClickConnectStart, onClickConnectEnd: onClickConnectEnd, connectionClickStartHandle: connectionClickStartHandle, connectionMode: connectionMode, isValidConnection: isValidConnectionStore } = store.getState();
        if (!nodeId || !connectionClickStartHandle && !isConnectableStart) return;
        if (!connectionClickStartHandle) {
            onClickConnectStart?.(event, {
                nodeId: nodeId,
                handleId: handleId,
                handleType: type
            });
            store.setState({
                connectionClickStartHandle: {
                    nodeId: nodeId,
                    type: type,
                    handleId: handleId
                }
            });
            return;
        }
        const doc = $b869bf1d00b93ac1$var$getHostForElement(event.target);
        const isValidConnectionHandler = isValidConnection || isValidConnectionStore || $b869bf1d00b93ac1$var$alwaysValid;
        const { connection: connection, isValid: isValid } = $b869bf1d00b93ac1$var$isValidHandle({
            nodeId: nodeId,
            id: handleId,
            type: type
        }, connectionMode, connectionClickStartHandle.nodeId, connectionClickStartHandle.handleId || null, connectionClickStartHandle.type, isValidConnectionHandler, doc);
        if (isValid) onConnectExtended(connection);
        onClickConnectEnd?.(event);
        store.setState({
            connectionClickStartHandle: null
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
        "data-handleid": handleId,
        "data-nodeid": nodeId,
        "data-handlepos": position,
        "data-id": `${nodeId}-${handleId}-${type}`,
        className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
            'react-flow__handle',
            `react-flow__handle-${position}`,
            'nodrag',
            noPanClassName,
            className,
            {
                source: !isTarget,
                target: isTarget,
                connectable: isConnectable,
                connectablestart: isConnectableStart,
                connectableend: isConnectableEnd,
                connecting: clickConnecting,
                // this class is used to style the handle when the user is connecting
                connectionindicator: isConnectable && (isConnectableStart && !connecting || isConnectableEnd && connecting)
            }
        ]),
        onMouseDown: onPointerDown,
        onTouchStart: onPointerDown,
        onClick: connectOnClick ? onClick : undefined,
        ref: ref,
        ...rest
    }, children);
});
$b869bf1d00b93ac1$var$Handle.displayName = 'Handle';
var $b869bf1d00b93ac1$export$94890c79f4cae6d6 = (0, $kyXgS.memo)($b869bf1d00b93ac1$var$Handle);
const $b869bf1d00b93ac1$var$DefaultNode = ({ data: data, isConnectable: isConnectable, targetPosition: targetPosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top, sourcePosition: sourcePosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$export$94890c79f4cae6d6, {
        type: "target",
        position: targetPosition,
        isConnectable: isConnectable
    }), data?.label, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$export$94890c79f4cae6d6, {
        type: "source",
        position: sourcePosition,
        isConnectable: isConnectable
    }));
};
$b869bf1d00b93ac1$var$DefaultNode.displayName = 'DefaultNode';
var $b869bf1d00b93ac1$var$DefaultNode$1 = (0, $kyXgS.memo)($b869bf1d00b93ac1$var$DefaultNode);
const $b869bf1d00b93ac1$var$InputNode = ({ data: data, isConnectable: isConnectable, sourcePosition: sourcePosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom })=>(0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).Fragment, null, data?.label, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$export$94890c79f4cae6d6, {
        type: "source",
        position: sourcePosition,
        isConnectable: isConnectable
    }));
$b869bf1d00b93ac1$var$InputNode.displayName = 'InputNode';
var $b869bf1d00b93ac1$var$InputNode$1 = (0, $kyXgS.memo)($b869bf1d00b93ac1$var$InputNode);
const $b869bf1d00b93ac1$var$OutputNode = ({ data: data, isConnectable: isConnectable, targetPosition: targetPosition = $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top })=>(0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$export$94890c79f4cae6d6, {
        type: "target",
        position: targetPosition,
        isConnectable: isConnectable
    }), data?.label);
$b869bf1d00b93ac1$var$OutputNode.displayName = 'OutputNode';
var $b869bf1d00b93ac1$var$OutputNode$1 = (0, $kyXgS.memo)($b869bf1d00b93ac1$var$OutputNode);
const $b869bf1d00b93ac1$var$GroupNode = ()=>null;
$b869bf1d00b93ac1$var$GroupNode.displayName = 'GroupNode';
const $b869bf1d00b93ac1$var$selector$e = (s)=>({
        selectedNodes: s.getNodes().filter((n)=>n.selected),
        selectedEdges: s.edges.filter((e)=>e.selected).map((e)=>({
                ...e
            }))
    });
const $b869bf1d00b93ac1$var$selectId = (obj)=>obj.id;
function $b869bf1d00b93ac1$var$areEqual(a, b) {
    return (0, $5b95e8cf664b5dbd$exports.shallow)(a.selectedNodes.map($b869bf1d00b93ac1$var$selectId), b.selectedNodes.map($b869bf1d00b93ac1$var$selectId)) && (0, $5b95e8cf664b5dbd$exports.shallow)(a.selectedEdges.map($b869bf1d00b93ac1$var$selectId), b.selectedEdges.map($b869bf1d00b93ac1$var$selectId));
}
// This is just a helper component for calling the onSelectionChange listener.
// @TODO: Now that we have the onNodesChange and on EdgesChange listeners, do we still need this component?
const $b869bf1d00b93ac1$var$SelectionListener = (0, $kyXgS.memo)(({ onSelectionChange: onSelectionChange })=>{
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    const { selectedNodes: selectedNodes, selectedEdges: selectedEdges } = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$e, $b869bf1d00b93ac1$var$areEqual);
    (0, $kyXgS.useEffect)(()=>{
        const params = {
            nodes: selectedNodes,
            edges: selectedEdges
        };
        onSelectionChange?.(params);
        store.getState().onSelectionChange.forEach((fn)=>fn(params));
    }, [
        selectedNodes,
        selectedEdges,
        onSelectionChange
    ]);
    return null;
});
$b869bf1d00b93ac1$var$SelectionListener.displayName = 'SelectionListener';
const $b869bf1d00b93ac1$var$changeSelector = (s)=>!!s.onSelectionChange;
function $b869bf1d00b93ac1$var$Wrapper$1({ onSelectionChange: onSelectionChange }) {
    const storeHasSelectionChange = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$changeSelector);
    if (onSelectionChange || storeHasSelectionChange) return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$SelectionListener, {
        onSelectionChange: onSelectionChange
    });
    return null;
}
const $b869bf1d00b93ac1$var$selector$d = (s)=>({
        setNodes: s.setNodes,
        setEdges: s.setEdges,
        setDefaultNodesAndEdges: s.setDefaultNodesAndEdges,
        setMinZoom: s.setMinZoom,
        setMaxZoom: s.setMaxZoom,
        setTranslateExtent: s.setTranslateExtent,
        setNodeExtent: s.setNodeExtent,
        reset: s.reset
    });
function $b869bf1d00b93ac1$var$useStoreUpdater(value, setStoreState) {
    (0, $kyXgS.useEffect)(()=>{
        if (typeof value !== 'undefined') setStoreState(value);
    }, [
        value
    ]);
}
// updates with values in store that don't have a dedicated setter function
function $b869bf1d00b93ac1$var$useDirectStoreUpdater(key, value, setState) {
    (0, $kyXgS.useEffect)(()=>{
        if (typeof value !== 'undefined') setState({
            [key]: value
        });
    }, [
        value
    ]);
}
const $b869bf1d00b93ac1$var$StoreUpdater = ({ nodes: nodes, edges: edges, defaultNodes: defaultNodes, defaultEdges: defaultEdges, onConnect: onConnect, onConnectStart: onConnectStart, onConnectEnd: onConnectEnd, onClickConnectStart: onClickConnectStart, onClickConnectEnd: onClickConnectEnd, nodesDraggable: nodesDraggable, nodesConnectable: nodesConnectable, nodesFocusable: nodesFocusable, edgesFocusable: edgesFocusable, edgesUpdatable: edgesUpdatable, elevateNodesOnSelect: elevateNodesOnSelect, minZoom: minZoom, maxZoom: maxZoom, nodeExtent: nodeExtent, onNodesChange: onNodesChange, onEdgesChange: onEdgesChange, elementsSelectable: elementsSelectable, connectionMode: connectionMode, snapGrid: snapGrid, snapToGrid: snapToGrid, translateExtent: translateExtent, connectOnClick: connectOnClick, defaultEdgeOptions: defaultEdgeOptions, fitView: fitView, fitViewOptions: fitViewOptions, onNodesDelete: onNodesDelete, onEdgesDelete: onEdgesDelete, onNodeDrag: onNodeDrag, onNodeDragStart: onNodeDragStart, onNodeDragStop: onNodeDragStop, onSelectionDrag: onSelectionDrag, onSelectionDragStart: onSelectionDragStart, onSelectionDragStop: onSelectionDragStop, noPanClassName: noPanClassName, nodeOrigin: nodeOrigin, rfId: rfId, autoPanOnConnect: autoPanOnConnect, autoPanOnNodeDrag: autoPanOnNodeDrag, onError: onError, connectionRadius: connectionRadius, isValidConnection: isValidConnection, nodeDragThreshold: nodeDragThreshold })=>{
    const { setNodes: setNodes, setEdges: setEdges, setDefaultNodesAndEdges: setDefaultNodesAndEdges, setMinZoom: setMinZoom, setMaxZoom: setMaxZoom, setTranslateExtent: setTranslateExtent, setNodeExtent: setNodeExtent, reset: reset } = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$d, (0, $5b95e8cf664b5dbd$exports.shallow));
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    (0, $kyXgS.useEffect)(()=>{
        const edgesWithDefaults = defaultEdges?.map((e)=>({
                ...e,
                ...defaultEdgeOptions
            }));
        setDefaultNodesAndEdges(defaultNodes, edgesWithDefaults);
        return ()=>{
            reset();
        };
    }, []);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('defaultEdgeOptions', defaultEdgeOptions, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('connectionMode', connectionMode, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onConnect', onConnect, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onConnectStart', onConnectStart, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onConnectEnd', onConnectEnd, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onClickConnectStart', onClickConnectStart, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onClickConnectEnd', onClickConnectEnd, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('nodesDraggable', nodesDraggable, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('nodesConnectable', nodesConnectable, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('nodesFocusable', nodesFocusable, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('edgesFocusable', edgesFocusable, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('edgesUpdatable', edgesUpdatable, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('elementsSelectable', elementsSelectable, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('elevateNodesOnSelect', elevateNodesOnSelect, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('snapToGrid', snapToGrid, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('snapGrid', snapGrid, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onNodesChange', onNodesChange, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onEdgesChange', onEdgesChange, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('connectOnClick', connectOnClick, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('fitViewOnInit', fitView, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('fitViewOnInitOptions', fitViewOptions, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onNodesDelete', onNodesDelete, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onEdgesDelete', onEdgesDelete, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onNodeDrag', onNodeDrag, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onNodeDragStart', onNodeDragStart, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onNodeDragStop', onNodeDragStop, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onSelectionDrag', onSelectionDrag, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onSelectionDragStart', onSelectionDragStart, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onSelectionDragStop', onSelectionDragStop, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('noPanClassName', noPanClassName, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('nodeOrigin', nodeOrigin, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('rfId', rfId, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('autoPanOnConnect', autoPanOnConnect, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('autoPanOnNodeDrag', autoPanOnNodeDrag, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('onError', onError, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('connectionRadius', connectionRadius, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('isValidConnection', isValidConnection, store.setState);
    $b869bf1d00b93ac1$var$useDirectStoreUpdater('nodeDragThreshold', nodeDragThreshold, store.setState);
    $b869bf1d00b93ac1$var$useStoreUpdater(nodes, setNodes);
    $b869bf1d00b93ac1$var$useStoreUpdater(edges, setEdges);
    $b869bf1d00b93ac1$var$useStoreUpdater(minZoom, setMinZoom);
    $b869bf1d00b93ac1$var$useStoreUpdater(maxZoom, setMaxZoom);
    $b869bf1d00b93ac1$var$useStoreUpdater(translateExtent, setTranslateExtent);
    $b869bf1d00b93ac1$var$useStoreUpdater(nodeExtent, setNodeExtent);
    return null;
};
const $b869bf1d00b93ac1$var$style = {
    display: 'none'
};
const $b869bf1d00b93ac1$var$ariaLiveStyle = {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0px, 0px, 0px, 0px)',
    clipPath: 'inset(100%)'
};
const $b869bf1d00b93ac1$var$ARIA_NODE_DESC_KEY = 'react-flow__node-desc';
const $b869bf1d00b93ac1$var$ARIA_EDGE_DESC_KEY = 'react-flow__edge-desc';
const $b869bf1d00b93ac1$var$ARIA_LIVE_MESSAGE = 'react-flow__aria-live';
const $b869bf1d00b93ac1$var$selector$c = (s)=>s.ariaLiveMessage;
function $b869bf1d00b93ac1$var$AriaLiveMessage({ rfId: rfId }) {
    const ariaLiveMessage = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$c);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
        id: `${$b869bf1d00b93ac1$var$ARIA_LIVE_MESSAGE}-${rfId}`,
        "aria-live": "assertive",
        "aria-atomic": "true",
        style: $b869bf1d00b93ac1$var$ariaLiveStyle
    }, ariaLiveMessage);
}
function $b869bf1d00b93ac1$var$A11yDescriptions({ rfId: rfId, disableKeyboardA11y: disableKeyboardA11y }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
        id: `${$b869bf1d00b93ac1$var$ARIA_NODE_DESC_KEY}-${rfId}`,
        style: $b869bf1d00b93ac1$var$style
    }, "Press enter or space to select a node.", !disableKeyboardA11y && 'You can then use the arrow keys to move the node around.', " Press delete to remove it and escape to cancel.", ' '), (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
        id: `${$b869bf1d00b93ac1$var$ARIA_EDGE_DESC_KEY}-${rfId}`,
        style: $b869bf1d00b93ac1$var$style
    }, "Press enter or space to select an edge. You can then press delete to remove it or escape to cancel."), !disableKeyboardA11y && (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$AriaLiveMessage, {
        rfId: rfId
    }));
}
// the keycode can be a string 'a' or an array of strings ['a', 'a+d']
// a string means a single key 'a' or a combination when '+' is used 'a+d'
// an array means different possibilities. Explainer: ['a', 'd+s'] here the
// user can use the single key 'a' or the combination 'd' + 's'
var $b869bf1d00b93ac1$export$b65485ca34c366f3 = (keyCode = null, options = {
    actInsideInputWithModifier: true
})=>{
    const [keyPressed, setKeyPressed] = (0, $kyXgS.useState)(false);
    // we need to remember if a modifier key is pressed in order to track it
    const modifierPressed = (0, $kyXgS.useRef)(false);
    // we need to remember the pressed keys in order to support combinations
    const pressedKeys = (0, $kyXgS.useRef)(new Set([]));
    // keyCodes = array with single keys [['a']] or key combinations [['a', 's']]
    // keysToWatch = array with all keys flattened ['a', 'd', 'ShiftLeft']
    // used to check if we store event.code or event.key. When the code is in the list of keysToWatch
    // we use the code otherwise the key. Explainer: When you press the left "command" key, the code is "MetaLeft"
    // and the key is "Meta". We want users to be able to pass keys and codes so we assume that the key is meant when
    // we can't find it in the list of keysToWatch.
    const [keyCodes, keysToWatch] = (0, $kyXgS.useMemo)(()=>{
        if (keyCode !== null) {
            const keyCodeArr = Array.isArray(keyCode) ? keyCode : [
                keyCode
            ];
            const keys = keyCodeArr.filter((kc)=>typeof kc === 'string').map((kc)=>kc.split('+'));
            const keysFlat = keys.reduce((res, item)=>res.concat(...item), []);
            return [
                keys,
                keysFlat
            ];
        }
        return [
            [],
            []
        ];
    }, [
        keyCode
    ]);
    (0, $kyXgS.useEffect)(()=>{
        const doc = typeof document !== 'undefined' ? document : null;
        const target = options?.target || doc;
        if (keyCode !== null) {
            const downHandler = (event)=>{
                modifierPressed.current = event.ctrlKey || event.metaKey || event.shiftKey;
                const preventAction = (!modifierPressed.current || modifierPressed.current && !options.actInsideInputWithModifier) && $b869bf1d00b93ac1$var$isInputDOMNode(event);
                if (preventAction) return false;
                const keyOrCode = $b869bf1d00b93ac1$var$useKeyOrCode(event.code, keysToWatch);
                pressedKeys.current.add(event[keyOrCode]);
                if ($b869bf1d00b93ac1$var$isMatchingKey(keyCodes, pressedKeys.current, false)) {
                    event.preventDefault();
                    setKeyPressed(true);
                }
            };
            const upHandler = (event)=>{
                const preventAction = (!modifierPressed.current || modifierPressed.current && !options.actInsideInputWithModifier) && $b869bf1d00b93ac1$var$isInputDOMNode(event);
                if (preventAction) return false;
                const keyOrCode = $b869bf1d00b93ac1$var$useKeyOrCode(event.code, keysToWatch);
                if ($b869bf1d00b93ac1$var$isMatchingKey(keyCodes, pressedKeys.current, true)) {
                    setKeyPressed(false);
                    pressedKeys.current.clear();
                } else pressedKeys.current.delete(event[keyOrCode]);
                // fix for Mac: when cmd key is pressed, keyup is not triggered for any other key, see: https://stackoverflow.com/questions/27380018/when-cmd-key-is-kept-pressed-keyup-is-not-triggered-for-any-other-key
                if (event.key === 'Meta') pressedKeys.current.clear();
                modifierPressed.current = false;
            };
            const resetHandler = ()=>{
                pressedKeys.current.clear();
                setKeyPressed(false);
            };
            target?.addEventListener('keydown', downHandler);
            target?.addEventListener('keyup', upHandler);
            window.addEventListener('blur', resetHandler);
            return ()=>{
                target?.removeEventListener('keydown', downHandler);
                target?.removeEventListener('keyup', upHandler);
                window.removeEventListener('blur', resetHandler);
            };
        }
    }, [
        keyCode,
        setKeyPressed
    ]);
    return keyPressed;
};
// utils
function $b869bf1d00b93ac1$var$isMatchingKey(keyCodes, pressedKeys, isUp) {
    return keyCodes// we only want to compare same sizes of keyCode definitions
    // and pressed keys. When the user specified 'Meta' as a key somewhere
    // this would also be truthy without this filter when user presses 'Meta' + 'r'
    .filter((keys)=>isUp || keys.length === pressedKeys.size)// since we want to support multiple possibilities only one of the
    // combinations need to be part of the pressed keys
    .some((keys)=>keys.every((k)=>pressedKeys.has(k)));
}
function $b869bf1d00b93ac1$var$useKeyOrCode(eventCode, keysToWatch) {
    return keysToWatch.includes(eventCode) ? 'code' : 'key';
}
function $b869bf1d00b93ac1$var$calculateXYZPosition(node, nodeInternals, result, nodeOrigin) {
    const parentId = node.parentNode || node.parentId;
    if (!parentId) return result;
    const parentNode = nodeInternals.get(parentId);
    const parentNodePosition = $b869bf1d00b93ac1$export$72c5647f6be28a9c(parentNode, nodeOrigin);
    return $b869bf1d00b93ac1$var$calculateXYZPosition(parentNode, nodeInternals, {
        x: (result.x ?? 0) + parentNodePosition.x,
        y: (result.y ?? 0) + parentNodePosition.y,
        z: (parentNode[$b869bf1d00b93ac1$export$90dfda29e9e20e50]?.z ?? 0) > (result.z ?? 0) ? parentNode[$b869bf1d00b93ac1$export$90dfda29e9e20e50]?.z ?? 0 : result.z ?? 0
    }, nodeOrigin);
}
function $b869bf1d00b93ac1$var$updateAbsoluteNodePositions(nodeInternals, nodeOrigin, parentNodes) {
    nodeInternals.forEach((node)=>{
        const parentId = node.parentNode || node.parentId;
        if (parentId && !nodeInternals.has(parentId)) throw new Error(`Parent node ${parentId} not found`);
        if (parentId || parentNodes?.[node.id]) {
            const { x: x, y: y, z: z } = $b869bf1d00b93ac1$var$calculateXYZPosition(node, nodeInternals, {
                ...node.position,
                z: node[$b869bf1d00b93ac1$export$90dfda29e9e20e50]?.z ?? 0
            }, nodeOrigin);
            node.positionAbsolute = {
                x: x,
                y: y
            };
            node[$b869bf1d00b93ac1$export$90dfda29e9e20e50].z = z;
            if (parentNodes?.[node.id]) node[$b869bf1d00b93ac1$export$90dfda29e9e20e50].isParent = true;
        }
    });
}
function $b869bf1d00b93ac1$var$createNodeInternals(nodes, nodeInternals, nodeOrigin, elevateNodesOnSelect) {
    const nextNodeInternals = new Map();
    const parentNodes = {};
    const selectedNodeZ = elevateNodesOnSelect ? 1000 : 0;
    nodes.forEach((node)=>{
        const z = ($b869bf1d00b93ac1$var$isNumeric(node.zIndex) ? node.zIndex : 0) + (node.selected ? selectedNodeZ : 0);
        const currInternals = nodeInternals.get(node.id);
        const internals = {
            ...node,
            positionAbsolute: {
                x: node.position.x,
                y: node.position.y
            }
        };
        const parentId = node.parentNode || node.parentId;
        if (parentId) parentNodes[parentId] = true;
        const resetHandleBounds = currInternals?.type && currInternals?.type !== node.type;
        Object.defineProperty(internals, $b869bf1d00b93ac1$export$90dfda29e9e20e50, {
            enumerable: false,
            value: {
                handleBounds: resetHandleBounds ? undefined : currInternals?.[$b869bf1d00b93ac1$export$90dfda29e9e20e50]?.handleBounds,
                z: z
            }
        });
        nextNodeInternals.set(node.id, internals);
    });
    $b869bf1d00b93ac1$var$updateAbsoluteNodePositions(nextNodeInternals, nodeOrigin, parentNodes);
    return nextNodeInternals;
}
function $b869bf1d00b93ac1$var$fitView(get, options = {}) {
    const { getNodes: getNodes, width: width, height: height, minZoom: minZoom, maxZoom: maxZoom, d3Zoom: d3Zoom, d3Selection: d3Selection, fitViewOnInitDone: fitViewOnInitDone, fitViewOnInit: fitViewOnInit, nodeOrigin: nodeOrigin } = get();
    const isInitialFitView = options.initial && !fitViewOnInitDone && fitViewOnInit;
    const d3initialized = d3Zoom && d3Selection;
    if (d3initialized && (isInitialFitView || !options.initial)) {
        const nodes = getNodes().filter((n)=>{
            const isVisible = options.includeHiddenNodes ? n.width && n.height : !n.hidden;
            if (options.nodes?.length) return isVisible && options.nodes.some((optionNode)=>optionNode.id === n.id);
            return isVisible;
        });
        const nodesInitialized = nodes.every((n)=>n.width && n.height);
        if (nodes.length > 0 && nodesInitialized) {
            const bounds = $b869bf1d00b93ac1$export$d5a2bfe3c0f7d322(nodes, nodeOrigin);
            const { x: x, y: y, zoom: zoom } = $b869bf1d00b93ac1$export$1ef7dc91ffb32547(bounds, width, height, options.minZoom ?? minZoom, options.maxZoom ?? maxZoom, options.padding ?? 0.1);
            const nextTransform = (0, $56c130654380f82b$export$f0954fd7d5368655).translate(x, y).scale(zoom);
            if (typeof options.duration === 'number' && options.duration > 0) d3Zoom.transform($b869bf1d00b93ac1$var$getD3Transition(d3Selection, options.duration), nextTransform);
            else d3Zoom.transform(d3Selection, nextTransform);
            return true;
        }
    }
    return false;
}
function $b869bf1d00b93ac1$var$handleControlledNodeSelectionChange(nodeChanges, nodeInternals) {
    nodeChanges.forEach((change)=>{
        const node = nodeInternals.get(change.id);
        if (node) nodeInternals.set(node.id, {
            ...node,
            [$b869bf1d00b93ac1$export$90dfda29e9e20e50]: node[$b869bf1d00b93ac1$export$90dfda29e9e20e50],
            selected: change.selected
        });
    });
    return new Map(nodeInternals);
}
function $b869bf1d00b93ac1$var$handleControlledEdgeSelectionChange(edgeChanges, edges) {
    return edges.map((e)=>{
        const change = edgeChanges.find((change)=>change.id === e.id);
        if (change) e.selected = change.selected;
        return e;
    });
}
function $b869bf1d00b93ac1$var$updateNodesAndEdgesSelections({ changedNodes: changedNodes, changedEdges: changedEdges, get: get, set: set }) {
    const { nodeInternals: nodeInternals, edges: edges, onNodesChange: onNodesChange, onEdgesChange: onEdgesChange, hasDefaultNodes: hasDefaultNodes, hasDefaultEdges: hasDefaultEdges } = get();
    if (changedNodes?.length) {
        if (hasDefaultNodes) set({
            nodeInternals: $b869bf1d00b93ac1$var$handleControlledNodeSelectionChange(changedNodes, nodeInternals)
        });
        onNodesChange?.(changedNodes);
    }
    if (changedEdges?.length) {
        if (hasDefaultEdges) set({
            edges: $b869bf1d00b93ac1$var$handleControlledEdgeSelectionChange(changedEdges, edges)
        });
        onEdgesChange?.(changedEdges);
    }
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $b869bf1d00b93ac1$var$noop = ()=>{};
const $b869bf1d00b93ac1$var$initialViewportHelper = {
    zoomIn: $b869bf1d00b93ac1$var$noop,
    zoomOut: $b869bf1d00b93ac1$var$noop,
    zoomTo: $b869bf1d00b93ac1$var$noop,
    getZoom: ()=>1,
    setViewport: $b869bf1d00b93ac1$var$noop,
    getViewport: ()=>({
            x: 0,
            y: 0,
            zoom: 1
        }),
    fitView: ()=>false,
    setCenter: $b869bf1d00b93ac1$var$noop,
    fitBounds: $b869bf1d00b93ac1$var$noop,
    project: (position)=>position,
    screenToFlowPosition: (position)=>position,
    flowToScreenPosition: (position)=>position,
    viewportInitialized: false
};
const $b869bf1d00b93ac1$var$selector$b = (s)=>({
        d3Zoom: s.d3Zoom,
        d3Selection: s.d3Selection
    });
const $b869bf1d00b93ac1$var$useViewportHelper = ()=>{
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    const { d3Zoom: d3Zoom, d3Selection: d3Selection } = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$b, (0, $5b95e8cf664b5dbd$exports.shallow));
    const viewportHelperFunctions = (0, $kyXgS.useMemo)(()=>{
        if (d3Selection && d3Zoom) return {
            zoomIn: (options)=>d3Zoom.scaleBy($b869bf1d00b93ac1$var$getD3Transition(d3Selection, options?.duration), 1.2),
            zoomOut: (options)=>d3Zoom.scaleBy($b869bf1d00b93ac1$var$getD3Transition(d3Selection, options?.duration), 1 / 1.2),
            zoomTo: (zoomLevel, options)=>d3Zoom.scaleTo($b869bf1d00b93ac1$var$getD3Transition(d3Selection, options?.duration), zoomLevel),
            getZoom: ()=>store.getState().transform[2],
            setViewport: (transform, options)=>{
                const [x, y, zoom] = store.getState().transform;
                const nextTransform = (0, $56c130654380f82b$export$f0954fd7d5368655).translate(transform.x ?? x, transform.y ?? y).scale(transform.zoom ?? zoom);
                d3Zoom.transform($b869bf1d00b93ac1$var$getD3Transition(d3Selection, options?.duration), nextTransform);
            },
            getViewport: ()=>{
                const [x, y, zoom] = store.getState().transform;
                return {
                    x: x,
                    y: y,
                    zoom: zoom
                };
            },
            fitView: (options)=>$b869bf1d00b93ac1$var$fitView(store.getState, options),
            setCenter: (x, y, options)=>{
                const { width: width, height: height, maxZoom: maxZoom } = store.getState();
                const nextZoom = typeof options?.zoom !== 'undefined' ? options.zoom : maxZoom;
                const centerX = width / 2 - x * nextZoom;
                const centerY = height / 2 - y * nextZoom;
                const transform = (0, $56c130654380f82b$export$f0954fd7d5368655).translate(centerX, centerY).scale(nextZoom);
                d3Zoom.transform($b869bf1d00b93ac1$var$getD3Transition(d3Selection, options?.duration), transform);
            },
            fitBounds: (bounds, options)=>{
                const { width: width, height: height, minZoom: minZoom, maxZoom: maxZoom } = store.getState();
                const { x: x, y: y, zoom: zoom } = $b869bf1d00b93ac1$export$1ef7dc91ffb32547(bounds, width, height, minZoom, maxZoom, options?.padding ?? 0.1);
                const transform = (0, $56c130654380f82b$export$f0954fd7d5368655).translate(x, y).scale(zoom);
                d3Zoom.transform($b869bf1d00b93ac1$var$getD3Transition(d3Selection, options?.duration), transform);
            },
            // @deprecated Use `screenToFlowPosition`.
            project: (position)=>{
                const { transform: transform, snapToGrid: snapToGrid, snapGrid: snapGrid } = store.getState();
                console.warn('[DEPRECATED] `project` is deprecated. Instead use `screenToFlowPosition`. There is no need to subtract the react flow bounds anymore! https://reactflow.dev/api-reference/types/react-flow-instance#screen-to-flow-position');
                return $b869bf1d00b93ac1$var$pointToRendererPoint(position, transform, snapToGrid, snapGrid);
            },
            screenToFlowPosition: (position)=>{
                const { transform: transform, snapToGrid: snapToGrid, snapGrid: snapGrid, domNode: domNode } = store.getState();
                if (!domNode) return position;
                const { x: domX, y: domY } = domNode.getBoundingClientRect();
                const relativePosition = {
                    x: position.x - domX,
                    y: position.y - domY
                };
                return $b869bf1d00b93ac1$var$pointToRendererPoint(relativePosition, transform, snapToGrid, snapGrid);
            },
            flowToScreenPosition: (position)=>{
                const { transform: transform, domNode: domNode } = store.getState();
                if (!domNode) return position;
                const { x: domX, y: domY } = domNode.getBoundingClientRect();
                const rendererPosition = $b869bf1d00b93ac1$var$rendererPointToPoint(position, transform);
                return {
                    x: rendererPosition.x + domX,
                    y: rendererPosition.y + domY
                };
            },
            viewportInitialized: true
        };
        return $b869bf1d00b93ac1$var$initialViewportHelper;
    }, [
        d3Zoom,
        d3Selection
    ]);
    return viewportHelperFunctions;
};
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */ function $b869bf1d00b93ac1$export$d820c8c2d187e1fb() {
    const viewportHelper = $b869bf1d00b93ac1$var$useViewportHelper();
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    const getNodes = (0, $kyXgS.useCallback)(()=>{
        return store.getState().getNodes().map((n)=>({
                ...n
            }));
    }, []);
    const getNode = (0, $kyXgS.useCallback)((id)=>{
        return store.getState().nodeInternals.get(id);
    }, []);
    const getEdges = (0, $kyXgS.useCallback)(()=>{
        const { edges: edges = [] } = store.getState();
        return edges.map((e)=>({
                ...e
            }));
    }, []);
    const getEdge = (0, $kyXgS.useCallback)((id)=>{
        const { edges: edges = [] } = store.getState();
        return edges.find((e)=>e.id === id);
    }, []);
    const setNodes = (0, $kyXgS.useCallback)((payload)=>{
        const { getNodes: getNodes, setNodes: setNodes, hasDefaultNodes: hasDefaultNodes, onNodesChange: onNodesChange } = store.getState();
        const nodes = getNodes();
        const nextNodes = typeof payload === 'function' ? payload(nodes) : payload;
        if (hasDefaultNodes) setNodes(nextNodes);
        else if (onNodesChange) {
            const changes = nextNodes.length === 0 ? nodes.map((node)=>({
                    type: 'remove',
                    id: node.id
                })) : nextNodes.map((node)=>({
                    item: node,
                    type: 'reset'
                }));
            onNodesChange(changes);
        }
    }, []);
    const setEdges = (0, $kyXgS.useCallback)((payload)=>{
        const { edges: edges = [], setEdges: setEdges, hasDefaultEdges: hasDefaultEdges, onEdgesChange: onEdgesChange } = store.getState();
        const nextEdges = typeof payload === 'function' ? payload(edges) : payload;
        if (hasDefaultEdges) setEdges(nextEdges);
        else if (onEdgesChange) {
            const changes = nextEdges.length === 0 ? edges.map((edge)=>({
                    type: 'remove',
                    id: edge.id
                })) : nextEdges.map((edge)=>({
                    item: edge,
                    type: 'reset'
                }));
            onEdgesChange(changes);
        }
    }, []);
    const addNodes = (0, $kyXgS.useCallback)((payload)=>{
        const nodes = Array.isArray(payload) ? payload : [
            payload
        ];
        const { getNodes: getNodes, setNodes: setNodes, hasDefaultNodes: hasDefaultNodes, onNodesChange: onNodesChange } = store.getState();
        if (hasDefaultNodes) {
            const currentNodes = getNodes();
            const nextNodes = [
                ...currentNodes,
                ...nodes
            ];
            setNodes(nextNodes);
        } else if (onNodesChange) {
            const changes = nodes.map((node)=>({
                    item: node,
                    type: 'add'
                }));
            onNodesChange(changes);
        }
    }, []);
    const addEdges = (0, $kyXgS.useCallback)((payload)=>{
        const nextEdges = Array.isArray(payload) ? payload : [
            payload
        ];
        const { edges: edges = [], setEdges: setEdges, hasDefaultEdges: hasDefaultEdges, onEdgesChange: onEdgesChange } = store.getState();
        if (hasDefaultEdges) setEdges([
            ...edges,
            ...nextEdges
        ]);
        else if (onEdgesChange) {
            const changes = nextEdges.map((edge)=>({
                    item: edge,
                    type: 'add'
                }));
            onEdgesChange(changes);
        }
    }, []);
    const toObject = (0, $kyXgS.useCallback)(()=>{
        const { getNodes: getNodes, edges: edges = [], transform: transform } = store.getState();
        const [x, y, zoom] = transform;
        return {
            nodes: getNodes().map((n)=>({
                    ...n
                })),
            edges: edges.map((e)=>({
                    ...e
                })),
            viewport: {
                x: x,
                y: y,
                zoom: zoom
            }
        };
    }, []);
    const deleteElements = (0, $kyXgS.useCallback)(({ nodes: nodesDeleted, edges: edgesDeleted })=>{
        const { nodeInternals: nodeInternals, getNodes: getNodes, edges: edges, hasDefaultNodes: hasDefaultNodes, hasDefaultEdges: hasDefaultEdges, onNodesDelete: onNodesDelete, onEdgesDelete: onEdgesDelete, onNodesChange: onNodesChange, onEdgesChange: onEdgesChange } = store.getState();
        const nodeIds = (nodesDeleted || []).map((node)=>node.id);
        const edgeIds = (edgesDeleted || []).map((edge)=>edge.id);
        const nodesToRemove = getNodes().reduce((res, node)=>{
            const parentId = node.parentNode || node.parentId;
            const parentHit = !nodeIds.includes(node.id) && parentId && res.find((n)=>n.id === parentId);
            const deletable = typeof node.deletable === 'boolean' ? node.deletable : true;
            if (deletable && (nodeIds.includes(node.id) || parentHit)) res.push(node);
            return res;
        }, []);
        const deletableEdges = edges.filter((e)=>typeof e.deletable === 'boolean' ? e.deletable : true);
        const initialHitEdges = deletableEdges.filter((e)=>edgeIds.includes(e.id));
        if (nodesToRemove || initialHitEdges) {
            const connectedEdges = $b869bf1d00b93ac1$export$d21e19ffbf7ce542(nodesToRemove, deletableEdges);
            const edgesToRemove = [
                ...initialHitEdges,
                ...connectedEdges
            ];
            const edgeIdsToRemove = edgesToRemove.reduce((res, edge)=>{
                if (!res.includes(edge.id)) res.push(edge.id);
                return res;
            }, []);
            if (hasDefaultEdges || hasDefaultNodes) {
                if (hasDefaultEdges) store.setState({
                    edges: edges.filter((e)=>!edgeIdsToRemove.includes(e.id))
                });
                if (hasDefaultNodes) {
                    nodesToRemove.forEach((node)=>{
                        nodeInternals.delete(node.id);
                    });
                    store.setState({
                        nodeInternals: new Map(nodeInternals)
                    });
                }
            }
            if (edgeIdsToRemove.length > 0) {
                onEdgesDelete?.(edgesToRemove);
                if (onEdgesChange) onEdgesChange(edgeIdsToRemove.map((id)=>({
                        id: id,
                        type: 'remove'
                    })));
            }
            if (nodesToRemove.length > 0) {
                onNodesDelete?.(nodesToRemove);
                if (onNodesChange) {
                    const nodeChanges = nodesToRemove.map((n)=>({
                            id: n.id,
                            type: 'remove'
                        }));
                    onNodesChange(nodeChanges);
                }
            }
        }
    }, []);
    const getNodeRect = (0, $kyXgS.useCallback)((nodeOrRect)=>{
        const isRect = $b869bf1d00b93ac1$var$isRectObject(nodeOrRect);
        const node = isRect ? null : store.getState().nodeInternals.get(nodeOrRect.id);
        if (!isRect && !node) return [
            null,
            null,
            isRect
        ];
        const nodeRect = isRect ? nodeOrRect : $b869bf1d00b93ac1$var$nodeToRect(node);
        return [
            nodeRect,
            node,
            isRect
        ];
    }, []);
    const getIntersectingNodes = (0, $kyXgS.useCallback)((nodeOrRect, partially = true, nodes)=>{
        const [nodeRect, node, isRect] = getNodeRect(nodeOrRect);
        if (!nodeRect) return [];
        return (nodes || store.getState().getNodes()).filter((n)=>{
            if (!isRect && (n.id === node.id || !n.positionAbsolute)) return false;
            const currNodeRect = $b869bf1d00b93ac1$var$nodeToRect(n);
            const overlappingArea = $b869bf1d00b93ac1$var$getOverlappingArea(currNodeRect, nodeRect);
            const partiallyVisible = partially && overlappingArea > 0;
            return partiallyVisible || overlappingArea >= nodeRect.width * nodeRect.height;
        });
    }, []);
    const isNodeIntersecting = (0, $kyXgS.useCallback)((nodeOrRect, area, partially = true)=>{
        const [nodeRect] = getNodeRect(nodeOrRect);
        if (!nodeRect) return false;
        const overlappingArea = $b869bf1d00b93ac1$var$getOverlappingArea(nodeRect, area);
        const partiallyVisible = partially && overlappingArea > 0;
        return partiallyVisible || overlappingArea >= nodeRect.width * nodeRect.height;
    }, []);
    return (0, $kyXgS.useMemo)(()=>{
        return {
            ...viewportHelper,
            getNodes: getNodes,
            getNode: getNode,
            getEdges: getEdges,
            getEdge: getEdge,
            setNodes: setNodes,
            setEdges: setEdges,
            addNodes: addNodes,
            addEdges: addEdges,
            toObject: toObject,
            deleteElements: deleteElements,
            getIntersectingNodes: getIntersectingNodes,
            isNodeIntersecting: isNodeIntersecting
        };
    }, [
        viewportHelper,
        getNodes,
        getNode,
        getEdges,
        getEdge,
        setNodes,
        setEdges,
        addNodes,
        addEdges,
        toObject,
        deleteElements,
        getIntersectingNodes,
        isNodeIntersecting
    ]);
}
const $b869bf1d00b93ac1$var$deleteKeyOptions = {
    actInsideInputWithModifier: false
};
var $b869bf1d00b93ac1$var$useGlobalKeyHandler = ({ deleteKeyCode: deleteKeyCode, multiSelectionKeyCode: multiSelectionKeyCode })=>{
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    const { deleteElements: deleteElements } = $b869bf1d00b93ac1$export$d820c8c2d187e1fb();
    const deleteKeyPressed = $b869bf1d00b93ac1$export$b65485ca34c366f3(deleteKeyCode, $b869bf1d00b93ac1$var$deleteKeyOptions);
    const multiSelectionKeyPressed = $b869bf1d00b93ac1$export$b65485ca34c366f3(multiSelectionKeyCode);
    (0, $kyXgS.useEffect)(()=>{
        if (deleteKeyPressed) {
            const { edges: edges, getNodes: getNodes } = store.getState();
            const selectedNodes = getNodes().filter((node)=>node.selected);
            const selectedEdges = edges.filter((edge)=>edge.selected);
            deleteElements({
                nodes: selectedNodes,
                edges: selectedEdges
            });
            store.setState({
                nodesSelectionActive: false
            });
        }
    }, [
        deleteKeyPressed
    ]);
    (0, $kyXgS.useEffect)(()=>{
        store.setState({
            multiSelectionActive: multiSelectionKeyPressed
        });
    }, [
        multiSelectionKeyPressed
    ]);
};
function $b869bf1d00b93ac1$var$useResizeHandler(rendererNode) {
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    (0, $kyXgS.useEffect)(()=>{
        let resizeObserver;
        const updateDimensions = ()=>{
            if (!rendererNode.current) return;
            const size = $b869bf1d00b93ac1$var$getDimensions(rendererNode.current);
            if (size.height === 0 || size.width === 0) store.getState().onError?.('004', $b869bf1d00b93ac1$var$errorMessages['error004']());
            store.setState({
                width: size.width || 500,
                height: size.height || 500
            });
        };
        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        if (rendererNode.current) {
            resizeObserver = new ResizeObserver(()=>updateDimensions());
            resizeObserver.observe(rendererNode.current);
        }
        return ()=>{
            window.removeEventListener('resize', updateDimensions);
            if (resizeObserver && rendererNode.current) resizeObserver.unobserve(rendererNode.current);
        };
    }, []);
}
const $b869bf1d00b93ac1$var$containerStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0
};
/* eslint-disable @typescript-eslint/ban-ts-comment */ const $b869bf1d00b93ac1$var$viewChanged = (prevViewport, eventTransform)=>prevViewport.x !== eventTransform.x || prevViewport.y !== eventTransform.y || prevViewport.zoom !== eventTransform.k;
const $b869bf1d00b93ac1$var$eventToFlowTransform = (eventTransform)=>({
        x: eventTransform.x,
        y: eventTransform.y,
        zoom: eventTransform.k
    });
const $b869bf1d00b93ac1$var$isWrappedWithClass = (event, className)=>event.target.closest(`.${className}`);
const $b869bf1d00b93ac1$var$isRightClickPan = (panOnDrag, usedButton)=>usedButton === 2 && Array.isArray(panOnDrag) && panOnDrag.includes(2);
const $b869bf1d00b93ac1$var$wheelDelta = (event)=>{
    const factor = event.ctrlKey && $b869bf1d00b93ac1$var$isMacOs() ? 10 : 1;
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * factor;
};
const $b869bf1d00b93ac1$var$selector$a = (s)=>({
        d3Zoom: s.d3Zoom,
        d3Selection: s.d3Selection,
        d3ZoomHandler: s.d3ZoomHandler,
        userSelectionActive: s.userSelectionActive
    });
const $b869bf1d00b93ac1$var$ZoomPane = ({ onMove: onMove, onMoveStart: onMoveStart, onMoveEnd: onMoveEnd, onPaneContextMenu: onPaneContextMenu, zoomOnScroll: zoomOnScroll = true, zoomOnPinch: zoomOnPinch = true, panOnScroll: panOnScroll = false, panOnScrollSpeed: panOnScrollSpeed = 0.5, panOnScrollMode: panOnScrollMode = $b869bf1d00b93ac1$export$5579ce9cc1808963.Free, zoomOnDoubleClick: zoomOnDoubleClick = true, elementsSelectable: elementsSelectable, panOnDrag: panOnDrag = true, defaultViewport: defaultViewport, translateExtent: translateExtent, minZoom: minZoom, maxZoom: maxZoom, zoomActivationKeyCode: zoomActivationKeyCode, preventScrolling: preventScrolling = true, children: children, noWheelClassName: noWheelClassName, noPanClassName: noPanClassName })=>{
    const timerId = (0, $kyXgS.useRef)();
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    const isZoomingOrPanning = (0, $kyXgS.useRef)(false);
    const zoomedWithRightMouseButton = (0, $kyXgS.useRef)(false);
    const zoomPane = (0, $kyXgS.useRef)(null);
    const prevTransform = (0, $kyXgS.useRef)({
        x: 0,
        y: 0,
        zoom: 0
    });
    const { d3Zoom: d3Zoom, d3Selection: d3Selection, d3ZoomHandler: d3ZoomHandler, userSelectionActive: userSelectionActive } = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$a, (0, $5b95e8cf664b5dbd$exports.shallow));
    const zoomActivationKeyPressed = $b869bf1d00b93ac1$export$b65485ca34c366f3(zoomActivationKeyCode);
    const mouseButton = (0, $kyXgS.useRef)(0);
    const isPanScrolling = (0, $kyXgS.useRef)(false);
    const panScrollTimeout = (0, $kyXgS.useRef)();
    $b869bf1d00b93ac1$var$useResizeHandler(zoomPane);
    (0, $kyXgS.useEffect)(()=>{
        if (zoomPane.current) {
            const bbox = zoomPane.current.getBoundingClientRect();
            const d3ZoomInstance = (0, $617ef72b275b25a1$export$2e2bcd8739ae039)().scaleExtent([
                minZoom,
                maxZoom
            ]).translateExtent(translateExtent);
            const selection = (0, $b0b9e4430a128489$export$2e2bcd8739ae039)(zoomPane.current).call(d3ZoomInstance);
            const updatedTransform = (0, $56c130654380f82b$export$f0954fd7d5368655).translate(defaultViewport.x, defaultViewport.y).scale($b869bf1d00b93ac1$export$7d15b64cf5a3a4c4(defaultViewport.zoom, minZoom, maxZoom));
            const extent = [
                [
                    0,
                    0
                ],
                [
                    bbox.width,
                    bbox.height
                ]
            ];
            const constrainedTransform = d3ZoomInstance.constrain()(updatedTransform, extent, translateExtent);
            d3ZoomInstance.transform(selection, constrainedTransform);
            d3ZoomInstance.wheelDelta($b869bf1d00b93ac1$var$wheelDelta);
            store.setState({
                d3Zoom: d3ZoomInstance,
                d3Selection: selection,
                d3ZoomHandler: selection.on('wheel.zoom'),
                // we need to pass transform because zoom handler is not registered when we set the initial transform
                transform: [
                    constrainedTransform.x,
                    constrainedTransform.y,
                    constrainedTransform.k
                ],
                domNode: zoomPane.current.closest('.react-flow')
            });
        }
    }, []);
    (0, $kyXgS.useEffect)(()=>{
        if (d3Selection && d3Zoom) {
            if (panOnScroll && !zoomActivationKeyPressed && !userSelectionActive) d3Selection.on('wheel.zoom', (event)=>{
                if ($b869bf1d00b93ac1$var$isWrappedWithClass(event, noWheelClassName)) return false;
                event.preventDefault();
                event.stopImmediatePropagation();
                const currentZoom = d3Selection.property('__zoom').k || 1;
                // macos and win set ctrlKey=true for pinch gesture on a trackpad
                if (event.ctrlKey && zoomOnPinch) {
                    const point = (0, $77a090e639ecc3fa$export$2e2bcd8739ae039)(event);
                    const pinchDelta = $b869bf1d00b93ac1$var$wheelDelta(event);
                    const zoom = currentZoom * Math.pow(2, pinchDelta);
                    // @ts-ignore
                    d3Zoom.scaleTo(d3Selection, zoom, point, event);
                    return;
                }
                // increase scroll speed in firefox
                // firefox: deltaMode === 1; chrome: deltaMode === 0
                const deltaNormalize = event.deltaMode === 1 ? 20 : 1;
                let deltaX = panOnScrollMode === $b869bf1d00b93ac1$export$5579ce9cc1808963.Vertical ? 0 : event.deltaX * deltaNormalize;
                let deltaY = panOnScrollMode === $b869bf1d00b93ac1$export$5579ce9cc1808963.Horizontal ? 0 : event.deltaY * deltaNormalize;
                // this enables vertical scrolling with shift + scroll on windows
                if (!$b869bf1d00b93ac1$var$isMacOs() && event.shiftKey && panOnScrollMode !== $b869bf1d00b93ac1$export$5579ce9cc1808963.Vertical) {
                    deltaX = event.deltaY * deltaNormalize;
                    deltaY = 0;
                }
                d3Zoom.translateBy(d3Selection, -(deltaX / currentZoom) * panOnScrollSpeed, -(deltaY / currentZoom) * panOnScrollSpeed, // @ts-ignore
                {
                    internal: true
                });
                const nextViewport = $b869bf1d00b93ac1$var$eventToFlowTransform(d3Selection.property('__zoom'));
                const { onViewportChangeStart: onViewportChangeStart, onViewportChange: onViewportChange, onViewportChangeEnd: onViewportChangeEnd } = store.getState();
                clearTimeout(panScrollTimeout.current);
                // for pan on scroll we need to handle the event calls on our own
                // we can't use the start, zoom and end events from d3-zoom
                // because start and move gets called on every scroll event and not once at the beginning
                if (!isPanScrolling.current) {
                    isPanScrolling.current = true;
                    onMoveStart?.(event, nextViewport);
                    onViewportChangeStart?.(nextViewport);
                }
                if (isPanScrolling.current) {
                    onMove?.(event, nextViewport);
                    onViewportChange?.(nextViewport);
                    panScrollTimeout.current = setTimeout(()=>{
                        onMoveEnd?.(event, nextViewport);
                        onViewportChangeEnd?.(nextViewport);
                        isPanScrolling.current = false;
                    }, 150);
                }
            }, {
                passive: false
            });
            else if (typeof d3ZoomHandler !== 'undefined') d3Selection.on('wheel.zoom', function(event, d) {
                // we still want to enable pinch zooming even if preventScrolling is set to false
                const invalidEvent = !preventScrolling && event.type === 'wheel' && !event.ctrlKey;
                if (invalidEvent || $b869bf1d00b93ac1$var$isWrappedWithClass(event, noWheelClassName)) return null;
                event.preventDefault();
                d3ZoomHandler.call(this, event, d);
            }, {
                passive: false
            });
        }
    }, [
        userSelectionActive,
        panOnScroll,
        panOnScrollMode,
        d3Selection,
        d3Zoom,
        d3ZoomHandler,
        zoomActivationKeyPressed,
        zoomOnPinch,
        preventScrolling,
        noWheelClassName,
        onMoveStart,
        onMove,
        onMoveEnd
    ]);
    (0, $kyXgS.useEffect)(()=>{
        if (d3Zoom) d3Zoom.on('start', (event)=>{
            if (!event.sourceEvent || event.sourceEvent.internal) return null;
            // we need to remember it here, because it's always 0 in the "zoom" event
            mouseButton.current = event.sourceEvent?.button;
            const { onViewportChangeStart: onViewportChangeStart } = store.getState();
            const flowTransform = $b869bf1d00b93ac1$var$eventToFlowTransform(event.transform);
            isZoomingOrPanning.current = true;
            prevTransform.current = flowTransform;
            if (event.sourceEvent?.type === 'mousedown') store.setState({
                paneDragging: true
            });
            onViewportChangeStart?.(flowTransform);
            onMoveStart?.(event.sourceEvent, flowTransform);
        });
    }, [
        d3Zoom,
        onMoveStart
    ]);
    (0, $kyXgS.useEffect)(()=>{
        if (d3Zoom) {
            if (userSelectionActive && !isZoomingOrPanning.current) d3Zoom.on('zoom', null);
            else if (!userSelectionActive) d3Zoom.on('zoom', (event)=>{
                const { onViewportChange: onViewportChange } = store.getState();
                store.setState({
                    transform: [
                        event.transform.x,
                        event.transform.y,
                        event.transform.k
                    ]
                });
                zoomedWithRightMouseButton.current = !!(onPaneContextMenu && $b869bf1d00b93ac1$var$isRightClickPan(panOnDrag, mouseButton.current ?? 0));
                if ((onMove || onViewportChange) && !event.sourceEvent?.internal) {
                    const flowTransform = $b869bf1d00b93ac1$var$eventToFlowTransform(event.transform);
                    onViewportChange?.(flowTransform);
                    onMove?.(event.sourceEvent, flowTransform);
                }
            });
        }
    }, [
        userSelectionActive,
        d3Zoom,
        onMove,
        panOnDrag,
        onPaneContextMenu
    ]);
    (0, $kyXgS.useEffect)(()=>{
        if (d3Zoom) d3Zoom.on('end', (event)=>{
            if (!event.sourceEvent || event.sourceEvent.internal) return null;
            const { onViewportChangeEnd: onViewportChangeEnd } = store.getState();
            isZoomingOrPanning.current = false;
            store.setState({
                paneDragging: false
            });
            if (onPaneContextMenu && $b869bf1d00b93ac1$var$isRightClickPan(panOnDrag, mouseButton.current ?? 0) && !zoomedWithRightMouseButton.current) onPaneContextMenu(event.sourceEvent);
            zoomedWithRightMouseButton.current = false;
            if ((onMoveEnd || onViewportChangeEnd) && $b869bf1d00b93ac1$var$viewChanged(prevTransform.current, event.transform)) {
                const flowTransform = $b869bf1d00b93ac1$var$eventToFlowTransform(event.transform);
                prevTransform.current = flowTransform;
                clearTimeout(timerId.current);
                timerId.current = setTimeout(()=>{
                    onViewportChangeEnd?.(flowTransform);
                    onMoveEnd?.(event.sourceEvent, flowTransform);
                }, panOnScroll ? 150 : 0);
            }
        });
    }, [
        d3Zoom,
        panOnScroll,
        panOnDrag,
        onMoveEnd,
        onPaneContextMenu
    ]);
    (0, $kyXgS.useEffect)(()=>{
        if (d3Zoom) d3Zoom.filter((event)=>{
            const zoomScroll = zoomActivationKeyPressed || zoomOnScroll;
            const pinchZoom = zoomOnPinch && event.ctrlKey;
            if ((panOnDrag === true || Array.isArray(panOnDrag) && panOnDrag.includes(1)) && event.button === 1 && event.type === 'mousedown' && ($b869bf1d00b93ac1$var$isWrappedWithClass(event, 'react-flow__node') || $b869bf1d00b93ac1$var$isWrappedWithClass(event, 'react-flow__edge'))) return true;
            // if all interactions are disabled, we prevent all zoom events
            if (!panOnDrag && !zoomScroll && !panOnScroll && !zoomOnDoubleClick && !zoomOnPinch) return false;
            // during a selection we prevent all other interactions
            if (userSelectionActive) return false;
            // if zoom on double click is disabled, we prevent the double click event
            if (!zoomOnDoubleClick && event.type === 'dblclick') return false;
            // if the target element is inside an element with the nowheel class, we prevent zooming
            if ($b869bf1d00b93ac1$var$isWrappedWithClass(event, noWheelClassName) && event.type === 'wheel') return false;
            // if the target element is inside an element with the nopan class, we prevent panning
            if ($b869bf1d00b93ac1$var$isWrappedWithClass(event, noPanClassName) && (event.type !== 'wheel' || panOnScroll && event.type === 'wheel' && !zoomActivationKeyPressed)) return false;
            if (!zoomOnPinch && event.ctrlKey && event.type === 'wheel') return false;
            // when there is no scroll handling enabled, we prevent all wheel events
            if (!zoomScroll && !panOnScroll && !pinchZoom && event.type === 'wheel') return false;
            // if the pane is not movable, we prevent dragging it with mousestart or touchstart
            if (!panOnDrag && (event.type === 'mousedown' || event.type === 'touchstart')) return false;
            // if the pane is only movable using allowed clicks
            if (Array.isArray(panOnDrag) && !panOnDrag.includes(event.button) && event.type === 'mousedown') return false;
            // We only allow right clicks if pan on drag is set to right click
            const buttonAllowed = Array.isArray(panOnDrag) && panOnDrag.includes(event.button) || !event.button || event.button <= 1;
            // default filter for d3-zoom
            return (!event.ctrlKey || event.type === 'wheel') && buttonAllowed;
        });
    }, [
        userSelectionActive,
        d3Zoom,
        zoomOnScroll,
        zoomOnPinch,
        panOnScroll,
        zoomOnDoubleClick,
        panOnDrag,
        elementsSelectable,
        zoomActivationKeyPressed
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
        className: "react-flow__renderer",
        ref: zoomPane,
        style: $b869bf1d00b93ac1$var$containerStyle
    }, children);
};
const $b869bf1d00b93ac1$var$selector$9 = (s)=>({
        userSelectionActive: s.userSelectionActive,
        userSelectionRect: s.userSelectionRect
    });
function $b869bf1d00b93ac1$var$UserSelection() {
    const { userSelectionActive: userSelectionActive, userSelectionRect: userSelectionRect } = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$9, (0, $5b95e8cf664b5dbd$exports.shallow));
    const isActive = userSelectionActive && userSelectionRect;
    if (!isActive) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
        className: "react-flow__selection react-flow__container",
        style: {
            width: userSelectionRect.width,
            height: userSelectionRect.height,
            transform: `translate(${userSelectionRect.x}px, ${userSelectionRect.y}px)`
        }
    });
}
function $b869bf1d00b93ac1$export$946ffab23cd720c9(res, updateItem) {
    const parentId = updateItem.parentNode || updateItem.parentId;
    const parent = res.find((e)=>e.id === parentId);
    if (parent) {
        const extendWidth = updateItem.position.x + updateItem.width - parent.width;
        const extendHeight = updateItem.position.y + updateItem.height - parent.height;
        if (extendWidth > 0 || extendHeight > 0 || updateItem.position.x < 0 || updateItem.position.y < 0) {
            parent.style = {
                ...parent.style
            };
            parent.style.width = parent.style.width ?? parent.width;
            parent.style.height = parent.style.height ?? parent.height;
            if (extendWidth > 0) parent.style.width += extendWidth;
            if (extendHeight > 0) parent.style.height += extendHeight;
            if (updateItem.position.x < 0) {
                const xDiff = Math.abs(updateItem.position.x);
                parent.position.x = parent.position.x - xDiff;
                parent.style.width += xDiff;
                updateItem.position.x = 0;
            }
            if (updateItem.position.y < 0) {
                const yDiff = Math.abs(updateItem.position.y);
                parent.position.y = parent.position.y - yDiff;
                parent.style.height += yDiff;
                updateItem.position.y = 0;
            }
            parent.width = parent.style.width;
            parent.height = parent.style.height;
        }
    }
}
function $b869bf1d00b93ac1$var$applyChanges(changes, elements) {
    // we need this hack to handle the setNodes and setEdges function of the useReactFlow hook for controlled flows
    if (changes.some((c)=>c.type === 'reset')) return changes.filter((c)=>c.type === 'reset').map((c)=>c.item);
    const initElements = changes.filter((c)=>c.type === 'add').map((c)=>c.item);
    return elements.reduce((res, item)=>{
        const currentChanges = changes.filter((c)=>c.id === item.id);
        if (currentChanges.length === 0) {
            res.push(item);
            return res;
        }
        const updateItem = {
            ...item
        };
        for (const currentChange of currentChanges)if (currentChange) switch(currentChange.type){
            case 'select':
                updateItem.selected = currentChange.selected;
                break;
            case 'position':
                if (typeof currentChange.position !== 'undefined') updateItem.position = currentChange.position;
                if (typeof currentChange.positionAbsolute !== 'undefined') updateItem.positionAbsolute = currentChange.positionAbsolute;
                if (typeof currentChange.dragging !== 'undefined') updateItem.dragging = currentChange.dragging;
                if (updateItem.expandParent) $b869bf1d00b93ac1$export$946ffab23cd720c9(res, updateItem);
                break;
            case 'dimensions':
                if (typeof currentChange.dimensions !== 'undefined') {
                    updateItem.width = currentChange.dimensions.width;
                    updateItem.height = currentChange.dimensions.height;
                }
                if (typeof currentChange.updateStyle !== 'undefined') updateItem.style = {
                    ...updateItem.style || {},
                    ...currentChange.dimensions
                };
                if (typeof currentChange.resizing === 'boolean') updateItem.resizing = currentChange.resizing;
                if (updateItem.expandParent) $b869bf1d00b93ac1$export$946ffab23cd720c9(res, updateItem);
                break;
            case 'remove':
                return res;
        }
        res.push(updateItem);
        return res;
    }, initElements);
}
function $b869bf1d00b93ac1$export$80563776c0ff2fb5(changes, nodes) {
    return $b869bf1d00b93ac1$var$applyChanges(changes, nodes);
}
function $b869bf1d00b93ac1$export$9beb31bb1f03bba4(changes, edges) {
    return $b869bf1d00b93ac1$var$applyChanges(changes, edges);
}
const $b869bf1d00b93ac1$var$createSelectionChange = (id, selected)=>({
        id: id,
        type: 'select',
        selected: selected
    });
function $b869bf1d00b93ac1$var$getSelectionChanges(items, selectedIds) {
    return items.reduce((res, item)=>{
        const willBeSelected = selectedIds.includes(item.id);
        if (!item.selected && willBeSelected) {
            item.selected = true;
            res.push($b869bf1d00b93ac1$var$createSelectionChange(item.id, true));
        } else if (item.selected && !willBeSelected) {
            item.selected = false;
            res.push($b869bf1d00b93ac1$var$createSelectionChange(item.id, false));
        }
        return res;
    }, []);
}
/**
 * The user selection rectangle gets displayed when a user drags the mouse while pressing shift
 */ const $b869bf1d00b93ac1$var$wrapHandler = (handler, containerRef)=>{
    return (event)=>{
        if (event.target !== containerRef.current) return;
        handler?.(event);
    };
};
const $b869bf1d00b93ac1$var$selector$8 = (s)=>({
        userSelectionActive: s.userSelectionActive,
        elementsSelectable: s.elementsSelectable,
        dragging: s.paneDragging
    });
const $b869bf1d00b93ac1$var$Pane = (0, $kyXgS.memo)(({ isSelecting: isSelecting, selectionMode: selectionMode = $b869bf1d00b93ac1$export$91484609d16ec765.Full, panOnDrag: panOnDrag, onSelectionStart: onSelectionStart, onSelectionEnd: onSelectionEnd, onPaneClick: onPaneClick, onPaneContextMenu: onPaneContextMenu, onPaneScroll: onPaneScroll, onPaneMouseEnter: onPaneMouseEnter, onPaneMouseMove: onPaneMouseMove, onPaneMouseLeave: onPaneMouseLeave, children: children })=>{
    const container = (0, $kyXgS.useRef)(null);
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    const prevSelectedNodesCount = (0, $kyXgS.useRef)(0);
    const prevSelectedEdgesCount = (0, $kyXgS.useRef)(0);
    const containerBounds = (0, $kyXgS.useRef)();
    const { userSelectionActive: userSelectionActive, elementsSelectable: elementsSelectable, dragging: dragging } = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$8, (0, $5b95e8cf664b5dbd$exports.shallow));
    const resetUserSelection = ()=>{
        store.setState({
            userSelectionActive: false,
            userSelectionRect: null
        });
        prevSelectedNodesCount.current = 0;
        prevSelectedEdgesCount.current = 0;
    };
    const onClick = (event)=>{
        onPaneClick?.(event);
        store.getState().resetSelectedElements();
        store.setState({
            nodesSelectionActive: false
        });
    };
    const onContextMenu = (event)=>{
        if (Array.isArray(panOnDrag) && panOnDrag?.includes(2)) {
            event.preventDefault();
            return;
        }
        onPaneContextMenu?.(event);
    };
    const onWheel = onPaneScroll ? (event)=>onPaneScroll(event) : undefined;
    const onMouseDown = (event)=>{
        const { resetSelectedElements: resetSelectedElements, domNode: domNode } = store.getState();
        containerBounds.current = domNode?.getBoundingClientRect();
        if (!elementsSelectable || !isSelecting || event.button !== 0 || event.target !== container.current || !containerBounds.current) return;
        const { x: x, y: y } = $b869bf1d00b93ac1$var$getEventPosition(event, containerBounds.current);
        resetSelectedElements();
        store.setState({
            userSelectionRect: {
                width: 0,
                height: 0,
                startX: x,
                startY: y,
                x: x,
                y: y
            }
        });
        onSelectionStart?.(event);
    };
    const onMouseMove = (event)=>{
        const { userSelectionRect: userSelectionRect, nodeInternals: nodeInternals, edges: edges, transform: transform, onNodesChange: onNodesChange, onEdgesChange: onEdgesChange, nodeOrigin: nodeOrigin, getNodes: getNodes } = store.getState();
        if (!isSelecting || !containerBounds.current || !userSelectionRect) return;
        store.setState({
            userSelectionActive: true,
            nodesSelectionActive: false
        });
        const mousePos = $b869bf1d00b93ac1$var$getEventPosition(event, containerBounds.current);
        const startX = userSelectionRect.startX ?? 0;
        const startY = userSelectionRect.startY ?? 0;
        const nextUserSelectRect = {
            ...userSelectionRect,
            x: mousePos.x < startX ? mousePos.x : startX,
            y: mousePos.y < startY ? mousePos.y : startY,
            width: Math.abs(mousePos.x - startX),
            height: Math.abs(mousePos.y - startY)
        };
        const nodes = getNodes();
        const selectedNodes = $b869bf1d00b93ac1$var$getNodesInside(nodeInternals, nextUserSelectRect, transform, selectionMode === $b869bf1d00b93ac1$export$91484609d16ec765.Partial, true, nodeOrigin);
        const selectedEdgeIds = $b869bf1d00b93ac1$export$d21e19ffbf7ce542(selectedNodes, edges).map((e)=>e.id);
        const selectedNodeIds = selectedNodes.map((n)=>n.id);
        if (prevSelectedNodesCount.current !== selectedNodeIds.length) {
            prevSelectedNodesCount.current = selectedNodeIds.length;
            const changes = $b869bf1d00b93ac1$var$getSelectionChanges(nodes, selectedNodeIds);
            if (changes.length) onNodesChange?.(changes);
        }
        if (prevSelectedEdgesCount.current !== selectedEdgeIds.length) {
            prevSelectedEdgesCount.current = selectedEdgeIds.length;
            const changes = $b869bf1d00b93ac1$var$getSelectionChanges(edges, selectedEdgeIds);
            if (changes.length) onEdgesChange?.(changes);
        }
        store.setState({
            userSelectionRect: nextUserSelectRect
        });
    };
    const onMouseUp = (event)=>{
        if (event.button !== 0) return;
        const { userSelectionRect: userSelectionRect } = store.getState();
        // We only want to trigger click functions when in selection mode if
        // the user did not move the mouse.
        if (!userSelectionActive && userSelectionRect && event.target === container.current) onClick?.(event);
        store.setState({
            nodesSelectionActive: prevSelectedNodesCount.current > 0
        });
        resetUserSelection();
        onSelectionEnd?.(event);
    };
    const onMouseLeave = (event)=>{
        if (userSelectionActive) {
            store.setState({
                nodesSelectionActive: prevSelectedNodesCount.current > 0
            });
            onSelectionEnd?.(event);
        }
        resetUserSelection();
    };
    const hasActiveSelection = elementsSelectable && (isSelecting || userSelectionActive);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
        className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
            'react-flow__pane',
            {
                dragging: dragging,
                selection: isSelecting
            }
        ]),
        onClick: hasActiveSelection ? undefined : $b869bf1d00b93ac1$var$wrapHandler(onClick, container),
        onContextMenu: $b869bf1d00b93ac1$var$wrapHandler(onContextMenu, container),
        onWheel: $b869bf1d00b93ac1$var$wrapHandler(onWheel, container),
        onMouseEnter: hasActiveSelection ? undefined : onPaneMouseEnter,
        onMouseDown: hasActiveSelection ? onMouseDown : undefined,
        onMouseMove: hasActiveSelection ? onMouseMove : onPaneMouseMove,
        onMouseUp: hasActiveSelection ? onMouseUp : undefined,
        onMouseLeave: hasActiveSelection ? onMouseLeave : onPaneMouseLeave,
        ref: container,
        style: $b869bf1d00b93ac1$var$containerStyle
    }, children, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$UserSelection, null));
});
$b869bf1d00b93ac1$var$Pane.displayName = 'Pane';
function $b869bf1d00b93ac1$var$isParentSelected(node, nodeInternals) {
    const parentId = node.parentNode || node.parentId;
    if (!parentId) return false;
    const parentNode = nodeInternals.get(parentId);
    if (!parentNode) return false;
    if (parentNode.selected) return true;
    return $b869bf1d00b93ac1$var$isParentSelected(parentNode, nodeInternals);
}
function $b869bf1d00b93ac1$var$hasSelector(target, selector, nodeRef) {
    let current = target;
    do {
        if (current?.matches(selector)) return true;
        if (current === nodeRef.current) return false;
        current = current.parentElement;
    }while (current);
    return false;
}
// looks for all selected nodes and created a NodeDragItem for each of them
function $b869bf1d00b93ac1$var$getDragItems(nodeInternals, nodesDraggable, mousePos, nodeId) {
    return Array.from(nodeInternals.values()).filter((n)=>(n.selected || n.id === nodeId) && (!n.parentNode || n.parentId || !$b869bf1d00b93ac1$var$isParentSelected(n, nodeInternals)) && (n.draggable || nodesDraggable && typeof n.draggable === 'undefined')).map((n)=>({
            id: n.id,
            position: n.position || {
                x: 0,
                y: 0
            },
            positionAbsolute: n.positionAbsolute || {
                x: 0,
                y: 0
            },
            distance: {
                x: mousePos.x - (n.positionAbsolute?.x ?? 0),
                y: mousePos.y - (n.positionAbsolute?.y ?? 0)
            },
            delta: {
                x: 0,
                y: 0
            },
            extent: n.extent,
            parentNode: n.parentNode || n.parentId,
            parentId: n.parentNode || n.parentId,
            width: n.width,
            height: n.height,
            expandParent: n.expandParent
        }));
}
function $b869bf1d00b93ac1$var$clampNodeExtent(node, extent) {
    if (!extent || extent === 'parent') return extent;
    return [
        extent[0],
        [
            extent[1][0] - (node.width || 0),
            extent[1][1] - (node.height || 0)
        ]
    ];
}
function $b869bf1d00b93ac1$var$calcNextPosition(node, nextPosition, nodeInternals, nodeExtent, nodeOrigin = [
    0,
    0
], onError) {
    const clampedNodeExtent = $b869bf1d00b93ac1$var$clampNodeExtent(node, node.extent || nodeExtent);
    let currentExtent = clampedNodeExtent;
    const parentId = node.parentNode || node.parentId;
    if (node.extent === 'parent' && !node.expandParent) {
        if (parentId && node.width && node.height) {
            const parent = nodeInternals.get(parentId);
            const { x: parentX, y: parentY } = $b869bf1d00b93ac1$export$72c5647f6be28a9c(parent, nodeOrigin).positionAbsolute;
            currentExtent = parent && $b869bf1d00b93ac1$var$isNumeric(parentX) && $b869bf1d00b93ac1$var$isNumeric(parentY) && $b869bf1d00b93ac1$var$isNumeric(parent.width) && $b869bf1d00b93ac1$var$isNumeric(parent.height) ? [
                [
                    parentX + node.width * nodeOrigin[0],
                    parentY + node.height * nodeOrigin[1]
                ],
                [
                    parentX + parent.width - node.width + node.width * nodeOrigin[0],
                    parentY + parent.height - node.height + node.height * nodeOrigin[1]
                ]
            ] : currentExtent;
        } else {
            onError?.('005', $b869bf1d00b93ac1$var$errorMessages['error005']());
            currentExtent = clampedNodeExtent;
        }
    } else if (node.extent && parentId && node.extent !== 'parent') {
        const parent = nodeInternals.get(parentId);
        const { x: parentX, y: parentY } = $b869bf1d00b93ac1$export$72c5647f6be28a9c(parent, nodeOrigin).positionAbsolute;
        currentExtent = [
            [
                node.extent[0][0] + parentX,
                node.extent[0][1] + parentY
            ],
            [
                node.extent[1][0] + parentX,
                node.extent[1][1] + parentY
            ]
        ];
    }
    let parentPosition = {
        x: 0,
        y: 0
    };
    if (parentId) {
        const parentNode = nodeInternals.get(parentId);
        parentPosition = $b869bf1d00b93ac1$export$72c5647f6be28a9c(parentNode, nodeOrigin).positionAbsolute;
    }
    const positionAbsolute = currentExtent && currentExtent !== 'parent' ? $b869bf1d00b93ac1$var$clampPosition(nextPosition, currentExtent) : nextPosition;
    return {
        position: {
            x: positionAbsolute.x - parentPosition.x,
            y: positionAbsolute.y - parentPosition.y
        },
        positionAbsolute: positionAbsolute
    };
}
// returns two params:
// 1. the dragged node (or the first of the list, if we are dragging a node selection)
// 2. array of selected nodes (for multi selections)
function $b869bf1d00b93ac1$var$getEventHandlerParams({ nodeId: nodeId, dragItems: dragItems, nodeInternals: nodeInternals }) {
    const extentedDragItems = dragItems.map((n)=>{
        const node = nodeInternals.get(n.id);
        return {
            ...node,
            position: n.position,
            positionAbsolute: n.positionAbsolute
        };
    });
    return [
        nodeId ? extentedDragItems.find((n)=>n.id === nodeId) : extentedDragItems[0],
        extentedDragItems
    ];
}
const $b869bf1d00b93ac1$var$getHandleBounds = (selector, nodeElement, zoom, nodeOrigin)=>{
    const handles = nodeElement.querySelectorAll(selector);
    if (!handles || !handles.length) return null;
    const handlesArray = Array.from(handles);
    const nodeBounds = nodeElement.getBoundingClientRect();
    const nodeOffset = {
        x: nodeBounds.width * nodeOrigin[0],
        y: nodeBounds.height * nodeOrigin[1]
    };
    return handlesArray.map((handle)=>{
        const handleBounds = handle.getBoundingClientRect();
        return {
            id: handle.getAttribute('data-handleid'),
            position: handle.getAttribute('data-handlepos'),
            x: (handleBounds.left - nodeBounds.left - nodeOffset.x) / zoom,
            y: (handleBounds.top - nodeBounds.top - nodeOffset.y) / zoom,
            ...$b869bf1d00b93ac1$var$getDimensions(handle)
        };
    });
};
function $b869bf1d00b93ac1$var$getMouseHandler(id, getState, handler) {
    return handler === undefined ? handler : (event)=>{
        const node = getState().nodeInternals.get(id);
        if (node) handler(event, {
            ...node
        });
    };
}
// this handler is called by
// 1. the click handler when node is not draggable or selectNodesOnDrag = false
// or
// 2. the on drag start handler when node is draggable and selectNodesOnDrag = true
function $b869bf1d00b93ac1$var$handleNodeClick({ id: id, store: store, unselect: unselect = false, nodeRef: nodeRef }) {
    const { addSelectedNodes: addSelectedNodes, unselectNodesAndEdges: unselectNodesAndEdges, multiSelectionActive: multiSelectionActive, nodeInternals: nodeInternals, onError: onError } = store.getState();
    const node = nodeInternals.get(id);
    if (!node) {
        onError?.('012', $b869bf1d00b93ac1$var$errorMessages['error012'](id));
        return;
    }
    store.setState({
        nodesSelectionActive: false
    });
    if (!node.selected) addSelectedNodes([
        id
    ]);
    else if (unselect || node.selected && multiSelectionActive) {
        unselectNodesAndEdges({
            nodes: [
                node
            ],
            edges: []
        });
        requestAnimationFrame(()=>nodeRef?.current?.blur());
    }
}
function $b869bf1d00b93ac1$export$7b38ecbf7e010cab() {
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    // returns the pointer position projected to the RF coordinate system
    const getPointerPosition = (0, $kyXgS.useCallback)(({ sourceEvent: sourceEvent })=>{
        const { transform: transform, snapGrid: snapGrid, snapToGrid: snapToGrid } = store.getState();
        const x = sourceEvent.touches ? sourceEvent.touches[0].clientX : sourceEvent.clientX;
        const y = sourceEvent.touches ? sourceEvent.touches[0].clientY : sourceEvent.clientY;
        const pointerPos = {
            x: (x - transform[0]) / transform[2],
            y: (y - transform[1]) / transform[2]
        };
        // we need the snapped position in order to be able to skip unnecessary drag events
        return {
            xSnapped: snapToGrid ? snapGrid[0] * Math.round(pointerPos.x / snapGrid[0]) : pointerPos.x,
            ySnapped: snapToGrid ? snapGrid[1] * Math.round(pointerPos.y / snapGrid[1]) : pointerPos.y,
            ...pointerPos
        };
    }, []);
    return getPointerPosition;
}
function $b869bf1d00b93ac1$var$wrapSelectionDragFunc(selectionFunc) {
    return (event, _, nodes)=>selectionFunc?.(event, nodes);
}
function $b869bf1d00b93ac1$var$useDrag({ nodeRef: nodeRef, disabled: disabled = false, noDragClassName: noDragClassName, handleSelector: handleSelector, nodeId: nodeId, isSelectable: isSelectable, selectNodesOnDrag: selectNodesOnDrag }) {
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    const [dragging, setDragging] = (0, $kyXgS.useState)(false);
    const dragItems = (0, $kyXgS.useRef)([]);
    const lastPos = (0, $kyXgS.useRef)({
        x: null,
        y: null
    });
    const autoPanId = (0, $kyXgS.useRef)(0);
    const containerBounds = (0, $kyXgS.useRef)(null);
    const mousePosition = (0, $kyXgS.useRef)({
        x: 0,
        y: 0
    });
    const dragEvent = (0, $kyXgS.useRef)(null);
    const autoPanStarted = (0, $kyXgS.useRef)(false);
    const dragStarted = (0, $kyXgS.useRef)(false);
    const abortDrag = (0, $kyXgS.useRef)(false);
    const getPointerPosition = $b869bf1d00b93ac1$export$7b38ecbf7e010cab();
    (0, $kyXgS.useEffect)(()=>{
        if (nodeRef?.current) {
            const selection = (0, $b0b9e4430a128489$export$2e2bcd8739ae039)(nodeRef.current);
            const updateNodes = ({ x: x, y: y })=>{
                const { nodeInternals: nodeInternals, onNodeDrag: onNodeDrag, onSelectionDrag: onSelectionDrag, updateNodePositions: updateNodePositions, nodeExtent: nodeExtent, snapGrid: snapGrid, snapToGrid: snapToGrid, nodeOrigin: nodeOrigin, onError: onError } = store.getState();
                lastPos.current = {
                    x: x,
                    y: y
                };
                let hasChange = false;
                let nodesBox = {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 0
                };
                if (dragItems.current.length > 1 && nodeExtent) {
                    const rect = $b869bf1d00b93ac1$export$d5a2bfe3c0f7d322(dragItems.current, nodeOrigin);
                    nodesBox = $b869bf1d00b93ac1$export$5497ab15485123ba(rect);
                }
                dragItems.current = dragItems.current.map((n)=>{
                    const nextPosition = {
                        x: x - n.distance.x,
                        y: y - n.distance.y
                    };
                    if (snapToGrid) {
                        nextPosition.x = snapGrid[0] * Math.round(nextPosition.x / snapGrid[0]);
                        nextPosition.y = snapGrid[1] * Math.round(nextPosition.y / snapGrid[1]);
                    }
                    // if there is selection with multiple nodes and a node extent is set, we need to adjust the node extent for each node
                    // based on its position so that the node stays at it's position relative to the selection.
                    const adjustedNodeExtent = [
                        [
                            nodeExtent[0][0],
                            nodeExtent[0][1]
                        ],
                        [
                            nodeExtent[1][0],
                            nodeExtent[1][1]
                        ]
                    ];
                    if (dragItems.current.length > 1 && nodeExtent && !n.extent) {
                        adjustedNodeExtent[0][0] = n.positionAbsolute.x - nodesBox.x + nodeExtent[0][0];
                        adjustedNodeExtent[1][0] = n.positionAbsolute.x + (n.width ?? 0) - nodesBox.x2 + nodeExtent[1][0];
                        adjustedNodeExtent[0][1] = n.positionAbsolute.y - nodesBox.y + nodeExtent[0][1];
                        adjustedNodeExtent[1][1] = n.positionAbsolute.y + (n.height ?? 0) - nodesBox.y2 + nodeExtent[1][1];
                    }
                    const updatedPos = $b869bf1d00b93ac1$var$calcNextPosition(n, nextPosition, nodeInternals, adjustedNodeExtent, nodeOrigin, onError);
                    // we want to make sure that we only fire a change event when there is a change
                    hasChange = hasChange || n.position.x !== updatedPos.position.x || n.position.y !== updatedPos.position.y;
                    n.position = updatedPos.position;
                    n.positionAbsolute = updatedPos.positionAbsolute;
                    return n;
                });
                if (!hasChange) return;
                updateNodePositions(dragItems.current, true, true);
                setDragging(true);
                const onDrag = nodeId ? onNodeDrag : $b869bf1d00b93ac1$var$wrapSelectionDragFunc(onSelectionDrag);
                if (onDrag && dragEvent.current) {
                    const [currentNode, nodes] = $b869bf1d00b93ac1$var$getEventHandlerParams({
                        nodeId: nodeId,
                        dragItems: dragItems.current,
                        nodeInternals: nodeInternals
                    });
                    onDrag(dragEvent.current, currentNode, nodes);
                }
            };
            const autoPan = ()=>{
                if (!containerBounds.current) return;
                const [xMovement, yMovement] = $b869bf1d00b93ac1$var$calcAutoPan(mousePosition.current, containerBounds.current);
                if (xMovement !== 0 || yMovement !== 0) {
                    const { transform: transform, panBy: panBy } = store.getState();
                    lastPos.current.x = (lastPos.current.x ?? 0) - xMovement / transform[2];
                    lastPos.current.y = (lastPos.current.y ?? 0) - yMovement / transform[2];
                    if (panBy({
                        x: xMovement,
                        y: yMovement
                    })) updateNodes(lastPos.current);
                }
                autoPanId.current = requestAnimationFrame(autoPan);
            };
            const startDrag = (event)=>{
                const { nodeInternals: nodeInternals, multiSelectionActive: multiSelectionActive, nodesDraggable: nodesDraggable, unselectNodesAndEdges: unselectNodesAndEdges, onNodeDragStart: onNodeDragStart, onSelectionDragStart: onSelectionDragStart } = store.getState();
                dragStarted.current = true;
                const onStart = nodeId ? onNodeDragStart : $b869bf1d00b93ac1$var$wrapSelectionDragFunc(onSelectionDragStart);
                if ((!selectNodesOnDrag || !isSelectable) && !multiSelectionActive && nodeId) {
                    if (!nodeInternals.get(nodeId)?.selected) // we need to reset selected nodes when selectNodesOnDrag=false
                    unselectNodesAndEdges();
                }
                if (nodeId && isSelectable && selectNodesOnDrag) $b869bf1d00b93ac1$var$handleNodeClick({
                    id: nodeId,
                    store: store,
                    nodeRef: nodeRef
                });
                const pointerPos = getPointerPosition(event);
                lastPos.current = pointerPos;
                dragItems.current = $b869bf1d00b93ac1$var$getDragItems(nodeInternals, nodesDraggable, pointerPos, nodeId);
                if (onStart && dragItems.current) {
                    const [currentNode, nodes] = $b869bf1d00b93ac1$var$getEventHandlerParams({
                        nodeId: nodeId,
                        dragItems: dragItems.current,
                        nodeInternals: nodeInternals
                    });
                    onStart(event.sourceEvent, currentNode, nodes);
                }
            };
            if (disabled) selection.on('.drag', null);
            else {
                const dragHandler = (0, $060ef0f969b66d1e$export$2e2bcd8739ae039)().on('start', (event)=>{
                    const { domNode: domNode, nodeDragThreshold: nodeDragThreshold } = store.getState();
                    if (nodeDragThreshold === 0) startDrag(event);
                    abortDrag.current = false;
                    const pointerPos = getPointerPosition(event);
                    lastPos.current = pointerPos;
                    containerBounds.current = domNode?.getBoundingClientRect() || null;
                    mousePosition.current = $b869bf1d00b93ac1$var$getEventPosition(event.sourceEvent, containerBounds.current);
                }).on('drag', (event)=>{
                    const pointerPos = getPointerPosition(event);
                    const { autoPanOnNodeDrag: autoPanOnNodeDrag, nodeDragThreshold: nodeDragThreshold } = store.getState();
                    if (event.sourceEvent.type === 'touchmove' && event.sourceEvent.touches.length > 1) abortDrag.current = true;
                    if (abortDrag.current) return;
                    if (!autoPanStarted.current && dragStarted.current && autoPanOnNodeDrag) {
                        autoPanStarted.current = true;
                        autoPan();
                    }
                    if (!dragStarted.current) {
                        const x = pointerPos.xSnapped - (lastPos?.current?.x ?? 0);
                        const y = pointerPos.ySnapped - (lastPos?.current?.y ?? 0);
                        const distance = Math.sqrt(x * x + y * y);
                        if (distance > nodeDragThreshold) startDrag(event);
                    }
                    // skip events without movement
                    if ((lastPos.current.x !== pointerPos.xSnapped || lastPos.current.y !== pointerPos.ySnapped) && dragItems.current && dragStarted.current) {
                        dragEvent.current = event.sourceEvent;
                        mousePosition.current = $b869bf1d00b93ac1$var$getEventPosition(event.sourceEvent, containerBounds.current);
                        updateNodes(pointerPos);
                    }
                }).on('end', (event)=>{
                    if (!dragStarted.current || abortDrag.current) return;
                    setDragging(false);
                    autoPanStarted.current = false;
                    dragStarted.current = false;
                    cancelAnimationFrame(autoPanId.current);
                    if (dragItems.current) {
                        const { updateNodePositions: updateNodePositions, nodeInternals: nodeInternals, onNodeDragStop: onNodeDragStop, onSelectionDragStop: onSelectionDragStop } = store.getState();
                        const onStop = nodeId ? onNodeDragStop : $b869bf1d00b93ac1$var$wrapSelectionDragFunc(onSelectionDragStop);
                        updateNodePositions(dragItems.current, false, false);
                        if (onStop) {
                            const [currentNode, nodes] = $b869bf1d00b93ac1$var$getEventHandlerParams({
                                nodeId: nodeId,
                                dragItems: dragItems.current,
                                nodeInternals: nodeInternals
                            });
                            onStop(event.sourceEvent, currentNode, nodes);
                        }
                    }
                }).filter((event)=>{
                    const target = event.target;
                    const isDraggable = !event.button && (!noDragClassName || !$b869bf1d00b93ac1$var$hasSelector(target, `.${noDragClassName}`, nodeRef)) && (!handleSelector || $b869bf1d00b93ac1$var$hasSelector(target, handleSelector, nodeRef));
                    return isDraggable;
                });
                selection.call(dragHandler);
                return ()=>{
                    selection.on('.drag', null);
                };
            }
        }
    }, [
        nodeRef,
        disabled,
        noDragClassName,
        handleSelector,
        isSelectable,
        store,
        nodeId,
        selectNodesOnDrag,
        getPointerPosition
    ]);
    return dragging;
}
function $b869bf1d00b93ac1$var$useUpdateNodePositions() {
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    const updatePositions = (0, $kyXgS.useCallback)((params)=>{
        const { nodeInternals: nodeInternals, nodeExtent: nodeExtent, updateNodePositions: updateNodePositions, getNodes: getNodes, snapToGrid: snapToGrid, snapGrid: snapGrid, onError: onError, nodesDraggable: nodesDraggable } = store.getState();
        const selectedNodes = getNodes().filter((n)=>n.selected && (n.draggable || nodesDraggable && typeof n.draggable === 'undefined'));
        // by default a node moves 5px on each key press, or 20px if shift is pressed
        // if snap grid is enabled, we use that for the velocity.
        const xVelo = snapToGrid ? snapGrid[0] : 5;
        const yVelo = snapToGrid ? snapGrid[1] : 5;
        const factor = params.isShiftPressed ? 4 : 1;
        const positionDiffX = params.x * xVelo * factor;
        const positionDiffY = params.y * yVelo * factor;
        const nodeUpdates = selectedNodes.map((n)=>{
            if (n.positionAbsolute) {
                const nextPosition = {
                    x: n.positionAbsolute.x + positionDiffX,
                    y: n.positionAbsolute.y + positionDiffY
                };
                if (snapToGrid) {
                    nextPosition.x = snapGrid[0] * Math.round(nextPosition.x / snapGrid[0]);
                    nextPosition.y = snapGrid[1] * Math.round(nextPosition.y / snapGrid[1]);
                }
                const { positionAbsolute: positionAbsolute, position: position } = $b869bf1d00b93ac1$var$calcNextPosition(n, nextPosition, nodeInternals, nodeExtent, undefined, onError);
                n.position = position;
                n.positionAbsolute = positionAbsolute;
            }
            return n;
        });
        updateNodePositions(nodeUpdates, true, false);
    }, []);
    return updatePositions;
}
const $b869bf1d00b93ac1$var$arrowKeyDiffs = {
    ArrowUp: {
        x: 0,
        y: -1
    },
    ArrowDown: {
        x: 0,
        y: 1
    },
    ArrowLeft: {
        x: -1,
        y: 0
    },
    ArrowRight: {
        x: 1,
        y: 0
    }
};
var $b869bf1d00b93ac1$var$wrapNode = (NodeComponent)=>{
    const NodeWrapper = ({ id: id, type: type, data: data, xPos: xPos, yPos: yPos, xPosOrigin: xPosOrigin, yPosOrigin: yPosOrigin, selected: selected, onClick: onClick, onMouseEnter: onMouseEnter, onMouseMove: onMouseMove, onMouseLeave: onMouseLeave, onContextMenu: onContextMenu, onDoubleClick: onDoubleClick, style: style, className: className, isDraggable: isDraggable, isSelectable: isSelectable, isConnectable: isConnectable, isFocusable: isFocusable, selectNodesOnDrag: selectNodesOnDrag, sourcePosition: sourcePosition, targetPosition: targetPosition, hidden: hidden, resizeObserver: resizeObserver, dragHandle: dragHandle, zIndex: zIndex, isParent: isParent, noDragClassName: noDragClassName, noPanClassName: noPanClassName, initialized: initialized, disableKeyboardA11y: disableKeyboardA11y, ariaLabel: ariaLabel, rfId: rfId, hasHandleBounds: hasHandleBounds })=>{
        const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
        const nodeRef = (0, $kyXgS.useRef)(null);
        const prevNodeRef = (0, $kyXgS.useRef)(null);
        const prevSourcePosition = (0, $kyXgS.useRef)(sourcePosition);
        const prevTargetPosition = (0, $kyXgS.useRef)(targetPosition);
        const prevType = (0, $kyXgS.useRef)(type);
        const hasPointerEvents = isSelectable || isDraggable || onClick || onMouseEnter || onMouseMove || onMouseLeave;
        const updatePositions = $b869bf1d00b93ac1$var$useUpdateNodePositions();
        const onMouseEnterHandler = $b869bf1d00b93ac1$var$getMouseHandler(id, store.getState, onMouseEnter);
        const onMouseMoveHandler = $b869bf1d00b93ac1$var$getMouseHandler(id, store.getState, onMouseMove);
        const onMouseLeaveHandler = $b869bf1d00b93ac1$var$getMouseHandler(id, store.getState, onMouseLeave);
        const onContextMenuHandler = $b869bf1d00b93ac1$var$getMouseHandler(id, store.getState, onContextMenu);
        const onDoubleClickHandler = $b869bf1d00b93ac1$var$getMouseHandler(id, store.getState, onDoubleClick);
        const onSelectNodeHandler = (event)=>{
            const { nodeDragThreshold: nodeDragThreshold } = store.getState();
            if (isSelectable && (!selectNodesOnDrag || !isDraggable || nodeDragThreshold > 0)) // this handler gets called within the drag start event when selectNodesOnDrag=true
            $b869bf1d00b93ac1$var$handleNodeClick({
                id: id,
                store: store,
                nodeRef: nodeRef
            });
            if (onClick) {
                const node = store.getState().nodeInternals.get(id);
                if (node) onClick(event, {
                    ...node
                });
            }
        };
        const onKeyDown = (event)=>{
            if ($b869bf1d00b93ac1$var$isInputDOMNode(event)) return;
            if (disableKeyboardA11y) return;
            if ($b869bf1d00b93ac1$var$elementSelectionKeys.includes(event.key) && isSelectable) {
                const unselect = event.key === 'Escape';
                $b869bf1d00b93ac1$var$handleNodeClick({
                    id: id,
                    store: store,
                    unselect: unselect,
                    nodeRef: nodeRef
                });
            } else if (isDraggable && selected && Object.prototype.hasOwnProperty.call($b869bf1d00b93ac1$var$arrowKeyDiffs, event.key)) {
                store.setState({
                    ariaLiveMessage: `Moved selected node ${event.key.replace('Arrow', '').toLowerCase()}. New position, x: ${~~xPos}, y: ${~~yPos}`
                });
                updatePositions({
                    x: $b869bf1d00b93ac1$var$arrowKeyDiffs[event.key].x,
                    y: $b869bf1d00b93ac1$var$arrowKeyDiffs[event.key].y,
                    isShiftPressed: event.shiftKey
                });
            }
        };
        (0, $kyXgS.useEffect)(()=>{
            return ()=>{
                if (prevNodeRef.current) {
                    resizeObserver?.unobserve(prevNodeRef.current);
                    prevNodeRef.current = null;
                }
            };
        }, []);
        (0, $kyXgS.useEffect)(()=>{
            if (nodeRef.current && !hidden) {
                const currNode = nodeRef.current;
                if (!initialized || !hasHandleBounds || prevNodeRef.current !== currNode) {
                    // At this point we always want to make sure that the node gets re-measured / re-initialized.
                    // We need to unobserve it first in case it is still observed
                    if (prevNodeRef.current) resizeObserver?.unobserve(prevNodeRef.current);
                    resizeObserver?.observe(currNode);
                    prevNodeRef.current = currNode;
                }
            }
        }, [
            hidden,
            initialized,
            hasHandleBounds
        ]);
        (0, $kyXgS.useEffect)(()=>{
            // when the user programmatically changes the source or handle position, we re-initialize the node
            const typeChanged = prevType.current !== type;
            const sourcePosChanged = prevSourcePosition.current !== sourcePosition;
            const targetPosChanged = prevTargetPosition.current !== targetPosition;
            if (nodeRef.current && (typeChanged || sourcePosChanged || targetPosChanged)) {
                if (typeChanged) prevType.current = type;
                if (sourcePosChanged) prevSourcePosition.current = sourcePosition;
                if (targetPosChanged) prevTargetPosition.current = targetPosition;
                store.getState().updateNodeDimensions([
                    {
                        id: id,
                        nodeElement: nodeRef.current,
                        forceUpdate: true
                    }
                ]);
            }
        }, [
            id,
            type,
            sourcePosition,
            targetPosition
        ]);
        const dragging = $b869bf1d00b93ac1$var$useDrag({
            nodeRef: nodeRef,
            disabled: hidden || !isDraggable,
            noDragClassName: noDragClassName,
            handleSelector: dragHandle,
            nodeId: id,
            isSelectable: isSelectable,
            selectNodesOnDrag: selectNodesOnDrag
        });
        if (hidden) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
            className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
                'react-flow__node',
                `react-flow__node-${type}`,
                {
                    // this is overwritable by passing `nopan` as a class name
                    [noPanClassName]: isDraggable
                },
                className,
                {
                    selected: selected,
                    selectable: isSelectable,
                    parent: isParent,
                    dragging: dragging
                }
            ]),
            ref: nodeRef,
            style: {
                zIndex: zIndex,
                transform: `translate(${xPosOrigin}px,${yPosOrigin}px)`,
                pointerEvents: hasPointerEvents ? 'all' : 'none',
                visibility: initialized ? 'visible' : 'hidden',
                ...style
            },
            "data-id": id,
            "data-testid": `rf__node-${id}`,
            onMouseEnter: onMouseEnterHandler,
            onMouseMove: onMouseMoveHandler,
            onMouseLeave: onMouseLeaveHandler,
            onContextMenu: onContextMenuHandler,
            onClick: onSelectNodeHandler,
            onDoubleClick: onDoubleClickHandler,
            onKeyDown: isFocusable ? onKeyDown : undefined,
            tabIndex: isFocusable ? 0 : undefined,
            role: isFocusable ? 'button' : undefined,
            "aria-describedby": disableKeyboardA11y ? undefined : `${$b869bf1d00b93ac1$var$ARIA_NODE_DESC_KEY}-${rfId}`,
            "aria-label": ariaLabel
        }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$Provider, {
            value: id
        }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement(NodeComponent, {
            id: id,
            data: data,
            type: type,
            xPos: xPos,
            yPos: yPos,
            selected: selected,
            isConnectable: isConnectable,
            sourcePosition: sourcePosition,
            targetPosition: targetPosition,
            dragging: dragging,
            dragHandle: dragHandle,
            zIndex: zIndex
        })));
    };
    NodeWrapper.displayName = 'NodeWrapper';
    return (0, $kyXgS.memo)(NodeWrapper);
};
/**
 * The nodes selection rectangle gets displayed when a user
 * made a selection with on or several nodes
 */ const $b869bf1d00b93ac1$var$selector$7 = (s)=>{
    const selectedNodes = s.getNodes().filter((n)=>n.selected);
    return {
        ...$b869bf1d00b93ac1$export$d5a2bfe3c0f7d322(selectedNodes, s.nodeOrigin),
        transformString: `translate(${s.transform[0]}px,${s.transform[1]}px) scale(${s.transform[2]})`,
        userSelectionActive: s.userSelectionActive
    };
};
function $b869bf1d00b93ac1$var$NodesSelection({ onSelectionContextMenu: onSelectionContextMenu, noPanClassName: noPanClassName, disableKeyboardA11y: disableKeyboardA11y }) {
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    const { width: width, height: height, x: left, y: top, transformString: transformString, userSelectionActive: userSelectionActive } = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$7, (0, $5b95e8cf664b5dbd$exports.shallow));
    const updatePositions = $b869bf1d00b93ac1$var$useUpdateNodePositions();
    const nodeRef = (0, $kyXgS.useRef)(null);
    (0, $kyXgS.useEffect)(()=>{
        if (!disableKeyboardA11y) nodeRef.current?.focus({
            preventScroll: true
        });
    }, [
        disableKeyboardA11y
    ]);
    $b869bf1d00b93ac1$var$useDrag({
        nodeRef: nodeRef
    });
    if (userSelectionActive || !width || !height) return null;
    const onContextMenu = onSelectionContextMenu ? (event)=>{
        const selectedNodes = store.getState().getNodes().filter((n)=>n.selected);
        onSelectionContextMenu(event, selectedNodes);
    } : undefined;
    const onKeyDown = (event)=>{
        if (Object.prototype.hasOwnProperty.call($b869bf1d00b93ac1$var$arrowKeyDiffs, event.key)) updatePositions({
            x: $b869bf1d00b93ac1$var$arrowKeyDiffs[event.key].x,
            y: $b869bf1d00b93ac1$var$arrowKeyDiffs[event.key].y,
            isShiftPressed: event.shiftKey
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
        className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
            'react-flow__nodesselection',
            'react-flow__container',
            noPanClassName
        ]),
        style: {
            transform: transformString
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
        ref: nodeRef,
        className: "react-flow__nodesselection-rect",
        onContextMenu: onContextMenu,
        tabIndex: disableKeyboardA11y ? undefined : -1,
        onKeyDown: disableKeyboardA11y ? undefined : onKeyDown,
        style: {
            width: width,
            height: height,
            top: top,
            left: left
        }
    }));
}
var $b869bf1d00b93ac1$var$NodesSelection$1 = (0, $kyXgS.memo)($b869bf1d00b93ac1$var$NodesSelection);
const $b869bf1d00b93ac1$var$selector$6 = (s)=>s.nodesSelectionActive;
const $b869bf1d00b93ac1$var$FlowRenderer = ({ children: children, onPaneClick: onPaneClick, onPaneMouseEnter: onPaneMouseEnter, onPaneMouseMove: onPaneMouseMove, onPaneMouseLeave: onPaneMouseLeave, onPaneContextMenu: onPaneContextMenu, onPaneScroll: onPaneScroll, deleteKeyCode: deleteKeyCode, onMove: onMove, onMoveStart: onMoveStart, onMoveEnd: onMoveEnd, selectionKeyCode: selectionKeyCode, selectionOnDrag: selectionOnDrag, selectionMode: selectionMode, onSelectionStart: onSelectionStart, onSelectionEnd: onSelectionEnd, multiSelectionKeyCode: multiSelectionKeyCode, panActivationKeyCode: panActivationKeyCode, zoomActivationKeyCode: zoomActivationKeyCode, elementsSelectable: elementsSelectable, zoomOnScroll: zoomOnScroll, zoomOnPinch: zoomOnPinch, panOnScroll: _panOnScroll, panOnScrollSpeed: panOnScrollSpeed, panOnScrollMode: panOnScrollMode, zoomOnDoubleClick: zoomOnDoubleClick, panOnDrag: _panOnDrag, defaultViewport: defaultViewport, translateExtent: translateExtent, minZoom: minZoom, maxZoom: maxZoom, preventScrolling: preventScrolling, onSelectionContextMenu: onSelectionContextMenu, noWheelClassName: noWheelClassName, noPanClassName: noPanClassName, disableKeyboardA11y: disableKeyboardA11y })=>{
    const nodesSelectionActive = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$6);
    const selectionKeyPressed = $b869bf1d00b93ac1$export$b65485ca34c366f3(selectionKeyCode);
    const panActivationKeyPressed = $b869bf1d00b93ac1$export$b65485ca34c366f3(panActivationKeyCode);
    const panOnDrag = panActivationKeyPressed || _panOnDrag;
    const panOnScroll = panActivationKeyPressed || _panOnScroll;
    const isSelecting = selectionKeyPressed || selectionOnDrag && panOnDrag !== true;
    $b869bf1d00b93ac1$var$useGlobalKeyHandler({
        deleteKeyCode: deleteKeyCode,
        multiSelectionKeyCode: multiSelectionKeyCode
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$ZoomPane, {
        onMove: onMove,
        onMoveStart: onMoveStart,
        onMoveEnd: onMoveEnd,
        onPaneContextMenu: onPaneContextMenu,
        elementsSelectable: elementsSelectable,
        zoomOnScroll: zoomOnScroll,
        zoomOnPinch: zoomOnPinch,
        panOnScroll: panOnScroll,
        panOnScrollSpeed: panOnScrollSpeed,
        panOnScrollMode: panOnScrollMode,
        zoomOnDoubleClick: zoomOnDoubleClick,
        panOnDrag: !selectionKeyPressed && panOnDrag,
        defaultViewport: defaultViewport,
        translateExtent: translateExtent,
        minZoom: minZoom,
        maxZoom: maxZoom,
        zoomActivationKeyCode: zoomActivationKeyCode,
        preventScrolling: preventScrolling,
        noWheelClassName: noWheelClassName,
        noPanClassName: noPanClassName
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$Pane, {
        onSelectionStart: onSelectionStart,
        onSelectionEnd: onSelectionEnd,
        onPaneClick: onPaneClick,
        onPaneMouseEnter: onPaneMouseEnter,
        onPaneMouseMove: onPaneMouseMove,
        onPaneMouseLeave: onPaneMouseLeave,
        onPaneContextMenu: onPaneContextMenu,
        onPaneScroll: onPaneScroll,
        panOnDrag: panOnDrag,
        isSelecting: !!isSelecting,
        selectionMode: selectionMode
    }, children, nodesSelectionActive && (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$NodesSelection$1, {
        onSelectionContextMenu: onSelectionContextMenu,
        noPanClassName: noPanClassName,
        disableKeyboardA11y: disableKeyboardA11y
    })));
};
$b869bf1d00b93ac1$var$FlowRenderer.displayName = 'FlowRenderer';
var $b869bf1d00b93ac1$var$FlowRenderer$1 = (0, $kyXgS.memo)($b869bf1d00b93ac1$var$FlowRenderer);
function $b869bf1d00b93ac1$var$useVisibleNodes(onlyRenderVisible) {
    const nodes = $b869bf1d00b93ac1$export$6ccbb43953eebf8((0, $kyXgS.useCallback)((s)=>onlyRenderVisible ? $b869bf1d00b93ac1$var$getNodesInside(s.nodeInternals, {
            x: 0,
            y: 0,
            width: s.width,
            height: s.height
        }, s.transform, true) : s.getNodes(), [
        onlyRenderVisible
    ]));
    return nodes;
}
function $b869bf1d00b93ac1$var$createNodeTypes(nodeTypes) {
    const standardTypes = {
        input: $b869bf1d00b93ac1$var$wrapNode(nodeTypes.input || $b869bf1d00b93ac1$var$InputNode$1),
        default: $b869bf1d00b93ac1$var$wrapNode(nodeTypes.default || $b869bf1d00b93ac1$var$DefaultNode$1),
        output: $b869bf1d00b93ac1$var$wrapNode(nodeTypes.output || $b869bf1d00b93ac1$var$OutputNode$1),
        group: $b869bf1d00b93ac1$var$wrapNode(nodeTypes.group || $b869bf1d00b93ac1$var$GroupNode)
    };
    const wrappedTypes = {};
    const specialTypes = Object.keys(nodeTypes).filter((k)=>![
            'input',
            'default',
            'output',
            'group'
        ].includes(k)).reduce((res, key)=>{
        res[key] = $b869bf1d00b93ac1$var$wrapNode(nodeTypes[key] || $b869bf1d00b93ac1$var$DefaultNode$1);
        return res;
    }, wrappedTypes);
    return {
        ...standardTypes,
        ...specialTypes
    };
}
const $b869bf1d00b93ac1$var$getPositionWithOrigin = ({ x: x, y: y, width: width, height: height, origin: origin })=>{
    if (!width || !height) return {
        x: x,
        y: y
    };
    if (origin[0] < 0 || origin[1] < 0 || origin[0] > 1 || origin[1] > 1) return {
        x: x,
        y: y
    };
    return {
        x: x - width * origin[0],
        y: y - height * origin[1]
    };
};
const $b869bf1d00b93ac1$var$selector$5 = (s)=>({
        nodesDraggable: s.nodesDraggable,
        nodesConnectable: s.nodesConnectable,
        nodesFocusable: s.nodesFocusable,
        elementsSelectable: s.elementsSelectable,
        updateNodeDimensions: s.updateNodeDimensions,
        onError: s.onError
    });
const $b869bf1d00b93ac1$var$NodeRenderer = (props)=>{
    const { nodesDraggable: nodesDraggable, nodesConnectable: nodesConnectable, nodesFocusable: nodesFocusable, elementsSelectable: elementsSelectable, updateNodeDimensions: updateNodeDimensions, onError: onError } = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$5, (0, $5b95e8cf664b5dbd$exports.shallow));
    const nodes = $b869bf1d00b93ac1$var$useVisibleNodes(props.onlyRenderVisibleElements);
    const resizeObserverRef = (0, $kyXgS.useRef)();
    const resizeObserver = (0, $kyXgS.useMemo)(()=>{
        if (typeof ResizeObserver === 'undefined') return null;
        const observer = new ResizeObserver((entries)=>{
            const updates = entries.map((entry)=>({
                    id: entry.target.getAttribute('data-id'),
                    nodeElement: entry.target,
                    forceUpdate: true
                }));
            updateNodeDimensions(updates);
        });
        resizeObserverRef.current = observer;
        return observer;
    }, []);
    (0, $kyXgS.useEffect)(()=>{
        return ()=>{
            resizeObserverRef?.current?.disconnect();
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
        className: "react-flow__nodes",
        style: $b869bf1d00b93ac1$var$containerStyle
    }, nodes.map((node)=>{
        let nodeType = node.type || 'default';
        if (!props.nodeTypes[nodeType]) {
            onError?.('003', $b869bf1d00b93ac1$var$errorMessages['error003'](nodeType));
            nodeType = 'default';
        }
        const NodeComponent = props.nodeTypes[nodeType] || props.nodeTypes.default;
        const isDraggable = !!(node.draggable || nodesDraggable && typeof node.draggable === 'undefined');
        const isSelectable = !!(node.selectable || elementsSelectable && typeof node.selectable === 'undefined');
        const isConnectable = !!(node.connectable || nodesConnectable && typeof node.connectable === 'undefined');
        const isFocusable = !!(node.focusable || nodesFocusable && typeof node.focusable === 'undefined');
        const clampedPosition = props.nodeExtent ? $b869bf1d00b93ac1$var$clampPosition(node.positionAbsolute, props.nodeExtent) : node.positionAbsolute;
        const posX = clampedPosition?.x ?? 0;
        const posY = clampedPosition?.y ?? 0;
        const posOrigin = $b869bf1d00b93ac1$var$getPositionWithOrigin({
            x: posX,
            y: posY,
            width: node.width ?? 0,
            height: node.height ?? 0,
            origin: props.nodeOrigin
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement(NodeComponent, {
            key: node.id,
            id: node.id,
            className: node.className,
            style: node.style,
            type: nodeType,
            data: node.data,
            sourcePosition: node.sourcePosition || $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom,
            targetPosition: node.targetPosition || $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top,
            hidden: node.hidden,
            xPos: posX,
            yPos: posY,
            xPosOrigin: posOrigin.x,
            yPosOrigin: posOrigin.y,
            selectNodesOnDrag: props.selectNodesOnDrag,
            onClick: props.onNodeClick,
            onMouseEnter: props.onNodeMouseEnter,
            onMouseMove: props.onNodeMouseMove,
            onMouseLeave: props.onNodeMouseLeave,
            onContextMenu: props.onNodeContextMenu,
            onDoubleClick: props.onNodeDoubleClick,
            selected: !!node.selected,
            isDraggable: isDraggable,
            isSelectable: isSelectable,
            isConnectable: isConnectable,
            isFocusable: isFocusable,
            resizeObserver: resizeObserver,
            dragHandle: node.dragHandle,
            zIndex: node[$b869bf1d00b93ac1$export$90dfda29e9e20e50]?.z ?? 0,
            isParent: !!node[$b869bf1d00b93ac1$export$90dfda29e9e20e50]?.isParent,
            noDragClassName: props.noDragClassName,
            noPanClassName: props.noPanClassName,
            initialized: !!node.width && !!node.height,
            rfId: props.rfId,
            disableKeyboardA11y: props.disableKeyboardA11y,
            ariaLabel: node.ariaLabel,
            hasHandleBounds: !!node[$b869bf1d00b93ac1$export$90dfda29e9e20e50]?.handleBounds
        });
    }));
};
$b869bf1d00b93ac1$var$NodeRenderer.displayName = 'NodeRenderer';
var $b869bf1d00b93ac1$var$NodeRenderer$1 = (0, $kyXgS.memo)($b869bf1d00b93ac1$var$NodeRenderer);
const $b869bf1d00b93ac1$var$shiftX = (x, shift, position)=>{
    if (position === $b869bf1d00b93ac1$export$13807d9ee5a34a42.Left) return x - shift;
    if (position === $b869bf1d00b93ac1$export$13807d9ee5a34a42.Right) return x + shift;
    return x;
};
const $b869bf1d00b93ac1$var$shiftY = (y, shift, position)=>{
    if (position === $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top) return y - shift;
    if (position === $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom) return y + shift;
    return y;
};
const $b869bf1d00b93ac1$var$EdgeUpdaterClassName = 'react-flow__edgeupdater';
const $b869bf1d00b93ac1$var$EdgeAnchor = ({ position: position, centerX: centerX, centerY: centerY, radius: radius = 10, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseOut: onMouseOut, type: type })=>(0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("circle", {
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseOut: onMouseOut,
        className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
            $b869bf1d00b93ac1$var$EdgeUpdaterClassName,
            `${$b869bf1d00b93ac1$var$EdgeUpdaterClassName}-${type}`
        ]),
        cx: $b869bf1d00b93ac1$var$shiftX(centerX, radius, position),
        cy: $b869bf1d00b93ac1$var$shiftY(centerY, radius, position),
        r: radius,
        stroke: "transparent",
        fill: "transparent"
    });
const $b869bf1d00b93ac1$var$alwaysValidConnection = ()=>true;
var $b869bf1d00b93ac1$var$wrapEdge = (EdgeComponent)=>{
    const EdgeWrapper = ({ id: id, className: className, type: type, data: data, onClick: onClick, onEdgeDoubleClick: onEdgeDoubleClick, selected: selected, animated: animated, label: label, labelStyle: labelStyle, labelShowBg: labelShowBg, labelBgStyle: labelBgStyle, labelBgPadding: labelBgPadding, labelBgBorderRadius: labelBgBorderRadius, style: style, source: source, target: target, sourceX: sourceX, sourceY: sourceY, targetX: targetX, targetY: targetY, sourcePosition: sourcePosition, targetPosition: targetPosition, elementsSelectable: elementsSelectable, hidden: hidden, sourceHandleId: sourceHandleId, targetHandleId: targetHandleId, onContextMenu: onContextMenu, onMouseEnter: onMouseEnter, onMouseMove: onMouseMove, onMouseLeave: onMouseLeave, reconnectRadius: reconnectRadius, onReconnect: onReconnect, onReconnectStart: onReconnectStart, onReconnectEnd: onReconnectEnd, markerEnd: markerEnd, markerStart: markerStart, rfId: rfId, ariaLabel: ariaLabel, isFocusable: isFocusable, isReconnectable: isReconnectable, pathOptions: pathOptions, interactionWidth: interactionWidth, disableKeyboardA11y: disableKeyboardA11y })=>{
        const edgeRef = (0, $kyXgS.useRef)(null);
        const [updateHover, setUpdateHover] = (0, $kyXgS.useState)(false);
        const [updating, setUpdating] = (0, $kyXgS.useState)(false);
        const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
        const markerStartUrl = (0, $kyXgS.useMemo)(()=>`url('#${$b869bf1d00b93ac1$var$getMarkerId(markerStart, rfId)}')`, [
            markerStart,
            rfId
        ]);
        const markerEndUrl = (0, $kyXgS.useMemo)(()=>`url('#${$b869bf1d00b93ac1$var$getMarkerId(markerEnd, rfId)}')`, [
            markerEnd,
            rfId
        ]);
        if (hidden) return null;
        const onEdgeClick = (event)=>{
            const { edges: edges, addSelectedEdges: addSelectedEdges, unselectNodesAndEdges: unselectNodesAndEdges, multiSelectionActive: multiSelectionActive } = store.getState();
            const edge = edges.find((e)=>e.id === id);
            if (!edge) return;
            if (elementsSelectable) {
                store.setState({
                    nodesSelectionActive: false
                });
                if (edge.selected && multiSelectionActive) {
                    unselectNodesAndEdges({
                        nodes: [],
                        edges: [
                            edge
                        ]
                    });
                    edgeRef.current?.blur();
                } else addSelectedEdges([
                    id
                ]);
            }
            if (onClick) onClick(event, edge);
        };
        const onEdgeDoubleClickHandler = $b869bf1d00b93ac1$var$getMouseHandler$1(id, store.getState, onEdgeDoubleClick);
        const onEdgeContextMenu = $b869bf1d00b93ac1$var$getMouseHandler$1(id, store.getState, onContextMenu);
        const onEdgeMouseEnter = $b869bf1d00b93ac1$var$getMouseHandler$1(id, store.getState, onMouseEnter);
        const onEdgeMouseMove = $b869bf1d00b93ac1$var$getMouseHandler$1(id, store.getState, onMouseMove);
        const onEdgeMouseLeave = $b869bf1d00b93ac1$var$getMouseHandler$1(id, store.getState, onMouseLeave);
        const handleEdgeUpdater = (event, isSourceHandle)=>{
            // avoid triggering edge updater if mouse btn is not left
            if (event.button !== 0) return;
            const { edges: edges, isValidConnection: isValidConnectionStore } = store.getState();
            const nodeId = isSourceHandle ? target : source;
            const handleId = (isSourceHandle ? targetHandleId : sourceHandleId) || null;
            const handleType = isSourceHandle ? 'target' : 'source';
            const isValidConnection = isValidConnectionStore || $b869bf1d00b93ac1$var$alwaysValidConnection;
            const isTarget = isSourceHandle;
            const edge = edges.find((e)=>e.id === id);
            setUpdating(true);
            onReconnectStart?.(event, edge, handleType);
            const _onReconnectEnd = (evt)=>{
                setUpdating(false);
                onReconnectEnd?.(evt, edge, handleType);
            };
            const onConnectEdge = (connection)=>onReconnect?.(edge, connection);
            $b869bf1d00b93ac1$var$handlePointerDown({
                event: event,
                handleId: handleId,
                nodeId: nodeId,
                onConnect: onConnectEdge,
                isTarget: isTarget,
                getState: store.getState,
                setState: store.setState,
                isValidConnection: isValidConnection,
                edgeUpdaterType: handleType,
                onReconnectEnd: _onReconnectEnd
            });
        };
        const onEdgeUpdaterSourceMouseDown = (event)=>handleEdgeUpdater(event, true);
        const onEdgeUpdaterTargetMouseDown = (event)=>handleEdgeUpdater(event, false);
        const onEdgeUpdaterMouseEnter = ()=>setUpdateHover(true);
        const onEdgeUpdaterMouseOut = ()=>setUpdateHover(false);
        const inactive = !elementsSelectable && !onClick;
        const onKeyDown = (event)=>{
            if (!disableKeyboardA11y && $b869bf1d00b93ac1$var$elementSelectionKeys.includes(event.key) && elementsSelectable) {
                const { unselectNodesAndEdges: unselectNodesAndEdges, addSelectedEdges: addSelectedEdges, edges: edges } = store.getState();
                const unselect = event.key === 'Escape';
                if (unselect) {
                    edgeRef.current?.blur();
                    unselectNodesAndEdges({
                        edges: [
                            edges.find((e)=>e.id === id)
                        ]
                    });
                } else addSelectedEdges([
                    id
                ]);
            }
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("g", {
            className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
                'react-flow__edge',
                `react-flow__edge-${type}`,
                className,
                {
                    selected: selected,
                    animated: animated,
                    inactive: inactive,
                    updating: updateHover
                }
            ]),
            onClick: onEdgeClick,
            onDoubleClick: onEdgeDoubleClickHandler,
            onContextMenu: onEdgeContextMenu,
            onMouseEnter: onEdgeMouseEnter,
            onMouseMove: onEdgeMouseMove,
            onMouseLeave: onEdgeMouseLeave,
            onKeyDown: isFocusable ? onKeyDown : undefined,
            tabIndex: isFocusable ? 0 : undefined,
            role: isFocusable ? 'button' : 'img',
            "data-testid": `rf__edge-${id}`,
            "aria-label": ariaLabel === null ? undefined : ariaLabel ? ariaLabel : `Edge from ${source} to ${target}`,
            "aria-describedby": isFocusable ? `${$b869bf1d00b93ac1$var$ARIA_EDGE_DESC_KEY}-${rfId}` : undefined,
            ref: edgeRef
        }, !updating && (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement(EdgeComponent, {
            id: id,
            source: source,
            target: target,
            selected: selected,
            animated: animated,
            label: label,
            labelStyle: labelStyle,
            labelShowBg: labelShowBg,
            labelBgStyle: labelBgStyle,
            labelBgPadding: labelBgPadding,
            labelBgBorderRadius: labelBgBorderRadius,
            data: data,
            style: style,
            sourceX: sourceX,
            sourceY: sourceY,
            targetX: targetX,
            targetY: targetY,
            sourcePosition: sourcePosition,
            targetPosition: targetPosition,
            sourceHandleId: sourceHandleId,
            targetHandleId: targetHandleId,
            markerStart: markerStartUrl,
            markerEnd: markerEndUrl,
            pathOptions: pathOptions,
            interactionWidth: interactionWidth
        }), isReconnectable && (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).Fragment, null, (isReconnectable === 'source' || isReconnectable === true) && (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$EdgeAnchor, {
            position: sourcePosition,
            centerX: sourceX,
            centerY: sourceY,
            radius: reconnectRadius,
            onMouseDown: onEdgeUpdaterSourceMouseDown,
            onMouseEnter: onEdgeUpdaterMouseEnter,
            onMouseOut: onEdgeUpdaterMouseOut,
            type: "source"
        }), (isReconnectable === 'target' || isReconnectable === true) && (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$EdgeAnchor, {
            position: targetPosition,
            centerX: targetX,
            centerY: targetY,
            radius: reconnectRadius,
            onMouseDown: onEdgeUpdaterTargetMouseDown,
            onMouseEnter: onEdgeUpdaterMouseEnter,
            onMouseOut: onEdgeUpdaterMouseOut,
            type: "target"
        })));
    };
    EdgeWrapper.displayName = 'EdgeWrapper';
    return (0, $kyXgS.memo)(EdgeWrapper);
};
function $b869bf1d00b93ac1$var$createEdgeTypes(edgeTypes) {
    const standardTypes = {
        default: $b869bf1d00b93ac1$var$wrapEdge(edgeTypes.default || $b869bf1d00b93ac1$export$f207ae4ec106d908),
        straight: $b869bf1d00b93ac1$var$wrapEdge(edgeTypes.bezier || $b869bf1d00b93ac1$export$39f45342fd1fc782),
        step: $b869bf1d00b93ac1$var$wrapEdge(edgeTypes.step || $b869bf1d00b93ac1$export$e27f63bd159868f),
        smoothstep: $b869bf1d00b93ac1$var$wrapEdge(edgeTypes.step || $b869bf1d00b93ac1$export$5a9a9b2ccbc8cfc8),
        simplebezier: $b869bf1d00b93ac1$var$wrapEdge(edgeTypes.simplebezier || $b869bf1d00b93ac1$export$b169c4f890f251a6)
    };
    const wrappedTypes = {};
    const specialTypes = Object.keys(edgeTypes).filter((k)=>![
            'default',
            'bezier'
        ].includes(k)).reduce((res, key)=>{
        res[key] = $b869bf1d00b93ac1$var$wrapEdge(edgeTypes[key] || $b869bf1d00b93ac1$export$f207ae4ec106d908);
        return res;
    }, wrappedTypes);
    return {
        ...standardTypes,
        ...specialTypes
    };
}
function $b869bf1d00b93ac1$var$getHandlePosition(position, nodeRect, handle = null) {
    const x = (handle?.x || 0) + nodeRect.x;
    const y = (handle?.y || 0) + nodeRect.y;
    const width = handle?.width || nodeRect.width;
    const height = handle?.height || nodeRect.height;
    switch(position){
        case $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top:
            return {
                x: x + width / 2,
                y: y
            };
        case $b869bf1d00b93ac1$export$13807d9ee5a34a42.Right:
            return {
                x: x + width,
                y: y + height / 2
            };
        case $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom:
            return {
                x: x + width / 2,
                y: y + height
            };
        case $b869bf1d00b93ac1$export$13807d9ee5a34a42.Left:
            return {
                x: x,
                y: y + height / 2
            };
    }
}
function $b869bf1d00b93ac1$var$getHandle(bounds, handleId) {
    if (!bounds) return null;
    if (bounds.length === 1 || !handleId) return bounds[0];
    else if (handleId) return bounds.find((d)=>d.id === handleId) || null;
    return null;
}
const $b869bf1d00b93ac1$var$getEdgePositions = (sourceNodeRect, sourceHandle, sourcePosition, targetNodeRect, targetHandle, targetPosition)=>{
    const sourceHandlePos = $b869bf1d00b93ac1$var$getHandlePosition(sourcePosition, sourceNodeRect, sourceHandle);
    const targetHandlePos = $b869bf1d00b93ac1$var$getHandlePosition(targetPosition, targetNodeRect, targetHandle);
    return {
        sourceX: sourceHandlePos.x,
        sourceY: sourceHandlePos.y,
        targetX: targetHandlePos.x,
        targetY: targetHandlePos.y
    };
};
function $b869bf1d00b93ac1$var$isEdgeVisible({ sourcePos: sourcePos, targetPos: targetPos, sourceWidth: sourceWidth, sourceHeight: sourceHeight, targetWidth: targetWidth, targetHeight: targetHeight, width: width, height: height, transform: transform }) {
    const edgeBox = {
        x: Math.min(sourcePos.x, targetPos.x),
        y: Math.min(sourcePos.y, targetPos.y),
        x2: Math.max(sourcePos.x + sourceWidth, targetPos.x + targetWidth),
        y2: Math.max(sourcePos.y + sourceHeight, targetPos.y + targetHeight)
    };
    if (edgeBox.x === edgeBox.x2) edgeBox.x2 += 1;
    if (edgeBox.y === edgeBox.y2) edgeBox.y2 += 1;
    const viewBox = $b869bf1d00b93ac1$export$5497ab15485123ba({
        x: (0 - transform[0]) / transform[2],
        y: (0 - transform[1]) / transform[2],
        width: width / transform[2],
        height: height / transform[2]
    });
    const xOverlap = Math.max(0, Math.min(viewBox.x2, edgeBox.x2) - Math.max(viewBox.x, edgeBox.x));
    const yOverlap = Math.max(0, Math.min(viewBox.y2, edgeBox.y2) - Math.max(viewBox.y, edgeBox.y));
    const overlappingArea = Math.ceil(xOverlap * yOverlap);
    return overlappingArea > 0;
}
function $b869bf1d00b93ac1$var$getNodeData(node) {
    const handleBounds = node?.[$b869bf1d00b93ac1$export$90dfda29e9e20e50]?.handleBounds || null;
    const isValid = handleBounds && node?.width && node?.height && typeof node?.positionAbsolute?.x !== 'undefined' && typeof node?.positionAbsolute?.y !== 'undefined';
    return [
        {
            x: node?.positionAbsolute?.x || 0,
            y: node?.positionAbsolute?.y || 0,
            width: node?.width || 0,
            height: node?.height || 0
        },
        handleBounds,
        !!isValid
    ];
}
const $b869bf1d00b93ac1$var$defaultEdgeTree = [
    {
        level: 0,
        isMaxLevel: true,
        edges: []
    }
];
function $b869bf1d00b93ac1$var$groupEdgesByZLevel(edges, nodeInternals, elevateEdgesOnSelect = false) {
    let maxLevel = -1;
    const levelLookup = edges.reduce((tree, edge)=>{
        const hasZIndex = $b869bf1d00b93ac1$var$isNumeric(edge.zIndex);
        let z = hasZIndex ? edge.zIndex : 0;
        if (elevateEdgesOnSelect) {
            const targetNode = nodeInternals.get(edge.target);
            const sourceNode = nodeInternals.get(edge.source);
            const edgeOrConnectedNodeSelected = edge.selected || targetNode?.selected || sourceNode?.selected;
            const selectedZIndex = Math.max(sourceNode?.[$b869bf1d00b93ac1$export$90dfda29e9e20e50]?.z || 0, targetNode?.[$b869bf1d00b93ac1$export$90dfda29e9e20e50]?.z || 0, 1000);
            z = (hasZIndex ? edge.zIndex : 0) + (edgeOrConnectedNodeSelected ? selectedZIndex : 0);
        }
        if (tree[z]) tree[z].push(edge);
        else tree[z] = [
            edge
        ];
        maxLevel = z > maxLevel ? z : maxLevel;
        return tree;
    }, {});
    const edgeTree = Object.entries(levelLookup).map(([key, edges])=>{
        const level = +key;
        return {
            edges: edges,
            level: level,
            isMaxLevel: level === maxLevel
        };
    });
    if (edgeTree.length === 0) return $b869bf1d00b93ac1$var$defaultEdgeTree;
    return edgeTree;
}
function $b869bf1d00b93ac1$var$useVisibleEdges(onlyRenderVisible, nodeInternals, elevateEdgesOnSelect) {
    const edges = $b869bf1d00b93ac1$export$6ccbb43953eebf8((0, $kyXgS.useCallback)((s)=>{
        if (!onlyRenderVisible) return s.edges;
        return s.edges.filter((e)=>{
            const sourceNode = nodeInternals.get(e.source);
            const targetNode = nodeInternals.get(e.target);
            return sourceNode?.width && sourceNode?.height && targetNode?.width && targetNode?.height && $b869bf1d00b93ac1$var$isEdgeVisible({
                sourcePos: sourceNode.positionAbsolute || {
                    x: 0,
                    y: 0
                },
                targetPos: targetNode.positionAbsolute || {
                    x: 0,
                    y: 0
                },
                sourceWidth: sourceNode.width,
                sourceHeight: sourceNode.height,
                targetWidth: targetNode.width,
                targetHeight: targetNode.height,
                width: s.width,
                height: s.height,
                transform: s.transform
            });
        });
    }, [
        onlyRenderVisible,
        nodeInternals
    ]));
    return $b869bf1d00b93ac1$var$groupEdgesByZLevel(edges, nodeInternals, elevateEdgesOnSelect);
}
const $b869bf1d00b93ac1$var$ArrowSymbol = ({ color: color = 'none', strokeWidth: strokeWidth = 1 })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("polyline", {
        style: {
            stroke: color,
            strokeWidth: strokeWidth
        },
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none",
        points: "-5,-4 0,0 -5,4"
    });
};
const $b869bf1d00b93ac1$var$ArrowClosedSymbol = ({ color: color = 'none', strokeWidth: strokeWidth = 1 })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("polyline", {
        style: {
            stroke: color,
            fill: color,
            strokeWidth: strokeWidth
        },
        strokeLinecap: "round",
        strokeLinejoin: "round",
        points: "-5,-4 0,0 -5,4 -5,-4"
    });
};
const $b869bf1d00b93ac1$var$MarkerSymbols = {
    [$b869bf1d00b93ac1$export$196ed004c7fb0ef2.Arrow]: $b869bf1d00b93ac1$var$ArrowSymbol,
    [$b869bf1d00b93ac1$export$196ed004c7fb0ef2.ArrowClosed]: $b869bf1d00b93ac1$var$ArrowClosedSymbol
};
function $b869bf1d00b93ac1$var$useMarkerSymbol(type) {
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    const symbol = (0, $kyXgS.useMemo)(()=>{
        const symbolExists = Object.prototype.hasOwnProperty.call($b869bf1d00b93ac1$var$MarkerSymbols, type);
        if (!symbolExists) {
            store.getState().onError?.('009', $b869bf1d00b93ac1$var$errorMessages['error009'](type));
            return null;
        }
        return $b869bf1d00b93ac1$var$MarkerSymbols[type];
    }, [
        type
    ]);
    return symbol;
}
const $b869bf1d00b93ac1$var$Marker = ({ id: id, type: type, color: color, width: width = 12.5, height: height = 12.5, markerUnits: markerUnits = 'strokeWidth', strokeWidth: strokeWidth, orient: orient = 'auto-start-reverse' })=>{
    const Symbol1 = $b869bf1d00b93ac1$var$useMarkerSymbol(type);
    if (!Symbol1) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("marker", {
        className: "react-flow__arrowhead",
        id: id,
        markerWidth: `${width}`,
        markerHeight: `${height}`,
        viewBox: "-10 -10 20 20",
        markerUnits: markerUnits,
        orient: orient,
        refX: "0",
        refY: "0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement(Symbol1, {
        color: color,
        strokeWidth: strokeWidth
    }));
};
const $b869bf1d00b93ac1$var$markerSelector = ({ defaultColor: defaultColor, rfId: rfId })=>(s)=>{
        const ids = [];
        return s.edges.reduce((markers, edge)=>{
            [
                edge.markerStart,
                edge.markerEnd
            ].forEach((marker)=>{
                if (marker && typeof marker === 'object') {
                    const markerId = $b869bf1d00b93ac1$var$getMarkerId(marker, rfId);
                    if (!ids.includes(markerId)) {
                        markers.push({
                            id: markerId,
                            color: marker.color || defaultColor,
                            ...marker
                        });
                        ids.push(markerId);
                    }
                }
            });
            return markers;
        }, []).sort((a, b)=>a.id.localeCompare(b.id));
    };
// when you have multiple flows on a page and you hide the first one, the other ones have no markers anymore
// when they do have markers with the same ids. To prevent this the user can pass a unique id to the react flow wrapper
// that we can then use for creating our unique marker ids
const $b869bf1d00b93ac1$var$MarkerDefinitions = ({ defaultColor: defaultColor, rfId: rfId })=>{
    const markers = $b869bf1d00b93ac1$export$6ccbb43953eebf8((0, $kyXgS.useCallback)($b869bf1d00b93ac1$var$markerSelector({
        defaultColor: defaultColor,
        rfId: rfId
    }), [
        defaultColor,
        rfId
    ]), // the id includes all marker options, so we just need to look at that part of the marker
    (a, b)=>!(a.length !== b.length || a.some((m, i)=>m.id !== b[i].id)));
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("defs", null, markers.map((marker)=>(0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$Marker, {
            id: marker.id,
            key: marker.id,
            type: marker.type,
            color: marker.color,
            width: marker.width,
            height: marker.height,
            markerUnits: marker.markerUnits,
            strokeWidth: marker.strokeWidth,
            orient: marker.orient
        })));
};
$b869bf1d00b93ac1$var$MarkerDefinitions.displayName = 'MarkerDefinitions';
var $b869bf1d00b93ac1$var$MarkerDefinitions$1 = (0, $kyXgS.memo)($b869bf1d00b93ac1$var$MarkerDefinitions);
const $b869bf1d00b93ac1$var$selector$4 = (s)=>({
        nodesConnectable: s.nodesConnectable,
        edgesFocusable: s.edgesFocusable,
        edgesUpdatable: s.edgesUpdatable,
        elementsSelectable: s.elementsSelectable,
        width: s.width,
        height: s.height,
        connectionMode: s.connectionMode,
        nodeInternals: s.nodeInternals,
        onError: s.onError
    });
const $b869bf1d00b93ac1$var$EdgeRenderer = ({ defaultMarkerColor: defaultMarkerColor, onlyRenderVisibleElements: onlyRenderVisibleElements, elevateEdgesOnSelect: elevateEdgesOnSelect, rfId: rfId, edgeTypes: edgeTypes, noPanClassName: noPanClassName, onEdgeContextMenu: onEdgeContextMenu, onEdgeMouseEnter: onEdgeMouseEnter, onEdgeMouseMove: onEdgeMouseMove, onEdgeMouseLeave: onEdgeMouseLeave, onEdgeClick: onEdgeClick, onEdgeDoubleClick: onEdgeDoubleClick, onReconnect: onReconnect, onReconnectStart: onReconnectStart, onReconnectEnd: onReconnectEnd, reconnectRadius: reconnectRadius, children: children, disableKeyboardA11y: disableKeyboardA11y })=>{
    const { edgesFocusable: edgesFocusable, edgesUpdatable: edgesUpdatable, elementsSelectable: elementsSelectable, width: width, height: height, connectionMode: connectionMode, nodeInternals: nodeInternals, onError: onError } = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$4, (0, $5b95e8cf664b5dbd$exports.shallow));
    const edgeTree = $b869bf1d00b93ac1$var$useVisibleEdges(onlyRenderVisibleElements, nodeInternals, elevateEdgesOnSelect);
    if (!width) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).Fragment, null, edgeTree.map(({ level: level, edges: edges, isMaxLevel: isMaxLevel })=>(0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("svg", {
            key: level,
            style: {
                zIndex: level
            },
            width: width,
            height: height,
            className: "react-flow__edges react-flow__container"
        }, isMaxLevel && (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$MarkerDefinitions$1, {
            defaultColor: defaultMarkerColor,
            rfId: rfId
        }), (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("g", null, edges.map((edge)=>{
            const [sourceNodeRect, sourceHandleBounds, sourceIsValid] = $b869bf1d00b93ac1$var$getNodeData(nodeInternals.get(edge.source));
            const [targetNodeRect, targetHandleBounds, targetIsValid] = $b869bf1d00b93ac1$var$getNodeData(nodeInternals.get(edge.target));
            if (!sourceIsValid || !targetIsValid) return null;
            let edgeType = edge.type || 'default';
            if (!edgeTypes[edgeType]) {
                onError?.('011', $b869bf1d00b93ac1$var$errorMessages['error011'](edgeType));
                edgeType = 'default';
            }
            const EdgeComponent = edgeTypes[edgeType] || edgeTypes.default;
            // when connection type is loose we can define all handles as sources and connect source -> source
            const targetNodeHandles = connectionMode === $b869bf1d00b93ac1$export$37c58f76dbdd36f6.Strict ? targetHandleBounds.target : (targetHandleBounds.target ?? []).concat(targetHandleBounds.source ?? []);
            const sourceHandle = $b869bf1d00b93ac1$var$getHandle(sourceHandleBounds.source, edge.sourceHandle);
            const targetHandle = $b869bf1d00b93ac1$var$getHandle(targetNodeHandles, edge.targetHandle);
            const sourcePosition = sourceHandle?.position || $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom;
            const targetPosition = targetHandle?.position || $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top;
            const isFocusable = !!(edge.focusable || edgesFocusable && typeof edge.focusable === 'undefined');
            const edgeReconnectable = edge.reconnectable || edge.updatable;
            const isReconnectable = typeof onReconnect !== 'undefined' && (edgeReconnectable || edgesUpdatable && typeof edgeReconnectable === 'undefined');
            if (!sourceHandle || !targetHandle) {
                onError?.('008', $b869bf1d00b93ac1$var$errorMessages['error008'](sourceHandle, edge));
                return null;
            }
            const { sourceX: sourceX, sourceY: sourceY, targetX: targetX, targetY: targetY } = $b869bf1d00b93ac1$var$getEdgePositions(sourceNodeRect, sourceHandle, sourcePosition, targetNodeRect, targetHandle, targetPosition);
            return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement(EdgeComponent, {
                key: edge.id,
                id: edge.id,
                className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
                    edge.className,
                    noPanClassName
                ]),
                type: edgeType,
                data: edge.data,
                selected: !!edge.selected,
                animated: !!edge.animated,
                hidden: !!edge.hidden,
                label: edge.label,
                labelStyle: edge.labelStyle,
                labelShowBg: edge.labelShowBg,
                labelBgStyle: edge.labelBgStyle,
                labelBgPadding: edge.labelBgPadding,
                labelBgBorderRadius: edge.labelBgBorderRadius,
                style: edge.style,
                source: edge.source,
                target: edge.target,
                sourceHandleId: edge.sourceHandle,
                targetHandleId: edge.targetHandle,
                markerEnd: edge.markerEnd,
                markerStart: edge.markerStart,
                sourceX: sourceX,
                sourceY: sourceY,
                targetX: targetX,
                targetY: targetY,
                sourcePosition: sourcePosition,
                targetPosition: targetPosition,
                elementsSelectable: elementsSelectable,
                onContextMenu: onEdgeContextMenu,
                onMouseEnter: onEdgeMouseEnter,
                onMouseMove: onEdgeMouseMove,
                onMouseLeave: onEdgeMouseLeave,
                onClick: onEdgeClick,
                onEdgeDoubleClick: onEdgeDoubleClick,
                onReconnect: onReconnect,
                onReconnectStart: onReconnectStart,
                onReconnectEnd: onReconnectEnd,
                reconnectRadius: reconnectRadius,
                rfId: rfId,
                ariaLabel: edge.ariaLabel,
                isFocusable: isFocusable,
                isReconnectable: isReconnectable,
                pathOptions: 'pathOptions' in edge ? edge.pathOptions : undefined,
                interactionWidth: edge.interactionWidth,
                disableKeyboardA11y: disableKeyboardA11y
            });
        })))), children);
};
$b869bf1d00b93ac1$var$EdgeRenderer.displayName = 'EdgeRenderer';
var $b869bf1d00b93ac1$var$EdgeRenderer$1 = (0, $kyXgS.memo)($b869bf1d00b93ac1$var$EdgeRenderer);
const $b869bf1d00b93ac1$var$selector$3 = (s)=>`translate(${s.transform[0]}px,${s.transform[1]}px) scale(${s.transform[2]})`;
function $b869bf1d00b93ac1$var$Viewport({ children: children }) {
    const transform = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$3);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
        className: "react-flow__viewport react-flow__container",
        style: {
            transform: transform
        }
    }, children);
}
function $b869bf1d00b93ac1$var$useOnInitHandler(onInit) {
    const rfInstance = $b869bf1d00b93ac1$export$d820c8c2d187e1fb();
    const isInitialized = (0, $kyXgS.useRef)(false);
    (0, $kyXgS.useEffect)(()=>{
        if (!isInitialized.current && rfInstance.viewportInitialized && onInit) {
            setTimeout(()=>onInit(rfInstance), 1);
            isInitialized.current = true;
        }
    }, [
        onInit,
        rfInstance.viewportInitialized
    ]);
}
const $b869bf1d00b93ac1$var$oppositePosition = {
    [$b869bf1d00b93ac1$export$13807d9ee5a34a42.Left]: $b869bf1d00b93ac1$export$13807d9ee5a34a42.Right,
    [$b869bf1d00b93ac1$export$13807d9ee5a34a42.Right]: $b869bf1d00b93ac1$export$13807d9ee5a34a42.Left,
    [$b869bf1d00b93ac1$export$13807d9ee5a34a42.Top]: $b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom,
    [$b869bf1d00b93ac1$export$13807d9ee5a34a42.Bottom]: $b869bf1d00b93ac1$export$13807d9ee5a34a42.Top
};
const $b869bf1d00b93ac1$var$ConnectionLine = ({ nodeId: nodeId, handleType: handleType, style: style, type: type = $b869bf1d00b93ac1$export$49e43009c370635d.Bezier, CustomComponent: CustomComponent, connectionStatus: connectionStatus })=>{
    const { fromNode: fromNode, handleId: handleId, toX: toX, toY: toY, connectionMode: connectionMode } = $b869bf1d00b93ac1$export$6ccbb43953eebf8((0, $kyXgS.useCallback)((s)=>({
            fromNode: s.nodeInternals.get(nodeId),
            handleId: s.connectionHandleId,
            toX: (s.connectionPosition.x - s.transform[0]) / s.transform[2],
            toY: (s.connectionPosition.y - s.transform[1]) / s.transform[2],
            connectionMode: s.connectionMode
        }), [
        nodeId
    ]), (0, $5b95e8cf664b5dbd$exports.shallow));
    const fromHandleBounds = fromNode?.[$b869bf1d00b93ac1$export$90dfda29e9e20e50]?.handleBounds;
    let handleBounds = fromHandleBounds?.[handleType];
    if (connectionMode === $b869bf1d00b93ac1$export$37c58f76dbdd36f6.Loose) handleBounds = handleBounds ? handleBounds : fromHandleBounds?.[handleType === 'source' ? 'target' : 'source'];
    if (!fromNode || !handleBounds) return null;
    const fromHandle = handleId ? handleBounds.find((d)=>d.id === handleId) : handleBounds[0];
    const fromHandleX = fromHandle ? fromHandle.x + fromHandle.width / 2 : (fromNode.width ?? 0) / 2;
    const fromHandleY = fromHandle ? fromHandle.y + fromHandle.height / 2 : fromNode.height ?? 0;
    const fromX = (fromNode.positionAbsolute?.x ?? 0) + fromHandleX;
    const fromY = (fromNode.positionAbsolute?.y ?? 0) + fromHandleY;
    const fromPosition = fromHandle?.position;
    const toPosition = fromPosition ? $b869bf1d00b93ac1$var$oppositePosition[fromPosition] : null;
    if (!fromPosition || !toPosition) return null;
    if (CustomComponent) return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement(CustomComponent, {
        connectionLineType: type,
        connectionLineStyle: style,
        fromNode: fromNode,
        fromHandle: fromHandle,
        fromX: fromX,
        fromY: fromY,
        toX: toX,
        toY: toY,
        fromPosition: fromPosition,
        toPosition: toPosition,
        connectionStatus: connectionStatus
    });
    let dAttr = '';
    const pathParams = {
        sourceX: fromX,
        sourceY: fromY,
        sourcePosition: fromPosition,
        targetX: toX,
        targetY: toY,
        targetPosition: toPosition
    };
    if (type === $b869bf1d00b93ac1$export$49e43009c370635d.Bezier) // we assume the destination position is opposite to the source position
    [dAttr] = $b869bf1d00b93ac1$export$b2afe50f305285f6(pathParams);
    else if (type === $b869bf1d00b93ac1$export$49e43009c370635d.Step) [dAttr] = $b869bf1d00b93ac1$export$a4b13b3fba17cda7({
        ...pathParams,
        borderRadius: 0
    });
    else if (type === $b869bf1d00b93ac1$export$49e43009c370635d.SmoothStep) [dAttr] = $b869bf1d00b93ac1$export$a4b13b3fba17cda7(pathParams);
    else if (type === $b869bf1d00b93ac1$export$49e43009c370635d.SimpleBezier) [dAttr] = $b869bf1d00b93ac1$export$a597383ee13c36d4(pathParams);
    else dAttr = `M${fromX},${fromY} ${toX},${toY}`;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("path", {
        d: dAttr,
        fill: "none",
        className: "react-flow__connection-path",
        style: style
    });
};
$b869bf1d00b93ac1$var$ConnectionLine.displayName = 'ConnectionLine';
const $b869bf1d00b93ac1$var$selector$2 = (s)=>({
        nodeId: s.connectionNodeId,
        handleType: s.connectionHandleType,
        nodesConnectable: s.nodesConnectable,
        connectionStatus: s.connectionStatus,
        width: s.width,
        height: s.height
    });
function $b869bf1d00b93ac1$var$ConnectionLineWrapper({ containerStyle: containerStyle, style: style, type: type, component: component }) {
    const { nodeId: nodeId, handleType: handleType, nodesConnectable: nodesConnectable, width: width, height: height, connectionStatus: connectionStatus } = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$2, (0, $5b95e8cf664b5dbd$exports.shallow));
    const isValid = !!(nodeId && handleType && width && nodesConnectable);
    if (!isValid) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("svg", {
        style: containerStyle,
        width: width,
        height: height,
        className: "react-flow__edges react-flow__connectionline react-flow__container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("g", {
        className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
            'react-flow__connection',
            connectionStatus
        ])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$ConnectionLine, {
        nodeId: nodeId,
        handleType: handleType,
        style: style,
        type: type,
        CustomComponent: component,
        connectionStatus: connectionStatus
    })));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b869bf1d00b93ac1$var$useNodeOrEdgeTypes(nodeOrEdgeTypes, createTypes) {
    const typesKeysRef = (0, $kyXgS.useRef)(null);
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    const typesParsed = (0, $kyXgS.useMemo)(()=>{
        return createTypes(nodeOrEdgeTypes);
    }, [
        nodeOrEdgeTypes
    ]);
    return typesParsed;
}
const $b869bf1d00b93ac1$var$GraphView = ({ nodeTypes: nodeTypes, edgeTypes: edgeTypes, onMove: onMove, onMoveStart: onMoveStart, onMoveEnd: onMoveEnd, onInit: onInit, onNodeClick: onNodeClick, onEdgeClick: onEdgeClick, onNodeDoubleClick: onNodeDoubleClick, onEdgeDoubleClick: onEdgeDoubleClick, onNodeMouseEnter: onNodeMouseEnter, onNodeMouseMove: onNodeMouseMove, onNodeMouseLeave: onNodeMouseLeave, onNodeContextMenu: onNodeContextMenu, onSelectionContextMenu: onSelectionContextMenu, onSelectionStart: onSelectionStart, onSelectionEnd: onSelectionEnd, connectionLineType: connectionLineType, connectionLineStyle: connectionLineStyle, connectionLineComponent: connectionLineComponent, connectionLineContainerStyle: connectionLineContainerStyle, selectionKeyCode: selectionKeyCode, selectionOnDrag: selectionOnDrag, selectionMode: selectionMode, multiSelectionKeyCode: multiSelectionKeyCode, panActivationKeyCode: panActivationKeyCode, zoomActivationKeyCode: zoomActivationKeyCode, deleteKeyCode: deleteKeyCode, onlyRenderVisibleElements: onlyRenderVisibleElements, elementsSelectable: elementsSelectable, selectNodesOnDrag: selectNodesOnDrag, defaultViewport: defaultViewport, translateExtent: translateExtent, minZoom: minZoom, maxZoom: maxZoom, preventScrolling: preventScrolling, defaultMarkerColor: defaultMarkerColor, zoomOnScroll: zoomOnScroll, zoomOnPinch: zoomOnPinch, panOnScroll: panOnScroll, panOnScrollSpeed: panOnScrollSpeed, panOnScrollMode: panOnScrollMode, zoomOnDoubleClick: zoomOnDoubleClick, panOnDrag: panOnDrag, onPaneClick: onPaneClick, onPaneMouseEnter: onPaneMouseEnter, onPaneMouseMove: onPaneMouseMove, onPaneMouseLeave: onPaneMouseLeave, onPaneScroll: onPaneScroll, onPaneContextMenu: onPaneContextMenu, onEdgeContextMenu: onEdgeContextMenu, onEdgeMouseEnter: onEdgeMouseEnter, onEdgeMouseMove: onEdgeMouseMove, onEdgeMouseLeave: onEdgeMouseLeave, onReconnect: onReconnect, onReconnectStart: onReconnectStart, onReconnectEnd: onReconnectEnd, reconnectRadius: reconnectRadius, noDragClassName: noDragClassName, noWheelClassName: noWheelClassName, noPanClassName: noPanClassName, elevateEdgesOnSelect: elevateEdgesOnSelect, disableKeyboardA11y: disableKeyboardA11y, nodeOrigin: nodeOrigin, nodeExtent: nodeExtent, rfId: rfId })=>{
    const nodeTypesWrapped = $b869bf1d00b93ac1$var$useNodeOrEdgeTypes(nodeTypes, $b869bf1d00b93ac1$var$createNodeTypes);
    const edgeTypesWrapped = $b869bf1d00b93ac1$var$useNodeOrEdgeTypes(edgeTypes, $b869bf1d00b93ac1$var$createEdgeTypes);
    $b869bf1d00b93ac1$var$useOnInitHandler(onInit);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$FlowRenderer$1, {
        onPaneClick: onPaneClick,
        onPaneMouseEnter: onPaneMouseEnter,
        onPaneMouseMove: onPaneMouseMove,
        onPaneMouseLeave: onPaneMouseLeave,
        onPaneContextMenu: onPaneContextMenu,
        onPaneScroll: onPaneScroll,
        deleteKeyCode: deleteKeyCode,
        selectionKeyCode: selectionKeyCode,
        selectionOnDrag: selectionOnDrag,
        selectionMode: selectionMode,
        onSelectionStart: onSelectionStart,
        onSelectionEnd: onSelectionEnd,
        multiSelectionKeyCode: multiSelectionKeyCode,
        panActivationKeyCode: panActivationKeyCode,
        zoomActivationKeyCode: zoomActivationKeyCode,
        elementsSelectable: elementsSelectable,
        onMove: onMove,
        onMoveStart: onMoveStart,
        onMoveEnd: onMoveEnd,
        zoomOnScroll: zoomOnScroll,
        zoomOnPinch: zoomOnPinch,
        zoomOnDoubleClick: zoomOnDoubleClick,
        panOnScroll: panOnScroll,
        panOnScrollSpeed: panOnScrollSpeed,
        panOnScrollMode: panOnScrollMode,
        panOnDrag: panOnDrag,
        defaultViewport: defaultViewport,
        translateExtent: translateExtent,
        minZoom: minZoom,
        maxZoom: maxZoom,
        onSelectionContextMenu: onSelectionContextMenu,
        preventScrolling: preventScrolling,
        noDragClassName: noDragClassName,
        noWheelClassName: noWheelClassName,
        noPanClassName: noPanClassName,
        disableKeyboardA11y: disableKeyboardA11y
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$Viewport, null, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$EdgeRenderer$1, {
        edgeTypes: edgeTypesWrapped,
        onEdgeClick: onEdgeClick,
        onEdgeDoubleClick: onEdgeDoubleClick,
        onlyRenderVisibleElements: onlyRenderVisibleElements,
        onEdgeContextMenu: onEdgeContextMenu,
        onEdgeMouseEnter: onEdgeMouseEnter,
        onEdgeMouseMove: onEdgeMouseMove,
        onEdgeMouseLeave: onEdgeMouseLeave,
        onReconnect: onReconnect,
        onReconnectStart: onReconnectStart,
        onReconnectEnd: onReconnectEnd,
        reconnectRadius: reconnectRadius,
        defaultMarkerColor: defaultMarkerColor,
        noPanClassName: noPanClassName,
        elevateEdgesOnSelect: !!elevateEdgesOnSelect,
        disableKeyboardA11y: disableKeyboardA11y,
        rfId: rfId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$ConnectionLineWrapper, {
        style: connectionLineStyle,
        type: connectionLineType,
        component: connectionLineComponent,
        containerStyle: connectionLineContainerStyle
    })), (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
        className: "react-flow__edgelabel-renderer"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$NodeRenderer$1, {
        nodeTypes: nodeTypesWrapped,
        onNodeClick: onNodeClick,
        onNodeDoubleClick: onNodeDoubleClick,
        onNodeMouseEnter: onNodeMouseEnter,
        onNodeMouseMove: onNodeMouseMove,
        onNodeMouseLeave: onNodeMouseLeave,
        onNodeContextMenu: onNodeContextMenu,
        selectNodesOnDrag: selectNodesOnDrag,
        onlyRenderVisibleElements: onlyRenderVisibleElements,
        noPanClassName: noPanClassName,
        noDragClassName: noDragClassName,
        disableKeyboardA11y: disableKeyboardA11y,
        nodeOrigin: nodeOrigin,
        nodeExtent: nodeExtent,
        rfId: rfId
    })));
};
$b869bf1d00b93ac1$var$GraphView.displayName = 'GraphView';
var $b869bf1d00b93ac1$var$GraphView$1 = (0, $kyXgS.memo)($b869bf1d00b93ac1$var$GraphView);
const $b869bf1d00b93ac1$var$infiniteExtent = [
    [
        Number.NEGATIVE_INFINITY,
        Number.NEGATIVE_INFINITY
    ],
    [
        Number.POSITIVE_INFINITY,
        Number.POSITIVE_INFINITY
    ]
];
const $b869bf1d00b93ac1$var$initialState = {
    rfId: '1',
    width: 0,
    height: 0,
    transform: [
        0,
        0,
        1
    ],
    nodeInternals: new Map(),
    edges: [],
    onNodesChange: null,
    onEdgesChange: null,
    hasDefaultNodes: false,
    hasDefaultEdges: false,
    d3Zoom: null,
    d3Selection: null,
    d3ZoomHandler: undefined,
    minZoom: 0.5,
    maxZoom: 2,
    translateExtent: $b869bf1d00b93ac1$var$infiniteExtent,
    nodeExtent: $b869bf1d00b93ac1$var$infiniteExtent,
    nodesSelectionActive: false,
    userSelectionActive: false,
    userSelectionRect: null,
    connectionNodeId: null,
    connectionHandleId: null,
    connectionHandleType: 'source',
    connectionPosition: {
        x: 0,
        y: 0
    },
    connectionStatus: null,
    connectionMode: $b869bf1d00b93ac1$export$37c58f76dbdd36f6.Strict,
    domNode: null,
    paneDragging: false,
    noPanClassName: 'nopan',
    nodeOrigin: [
        0,
        0
    ],
    nodeDragThreshold: 0,
    snapGrid: [
        15,
        15
    ],
    snapToGrid: false,
    nodesDraggable: true,
    nodesConnectable: true,
    nodesFocusable: true,
    edgesFocusable: true,
    edgesUpdatable: true,
    elementsSelectable: true,
    elevateNodesOnSelect: true,
    fitViewOnInit: false,
    fitViewOnInitDone: false,
    fitViewOnInitOptions: undefined,
    onSelectionChange: [],
    multiSelectionActive: false,
    connectionStartHandle: null,
    connectionEndHandle: null,
    connectionClickStartHandle: null,
    connectOnClick: true,
    ariaLiveMessage: '',
    autoPanOnConnect: true,
    autoPanOnNodeDrag: true,
    connectionRadius: 20,
    onError: $b869bf1d00b93ac1$var$devWarn,
    isValidConnection: undefined
};
const $b869bf1d00b93ac1$var$createRFStore = ()=>(0, $cc7fb5eb30111903$export$c883e057baa24e24)((set, get)=>({
            ...$b869bf1d00b93ac1$var$initialState,
            setNodes: (nodes)=>{
                const { nodeInternals: nodeInternals, nodeOrigin: nodeOrigin, elevateNodesOnSelect: elevateNodesOnSelect } = get();
                set({
                    nodeInternals: $b869bf1d00b93ac1$var$createNodeInternals(nodes, nodeInternals, nodeOrigin, elevateNodesOnSelect)
                });
            },
            getNodes: ()=>{
                return Array.from(get().nodeInternals.values());
            },
            setEdges: (edges)=>{
                const { defaultEdgeOptions: defaultEdgeOptions = {} } = get();
                set({
                    edges: edges.map((e)=>({
                            ...defaultEdgeOptions,
                            ...e
                        }))
                });
            },
            setDefaultNodesAndEdges: (nodes, edges)=>{
                const hasDefaultNodes = typeof nodes !== 'undefined';
                const hasDefaultEdges = typeof edges !== 'undefined';
                const nodeInternals = hasDefaultNodes ? $b869bf1d00b93ac1$var$createNodeInternals(nodes, new Map(), get().nodeOrigin, get().elevateNodesOnSelect) : new Map();
                const nextEdges = hasDefaultEdges ? edges : [];
                set({
                    nodeInternals: nodeInternals,
                    edges: nextEdges,
                    hasDefaultNodes: hasDefaultNodes,
                    hasDefaultEdges: hasDefaultEdges
                });
            },
            updateNodeDimensions: (updates)=>{
                const { onNodesChange: onNodesChange, nodeInternals: nodeInternals, fitViewOnInit: fitViewOnInit, fitViewOnInitDone: fitViewOnInitDone, fitViewOnInitOptions: fitViewOnInitOptions, domNode: domNode, nodeOrigin: nodeOrigin } = get();
                const viewportNode = domNode?.querySelector('.react-flow__viewport');
                if (!viewportNode) return;
                const style = window.getComputedStyle(viewportNode);
                const { m22: zoom } = new window.DOMMatrixReadOnly(style.transform);
                const changes = updates.reduce((res, update)=>{
                    const node = nodeInternals.get(update.id);
                    if (node?.hidden) nodeInternals.set(node.id, {
                        ...node,
                        [$b869bf1d00b93ac1$export$90dfda29e9e20e50]: {
                            ...node[$b869bf1d00b93ac1$export$90dfda29e9e20e50],
                            // we need to reset the handle bounds when the node is hidden
                            // in order to force a new observation when the node is shown again
                            handleBounds: undefined
                        }
                    });
                    else if (node) {
                        const dimensions = $b869bf1d00b93ac1$var$getDimensions(update.nodeElement);
                        const doUpdate = !!(dimensions.width && dimensions.height && (node.width !== dimensions.width || node.height !== dimensions.height || update.forceUpdate));
                        if (doUpdate) {
                            nodeInternals.set(node.id, {
                                ...node,
                                [$b869bf1d00b93ac1$export$90dfda29e9e20e50]: {
                                    ...node[$b869bf1d00b93ac1$export$90dfda29e9e20e50],
                                    handleBounds: {
                                        source: $b869bf1d00b93ac1$var$getHandleBounds('.source', update.nodeElement, zoom, nodeOrigin),
                                        target: $b869bf1d00b93ac1$var$getHandleBounds('.target', update.nodeElement, zoom, nodeOrigin)
                                    }
                                },
                                ...dimensions
                            });
                            res.push({
                                id: node.id,
                                type: 'dimensions',
                                dimensions: dimensions
                            });
                        }
                    }
                    return res;
                }, []);
                $b869bf1d00b93ac1$var$updateAbsoluteNodePositions(nodeInternals, nodeOrigin);
                const nextFitViewOnInitDone = fitViewOnInitDone || fitViewOnInit && !fitViewOnInitDone && $b869bf1d00b93ac1$var$fitView(get, {
                    initial: true,
                    ...fitViewOnInitOptions
                });
                set({
                    nodeInternals: new Map(nodeInternals),
                    fitViewOnInitDone: nextFitViewOnInitDone
                });
                if (changes?.length > 0) onNodesChange?.(changes);
            },
            updateNodePositions: (nodeDragItems, positionChanged = true, dragging = false)=>{
                const { triggerNodeChanges: triggerNodeChanges } = get();
                const changes = nodeDragItems.map((node)=>{
                    const change = {
                        id: node.id,
                        type: 'position',
                        dragging: dragging
                    };
                    if (positionChanged) {
                        change.positionAbsolute = node.positionAbsolute;
                        change.position = node.position;
                    }
                    return change;
                });
                triggerNodeChanges(changes);
            },
            triggerNodeChanges: (changes)=>{
                const { onNodesChange: onNodesChange, nodeInternals: nodeInternals, hasDefaultNodes: hasDefaultNodes, nodeOrigin: nodeOrigin, getNodes: getNodes, elevateNodesOnSelect: elevateNodesOnSelect } = get();
                if (changes?.length) {
                    if (hasDefaultNodes) {
                        const nodes = $b869bf1d00b93ac1$export$80563776c0ff2fb5(changes, getNodes());
                        const nextNodeInternals = $b869bf1d00b93ac1$var$createNodeInternals(nodes, nodeInternals, nodeOrigin, elevateNodesOnSelect);
                        set({
                            nodeInternals: nextNodeInternals
                        });
                    }
                    onNodesChange?.(changes);
                }
            },
            addSelectedNodes: (selectedNodeIds)=>{
                const { multiSelectionActive: multiSelectionActive, edges: edges, getNodes: getNodes } = get();
                let changedNodes;
                let changedEdges = null;
                if (multiSelectionActive) changedNodes = selectedNodeIds.map((nodeId)=>$b869bf1d00b93ac1$var$createSelectionChange(nodeId, true));
                else {
                    changedNodes = $b869bf1d00b93ac1$var$getSelectionChanges(getNodes(), selectedNodeIds);
                    changedEdges = $b869bf1d00b93ac1$var$getSelectionChanges(edges, []);
                }
                $b869bf1d00b93ac1$var$updateNodesAndEdgesSelections({
                    changedNodes: changedNodes,
                    changedEdges: changedEdges,
                    get: get,
                    set: set
                });
            },
            addSelectedEdges: (selectedEdgeIds)=>{
                const { multiSelectionActive: multiSelectionActive, edges: edges, getNodes: getNodes } = get();
                let changedEdges;
                let changedNodes = null;
                if (multiSelectionActive) changedEdges = selectedEdgeIds.map((edgeId)=>$b869bf1d00b93ac1$var$createSelectionChange(edgeId, true));
                else {
                    changedEdges = $b869bf1d00b93ac1$var$getSelectionChanges(edges, selectedEdgeIds);
                    changedNodes = $b869bf1d00b93ac1$var$getSelectionChanges(getNodes(), []);
                }
                $b869bf1d00b93ac1$var$updateNodesAndEdgesSelections({
                    changedNodes: changedNodes,
                    changedEdges: changedEdges,
                    get: get,
                    set: set
                });
            },
            unselectNodesAndEdges: ({ nodes: nodes, edges: edges } = {})=>{
                const { edges: storeEdges, getNodes: getNodes } = get();
                const nodesToUnselect = nodes ? nodes : getNodes();
                const edgesToUnselect = edges ? edges : storeEdges;
                const changedNodes = nodesToUnselect.map((n)=>{
                    n.selected = false;
                    return $b869bf1d00b93ac1$var$createSelectionChange(n.id, false);
                });
                const changedEdges = edgesToUnselect.map((edge)=>$b869bf1d00b93ac1$var$createSelectionChange(edge.id, false));
                $b869bf1d00b93ac1$var$updateNodesAndEdgesSelections({
                    changedNodes: changedNodes,
                    changedEdges: changedEdges,
                    get: get,
                    set: set
                });
            },
            setMinZoom: (minZoom)=>{
                const { d3Zoom: d3Zoom, maxZoom: maxZoom } = get();
                d3Zoom?.scaleExtent([
                    minZoom,
                    maxZoom
                ]);
                set({
                    minZoom: minZoom
                });
            },
            setMaxZoom: (maxZoom)=>{
                const { d3Zoom: d3Zoom, minZoom: minZoom } = get();
                d3Zoom?.scaleExtent([
                    minZoom,
                    maxZoom
                ]);
                set({
                    maxZoom: maxZoom
                });
            },
            setTranslateExtent: (translateExtent)=>{
                get().d3Zoom?.translateExtent(translateExtent);
                set({
                    translateExtent: translateExtent
                });
            },
            resetSelectedElements: ()=>{
                const { edges: edges, getNodes: getNodes } = get();
                const nodes = getNodes();
                const nodesToUnselect = nodes.filter((e)=>e.selected).map((n)=>$b869bf1d00b93ac1$var$createSelectionChange(n.id, false));
                const edgesToUnselect = edges.filter((e)=>e.selected).map((e)=>$b869bf1d00b93ac1$var$createSelectionChange(e.id, false));
                $b869bf1d00b93ac1$var$updateNodesAndEdgesSelections({
                    changedNodes: nodesToUnselect,
                    changedEdges: edgesToUnselect,
                    get: get,
                    set: set
                });
            },
            setNodeExtent: (nodeExtent)=>{
                const { nodeInternals: nodeInternals } = get();
                nodeInternals.forEach((node)=>{
                    node.positionAbsolute = $b869bf1d00b93ac1$var$clampPosition(node.position, nodeExtent);
                });
                set({
                    nodeExtent: nodeExtent,
                    nodeInternals: new Map(nodeInternals)
                });
            },
            panBy: (delta)=>{
                const { transform: transform, width: width, height: height, d3Zoom: d3Zoom, d3Selection: d3Selection, translateExtent: translateExtent } = get();
                if (!d3Zoom || !d3Selection || !delta.x && !delta.y) return false;
                const nextTransform = (0, $56c130654380f82b$export$f0954fd7d5368655).translate(transform[0] + delta.x, transform[1] + delta.y).scale(transform[2]);
                const extent = [
                    [
                        0,
                        0
                    ],
                    [
                        width,
                        height
                    ]
                ];
                const constrainedTransform = d3Zoom?.constrain()(nextTransform, extent, translateExtent);
                d3Zoom.transform(d3Selection, constrainedTransform);
                const transformChanged = transform[0] !== constrainedTransform.x || transform[1] !== constrainedTransform.y || transform[2] !== constrainedTransform.k;
                return transformChanged;
            },
            cancelConnection: ()=>set({
                    connectionNodeId: $b869bf1d00b93ac1$var$initialState.connectionNodeId,
                    connectionHandleId: $b869bf1d00b93ac1$var$initialState.connectionHandleId,
                    connectionHandleType: $b869bf1d00b93ac1$var$initialState.connectionHandleType,
                    connectionStatus: $b869bf1d00b93ac1$var$initialState.connectionStatus,
                    connectionStartHandle: $b869bf1d00b93ac1$var$initialState.connectionStartHandle,
                    connectionEndHandle: $b869bf1d00b93ac1$var$initialState.connectionEndHandle
                }),
            reset: ()=>set({
                    ...$b869bf1d00b93ac1$var$initialState
                })
        }), Object.is);
const $b869bf1d00b93ac1$export$9e7d1e09b3718a14 = ({ children: children })=>{
    const storeRef = (0, $kyXgS.useRef)(null);
    if (!storeRef.current) storeRef.current = $b869bf1d00b93ac1$var$createRFStore();
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$Provider$1, {
        value: storeRef.current
    }, children);
};
$b869bf1d00b93ac1$export$9e7d1e09b3718a14.displayName = 'ReactFlowProvider';
const $b869bf1d00b93ac1$var$Wrapper = ({ children: children })=>{
    const isWrapped = (0, $kyXgS.useContext)($b869bf1d00b93ac1$var$StoreContext);
    if (isWrapped) // we need to wrap it with a fragment because it's not allowed for children to be a ReactNode
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).Fragment, null, children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$export$9e7d1e09b3718a14, null, children);
};
$b869bf1d00b93ac1$var$Wrapper.displayName = 'ReactFlowWrapper';
const $b869bf1d00b93ac1$var$defaultNodeTypes = {
    input: $b869bf1d00b93ac1$var$InputNode$1,
    default: $b869bf1d00b93ac1$var$DefaultNode$1,
    output: $b869bf1d00b93ac1$var$OutputNode$1,
    group: $b869bf1d00b93ac1$var$GroupNode
};
const $b869bf1d00b93ac1$var$defaultEdgeTypes = {
    default: $b869bf1d00b93ac1$export$f207ae4ec106d908,
    straight: $b869bf1d00b93ac1$export$39f45342fd1fc782,
    step: $b869bf1d00b93ac1$export$e27f63bd159868f,
    smoothstep: $b869bf1d00b93ac1$export$5a9a9b2ccbc8cfc8,
    simplebezier: $b869bf1d00b93ac1$export$b169c4f890f251a6
};
const $b869bf1d00b93ac1$var$initNodeOrigin = [
    0,
    0
];
const $b869bf1d00b93ac1$var$initSnapGrid = [
    15,
    15
];
const $b869bf1d00b93ac1$var$initDefaultViewport = {
    x: 0,
    y: 0,
    zoom: 1
};
const $b869bf1d00b93ac1$var$wrapperStyle = {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 0
};
const $b869bf1d00b93ac1$export$d0a0e394104ac801 = (0, $kyXgS.forwardRef)(({ nodes: nodes, edges: edges, defaultNodes: defaultNodes, defaultEdges: defaultEdges, className: className, nodeTypes: nodeTypes = $b869bf1d00b93ac1$var$defaultNodeTypes, edgeTypes: edgeTypes = $b869bf1d00b93ac1$var$defaultEdgeTypes, onNodeClick: onNodeClick, onEdgeClick: onEdgeClick, onInit: onInit, onMove: onMove, onMoveStart: onMoveStart, onMoveEnd: onMoveEnd, onConnect: onConnect, onConnectStart: onConnectStart, onConnectEnd: onConnectEnd, onClickConnectStart: onClickConnectStart, onClickConnectEnd: onClickConnectEnd, onNodeMouseEnter: onNodeMouseEnter, onNodeMouseMove: onNodeMouseMove, onNodeMouseLeave: onNodeMouseLeave, onNodeContextMenu: onNodeContextMenu, onNodeDoubleClick: onNodeDoubleClick, onNodeDragStart: onNodeDragStart, onNodeDrag: onNodeDrag, onNodeDragStop: onNodeDragStop, onNodesDelete: onNodesDelete, onEdgesDelete: onEdgesDelete, onSelectionChange: onSelectionChange, onSelectionDragStart: onSelectionDragStart, onSelectionDrag: onSelectionDrag, onSelectionDragStop: onSelectionDragStop, onSelectionContextMenu: onSelectionContextMenu, onSelectionStart: onSelectionStart, onSelectionEnd: onSelectionEnd, connectionMode: connectionMode = $b869bf1d00b93ac1$export$37c58f76dbdd36f6.Strict, connectionLineType: connectionLineType = $b869bf1d00b93ac1$export$49e43009c370635d.Bezier, connectionLineStyle: connectionLineStyle, connectionLineComponent: connectionLineComponent, connectionLineContainerStyle: connectionLineContainerStyle, deleteKeyCode: deleteKeyCode = 'Backspace', selectionKeyCode: selectionKeyCode = 'Shift', selectionOnDrag: selectionOnDrag = false, selectionMode: selectionMode = $b869bf1d00b93ac1$export$91484609d16ec765.Full, panActivationKeyCode: panActivationKeyCode = 'Space', multiSelectionKeyCode: multiSelectionKeyCode = $b869bf1d00b93ac1$var$isMacOs() ? 'Meta' : 'Control', zoomActivationKeyCode: zoomActivationKeyCode = $b869bf1d00b93ac1$var$isMacOs() ? 'Meta' : 'Control', snapToGrid: snapToGrid = false, snapGrid: snapGrid = $b869bf1d00b93ac1$var$initSnapGrid, onlyRenderVisibleElements: onlyRenderVisibleElements = false, selectNodesOnDrag: selectNodesOnDrag = true, nodesDraggable: nodesDraggable, nodesConnectable: nodesConnectable, nodesFocusable: nodesFocusable, nodeOrigin: nodeOrigin = $b869bf1d00b93ac1$var$initNodeOrigin, edgesFocusable: edgesFocusable, edgesUpdatable: edgesUpdatable, elementsSelectable: elementsSelectable, defaultViewport: defaultViewport = $b869bf1d00b93ac1$var$initDefaultViewport, minZoom: minZoom = 0.5, maxZoom: maxZoom = 2, translateExtent: translateExtent = $b869bf1d00b93ac1$var$infiniteExtent, preventScrolling: preventScrolling = true, nodeExtent: nodeExtent, defaultMarkerColor: defaultMarkerColor = '#b1b1b7', zoomOnScroll: zoomOnScroll = true, zoomOnPinch: zoomOnPinch = true, panOnScroll: panOnScroll = false, panOnScrollSpeed: panOnScrollSpeed = 0.5, panOnScrollMode: panOnScrollMode = $b869bf1d00b93ac1$export$5579ce9cc1808963.Free, zoomOnDoubleClick: zoomOnDoubleClick = true, panOnDrag: panOnDrag = true, onPaneClick: onPaneClick, onPaneMouseEnter: onPaneMouseEnter, onPaneMouseMove: onPaneMouseMove, onPaneMouseLeave: onPaneMouseLeave, onPaneScroll: onPaneScroll, onPaneContextMenu: onPaneContextMenu, children: children, onEdgeContextMenu: onEdgeContextMenu, onEdgeDoubleClick: onEdgeDoubleClick, onEdgeMouseEnter: onEdgeMouseEnter, onEdgeMouseMove: onEdgeMouseMove, onEdgeMouseLeave: onEdgeMouseLeave, onEdgeUpdate: onEdgeUpdate, onEdgeUpdateStart: onEdgeUpdateStart, onEdgeUpdateEnd: onEdgeUpdateEnd, onReconnect: onReconnect, onReconnectStart: onReconnectStart, onReconnectEnd: onReconnectEnd, reconnectRadius: reconnectRadius = 10, edgeUpdaterRadius: edgeUpdaterRadius = 10, onNodesChange: onNodesChange, onEdgesChange: onEdgesChange, noDragClassName: noDragClassName = 'nodrag', noWheelClassName: noWheelClassName = 'nowheel', noPanClassName: noPanClassName = 'nopan', fitView: fitView = false, fitViewOptions: fitViewOptions, connectOnClick: connectOnClick = true, attributionPosition: attributionPosition, proOptions: proOptions, defaultEdgeOptions: defaultEdgeOptions, elevateNodesOnSelect: elevateNodesOnSelect = true, elevateEdgesOnSelect: elevateEdgesOnSelect = false, disableKeyboardA11y: disableKeyboardA11y = false, autoPanOnConnect: autoPanOnConnect = true, autoPanOnNodeDrag: autoPanOnNodeDrag = true, connectionRadius: connectionRadius = 20, isValidConnection: isValidConnection, onError: onError, style: style, id: id, nodeDragThreshold: nodeDragThreshold, ...rest }, ref)=>{
    const rfId = id || '1';
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("div", {
        ...rest,
        style: {
            ...style,
            ...$b869bf1d00b93ac1$var$wrapperStyle
        },
        ref: ref,
        className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
            'react-flow',
            className
        ]),
        "data-testid": "rf__wrapper",
        id: id
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$Wrapper, null, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$GraphView$1, {
        onInit: onInit,
        onMove: onMove,
        onMoveStart: onMoveStart,
        onMoveEnd: onMoveEnd,
        onNodeClick: onNodeClick,
        onEdgeClick: onEdgeClick,
        onNodeMouseEnter: onNodeMouseEnter,
        onNodeMouseMove: onNodeMouseMove,
        onNodeMouseLeave: onNodeMouseLeave,
        onNodeContextMenu: onNodeContextMenu,
        onNodeDoubleClick: onNodeDoubleClick,
        nodeTypes: nodeTypes,
        edgeTypes: edgeTypes,
        connectionLineType: connectionLineType,
        connectionLineStyle: connectionLineStyle,
        connectionLineComponent: connectionLineComponent,
        connectionLineContainerStyle: connectionLineContainerStyle,
        selectionKeyCode: selectionKeyCode,
        selectionOnDrag: selectionOnDrag,
        selectionMode: selectionMode,
        deleteKeyCode: deleteKeyCode,
        multiSelectionKeyCode: multiSelectionKeyCode,
        panActivationKeyCode: panActivationKeyCode,
        zoomActivationKeyCode: zoomActivationKeyCode,
        onlyRenderVisibleElements: onlyRenderVisibleElements,
        selectNodesOnDrag: selectNodesOnDrag,
        defaultViewport: defaultViewport,
        translateExtent: translateExtent,
        minZoom: minZoom,
        maxZoom: maxZoom,
        preventScrolling: preventScrolling,
        zoomOnScroll: zoomOnScroll,
        zoomOnPinch: zoomOnPinch,
        zoomOnDoubleClick: zoomOnDoubleClick,
        panOnScroll: panOnScroll,
        panOnScrollSpeed: panOnScrollSpeed,
        panOnScrollMode: panOnScrollMode,
        panOnDrag: panOnDrag,
        onPaneClick: onPaneClick,
        onPaneMouseEnter: onPaneMouseEnter,
        onPaneMouseMove: onPaneMouseMove,
        onPaneMouseLeave: onPaneMouseLeave,
        onPaneScroll: onPaneScroll,
        onPaneContextMenu: onPaneContextMenu,
        onSelectionContextMenu: onSelectionContextMenu,
        onSelectionStart: onSelectionStart,
        onSelectionEnd: onSelectionEnd,
        onEdgeContextMenu: onEdgeContextMenu,
        onEdgeDoubleClick: onEdgeDoubleClick,
        onEdgeMouseEnter: onEdgeMouseEnter,
        onEdgeMouseMove: onEdgeMouseMove,
        onEdgeMouseLeave: onEdgeMouseLeave,
        onReconnect: onReconnect ?? onEdgeUpdate,
        onReconnectStart: onReconnectStart ?? onEdgeUpdateStart,
        onReconnectEnd: onReconnectEnd ?? onEdgeUpdateEnd,
        reconnectRadius: reconnectRadius ?? edgeUpdaterRadius,
        defaultMarkerColor: defaultMarkerColor,
        noDragClassName: noDragClassName,
        noWheelClassName: noWheelClassName,
        noPanClassName: noPanClassName,
        elevateEdgesOnSelect: elevateEdgesOnSelect,
        rfId: rfId,
        disableKeyboardA11y: disableKeyboardA11y,
        nodeOrigin: nodeOrigin,
        nodeExtent: nodeExtent
    }), (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$StoreUpdater, {
        nodes: nodes,
        edges: edges,
        defaultNodes: defaultNodes,
        defaultEdges: defaultEdges,
        onConnect: onConnect,
        onConnectStart: onConnectStart,
        onConnectEnd: onConnectEnd,
        onClickConnectStart: onClickConnectStart,
        onClickConnectEnd: onClickConnectEnd,
        nodesDraggable: nodesDraggable,
        nodesConnectable: nodesConnectable,
        nodesFocusable: nodesFocusable,
        edgesFocusable: edgesFocusable,
        edgesUpdatable: edgesUpdatable,
        elementsSelectable: elementsSelectable,
        elevateNodesOnSelect: elevateNodesOnSelect,
        minZoom: minZoom,
        maxZoom: maxZoom,
        nodeExtent: nodeExtent,
        onNodesChange: onNodesChange,
        onEdgesChange: onEdgesChange,
        snapToGrid: snapToGrid,
        snapGrid: snapGrid,
        connectionMode: connectionMode,
        translateExtent: translateExtent,
        connectOnClick: connectOnClick,
        defaultEdgeOptions: defaultEdgeOptions,
        fitView: fitView,
        fitViewOptions: fitViewOptions,
        onNodesDelete: onNodesDelete,
        onEdgesDelete: onEdgesDelete,
        onNodeDragStart: onNodeDragStart,
        onNodeDrag: onNodeDrag,
        onNodeDragStop: onNodeDragStop,
        onSelectionDrag: onSelectionDrag,
        onSelectionDragStart: onSelectionDragStart,
        onSelectionDragStop: onSelectionDragStop,
        noPanClassName: noPanClassName,
        nodeOrigin: nodeOrigin,
        rfId: rfId,
        autoPanOnConnect: autoPanOnConnect,
        autoPanOnNodeDrag: autoPanOnNodeDrag,
        onError: onError,
        connectionRadius: connectionRadius,
        isValidConnection: isValidConnection,
        nodeDragThreshold: nodeDragThreshold
    }), (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$Wrapper$1, {
        onSelectionChange: onSelectionChange
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$Attribution, {
        proOptions: proOptions,
        position: attributionPosition
    }), (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($b869bf1d00b93ac1$var$A11yDescriptions, {
        rfId: rfId,
        disableKeyboardA11y: disableKeyboardA11y
    })));
});
$b869bf1d00b93ac1$export$d0a0e394104ac801.displayName = 'ReactFlow';
const $b869bf1d00b93ac1$var$selector$1 = (s)=>s.domNode?.querySelector('.react-flow__edgelabel-renderer');
function $b869bf1d00b93ac1$export$9646290936eecd78({ children: children }) {
    const edgeLabelRenderer = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector$1);
    if (!edgeLabelRenderer) return null;
    return (0, $58bbac072954e0a3$exports.createPortal)(children, edgeLabelRenderer);
}
function $b869bf1d00b93ac1$export$6838d2bcb44ea5f9() {
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    return (0, $kyXgS.useCallback)((id)=>{
        const { domNode: domNode, updateNodeDimensions: updateNodeDimensions } = store.getState();
        const updateIds = Array.isArray(id) ? id : [
            id
        ];
        const updates = updateIds.reduce((res, updateId)=>{
            const nodeElement = domNode?.querySelector(`.react-flow__node[data-id="${updateId}"]`);
            if (nodeElement) res.push({
                id: updateId,
                nodeElement: nodeElement,
                forceUpdate: true
            });
            return res;
        }, []);
        requestAnimationFrame(()=>updateNodeDimensions(updates));
    }, []);
}
const $b869bf1d00b93ac1$var$nodesSelector = (state)=>state.getNodes();
function $b869bf1d00b93ac1$export$74111531c1affe9() {
    const nodes = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$nodesSelector, (0, $5b95e8cf664b5dbd$exports.shallow));
    return nodes;
}
const $b869bf1d00b93ac1$var$edgesSelector = (state)=>state.edges;
function $b869bf1d00b93ac1$export$a3d7498444161e11() {
    const edges = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$edgesSelector, (0, $5b95e8cf664b5dbd$exports.shallow));
    return edges;
}
const $b869bf1d00b93ac1$var$viewportSelector = (state)=>({
        x: state.transform[0],
        y: state.transform[1],
        zoom: state.transform[2]
    });
function $b869bf1d00b93ac1$export$297ec8eb77d6211d() {
    const viewport = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$viewportSelector, (0, $5b95e8cf664b5dbd$exports.shallow));
    return viewport;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ function $b869bf1d00b93ac1$var$createUseItemsState(applyChanges) {
    return (initialItems)=>{
        const [items, setItems] = (0, $kyXgS.useState)(initialItems);
        const onItemsChange = (0, $kyXgS.useCallback)((changes)=>setItems((items)=>applyChanges(changes, items)), []);
        return [
            items,
            setItems,
            onItemsChange
        ];
    };
}
const $b869bf1d00b93ac1$export$bd078ae466d36fdb = $b869bf1d00b93ac1$var$createUseItemsState($b869bf1d00b93ac1$export$80563776c0ff2fb5);
const $b869bf1d00b93ac1$export$e087148e8ce6c014 = $b869bf1d00b93ac1$var$createUseItemsState($b869bf1d00b93ac1$export$9beb31bb1f03bba4);
function $b869bf1d00b93ac1$export$a6cb3509f61bf58({ onStart: onStart, onChange: onChange, onEnd: onEnd }) {
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    (0, $kyXgS.useEffect)(()=>{
        store.setState({
            onViewportChangeStart: onStart
        });
    }, [
        onStart
    ]);
    (0, $kyXgS.useEffect)(()=>{
        store.setState({
            onViewportChange: onChange
        });
    }, [
        onChange
    ]);
    (0, $kyXgS.useEffect)(()=>{
        store.setState({
            onViewportChangeEnd: onEnd
        });
    }, [
        onEnd
    ]);
}
function $b869bf1d00b93ac1$export$4e6030d90542e1e7({ onChange: onChange }) {
    const store = $b869bf1d00b93ac1$export$d4cd09bdc073d04b();
    (0, $kyXgS.useEffect)(()=>{
        const nextSelectionChangeHandlers = [
            ...store.getState().onSelectionChange,
            onChange
        ];
        store.setState({
            onSelectionChange: nextSelectionChangeHandlers
        });
        return ()=>{
            const nextHandlers = store.getState().onSelectionChange.filter((fn)=>fn !== onChange);
            store.setState({
                onSelectionChange: nextHandlers
            });
        };
    }, [
        onChange
    ]);
}
const $b869bf1d00b93ac1$var$selector = (options)=>(s)=>{
        if (s.nodeInternals.size === 0) return false;
        return s.getNodes().filter((n)=>options.includeHiddenNodes ? true : !n.hidden).every((n)=>n[$b869bf1d00b93ac1$export$90dfda29e9e20e50]?.handleBounds !== undefined);
    };
const $b869bf1d00b93ac1$var$defaultOptions = {
    includeHiddenNodes: false
};
function $b869bf1d00b93ac1$export$7ccf5bebb24321d8(options = $b869bf1d00b93ac1$var$defaultOptions) {
    const initialized = $b869bf1d00b93ac1$export$6ccbb43953eebf8($b869bf1d00b93ac1$var$selector(options));
    return initialized;
}




var $kyXgS = parcelRequire("kyXgS");

var $kyXgS = parcelRequire("kyXgS");



var $88c35a3efe04b9ee$export$a989e83032c4ec83;
(function(BackgroundVariant) {
    BackgroundVariant["Lines"] = "lines";
    BackgroundVariant["Dots"] = "dots";
    BackgroundVariant["Cross"] = "cross";
})($88c35a3efe04b9ee$export$a989e83032c4ec83 || ($88c35a3efe04b9ee$export$a989e83032c4ec83 = {}));
function $88c35a3efe04b9ee$var$LinePattern({ color: color, dimensions: dimensions, lineWidth: lineWidth }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("path", {
        stroke: color,
        strokeWidth: lineWidth,
        d: `M${dimensions[0] / 2} 0 V${dimensions[1]} M0 ${dimensions[1] / 2} H${dimensions[0]}`
    });
}
function $88c35a3efe04b9ee$var$DotPattern({ color: color, radius: radius }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("circle", {
        cx: radius,
        cy: radius,
        r: radius,
        fill: color
    });
}
const $88c35a3efe04b9ee$var$defaultColor = {
    [$88c35a3efe04b9ee$export$a989e83032c4ec83.Dots]: '#91919a',
    [$88c35a3efe04b9ee$export$a989e83032c4ec83.Lines]: '#eee',
    [$88c35a3efe04b9ee$export$a989e83032c4ec83.Cross]: '#e2e2e2'
};
const $88c35a3efe04b9ee$var$defaultSize = {
    [$88c35a3efe04b9ee$export$a989e83032c4ec83.Dots]: 1,
    [$88c35a3efe04b9ee$export$a989e83032c4ec83.Lines]: 1,
    [$88c35a3efe04b9ee$export$a989e83032c4ec83.Cross]: 6
};
const $88c35a3efe04b9ee$var$selector = (s)=>({
        transform: s.transform,
        patternId: `pattern-${s.rfId}`
    });
function $88c35a3efe04b9ee$var$Background({ id: id, variant: variant = $88c35a3efe04b9ee$export$a989e83032c4ec83.Dots, gap: // only used for dots and cross
gap = 20, size: // only used for lines and cross
size, lineWidth: lineWidth = 1, offset: offset = 2, color: color, style: style, className: className }) {
    const ref = (0, $kyXgS.useRef)(null);
    const { transform: transform, patternId: patternId } = (0, $b869bf1d00b93ac1$export$6ccbb43953eebf8)($88c35a3efe04b9ee$var$selector, (0, $5b95e8cf664b5dbd$exports.shallow));
    const patternColor = color || $88c35a3efe04b9ee$var$defaultColor[variant];
    const patternSize = size || $88c35a3efe04b9ee$var$defaultSize[variant];
    const isDots = variant === $88c35a3efe04b9ee$export$a989e83032c4ec83.Dots;
    const isCross = variant === $88c35a3efe04b9ee$export$a989e83032c4ec83.Cross;
    const gapXY = Array.isArray(gap) ? gap : [
        gap,
        gap
    ];
    const scaledGap = [
        gapXY[0] * transform[2] || 1,
        gapXY[1] * transform[2] || 1
    ];
    const scaledSize = patternSize * transform[2];
    const patternDimensions = isCross ? [
        scaledSize,
        scaledSize
    ] : scaledGap;
    const patternOffset = isDots ? [
        scaledSize / offset,
        scaledSize / offset
    ] : [
        patternDimensions[0] / offset,
        patternDimensions[1] / offset
    ];
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("svg", {
        className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
            'react-flow__background',
            className
        ]),
        style: {
            ...style,
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0
        },
        ref: ref,
        "data-testid": "rf__background"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("pattern", {
        id: patternId + id,
        x: transform[0] % scaledGap[0],
        y: transform[1] % scaledGap[1],
        width: scaledGap[0],
        height: scaledGap[1],
        patternUnits: "userSpaceOnUse",
        patternTransform: `translate(-${patternOffset[0]},-${patternOffset[1]})`
    }, isDots ? (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($88c35a3efe04b9ee$var$DotPattern, {
        color: patternColor,
        radius: scaledSize / offset
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($88c35a3efe04b9ee$var$LinePattern, {
        dimensions: patternDimensions,
        color: patternColor,
        lineWidth: lineWidth
    })), (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: `url(#${patternId + id})`
    }));
}
$88c35a3efe04b9ee$var$Background.displayName = 'Background';
var $88c35a3efe04b9ee$export$668799e4797757a8 = (0, $kyXgS.memo)($88c35a3efe04b9ee$var$Background);


var $kyXgS = parcelRequire("kyXgS");



function $5d52deba1f384703$var$PlusIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("path", {
        d: "M32 18.133H18.133V32h-4.266V18.133H0v-4.266h13.867V0h4.266v13.867H32z"
    }));
}
function $5d52deba1f384703$var$MinusIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 5"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("path", {
        d: "M0 0h32v4.2H0z"
    }));
}
function $5d52deba1f384703$var$FitViewIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 30"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("path", {
        d: "M3.692 4.63c0-.53.4-.938.939-.938h5.215V0H4.708C2.13 0 0 2.054 0 4.63v5.216h3.692V4.631zM27.354 0h-5.2v3.692h5.17c.53 0 .984.4.984.939v5.215H32V4.631A4.624 4.624 0 0027.354 0zm.954 24.83c0 .532-.4.94-.939.94h-5.215v3.768h5.215c2.577 0 4.631-2.13 4.631-4.707v-5.139h-3.692v5.139zm-23.677.94c-.531 0-.939-.4-.939-.94v-5.138H0v5.139c0 2.577 2.13 4.707 4.708 4.707h5.138V25.77H4.631z"
    }));
}
function $5d52deba1f384703$var$LockIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 32"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("path", {
        d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0 8 0 4.571 3.429 4.571 7.619v3.048H3.048A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047zm4.724-13.866H7.467V7.619c0-2.59 2.133-4.724 4.723-4.724 2.591 0 4.724 2.133 4.724 4.724v3.048z"
    }));
}
function $5d52deba1f384703$var$UnlockIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 32"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("path", {
        d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0c-4.114 1.828-1.37 2.133.305 2.438 1.676.305 4.42 2.59 4.42 5.181v3.048H3.047A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047z"
    }));
}
const $5d52deba1f384703$export$603fbdbca69b5a31 = ({ children: children, className: className, ...rest })=>(0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("button", {
        type: "button",
        className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
            'react-flow__controls-button',
            className
        ]),
        ...rest
    }, children);
$5d52deba1f384703$export$603fbdbca69b5a31.displayName = 'ControlButton';
const $5d52deba1f384703$var$selector = (s)=>({
        isInteractive: s.nodesDraggable || s.nodesConnectable || s.elementsSelectable,
        minZoomReached: s.transform[2] <= s.minZoom,
        maxZoomReached: s.transform[2] >= s.maxZoom
    });
const $5d52deba1f384703$var$Controls = ({ style: style, showZoom: showZoom = true, showFitView: showFitView = true, showInteractive: showInteractive = true, fitViewOptions: fitViewOptions, onZoomIn: onZoomIn, onZoomOut: onZoomOut, onFitView: onFitView, onInteractiveChange: onInteractiveChange, className: className, children: children, position: position = 'bottom-left' })=>{
    const store = (0, $b869bf1d00b93ac1$export$d4cd09bdc073d04b)();
    const [isVisible, setIsVisible] = (0, $kyXgS.useState)(false);
    const { isInteractive: isInteractive, minZoomReached: minZoomReached, maxZoomReached: maxZoomReached } = (0, $b869bf1d00b93ac1$export$6ccbb43953eebf8)($5d52deba1f384703$var$selector, (0, $5b95e8cf664b5dbd$exports.shallow));
    const { zoomIn: zoomIn, zoomOut: zoomOut, fitView: fitView } = (0, $b869bf1d00b93ac1$export$d820c8c2d187e1fb)();
    (0, $kyXgS.useEffect)(()=>{
        setIsVisible(true);
    }, []);
    if (!isVisible) return null;
    const onZoomInHandler = ()=>{
        zoomIn();
        onZoomIn?.();
    };
    const onZoomOutHandler = ()=>{
        zoomOut();
        onZoomOut?.();
    };
    const onFitViewHandler = ()=>{
        fitView(fitViewOptions);
        onFitView?.();
    };
    const onToggleInteractivity = ()=>{
        store.setState({
            nodesDraggable: !isInteractive,
            nodesConnectable: !isInteractive,
            elementsSelectable: !isInteractive
        });
        onInteractiveChange?.(!isInteractive);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement((0, $b869bf1d00b93ac1$export$2ddb90ad54e5f587), {
        className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
            'react-flow__controls',
            className
        ]),
        position: position,
        style: style,
        "data-testid": "rf__controls"
    }, showZoom && (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($5d52deba1f384703$export$603fbdbca69b5a31, {
        onClick: onZoomInHandler,
        className: "react-flow__controls-zoomin",
        title: "zoom in",
        "aria-label": "zoom in",
        disabled: maxZoomReached
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($5d52deba1f384703$var$PlusIcon, null)), (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($5d52deba1f384703$export$603fbdbca69b5a31, {
        onClick: onZoomOutHandler,
        className: "react-flow__controls-zoomout",
        title: "zoom out",
        "aria-label": "zoom out",
        disabled: minZoomReached
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($5d52deba1f384703$var$MinusIcon, null))), showFitView && (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($5d52deba1f384703$export$603fbdbca69b5a31, {
        className: "react-flow__controls-fitview",
        onClick: onFitViewHandler,
        title: "fit view",
        "aria-label": "fit view"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($5d52deba1f384703$var$FitViewIcon, null)), showInteractive && (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($5d52deba1f384703$export$603fbdbca69b5a31, {
        className: "react-flow__controls-interactive",
        onClick: onToggleInteractivity,
        title: "toggle interactivity",
        "aria-label": "toggle interactivity"
    }, isInteractive ? (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($5d52deba1f384703$var$UnlockIcon, null) : (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($5d52deba1f384703$var$LockIcon, null)), children);
};
$5d52deba1f384703$var$Controls.displayName = 'Controls';
var $5d52deba1f384703$export$c7c44baae9d9f25f = (0, $kyXgS.memo)($5d52deba1f384703$var$Controls);


var $kyXgS = parcelRequire("kyXgS");





const $0456767255f0c2cb$var$MiniMapNode = ({ id: id, x: x, y: y, width: width, height: height, style: style, color: color, strokeColor: strokeColor, strokeWidth: strokeWidth, className: className, borderRadius: borderRadius, shapeRendering: shapeRendering, onClick: onClick, selected: selected })=>{
    const { background: background, backgroundColor: backgroundColor } = style || {};
    const fill = color || background || backgroundColor;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("rect", {
        className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
            'react-flow__minimap-node',
            {
                selected: selected
            },
            className
        ]),
        x: x,
        y: y,
        rx: borderRadius,
        ry: borderRadius,
        width: width,
        height: height,
        fill: fill,
        stroke: strokeColor,
        strokeWidth: strokeWidth,
        shapeRendering: shapeRendering,
        onClick: onClick ? (event)=>onClick(event, id) : undefined
    });
};
$0456767255f0c2cb$var$MiniMapNode.displayName = 'MiniMapNode';
var $0456767255f0c2cb$var$MiniMapNode$1 = (0, $kyXgS.memo)($0456767255f0c2cb$var$MiniMapNode);
/* eslint-disable @typescript-eslint/ban-ts-comment */ const $0456767255f0c2cb$var$selector$1 = (s)=>s.nodeOrigin;
const $0456767255f0c2cb$var$selectorNodes = (s)=>s.getNodes().filter((node)=>!node.hidden && node.width && node.height);
const $0456767255f0c2cb$var$getAttrFunction = (func)=>func instanceof Function ? func : ()=>func;
function $0456767255f0c2cb$var$MiniMapNodes({ nodeStrokeColor: nodeStrokeColor = 'transparent', nodeColor: nodeColor = '#e2e2e2', nodeClassName: nodeClassName = '', nodeBorderRadius: nodeBorderRadius = 5, nodeStrokeWidth: nodeStrokeWidth = 2, // We need to rename the prop to be `CapitalCase` so that JSX will render it as
// a component properly.
nodeComponent: NodeComponent = $0456767255f0c2cb$var$MiniMapNode$1, onClick: onClick }) {
    const nodes = (0, $b869bf1d00b93ac1$export$6ccbb43953eebf8)($0456767255f0c2cb$var$selectorNodes, (0, $5b95e8cf664b5dbd$exports.shallow));
    const nodeOrigin = (0, $b869bf1d00b93ac1$export$6ccbb43953eebf8)($0456767255f0c2cb$var$selector$1);
    const nodeColorFunc = $0456767255f0c2cb$var$getAttrFunction(nodeColor);
    const nodeStrokeColorFunc = $0456767255f0c2cb$var$getAttrFunction(nodeStrokeColor);
    const nodeClassNameFunc = $0456767255f0c2cb$var$getAttrFunction(nodeClassName);
    const shapeRendering = typeof window === 'undefined' || !!window.chrome ? 'crispEdges' : 'geometricPrecision';
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).Fragment, null, nodes.map((node)=>{
        const { x: x, y: y } = (0, $b869bf1d00b93ac1$export$72c5647f6be28a9c)(node, nodeOrigin).positionAbsolute;
        return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement(NodeComponent, {
            key: node.id,
            x: x,
            y: y,
            width: node.width,
            height: node.height,
            style: node.style,
            selected: node.selected,
            className: nodeClassNameFunc(node),
            color: nodeColorFunc(node),
            borderRadius: nodeBorderRadius,
            strokeColor: nodeStrokeColorFunc(node),
            strokeWidth: nodeStrokeWidth,
            shapeRendering: shapeRendering,
            onClick: onClick,
            id: node.id
        });
    }));
}
var $0456767255f0c2cb$var$MiniMapNodes$1 = (0, $kyXgS.memo)($0456767255f0c2cb$var$MiniMapNodes);
/* eslint-disable @typescript-eslint/ban-ts-comment */ const $0456767255f0c2cb$var$defaultWidth = 200;
const $0456767255f0c2cb$var$defaultHeight = 150;
const $0456767255f0c2cb$var$selector = (s)=>{
    const nodes = s.getNodes();
    const viewBB = {
        x: -s.transform[0] / s.transform[2],
        y: -s.transform[1] / s.transform[2],
        width: s.width / s.transform[2],
        height: s.height / s.transform[2]
    };
    return {
        viewBB: viewBB,
        boundingRect: nodes.length > 0 ? (0, $b869bf1d00b93ac1$export$e8bafcabcad2e005)((0, $b869bf1d00b93ac1$export$d5a2bfe3c0f7d322)(nodes, s.nodeOrigin), viewBB) : viewBB,
        rfId: s.rfId
    };
};
const $0456767255f0c2cb$var$ARIA_LABEL_KEY = 'react-flow__minimap-desc';
function $0456767255f0c2cb$var$MiniMap({ style: style, className: className, nodeStrokeColor: nodeStrokeColor = 'transparent', nodeColor: nodeColor = '#e2e2e2', nodeClassName: nodeClassName = '', nodeBorderRadius: nodeBorderRadius = 5, nodeStrokeWidth: nodeStrokeWidth = 2, nodeComponent: // We need to rename the prop to be `CapitalCase` so that JSX will render it as
// a component properly.
nodeComponent, maskColor: maskColor = 'rgb(240, 240, 240, 0.6)', maskStrokeColor: maskStrokeColor = 'none', maskStrokeWidth: maskStrokeWidth = 1, position: position = 'bottom-right', onClick: onClick, onNodeClick: onNodeClick, pannable: pannable = false, zoomable: zoomable = false, ariaLabel: ariaLabel = 'React Flow mini map', inversePan: inversePan = false, zoomStep: zoomStep = 10, offsetScale: offsetScale = 5 }) {
    const store = (0, $b869bf1d00b93ac1$export$d4cd09bdc073d04b)();
    const svg = (0, $kyXgS.useRef)(null);
    const { boundingRect: boundingRect, viewBB: viewBB, rfId: rfId } = (0, $b869bf1d00b93ac1$export$6ccbb43953eebf8)($0456767255f0c2cb$var$selector, (0, $5b95e8cf664b5dbd$exports.shallow));
    const elementWidth = style?.width ?? $0456767255f0c2cb$var$defaultWidth;
    const elementHeight = style?.height ?? $0456767255f0c2cb$var$defaultHeight;
    const scaledWidth = boundingRect.width / elementWidth;
    const scaledHeight = boundingRect.height / elementHeight;
    const viewScale = Math.max(scaledWidth, scaledHeight);
    const viewWidth = viewScale * elementWidth;
    const viewHeight = viewScale * elementHeight;
    const offset = offsetScale * viewScale;
    const x = boundingRect.x - (viewWidth - boundingRect.width) / 2 - offset;
    const y = boundingRect.y - (viewHeight - boundingRect.height) / 2 - offset;
    const width = viewWidth + offset * 2;
    const height = viewHeight + offset * 2;
    const labelledBy = `${$0456767255f0c2cb$var$ARIA_LABEL_KEY}-${rfId}`;
    const viewScaleRef = (0, $kyXgS.useRef)(0);
    viewScaleRef.current = viewScale;
    (0, $kyXgS.useEffect)(()=>{
        if (svg.current) {
            const selection = (0, $b0b9e4430a128489$export$2e2bcd8739ae039)(svg.current);
            const zoomHandler = (event)=>{
                const { transform: transform, d3Selection: d3Selection, d3Zoom: d3Zoom } = store.getState();
                if (event.sourceEvent.type !== 'wheel' || !d3Selection || !d3Zoom) return;
                const pinchDelta = -event.sourceEvent.deltaY * (event.sourceEvent.deltaMode === 1 ? 0.05 : event.sourceEvent.deltaMode ? 1 : 0.002) * zoomStep;
                const zoom = transform[2] * Math.pow(2, pinchDelta);
                d3Zoom.scaleTo(d3Selection, zoom);
            };
            const panHandler = (event)=>{
                const { transform: transform, d3Selection: d3Selection, d3Zoom: d3Zoom, translateExtent: translateExtent, width: width, height: height } = store.getState();
                if (event.sourceEvent.type !== 'mousemove' || !d3Selection || !d3Zoom) return;
                // @TODO: how to calculate the correct next position? Math.max(1, transform[2]) is a workaround.
                const moveScale = viewScaleRef.current * Math.max(1, transform[2]) * (inversePan ? -1 : 1);
                const position = {
                    x: transform[0] - event.sourceEvent.movementX * moveScale,
                    y: transform[1] - event.sourceEvent.movementY * moveScale
                };
                const extent = [
                    [
                        0,
                        0
                    ],
                    [
                        width,
                        height
                    ]
                ];
                const nextTransform = (0, $56c130654380f82b$export$f0954fd7d5368655).translate(position.x, position.y).scale(transform[2]);
                const constrainedTransform = d3Zoom.constrain()(nextTransform, extent, translateExtent);
                d3Zoom.transform(d3Selection, constrainedTransform);
            };
            const zoomAndPanHandler = (0, $617ef72b275b25a1$export$2e2bcd8739ae039)()// @ts-ignore
            .on('zoom', pannable ? panHandler : null)// @ts-ignore
            .on('zoom.wheel', zoomable ? zoomHandler : null);
            selection.call(zoomAndPanHandler);
            return ()=>{
                selection.on('zoom', null);
            };
        }
    }, [
        pannable,
        zoomable,
        inversePan,
        zoomStep
    ]);
    const onSvgClick = onClick ? (event)=>{
        const rfCoord = (0, $77a090e639ecc3fa$export$2e2bcd8739ae039)(event);
        onClick(event, {
            x: rfCoord[0],
            y: rfCoord[1]
        });
    } : undefined;
    const onSvgNodeClick = onNodeClick ? (event, nodeId)=>{
        const node = store.getState().nodeInternals.get(nodeId);
        onNodeClick(event, node);
    } : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement((0, $b869bf1d00b93ac1$export$2ddb90ad54e5f587), {
        position: position,
        style: style,
        className: (0, $611d9e3cbd014da4$export$2e2bcd8739ae039)([
            'react-flow__minimap',
            className
        ]),
        "data-testid": "rf__minimap"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("svg", {
        width: elementWidth,
        height: elementHeight,
        viewBox: `${x} ${y} ${width} ${height}`,
        role: "img",
        "aria-labelledby": labelledBy,
        ref: svg,
        onClick: onSvgClick
    }, ariaLabel && (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("title", {
        id: labelledBy
    }, ariaLabel), (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement($0456767255f0c2cb$var$MiniMapNodes$1, {
        onClick: onSvgNodeClick,
        nodeColor: nodeColor,
        nodeStrokeColor: nodeStrokeColor,
        nodeBorderRadius: nodeBorderRadius,
        nodeClassName: nodeClassName,
        nodeStrokeWidth: nodeStrokeWidth,
        nodeComponent: nodeComponent
    }), (0, (/*@__PURE__*/$parcel$interopDefault($kyXgS))).createElement("path", {
        className: "react-flow__minimap-mask",
        d: `M${x - offset},${y - offset}h${width + offset * 2}v${height + offset * 2}h${-width - offset * 2}z
        M${viewBB.x},${viewBB.y}h${viewBB.width}v${viewBB.height}h${-viewBB.width}z`,
        fill: maskColor,
        fillRule: "evenodd",
        stroke: maskStrokeColor,
        strokeWidth: maskStrokeWidth,
        pointerEvents: "none"
    })));
}
$0456767255f0c2cb$var$MiniMap.displayName = 'MiniMap';
var $0456767255f0c2cb$export$a97dd8f3835953ef = (0, $kyXgS.memo)($0456767255f0c2cb$var$MiniMap);




var $kyXgS = parcelRequire("kyXgS");
// Identifier helpers shared by the editor and the Python code generator.
const $309118e693f668de$var$PYTHON_KEYWORDS = new Set([
    'False',
    'None',
    'True',
    'and',
    'as',
    'assert',
    'async',
    'await',
    'break',
    'class',
    'continue',
    'def',
    'del',
    'elif',
    'else',
    'except',
    'finally',
    'for',
    'from',
    'global',
    'if',
    'import',
    'in',
    'is',
    'lambda',
    'nonlocal',
    'not',
    'or',
    'pass',
    'raise',
    'return',
    'try',
    'while',
    'with',
    'yield'
]);
const $309118e693f668de$export$b0374bdaac8a7e4c = new Set([
    '__start__',
    '__end__'
]);
const $309118e693f668de$export$9ed91437bfb12e9d = (name)=>$309118e693f668de$var$PYTHON_KEYWORDS.has(name);
const $309118e693f668de$export$6421a5e13ad6bdd7 = (name)=>typeof name === 'string' && /^[A-Za-z_][A-Za-z0-9_]*$/.test(name) && !$309118e693f668de$export$9ed91437bfb12e9d(name);
function $309118e693f668de$export$7f895517f6316334(text, fallback = 'node') {
    const token = String(text ?? '').trim().replace(/\s+/g, '_').replace(/[^A-Za-z0-9_]/g, '');
    return token || fallback;
}
const $309118e693f668de$export$cc8b315fc368b20a = (text, fallback = 'node')=>$309118e693f668de$export$7f895517f6316334(text, fallback).replace(/([a-z0-9])([A-Z])/g, '$1_$2').replace(/_{2,}/g, '_').toLowerCase();
function $309118e693f668de$var$makeUnique(candidate, taken) {
    if (!taken.has(candidate)) return candidate;
    let counter = 1;
    while(taken.has(`${candidate}_${counter}`))counter += 1;
    return `${candidate}_${counter}`;
}
function $309118e693f668de$export$3ee0ba14f603656f(label, existingNodes, excludeId = null) {
    const taken = new Set(existingNodes.filter((node)=>node.id !== excludeId && node.data?.codeIdentifier).map((node)=>node.data.codeIdentifier));
    return $309118e693f668de$var$makeUnique($309118e693f668de$export$7f895517f6316334(label), taken);
}
function $309118e693f668de$export$517ec1dbcee38377(base, taken, fallback = 'node') {
    let candidate = $309118e693f668de$export$7f895517f6316334(base, fallback);
    if (/^[0-9]/.test(candidate)) candidate = `_${candidate}`;
    if ($309118e693f668de$export$9ed91437bfb12e9d(candidate)) candidate = `${candidate}_`;
    const unique = $309118e693f668de$var$makeUnique(candidate, taken);
    taken.add(unique);
    return unique;
}
const $309118e693f668de$export$57c1cd480f1b6e37 = (text)=>JSON.stringify(String(text ?? ''));
const $309118e693f668de$export$6b103d4e680094b6 = (text)=>String(text ?? '').replace(/\\/g, '\\\\').replace(/"/g, "'").replace(/\s+/g, ' ').trim();


const $0f96f2a40cf4a802$export$a473c43a4db1086c = {
    start: {
        type: 'start',
        label: 'START',
        singleton: true,
        hint: 'Graph entry point'
    },
    end: {
        type: 'end',
        label: 'END',
        singleton: true,
        hint: 'Graph exit point'
    },
    agent: {
        type: 'agent',
        label: 'Agent',
        hint: 'Node registered with add_node'
    },
    tool: {
        type: 'tool',
        label: 'Tool',
        hint: 'Node registered with add_node'
    },
    conditional_edge: {
        type: 'conditional_edge',
        label: 'Conditional Edge',
        hint: 'Router function for add_conditional_edges'
    },
    text: {
        type: 'text',
        label: 'Memo',
        hint: 'Memo not included in generated code'
    }
};
const $0f96f2a40cf4a802$export$56306d5c07fe221a = Object.keys($0f96f2a40cf4a802$export$a473c43a4db1086c);
const $0f96f2a40cf4a802$export$e8c7195f7e503a51 = (type)=>type === 'agent' || type === 'tool';
const $0f96f2a40cf4a802$export$2ee57b564e50eb4b = (type)=>$0f96f2a40cf4a802$export$e8c7195f7e503a51(type) || type === 'conditional_edge';


/** Build directed adjacency for known, non-text graph nodes and edges. */ function $b6645270109f11ec$export$d3e3ede9ca55bc3f({ nodes: nodes = [], edges: edges = [] } = {}, { reverse: reverse = false } = {}) {
    const routableIds = new Set(nodes.filter((node)=>node.data?.type !== 'text').map((node)=>node.id));
    const adjacency = new Map([
        ...routableIds
    ].map((id)=>[
            id,
            []
        ]));
    edges.forEach((edge)=>{
        if (!routableIds.has(edge.source) || !routableIds.has(edge.target)) return;
        const from = reverse ? edge.target : edge.source;
        const to = reverse ? edge.source : edge.target;
        adjacency.get(from).push(to);
    });
    return adjacency;
}
function $b6645270109f11ec$export$238baef9bde70669(startIds, adjacency) {
    const seen = new Set(startIds);
    const queue = [
        ...startIds
    ];
    for(let index = 0; index < queue.length; index += 1){
        const current = queue[index];
        (adjacency.get(current) || []).forEach((next)=>{
            if (!seen.has(next)) {
                seen.add(next);
                queue.push(next);
            }
        });
    }
    return seen;
}
function $b6645270109f11ec$export$4a9be9cb8ef3f267(routerId, targetId, adjacency) {
    return $b6645270109f11ec$export$238baef9bde70669([
        targetId
    ], adjacency).has(routerId);
}
function $b6645270109f11ec$export$c1c6338381e71927(adjacency) {
    const state = new Map();
    const visit = (nodeId)=>{
        const current = state.get(nodeId);
        if (current === 'visiting') return true;
        if (current === 'visited') return false;
        state.set(nodeId, 'visiting');
        for (const next of adjacency.get(nodeId) || []){
            if (visit(next)) return true;
        }
        state.set(nodeId, 'visited');
        return false;
    };
    return [
        ...adjacency.keys()
    ].some(visit);
}


const $025995cee117ee16$export$cd85767a926998a6 = 'my_graph';
const $025995cee117ee16$export$a15eca9ac5ccd268 = 'messages: list';
const $025995cee117ee16$var$STATE_CLASS = 'State';
const $025995cee117ee16$var$COMPILED_NAME = 'app';
const $025995cee117ee16$var$FIELD_RE = /^([A-Za-z_][A-Za-z0-9_]*)\s*:\s*(.+)$/;
const $025995cee117ee16$var$STATE_ANNOTATION_IMPORTS = Object.freeze({
    Annotated: {
        kind: 'from',
        module: 'typing'
    },
    Any: {
        kind: 'from',
        module: 'typing'
    },
    Callable: {
        kind: 'from',
        module: 'typing'
    },
    Dict: {
        kind: 'from',
        module: 'typing'
    },
    Iterable: {
        kind: 'from',
        module: 'typing'
    },
    List: {
        kind: 'from',
        module: 'typing'
    },
    Literal: {
        kind: 'from',
        module: 'typing'
    },
    Mapping: {
        kind: 'from',
        module: 'typing'
    },
    Optional: {
        kind: 'from',
        module: 'typing'
    },
    Sequence: {
        kind: 'from',
        module: 'typing'
    },
    Set: {
        kind: 'from',
        module: 'typing'
    },
    Tuple: {
        kind: 'from',
        module: 'typing'
    },
    Union: {
        kind: 'from',
        module: 'typing'
    },
    AnyMessage: {
        kind: 'from',
        module: 'langchain_core.messages'
    },
    add_messages: {
        kind: 'from',
        module: 'langgraph.graph.message'
    },
    IsLastStep: {
        kind: 'from',
        module: 'langgraph.managed'
    },
    RemainingSteps: {
        kind: 'from',
        module: 'langgraph.managed'
    },
    Overwrite: {
        kind: 'from',
        module: 'langgraph.types'
    },
    operator: {
        kind: 'import',
        module: 'operator'
    }
});
const $025995cee117ee16$var$STATE_ANNOTATION_BUILTINS = new Set([
    'False',
    'None',
    'True',
    'bool',
    'bytes',
    'complex',
    'dict',
    'float',
    'frozenset',
    'int',
    'list',
    'object',
    'set',
    'str',
    'tuple',
    'type'
]);
const $025995cee117ee16$var$EMITTED_ANNOTATION_NAMES = new Set([
    $025995cee117ee16$var$STATE_CLASS,
    'END',
    'START',
    'StateGraph',
    'TypedDict'
]);
function $025995cee117ee16$var$annotationIdentifiers(annotation) {
    const withoutStrings = String(annotation).replace(/(['"])(?:\\.|(?!\1)[^\\])*\1/g, '');
    const identifiers = [];
    const tokenPattern = /[A-Za-z_][A-Za-z0-9_]*/g;
    let match;
    while((match = tokenPattern.exec(withoutStrings)) !== null){
        const before = withoutStrings.slice(0, match.index).trimEnd();
        if (!before.endsWith('.')) identifiers.push(match[0]);
    }
    return identifiers;
}
function $025995cee117ee16$export$e45b44879ac03376(fields) {
    const typingNames = new Set();
    const langchainMessageNames = new Set();
    const langgraphMessageNames = new Set();
    const langgraphManagedNames = new Set();
    const langgraphTypeNames = new Set();
    const moduleNames = new Set();
    const unknownNames = new Set();
    fields.forEach(({ annotation: annotation })=>{
        $025995cee117ee16$var$annotationIdentifiers(annotation).forEach((name)=>{
            const target = $025995cee117ee16$var$STATE_ANNOTATION_IMPORTS[name];
            if (target?.kind === 'import') moduleNames.add(target.module);
            else if (target?.module === 'typing') typingNames.add(name);
            else if (target?.module === 'langchain_core.messages') langchainMessageNames.add(name);
            else if (target?.module === 'langgraph.graph.message') langgraphMessageNames.add(name);
            else if (target?.module === 'langgraph.managed') langgraphManagedNames.add(name);
            else if (target?.module === 'langgraph.types') langgraphTypeNames.add(name);
            else if (!$025995cee117ee16$var$STATE_ANNOTATION_BUILTINS.has(name) && !$025995cee117ee16$var$EMITTED_ANNOTATION_NAMES.has(name)) unknownNames.add(name);
        });
    });
    return {
        typingNames: [
            ...typingNames
        ].sort(),
        langchainMessageNames: [
            ...langchainMessageNames
        ].sort(),
        langgraphMessageNames: [
            ...langgraphMessageNames
        ].sort(),
        langgraphManagedNames: [
            ...langgraphManagedNames
        ].sort(),
        langgraphTypeNames: [
            ...langgraphTypeNames
        ].sort(),
        moduleNames: [
            ...moduleNames
        ].sort(),
        unknownNames: [
            ...unknownNames
        ].sort()
    };
}
function $025995cee117ee16$export$23b3128d1e332759(text) {
    const fields = [];
    const invalid = [];
    String(text ?? '').split('\n').forEach((rawLine)=>{
        const line = rawLine.trim();
        if (!line || line.startsWith('#')) return;
        const match = $025995cee117ee16$var$FIELD_RE.exec(line);
        if (match) fields.push({
            name: match[1],
            annotation: match[2].trim()
        });
        else invalid.push(line);
    });
    return {
        fields: fields,
        invalid: invalid
    };
}
function $025995cee117ee16$export$f639a7975ab57b8b(edge, targetNode, nodeNames, isLoop = false) {
    const explicit = typeof edge?.data?.branchKey === 'string' ? edge.data.branchKey.trim() : '';
    if (explicit) return explicit;
    if (targetNode?.data?.type === 'end') return 'end';
    if (isLoop) return '';
    return nodeNames.get(targetNode?.id) || 'branch';
}
function $025995cee117ee16$export$9934590481ce934a({ nodes: nodes = [], edges: edges = [], graphName: graphName, stateFields: stateFields } = {}) {
    const byId = new Map(nodes.map((node)=>[
            node.id,
            node
        ]));
    const typeOf = (id)=>byId.get(id)?.data?.type;
    const codeNodes = nodes.filter((node)=>(0, $0f96f2a40cf4a802$export$e8c7195f7e503a51)(node.data?.type));
    const routerNodes = nodes.filter((node)=>node.data?.type === 'conditional_edge');
    const safeGraphName = (0, $309118e693f668de$export$6421a5e13ad6bdd7)(graphName) ? graphName : $025995cee117ee16$export$cd85767a926998a6;
    // Everything already bound in the emitted module, plus `state` so a generated
    // function never shadows its own parameter.
    const taken = new Set([
        $025995cee117ee16$var$STATE_CLASS,
        'END',
        'START',
        'StateGraph',
        'TypedDict',
        'Literal',
        'state'
    ]);
    taken.add(safeGraphName);
    const compiledName = (0, $309118e693f668de$export$517ec1dbcee38377)($025995cee117ee16$var$COMPILED_NAME, taken);
    const nodeNames = new Map();
    codeNodes.forEach((node)=>{
        nodeNames.set(node.id, node.data?.codeIdentifier || (0, $309118e693f668de$export$7f895517f6316334)(node.data?.label));
    });
    const functionNames = new Map();
    codeNodes.forEach((node)=>{
        functionNames.set(node.id, (0, $309118e693f668de$export$517ec1dbcee38377)((0, $309118e693f668de$export$cc8b315fc368b20a)(nodeNames.get(node.id)), taken));
    });
    const routerFunctionNames = new Map();
    routerNodes.forEach((node)=>{
        const base = node.data?.codeIdentifier || node.data?.label || 'route';
        routerFunctionNames.set(node.id, (0, $309118e693f668de$export$517ec1dbcee38377)((0, $309118e693f668de$export$cc8b315fc368b20a)(base, 'route'), taken, 'route'));
    });
    // How a node is referred to on either end of an edge in the generated code.
    const asSource = (id)=>{
        const type = typeOf(id);
        if (type === 'start') return 'START';
        if ((0, $0f96f2a40cf4a802$export$e8c7195f7e503a51)(type)) return (0, $309118e693f668de$export$57c1cd480f1b6e37)(nodeNames.get(id));
        return null; // END may not have outgoing edges; text/conditional are not endpoints
    };
    const asTarget = (id)=>{
        const type = typeOf(id);
        if (type === 'end') return 'END';
        if ((0, $0f96f2a40cf4a802$export$e8c7195f7e503a51)(type)) return (0, $309118e693f668de$export$57c1cd480f1b6e37)(nodeNames.get(id));
        return null; // START may not have incoming edges
    };
    const known = (edge)=>byId.has(edge.source) && byId.has(edge.target);
    const adjacency = (0, $b6645270109f11ec$export$d3e3ede9ca55bc3f)({
        nodes: nodes,
        edges: edges
    });
    const plainEdges = edges.filter((edge)=>known(edge) && typeOf(edge.source) !== 'conditional_edge' && typeOf(edge.target) !== 'conditional_edge' && asSource(edge.source) && asTarget(edge.target));
    const allRouters = routerNodes.map((node)=>{
        const branches = edges.filter((edge)=>known(edge) && edge.source === node.id && asTarget(edge.target)).map((edge)=>{
            const targetNode = byId.get(edge.target);
            const isLoop = (0, $b6645270109f11ec$export$4a9be9cb8ef3f267)(node.id, edge.target, adjacency);
            const explicitKey = typeof edge.data?.branchKey === 'string' ? edge.data.branchKey.trim() : '';
            return {
                edgeId: edge.id,
                key: $025995cee117ee16$export$f639a7975ab57b8b(edge, targetNode, nodeNames, isLoop),
                hasExplicitKey: Boolean(explicitKey),
                target: asTarget(edge.target),
                targetLabel: targetNode.data?.type === 'end' ? 'END' : nodeNames.get(edge.target) || targetNode.data?.label || edge.target,
                isLoop: isLoop
            };
        });
        const sources = [];
        edges.filter((edge)=>known(edge) && edge.target === node.id && asSource(edge.source)).forEach((edge)=>{
            const ref = asSource(edge.source);
            if (!sources.includes(ref)) sources.push(ref);
        });
        return {
            nodeId: node.id,
            label: node.data?.label || 'Conditional Edge',
            functionName: routerFunctionNames.get(node.id),
            branches: branches,
            sources: sources
        };
    });
    const routers = allRouters.filter((router)=>router.branches.length > 0 && router.sources.length > 0);
    return {
        graphName: safeGraphName,
        compiledName: compiledName,
        stateFields: $025995cee117ee16$export$23b3128d1e332759(stateFields ?? $025995cee117ee16$export$a15eca9ac5ccd268),
        codeNodes: codeNodes,
        nodeNames: nodeNames,
        functionNames: functionNames,
        allRouters: allRouters,
        hasCycle: (0, $b6645270109f11ec$export$c1c6338381e71927)(adjacency),
        // START edges are emitted first so the generated graph reads top-down.
        startEdges: plainEdges.filter((edge)=>typeOf(edge.source) === 'start'),
        plainEdges: plainEdges.filter((edge)=>typeOf(edge.source) !== 'start'),
        routers: routers,
        asSource: asSource,
        asTarget: asTarget
    };
}
function $025995cee117ee16$var$renderStateClass(fields) {
    const lines = [
        `class ${$025995cee117ee16$var$STATE_CLASS}(TypedDict):`,
        '    """Shared graph state for all nodes."""',
        ''
    ];
    if (fields.length === 0) lines.push('    pass');
    else fields.forEach((field)=>lines.push(`    ${field.name}: ${field.annotation}`));
    return lines.join('\n');
}
function $025995cee117ee16$var$renderNodeFunction(node, functionName) {
    return [
        `def ${functionName}(state: ${$025995cee117ee16$var$STATE_CLASS}) -> dict:`,
        `    """TODO: Implement the '${(0, $309118e693f668de$export$6b103d4e680094b6)(node.data?.label) || functionName}' node."""`,
        '    return {}'
    ].join('\n');
}
function $025995cee117ee16$var$renderRouterFunction(router) {
    const uniqueBranches = router.branches.filter((branch, index, branches)=>branches.findIndex((candidate)=>candidate.key === branch.key) === index);
    const keys = uniqueBranches.map((branch)=>branch.key);
    const literal = keys.map((0, $309118e693f668de$export$57c1cd480f1b6e37)).join(', ');
    const defaultBranch = uniqueBranches.find((branch)=>branch.target === 'END') || uniqueBranches.find((branch)=>!branch.isLoop) || uniqueBranches[0];
    const loopBranches = uniqueBranches.filter((branch)=>branch.isLoop);
    const lines = [
        `def ${router.functionName}(state: ${$025995cee117ee16$var$STATE_CLASS}) -> Literal[${literal}]:`
    ];
    if (loopBranches.length > 0) {
        const descriptions = loopBranches.map((branch)=>`${branch.key || '(empty key)'} -> ${branch.targetLabel}`).join(', ');
        lines.push(`    """TODO: Implement the branch condition for '${(0, $309118e693f668de$export$6b103d4e680094b6)(router.label)}'.`, `    Loop branch ${(0, $309118e693f668de$export$6b103d4e680094b6)(descriptions)}: you must implement a termination condition.`, '    """');
    } else lines.push(`    """TODO: Implement the branch condition for '${(0, $309118e693f668de$export$6b103d4e680094b6)(router.label)}'."""`);
    lines.push(`    return ${(0, $309118e693f668de$export$57c1cd480f1b6e37)(defaultBranch.key)}`);
    return lines.join('\n');
}
function $025995cee117ee16$var$annotatedBase(annotation) {
    const text = String(annotation).trim();
    if (!text.startsWith('Annotated[') || !text.endsWith(']')) return text;
    const content = text.slice(10, -1);
    let depth = 0;
    for(let index = 0; index < content.length; index += 1){
        const character = content[index];
        if ('[({'.includes(character)) depth += 1;
        else if ('])}'.includes(character)) depth -= 1;
        else if (character === ',' && depth === 0) return content.slice(0, index).trim();
    }
    return text;
}
function $025995cee117ee16$var$defaultForAnnotation(annotation) {
    const base = $025995cee117ee16$var$annotatedBase(annotation);
    const match = /^(list|dict|str|int|float|bool|set|tuple)(?:\[.*\])?$/.exec(base);
    if (!match) return null;
    return ({
        list: '[]',
        dict: '{}',
        str: '""',
        int: '0',
        float: '0.0',
        bool: 'False',
        set: 'set()',
        tuple: '()'
    })[match[1]];
}
function $025995cee117ee16$var$renderCycleExample(plan) {
    const defaults = plan.stateFields.fields.map((field)=>({
            name: field.name,
            value: $025995cee117ee16$var$defaultForAnnotation(field.annotation)
        }));
    const canInitialize = defaults.every((field)=>field.value !== null);
    const lines = [
        'if __name__ == "__main__":',
        '    # This graph contains a loop. It stops at recursion_limit if the termination condition is not met.'
    ];
    if (!canInitialize) lines.push('    # TODO: Provide initial values matching the actual State fields.', '    initial_state = {}');
    else if (defaults.length === 0) lines.push('    initial_state = {}');
    else {
        lines.push('    initial_state = {');
        defaults.forEach((field)=>lines.push(`        ${(0, $309118e693f668de$export$57c1cd480f1b6e37)(field.name)}: ${field.value},`));
        lines.push('    }');
    }
    lines.push(`    print(${plan.compiledName}.invoke(initial_state, config={"recursion_limit": 25}))`);
    return lines.join('\n');
}
function $025995cee117ee16$var$renderGraph(plan) {
    const { graphName: graphName } = plan;
    const lines = [
        `${graphName} = StateGraph(${$025995cee117ee16$var$STATE_CLASS})`
    ];
    if (plan.codeNodes.length > 0) {
        lines.push('');
        plan.codeNodes.forEach((node)=>{
            lines.push(`${graphName}.add_node(${(0, $309118e693f668de$export$57c1cd480f1b6e37)(plan.nodeNames.get(node.id))}, ${plan.functionNames.get(node.id)})`);
        });
    }
    const edgeLines = [
        ...plan.startEdges.map((edge)=>`${graphName}.add_edge(START, ${plan.asTarget(edge.target)})`),
        ...plan.plainEdges.map((edge)=>`${graphName}.add_edge(${plan.asSource(edge.source)}, ${plan.asTarget(edge.target)})`)
    ];
    if (edgeLines.length > 0) lines.push('', ...edgeLines);
    plan.routers.forEach((router)=>{
        router.sources.forEach((source)=>{
            lines.push('', `${graphName}.add_conditional_edges(`, `    ${source},`, `    ${router.functionName},`, '    {', ...router.branches.map((branch)=>`        ${(0, $309118e693f668de$export$57c1cd480f1b6e37)(branch.key)}: ${branch.target},`), '    },', ')');
        });
    });
    lines.push('', `${plan.compiledName} = ${graphName}.compile()`);
    if (plan.hasCycle) lines.push('', '', $025995cee117ee16$var$renderCycleExample(plan));
    return lines.join('\n');
}
function $025995cee117ee16$export$f508c41f57988c9f(input = {}) {
    const plan = $025995cee117ee16$export$9934590481ce934a(input);
    const annotationSymbols = $025995cee117ee16$export$e45b44879ac03376(plan.stateFields.fields);
    const usesStart = plan.startEdges.length > 0 || plan.routers.some((r)=>r.sources.includes('START'));
    const usesEnd = plan.plainEdges.some((edge)=>plan.asTarget(edge.target) === 'END') || plan.routers.some((router)=>router.branches.some((branch)=>branch.target === 'END'));
    const typingNames = new Set([
        'TypedDict',
        ...annotationSymbols.typingNames
    ]);
    if (plan.routers.length > 0) typingNames.add('Literal');
    const langgraphNames = [
        'StateGraph'
    ];
    if (usesEnd) langgraphNames.unshift('END');
    if (usesStart) langgraphNames.splice(usesEnd ? 1 : 0, 0, 'START');
    const header = [
        '"""Graph generated by LangGraph CAD.',
        '',
        "Only fill in the function bodies marked TODO \u2014 the graph wiring will compile as is.",
        '"""'
    ].join('\n');
    const standardImports = [
        ...annotationSymbols.moduleNames.map((name)=>`import ${name}`),
        `from typing import ${[
            ...typingNames
        ].sort().join(', ')}`
    ];
    const langgraphImports = [
        ...annotationSymbols.langchainMessageNames.length > 0 ? [
            `from langchain_core.messages import ${annotationSymbols.langchainMessageNames.join(', ')}`
        ] : [],
        `from langgraph.graph import ${langgraphNames.sort().join(', ')}`,
        ...annotationSymbols.langgraphMessageNames.length > 0 ? [
            `from langgraph.graph.message import ${annotationSymbols.langgraphMessageNames.join(', ')}`
        ] : [],
        ...annotationSymbols.langgraphManagedNames.length > 0 ? [
            `from langgraph.managed import ${annotationSymbols.langgraphManagedNames.join(', ')}`
        ] : [],
        ...annotationSymbols.langgraphTypeNames.length > 0 ? [
            `from langgraph.types import ${annotationSymbols.langgraphTypeNames.join(', ')}`
        ] : []
    ];
    const imports = `${standardImports.join('\n')}\n\n${langgraphImports.join('\n')}`;
    const definitions = [
        $025995cee117ee16$var$renderStateClass(plan.stateFields.fields),
        ...plan.codeNodes.map((node)=>$025995cee117ee16$var$renderNodeFunction(node, plan.functionNames.get(node.id))),
        ...plan.routers.map($025995cee117ee16$var$renderRouterFunction),
        $025995cee117ee16$var$renderGraph(plan)
    ];
    return `${header}\n\n${imports}\n\n\n${definitions.join('\n\n\n')}\n`;
}


const $b15cf0739a41e706$var$HORIZONTAL_GAP = 280;
const $b15cf0739a41e706$var$VERTICAL_GAP = 180;
const $b15cf0739a41e706$var$ORIGIN_X = 80;
const $b15cf0739a41e706$var$ORIGIN_Y = 60;
function $b15cf0739a41e706$export$9c1e37147b60c4b6({ nodes: nodes = [], edges: edges = [] } = {}) {
    const nodeCopies = nodes.map((node)=>({
            ...node,
            data: node.data ? {
                ...node.data
            } : node.data
        }));
    const knownIds = new Set(nodeCopies.map((node)=>node.id));
    const adjacency = new Map(nodeCopies.map((node)=>[
            node.id,
            []
        ]));
    edges.forEach((edge)=>{
        if (!knownIds.has(edge.source) || !knownIds.has(edge.target)) return;
        adjacency.get(edge.source).push(edge.target);
    });
    const rankById = new Map();
    const queue = [];
    nodeCopies.forEach((node)=>{
        if (node.data?.type !== 'start') return;
        rankById.set(node.id, 0);
        queue.push(node.id);
    });
    for(let index = 0; index < queue.length; index += 1){
        const source = queue[index];
        const nextRank = rankById.get(source) + 1;
        adjacency.get(source).forEach((target)=>{
            if (rankById.has(target)) return;
            rankById.set(target, nextRank);
            queue.push(target);
        });
    }
    let lastRank = rankById.size > 0 ? Math.max(...rankById.values()) : -1;
    nodeCopies.forEach((node)=>{
        if (rankById.has(node.id)) return;
        lastRank += 1;
        rankById.set(node.id, lastRank);
    });
    const nodesByRank = new Map();
    nodeCopies.forEach((node)=>{
        const rank = rankById.get(node.id);
        if (!nodesByRank.has(rank)) nodesByRank.set(rank, []);
        nodesByRank.get(rank).push(node.id);
    });
    const positionById = new Map();
    [
        ...nodesByRank.entries()
    ].sort(([left], [right])=>left - right).forEach(([rank, ids])=>{
        ids.forEach((id, index)=>{
            positionById.set(id, {
                x: $b15cf0739a41e706$var$ORIGIN_X + index * $b15cf0739a41e706$var$HORIZONTAL_GAP,
                y: $b15cf0739a41e706$var$ORIGIN_Y + rank * $b15cf0739a41e706$var$VERTICAL_GAP
            });
        });
    });
    return {
        nodes: nodeCopies.map((node)=>({
                ...node,
                position: positionById.get(node.id)
            })),
        edges: edges.map((edge)=>({
                ...edge,
                data: edge.data ? {
                    ...edge.data
                } : edge.data
            }))
    };
}




const $4dbddc370d338f21$export$65c3dcaa85b9883b = 1;
const $4dbddc370d338f21$export$27ea7785c5c74343 = 8000;
const $4dbddc370d338f21$var$MAX_NODES = 500;
const $4dbddc370d338f21$var$MAX_EDGES = 2000;
const $4dbddc370d338f21$var$MAX_ID = 128;
const $4dbddc370d338f21$var$MAX_LABEL = 200;
const $4dbddc370d338f21$var$MAX_BRANCH_KEY = 100;
const $4dbddc370d338f21$var$MAX_STATE_FIELDS = 2000;
const $4dbddc370d338f21$var$isFiniteNumber = (value)=>typeof value === 'number' && Number.isFinite(value);
const $4dbddc370d338f21$var$isString = (value)=>typeof value === 'string';
const $4dbddc370d338f21$var$clamp = (text, max)=>String(text).slice(0, max);
class $4dbddc370d338f21$var$DecodeError extends Error {
}
const $4dbddc370d338f21$var$fail = (reason)=>{
    throw new $4dbddc370d338f21$var$DecodeError(reason);
};
function $4dbddc370d338f21$var$readPosition(raw) {
    if (!raw || !$4dbddc370d338f21$var$isFiniteNumber(raw.x) || !$4dbddc370d338f21$var$isFiniteNumber(raw.y)) $4dbddc370d338f21$var$fail('The node position is invalid.');
    return {
        x: raw.x,
        y: raw.y
    };
}
function $4dbddc370d338f21$var$readNode(raw) {
    if (!raw || !$4dbddc370d338f21$var$isString(raw.id) || !raw.id || raw.id.length > $4dbddc370d338f21$var$MAX_ID) $4dbddc370d338f21$var$fail('The node ID is invalid.');
    const data = raw.data || {};
    if (!$4dbddc370d338f21$var$isString(data.type) || !Object.hasOwn((0, $0f96f2a40cf4a802$export$a473c43a4db1086c), data.type)) $4dbddc370d338f21$var$fail(`Unknown node type: ${String(data.type)}`);
    const node = {
        id: raw.id,
        position: $4dbddc370d338f21$var$readPosition(raw.position),
        data: {
            type: data.type,
            label: $4dbddc370d338f21$var$isString(data.label) ? $4dbddc370d338f21$var$clamp(data.label, $4dbddc370d338f21$var$MAX_LABEL) : (0, $0f96f2a40cf4a802$export$a473c43a4db1086c)[data.type].label
        }
    };
    if ((0, $0f96f2a40cf4a802$export$2ee57b564e50eb4b)(data.type)) {
        const identifier = $4dbddc370d338f21$var$isString(data.codeIdentifier) ? data.codeIdentifier : '';
        if (identifier && !/^[A-Za-z0-9_]+$/.test(identifier)) $4dbddc370d338f21$var$fail('The node identifier contains invalid characters.');
        node.data.codeIdentifier = identifier || undefined;
    }
    return node;
}
function $4dbddc370d338f21$var$readEdge(raw, nodeIds) {
    if (!raw || !$4dbddc370d338f21$var$isString(raw.id) || !raw.id || raw.id.length > $4dbddc370d338f21$var$MAX_ID) $4dbddc370d338f21$var$fail('The edge ID is invalid.');
    if (!nodeIds.has(raw.source) || !nodeIds.has(raw.target)) $4dbddc370d338f21$var$fail('An edge refers to a node that does not exist.');
    const data = raw.data || {};
    const edge = {
        id: raw.id,
        source: raw.source,
        target: raw.target,
        data: {}
    };
    if ($4dbddc370d338f21$var$isString(data.branchKey) && data.branchKey.trim()) edge.data.branchKey = $4dbddc370d338f21$var$clamp(data.branchKey.trim(), $4dbddc370d338f21$var$MAX_BRANCH_KEY);
    if (data.controlPoint) {
        edge.data.controlPoint = $4dbddc370d338f21$var$readPosition(data.controlPoint);
        edge.data.controlPointDragged = true;
    }
    return edge;
}
/** Normalise any accepted payload (current or legacy) into the persisted shape. */ function $4dbddc370d338f21$var$readState(raw) {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) $4dbddc370d338f21$var$fail('This is not a saved graph payload.');
    if (raw.v !== undefined && raw.v !== $4dbddc370d338f21$export$65c3dcaa85b9883b) $4dbddc370d338f21$var$fail(`Unsupported save version: ${String(raw.v)}`);
    const rawNodes = Array.isArray(raw.nodes) ? raw.nodes : $4dbddc370d338f21$var$fail('nodes must be an array.');
    const rawEdges = Array.isArray(raw.edges) ? raw.edges : [];
    if (rawNodes.length > $4dbddc370d338f21$var$MAX_NODES) $4dbddc370d338f21$var$fail(`Too many nodes (${rawNodes.length} > ${$4dbddc370d338f21$var$MAX_NODES}).`);
    if (rawEdges.length > $4dbddc370d338f21$var$MAX_EDGES) $4dbddc370d338f21$var$fail(`Too many edges (${rawEdges.length} > ${$4dbddc370d338f21$var$MAX_EDGES}).`);
    const nodes = rawNodes.map($4dbddc370d338f21$var$readNode);
    const nodeIds = new Set(nodes.map((node)=>node.id));
    if (nodeIds.size !== nodes.length) $4dbddc370d338f21$var$fail('Duplicate node IDs are not allowed.');
    const edges = rawEdges.map((edge)=>$4dbddc370d338f21$var$readEdge(edge, nodeIds));
    const edgeIds = new Set(edges.map((edge)=>edge.id));
    if (edgeIds.size !== edges.length) $4dbddc370d338f21$var$fail('Duplicate edge IDs are not allowed.');
    return {
        v: $4dbddc370d338f21$export$65c3dcaa85b9883b,
        graphName: $4dbddc370d338f21$var$isString(raw.graphName) && raw.graphName ? $4dbddc370d338f21$var$clamp(raw.graphName, 64) : (0, $025995cee117ee16$export$cd85767a926998a6),
        stateFields: $4dbddc370d338f21$var$isString(raw.stateFields) ? $4dbddc370d338f21$var$clamp(raw.stateFields, $4dbddc370d338f21$var$MAX_STATE_FIELDS) : (0, $025995cee117ee16$export$a15eca9ac5ccd268),
        nodes: nodes,
        edges: edges
    };
}
function $4dbddc370d338f21$export$de5e90bd767c5d82() {
    return {
        v: $4dbddc370d338f21$export$65c3dcaa85b9883b,
        graphName: (0, $025995cee117ee16$export$cd85767a926998a6),
        stateFields: (0, $025995cee117ee16$export$a15eca9ac5ccd268),
        nodes: [
            {
                id: 'start-1',
                position: {
                    x: 100,
                    y: 100
                },
                data: {
                    type: 'start',
                    label: 'START'
                }
            }
        ],
        edges: []
    };
}
function $4dbddc370d338f21$export$1244e9dd32dc68ea({ nodes: nodes = [], edges: edges = [], graphName: graphName, stateFields: stateFields }) {
    return {
        v: $4dbddc370d338f21$export$65c3dcaa85b9883b,
        graphName: graphName || (0, $025995cee117ee16$export$cd85767a926998a6),
        stateFields: stateFields ?? (0, $025995cee117ee16$export$a15eca9ac5ccd268),
        nodes: nodes.map((node)=>{
            const persisted = {
                id: node.id,
                position: {
                    x: Math.round(node.position.x),
                    y: Math.round(node.position.y)
                },
                data: {
                    type: node.data.type,
                    label: node.data.label
                }
            };
            if (node.data.codeIdentifier) persisted.data.codeIdentifier = node.data.codeIdentifier;
            return persisted;
        }),
        edges: edges.map((edge)=>{
            const persisted = {
                id: edge.id,
                source: edge.source,
                target: edge.target
            };
            const data = {};
            if (edge.data?.branchKey) data.branchKey = edge.data.branchKey;
            if (edge.data?.controlPointDragged && edge.data.controlPoint) data.controlPoint = {
                x: Math.round(edge.data.controlPoint.x),
                y: Math.round(edge.data.controlPoint.y)
            };
            if (Object.keys(data).length > 0) persisted.data = data;
            return persisted;
        })
    };
}
const $4dbddc370d338f21$export$d7cf40567ee3d83d = (node)=>({
        ...node,
        type: 'custom',
        zIndex: 10
    });
const $4dbddc370d338f21$export$ca2260abc4aabad5 = (edge)=>({
        ...edge,
        type: 'customEdge',
        data: edge.data || {},
        zIndex: 5
    });
const $4dbddc370d338f21$export$ba5ae29bdb29802d = (state)=>encodeURIComponent(JSON.stringify($4dbddc370d338f21$export$1244e9dd32dc68ea(state)));
function $4dbddc370d338f21$export$f011bbd5d4754f0f(hash) {
    const payload = String(hash || '').replace(/^#/, '');
    if (!payload) return {
        ok: true,
        state: null
    };
    let parsed;
    try {
        parsed = JSON.parse(decodeURIComponent(payload));
    } catch  {
        return {
            ok: false,
            reason: 'The graph data in the URL is not valid JSON.'
        };
    }
    try {
        return {
            ok: true,
            state: $4dbddc370d338f21$var$readState(parsed)
        };
    } catch (err) {
        if (err instanceof $4dbddc370d338f21$var$DecodeError) return {
            ok: false,
            reason: err.message
        };
        throw err;
    }
}


const $5821f2f277f9d237$var$MARKER_RE = /\b(add_conditional_edges|set_entry_point|set_finish_point|add_sequence|add_node|add_edge|StateGraph)\s*\(/g;
const $5821f2f277f9d237$var$IDENTIFIER_RE = /^[A-Za-z_][A-Za-z0-9_]*$/;
function $5821f2f277f9d237$var$maskPython(source) {
    const characters = source.split('');
    const masked = source.split('');
    let quote = null;
    let triple = false;
    let escaped = false;
    let comment = false;
    const hide = (index)=>{
        if (characters[index] !== '\n') masked[index] = ' ';
    };
    for(let index = 0; index < characters.length; index += 1){
        const character = characters[index];
        if (comment) {
            hide(index);
            if (character === '\n') comment = false;
            continue;
        }
        if (quote) {
            hide(index);
            if (triple) {
                if (source.slice(index, index + 3) === quote.repeat(3)) {
                    hide(index + 1);
                    hide(index + 2);
                    index += 2;
                    quote = null;
                    triple = false;
                }
            } else if (escaped) escaped = false;
            else if (character === '\n') quote = null;
            else if (character === '\\') escaped = true;
            else if (character === quote) quote = null;
            continue;
        }
        if (character === '#') {
            comment = true;
            hide(index);
            continue;
        }
        if (character === '"' || character === "'") {
            quote = character;
            triple = source.slice(index, index + 3) === character.repeat(3);
            hide(index);
            if (triple) {
                hide(index + 1);
                hide(index + 2);
                index += 2;
            }
        }
    }
    return masked.join('');
}
function $5821f2f277f9d237$var$lineStarts(source) {
    const starts = [
        0
    ];
    for(let index = 0; index < source.length; index += 1)if (source[index] === '\n') starts.push(index + 1);
    return starts;
}
function $5821f2f277f9d237$var$lineOfOffset(starts, offset) {
    let low = 0;
    let high = starts.length;
    while(low + 1 < high){
        const middle = Math.floor((low + high) / 2);
        if (starts[middle] <= offset) low = middle;
        else high = middle;
    }
    return low + 1;
}
function $5821f2f277f9d237$var$indentation(text) {
    const prefix = text.match(/^[ \t]*/)?.[0] || '';
    return [
        ...prefix
    ].reduce((width, character)=>width + (character === '\t' ? 4 : 1), 0);
}
function $5821f2f277f9d237$var$enclosingBlockReason(lines, maskedLines, lineIndex) {
    const currentIndent = $5821f2f277f9d237$var$indentation(lines[lineIndex]);
    if (currentIndent === 0) return null;
    for(let index = lineIndex - 1; index >= 0; index -= 1){
        const text = maskedLines[index];
        if (!text.trim() || $5821f2f277f9d237$var$indentation(text) >= currentIndent || !text.trimEnd().endsWith(':')) continue;
        const header = text.trim();
        if (/^(async\s+)?(for|while)\b/.test(header)) return 'Calls created inside loops cannot be imported.';
        if (/^(if|elif|else\b|match\b|case\b)/.test(header)) return 'Calls created inside conditional blocks cannot be imported.';
        if (/^(async\s+)?def\b/.test(header)) return 'Graph construction calls inside function blocks cannot be imported.';
        return 'Dynamic graph construction calls inside indented blocks cannot be imported.';
    }
    return 'Dynamic graph construction calls inside indented blocks cannot be imported.';
}
function $5821f2f277f9d237$var$findCallEnd(masked, openIndex) {
    let depth = 0;
    for(let index = openIndex; index < masked.length; index += 1){
        if (masked[index] === '(') depth += 1;
        else if (masked[index] === ')') {
            depth -= 1;
            if (depth === 0) return index;
        }
    }
    return -1;
}
function $5821f2f277f9d237$var$splitTopLevel(raw) {
    const masked = $5821f2f277f9d237$var$maskPython(raw);
    const parts = [];
    let start = 0;
    const stack = [];
    const pairs = {
        ')': '(',
        ']': '[',
        '}': '{'
    };
    for(let index = 0; index < masked.length; index += 1){
        const character = masked[index];
        if ('([{'.includes(character)) stack.push(character);
        else if (')]}'.includes(character)) {
            if (stack.at(-1) === pairs[character]) stack.pop();
        } else if (character === ',' && stack.length === 0) {
            parts.push(raw.slice(start, index).trim());
            start = index + 1;
        }
    }
    const tail = raw.slice(start).trim();
    if (tail) parts.push(tail);
    return parts;
}
function $5821f2f277f9d237$var$splitKeyValue(raw) {
    const masked = $5821f2f277f9d237$var$maskPython(raw);
    const stack = [];
    const pairs = {
        ')': '(',
        ']': '[',
        '}': '{'
    };
    for(let index = 0; index < masked.length; index += 1){
        const character = masked[index];
        if ('([{'.includes(character)) stack.push(character);
        else if (')]}'.includes(character)) {
            if (stack.at(-1) === pairs[character]) stack.pop();
        } else if (character === ':' && stack.length === 0) return [
            raw.slice(0, index).trim(),
            raw.slice(index + 1).trim()
        ];
    }
    return null;
}
function $5821f2f277f9d237$var$parseStringLiteral(raw) {
    const text = raw.trim();
    if (/^"(?:\\.|[^"\\\n])*"$/.test(text)) try {
        return JSON.parse(text);
    } catch  {
        return null;
    }
    const match = /^'((?:\\.|[^'\\\n])*)'$/.exec(text);
    if (!match) return null;
    return match[1].replace(/\\([\\"'nrt])/g, (_, escaped)=>({
            '\\': '\\',
            '"': '"',
            "'": "'",
            n: '\n',
            r: '\r',
            t: '\t'
        })[escaped]);
}
function $5821f2f277f9d237$var$parseEndpoint(raw, { allowEnd: allowEnd = true } = {}) {
    const text = raw.trim();
    const literal = $5821f2f277f9d237$var$parseStringLiteral(text);
    if (literal !== null) return {
        kind: 'node',
        name: literal
    };
    if (text === 'START') return {
        kind: 'start',
        name: 'START'
    };
    if (allowEnd && text === 'END') return {
        kind: 'end',
        name: 'END'
    };
    return null;
}
function $5821f2f277f9d237$var$parsePathMap(raw) {
    const text = raw.trim();
    if (!text.startsWith('{')) return {
        error: 'path_map must be a literal dictionary.'
    };
    if (!text.endsWith('}')) return {
        error: 'The path_map dictionary is not closed.'
    };
    const content = text.slice(1, -1).trim();
    if (!content) return {
        entries: []
    };
    const entries = [];
    for (const part of $5821f2f277f9d237$var$splitTopLevel(content)){
        const pair = $5821f2f277f9d237$var$splitKeyValue(part);
        if (!pair) return {
            error: 'A path_map entry must contain a key and target.'
        };
        const key = $5821f2f277f9d237$var$parseStringLiteral(pair[0]);
        const target = $5821f2f277f9d237$var$parseEndpoint(pair[1], {
            allowEnd: true
        });
        if (key === null) return {
            error: 'The path_map branch key must be a string literal.'
        };
        if (!target || target.kind === 'start') return {
            error: 'The path_map branch target is a variable or uses an unsupported form.'
        };
        entries.push({
            key: key,
            target: target
        });
    }
    return {
        entries: entries
    };
}
function $5821f2f277f9d237$var$readStateFields(lines, maskedLines) {
    for(let index = 0; index < maskedLines.length; index += 1){
        const header = /^(\s*)class\s+State\s*\(\s*TypedDict\s*\)\s*:/.exec(maskedLines[index]);
        if (!header) continue;
        const classIndent = $5821f2f277f9d237$var$indentation(header[1]);
        let childIndent = null;
        const fields = [];
        for(let cursor = index + 1; cursor < lines.length; cursor += 1){
            const maskedLine = maskedLines[cursor];
            if (!maskedLine.trim()) continue;
            const indent = $5821f2f277f9d237$var$indentation(maskedLine);
            if (indent <= classIndent) break;
            if (childIndent === null) childIndent = indent;
            if (indent !== childIndent) continue;
            const field = /^\s*([A-Za-z_][A-Za-z0-9_]*)\s*:\s*(.+?)\s*$/.exec(lines[cursor]);
            if (field) fields.push(`${field[1]}: ${field[2]}`);
        }
        return fields.join('\n');
    }
    return 0, $025995cee117ee16$export$a15eca9ac5ccd268;
}
function $5821f2f277f9d237$var$collectCandidates(source, masked) {
    const lines = source.split('\n');
    const maskedLines = masked.split('\n');
    const starts = $5821f2f277f9d237$var$lineStarts(source);
    const candidates = [];
    $5821f2f277f9d237$var$MARKER_RE.lastIndex = 0;
    let match = $5821f2f277f9d237$var$MARKER_RE.exec(masked);
    while(match){
        const line = $5821f2f277f9d237$var$lineOfOffset(starts, match.index);
        const openIndex = masked.indexOf('(', match.index);
        const endIndex = $5821f2f277f9d237$var$findCallEnd(masked, openIndex);
        candidates.push({
            marker: match[1],
            line: line,
            markerColumn: match.index - starts[line - 1],
            text: lines[line - 1] ?? '',
            maskedLine: maskedLines[line - 1] ?? '',
            blockReason: $5821f2f277f9d237$var$enclosingBlockReason(lines, maskedLines, line - 1),
            start: match.index,
            openIndex: openIndex,
            endIndex: endIndex,
            raw: endIndex < 0 ? source.slice(match.index) : source.slice(match.index, endIndex + 1),
            args: endIndex < 0 ? null : source.slice(openIndex + 1, endIndex)
        });
        match = $5821f2f277f9d237$var$MARKER_RE.exec(masked);
    }
    return {
        candidates: candidates,
        lines: lines,
        maskedLines: maskedLines
    };
}
function $5821f2f277f9d237$var$receiverBefore(candidate) {
    if (candidate.marker === 'StateGraph') return null;
    const prefix = candidate.maskedLine.slice(0, candidate.markerColumn);
    return /([A-Za-z_][A-Za-z0-9_]*)\s*\.\s*$/.exec(prefix)?.[1] || null;
}
function $5821f2f277f9d237$var$graphAssignment(candidate) {
    const prefix = candidate.maskedLine.slice(0, candidate.markerColumn);
    return /^\s*([A-Za-z_][A-Za-z0-9_]*)\s*=\s*$/.exec(prefix)?.[1] || null;
}
function $5821f2f277f9d237$var$nodeType(name) {
    return /tools?/i.test(name) ? 'tool' : 'agent';
}
function $5821f2f277f9d237$export$9266306278d4ae62(source) {
    const text = String(source ?? '');
    const masked = $5821f2f277f9d237$var$maskPython(text);
    const { candidates: candidates, lines: lines, maskedLines: maskedLines } = $5821f2f277f9d237$var$collectCandidates(text, masked);
    const unreadableByLine = new Map();
    const calls = [];
    let graphName = null;
    const reject = (candidate, reason)=>{
        if (!unreadableByLine.has(candidate.line)) unreadableByLine.set(candidate.line, {
            line: candidate.line,
            text: candidate.text,
            reason: reason
        });
    };
    candidates.forEach((candidate)=>{
        if (candidate.blockReason) {
            reject(candidate, candidate.blockReason);
            return;
        }
        if (candidate.endIndex < 0) {
            reject(candidate, candidate.marker === 'add_conditional_edges' ? 'The conditional edge call or path_map dictionary is not closed.' : 'The graph construction call is not closed.');
            return;
        }
        if (candidate.marker === 'StateGraph') {
            const assigned = $5821f2f277f9d237$var$graphAssignment(candidate);
            if (!assigned) reject(candidate, 'StateGraph must be assigned to a simple graph variable to be imported.');
            else if (graphName && graphName !== assigned) reject(candidate, 'Multiple StateGraph variables cannot be imported.');
            else graphName = assigned;
            return;
        }
        calls.push({
            ...candidate,
            receiver: $5821f2f277f9d237$var$receiverBefore(candidate)
        });
    });
    const explicitNames = new Set();
    const parsedCalls = [];
    calls.forEach((candidate)=>{
        if (!candidate.receiver || !graphName || candidate.receiver !== graphName) {
            reject(candidate, 'Calls on another graph variable or an unknown receiver cannot be imported.');
            return;
        }
        const args = $5821f2f277f9d237$var$splitTopLevel(candidate.args);
        if (candidate.marker === 'add_sequence') {
            reject(candidate, 'add_sequence is not supported. Expand it into add_node and add_edge calls.');
            return;
        }
        if (candidate.marker === 'add_node') {
            let name = null;
            if (args.length === 1 && $5821f2f277f9d237$var$IDENTIFIER_RE.test(args[0])) name = args[0];
            else if (args.length === 2 && $5821f2f277f9d237$var$IDENTIFIER_RE.test(args[1])) name = $5821f2f277f9d237$var$parseStringLiteral(args[0]);
            if (name === null) {
                reject(candidate, 'The node name is a variable or uses an unsupported form.');
                return;
            }
            explicitNames.add(name);
            parsedCalls.push({
                kind: 'node',
                name: name,
                line: candidate.line
            });
            return;
        }
        if (candidate.marker === 'add_edge') {
            const sourceEndpoint = args.length === 2 ? $5821f2f277f9d237$var$parseEndpoint(args[0]) : null;
            const targetEndpoint = args.length === 2 ? $5821f2f277f9d237$var$parseEndpoint(args[1]) : null;
            if (!sourceEndpoint || !targetEndpoint || sourceEndpoint.kind === 'end' || targetEndpoint.kind === 'start') {
                reject(candidate, 'The edge endpoint is a variable or uses an unsupported form.');
                return;
            }
            parsedCalls.push({
                kind: 'edge',
                source: sourceEndpoint,
                target: targetEndpoint,
                line: candidate.line
            });
            return;
        }
        if (candidate.marker === 'set_entry_point' || candidate.marker === 'set_finish_point') {
            const endpoint = args.length === 1 ? $5821f2f277f9d237$var$parseEndpoint(args[0]) : null;
            if (!endpoint || endpoint.kind !== 'node') {
                reject(candidate, 'The entry or finish point name is a variable and cannot be imported.');
                return;
            }
            parsedCalls.push(candidate.marker === 'set_entry_point' ? {
                kind: 'edge',
                source: {
                    kind: 'start',
                    name: 'START'
                },
                target: endpoint,
                line: candidate.line
            } : {
                kind: 'edge',
                source: endpoint,
                target: {
                    kind: 'end',
                    name: 'END'
                },
                line: candidate.line
            });
            return;
        }
        if (candidate.marker === 'add_conditional_edges') {
            if (args.length < 3) {
                reject(candidate, 'There is no path_map, so the branch targets are unknown.');
                return;
            }
            const sourceEndpoint = $5821f2f277f9d237$var$parseEndpoint(args[0], {
                allowEnd: false
            });
            const router = args[1]?.trim();
            const pathMap = args.length === 3 ? $5821f2f277f9d237$var$parsePathMap(args[2]) : null;
            if (!sourceEndpoint) reject(candidate, 'The conditional edge source is a variable and cannot be imported.');
            else if (!$5821f2f277f9d237$var$IDENTIFIER_RE.test(router || '')) reject(candidate, 'The router function is not a simple identifier and cannot be imported.');
            else if (args.length !== 3) reject(candidate, 'The conditional edge has unsupported extra arguments and cannot be imported.');
            else if (pathMap.error) reject(candidate, pathMap.error);
            else parsedCalls.push({
                kind: 'conditional',
                source: sourceEndpoint,
                router: router,
                branches: pathMap.entries,
                line: candidate.line
            });
        }
    });
    const nodes = [];
    const edges = [];
    const implied = [];
    const byKey = new Map();
    const counters = new Map();
    const nextId = (type)=>{
        const prefix = type === 'conditional_edge' ? 'conditional' : type;
        const next = (counters.get(prefix) || 0) + 1;
        counters.set(prefix, next);
        return `${prefix}-${next}`;
    };
    const ensureNode = (endpoint, { router: router = false } = {})=>{
        const key = router ? `router:${endpoint.name}` : `${endpoint.kind}:${endpoint.name}`;
        if (byKey.has(key)) return byKey.get(key);
        let type = endpoint.kind;
        if (router) type = 'conditional_edge';
        else if (endpoint.kind === 'node') type = $5821f2f277f9d237$var$nodeType(endpoint.name);
        const id = nextId(type);
        const data = {
            type: type,
            label: endpoint.name
        };
        if (type === 'conditional_edge' || (type === 'agent' || type === 'tool') && /^[A-Za-z0-9_]+$/.test(endpoint.name)) data.codeIdentifier = endpoint.name;
        nodes.push({
            id: id,
            data: data
        });
        byKey.set(key, id);
        return id;
    };
    const addEdge = (sourceId, targetId, data)=>{
        const edge = {
            id: `edge-${edges.length + 1}`,
            source: sourceId,
            target: targetId
        };
        if (data) edge.data = data;
        edges.push(edge);
    };
    const noteImplied = (endpoint)=>{
        if (endpoint.kind !== 'node' || explicitNames.has(endpoint.name) || implied.includes(endpoint.name)) return;
        implied.push(endpoint.name);
    };
    parsedCalls.filter((call)=>call.kind === 'node').forEach((call)=>{
        ensureNode({
            kind: 'node',
            name: call.name
        });
    });
    const conditionalEdgeKeys = new Set();
    parsedCalls.filter((call)=>call.kind !== 'node').forEach((call)=>{
        if (call.kind === 'edge') {
            noteImplied(call.source);
            noteImplied(call.target);
            addEdge(ensureNode(call.source), ensureNode(call.target));
            return;
        }
        noteImplied(call.source);
        const sourceId = ensureNode(call.source);
        const routerId = ensureNode({
            kind: 'router',
            name: call.router
        }, {
            router: true
        });
        const sourceKey = `${sourceId}->${routerId}`;
        if (!conditionalEdgeKeys.has(sourceKey)) {
            conditionalEdgeKeys.add(sourceKey);
            addEdge(sourceId, routerId);
        }
        call.branches.forEach(({ key: key, target: target })=>{
            noteImplied(target);
            const targetId = ensureNode(target);
            const branchKey = `${routerId}->${targetId}:${key}`;
            if (!conditionalEdgeKeys.has(branchKey)) {
                conditionalEdgeKeys.add(branchKey);
                addEdge(routerId, targetId, {
                    branchKey: key
                });
            }
        });
    });
    const unreadable = [
        ...unreadableByLine.values()
    ].sort((left, right)=>left.line - right.line);
    const summary = {
        nodes: nodes.length,
        edges: edges.length,
        routers: nodes.filter((node)=>node.data.type === 'conditional_edge').length
    };
    if (nodes.length === 0 && edges.length === 0) return {
        state: null,
        unreadable: unreadable,
        implied: implied,
        summary: summary
    };
    const laidOut = (0, $b15cf0739a41e706$export$9c1e37147b60c4b6)({
        nodes: nodes,
        edges: edges
    });
    return {
        state: {
            v: (0, $4dbddc370d338f21$export$65c3dcaa85b9883b),
            graphName: graphName || (0, $025995cee117ee16$export$cd85767a926998a6),
            stateFields: $5821f2f277f9d237$var$readStateFields(lines, maskedLines),
            nodes: laidOut.nodes,
            edges: laidOut.edges
        },
        unreadable: unreadable,
        implied: implied,
        summary: summary
    };
}


// Minimal Python tokenizer. The panel only ever renders code this app just
// generated, so a full grammar (and the dependency that comes with it) would be
// far more machinery than the job needs.
const $638ad299a2611792$var$KEYWORDS = new Set([
    'False',
    'None',
    'True',
    'and',
    'as',
    'assert',
    'async',
    'await',
    'break',
    'class',
    'continue',
    'def',
    'del',
    'elif',
    'else',
    'except',
    'finally',
    'for',
    'from',
    'global',
    'if',
    'import',
    'in',
    'is',
    'lambda',
    'nonlocal',
    'not',
    'or',
    'pass',
    'raise',
    'return',
    'try',
    'while',
    'with',
    'yield'
]);
const $638ad299a2611792$var$BUILTINS = new Set([
    'bool',
    'bytes',
    'dict',
    'float',
    'frozenset',
    'int',
    'list',
    'object',
    'set',
    'str',
    'tuple',
    'Any',
    'Annotated',
    'Literal',
    'Optional',
    'Sequence',
    'TypedDict',
    'Union'
]);
const $638ad299a2611792$var$SCANNER = new RegExp([
    '("""[\\s\\S]*?"""|\'\'\'[\\s\\S]*?\'\'\')',
    '(#[^\\n]*)',
    '("(?:\\\\.|[^"\\\\\\n])*"|\'(?:\\\\.|[^\'\\\\\\n])*\')',
    '(\\b\\d+(?:\\.\\d+)?\\b)',
    '([A-Za-z_][A-Za-z0-9_]*)'
].join('|'), 'g');
function $638ad299a2611792$export$2b4dd9309f97eb17(code) {
    const source = String(code ?? '');
    const tokens = [];
    let lastIndex = 0;
    let previousWord = null;
    const pushPlain = (value)=>{
        if (value) tokens.push({
            type: 'plain',
            value: value
        });
    };
    $638ad299a2611792$var$SCANNER.lastIndex = 0;
    let match = $638ad299a2611792$var$SCANNER.exec(source);
    while(match !== null){
        pushPlain(source.slice(lastIndex, match.index));
        const [value, triple, comment, string, number, word] = match;
        if (triple || string) tokens.push({
            type: 'string',
            value: value
        });
        else if (comment) tokens.push({
            type: 'comment',
            value: value
        });
        else if (number) tokens.push({
            type: 'number',
            value: value
        });
        else if (word) {
            if (previousWord === 'def' || previousWord === 'class') tokens.push({
                type: 'entity',
                value: value
            });
            else if ($638ad299a2611792$var$KEYWORDS.has(word)) tokens.push({
                type: 'keyword',
                value: value
            });
            else if ($638ad299a2611792$var$BUILTINS.has(word)) tokens.push({
                type: 'builtin',
                value: value
            });
            else tokens.push({
                type: 'plain',
                value: value
            });
            previousWord = word;
        }
        lastIndex = match.index + value.length;
        match = $638ad299a2611792$var$SCANNER.exec(source);
    }
    pushPlain(source.slice(lastIndex));
    return tokens;
}
function $638ad299a2611792$export$2711f023de78499c(code) {
    const source = String(code ?? '');
    const lines = [
        {
            line: 1,
            text: '',
            tokens: []
        }
    ];
    $638ad299a2611792$export$2b4dd9309f97eb17(source).forEach((token)=>{
        let start = 0;
        for(let index = 0; index < token.value.length; index += 1){
            if (token.value[index] !== '\n') continue;
            const value = token.value.slice(start, index + 1);
            lines.at(-1).tokens.push({
                ...token,
                value: value
            });
            lines.at(-1).text += value;
            lines.push({
                line: lines.length + 1,
                text: '',
                tokens: []
            });
            start = index + 1;
        }
        if (start < token.value.length) {
            const value = token.value.slice(start);
            lines.at(-1).tokens.push({
                ...token,
                value: value
            });
            lines.at(-1).text += value;
        }
    });
    return lines;
}
const $638ad299a2611792$export$4d67c03d46371216 = {
    plain: '#e6e6e6',
    keyword: '#c792ea',
    builtin: '#82aaff',
    string: '#c3e88d',
    comment: '#7f8c98',
    number: '#f78c6c',
    entity: '#ffcb6b'
};


const $8a208501073d048d$var$LEVEL_STYLE = {
    error: {
        background: '#fdecea',
        border: '#f5c2c0',
        color: '#8f1f18',
        icon: "\u2715"
    },
    warning: {
        background: '#fff8e1',
        border: '#ffe08a',
        color: '#7a5600',
        icon: '!'
    }
};
const $8a208501073d048d$var$MODE_BUTTON_STYLE = {
    padding: '7px 10px',
    border: '1px solid #b8bec7',
    background: '#fff',
    color: '#333',
    cursor: 'pointer',
    fontSize: '13px'
};
function $8a208501073d048d$var$IssueList({ issues: issues, onFocus: onFocus }) {
    if (issues.length === 0) return null;
    const { background: background, border: border, color: color, icon: icon } = $8a208501073d048d$var$LEVEL_STYLE[issues[0].level];
    return /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("ul", {
        style: {
            listStyle: 'none',
            margin: '0 0 10px',
            padding: '8px 10px',
            background: background,
            border: `1px solid ${border}`,
            borderRadius: '6px',
            color: color,
            fontSize: '13px',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px'
        },
        children: issues.map((issue, index)=>/*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("li", {
                style: {
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'baseline'
                },
                children: [
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("span", {
                        "aria-hidden": "true",
                        children: icon
                    }),
                    issue.nodeIds.length > 0 ? /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onFocus(issue.nodeIds),
                        style: {
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            color: 'inherit',
                            font: 'inherit',
                            textAlign: 'left',
                            cursor: 'pointer',
                            textDecoration: 'underline dotted'
                        },
                        children: issue.message
                    }) : /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("span", {
                        children: issue.message
                    })
                ]
            }, `${issue.id}-${index}`))
    });
}
function $8a208501073d048d$var$ModeButton({ active: active, children: children, onClick: onClick, rounded: rounded }) {
    return /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
        type: "button",
        "aria-pressed": active,
        onClick: onClick,
        style: {
            ...$8a208501073d048d$var$MODE_BUTTON_STYLE,
            background: active ? '#0d6efd' : $8a208501073d048d$var$MODE_BUTTON_STYLE.background,
            color: active ? '#fff' : $8a208501073d048d$var$MODE_BUTTON_STYLE.color,
            borderColor: active ? '#0d6efd' : '#b8bec7',
            borderRadius: rounded
        },
        children: children
    });
}
function $8a208501073d048d$var$ImportReview({ source: source, result: result, onApply: onApply }) {
    const lines = (0, $kyXgS.useMemo)(()=>(0, $638ad299a2611792$export$2711f023de78499c)(source), [
        source
    ]);
    const unreadableByLine = (0, $kyXgS.useMemo)(()=>new Map(result.unreadable.map((item)=>[
                item.line,
                item
            ])), [
        result.unreadable
    ]);
    const summaryItems = [
        `${result.summary.nodes} nodes`,
        `${result.summary.edges} edges`,
        `${result.unreadable.length} unreadable lines`,
        `${result.implied.length} nodes referenced without add_node`
    ];
    return /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            gap: '10px',
            minHeight: 0,
            overflowY: 'auto'
        },
        children: [
            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("div", {
                "aria-label": "Python code conversion summary",
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '6px 12px',
                    padding: '9px 10px',
                    border: '1px solid #d7dce2',
                    borderRadius: '6px',
                    background: '#f7f8fa',
                    color: '#333',
                    fontSize: '13px'
                },
                children: summaryItems.map((item)=>/*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("span", {
                        children: item
                    }, item))
            }),
            !result.state && /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("p", {
                role: "alert",
                style: {
                    margin: 0,
                    padding: '9px 10px',
                    borderRadius: '6px',
                    background: '#fdecea',
                    color: '#8f1f18',
                    fontSize: '13px'
                },
                children: "No graph-building calls were found. The current canvas remains unchanged."
            }),
            result.implied.length > 0 && /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
                style: {
                    padding: '9px 10px',
                    border: '1px solid #ffe08a',
                    borderRadius: '6px',
                    background: '#fff8e1',
                    color: '#6b4d00',
                    fontSize: '13px'
                },
                children: [
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("strong", {
                        children: "Nodes referenced without add_node:"
                    }),
                    " ",
                    result.implied.join(', ')
                ]
            }),
            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: '150px',
                    overflow: 'auto',
                    background: '#2d2d2d',
                    borderRadius: '6px',
                    border: '1px solid #444'
                },
                children: /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("div", {
                    role: "region",
                    "aria-label": "Parsed Python code",
                    style: {
                        minWidth: 'max-content',
                        padding: '10px 0',
                        font: '13px/1.5 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
                        color: (0, $638ad299a2611792$export$4d67c03d46371216).plain
                    },
                    children: lines.map((line)=>{
                        const unreadable = unreadableByLine.get(line.line);
                        return /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
                            title: unreadable?.reason,
                            style: {
                                display: 'grid',
                                gridTemplateColumns: '44px minmax(max-content, 1fr)',
                                minHeight: '1.5em',
                                background: unreadable ? 'rgba(239, 68, 68, 0.38)' : 'transparent',
                                boxShadow: unreadable ? 'inset 4px 0 #ff5a5f' : 'none'
                            },
                            children: [
                                /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("span", {
                                    "aria-hidden": "true",
                                    style: {
                                        paddingRight: '10px',
                                        color: unreadable ? '#ffd6d6' : '#858b98',
                                        textAlign: 'right',
                                        userSelect: 'none'
                                    },
                                    children: line.line
                                }),
                                /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("code", {
                                    style: {
                                        paddingRight: '12px',
                                        whiteSpace: 'pre'
                                    },
                                    children: line.tokens.map((token, index)=>// eslint-disable-next-line react/no-array-index-key
                                        /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("span", {
                                            style: {
                                                color: (0, $638ad299a2611792$export$4d67c03d46371216)[token.type]
                                            },
                                            children: token.value.endsWith('\n') ? token.value.slice(0, -1) : token.value
                                        }, index))
                                })
                            ]
                        }, line.line);
                    })
                })
            }),
            result.unreadable.length > 0 && /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
                style: {
                    color: '#8f1f18',
                    fontSize: '13px'
                },
                children: [
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("strong", {
                        children: "Unreadable lines and reasons"
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("ul", {
                        style: {
                            margin: '6px 0 0',
                            paddingLeft: '20px'
                        },
                        children: result.unreadable.map((item)=>/*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("li", {
                                children: [
                                    "Line ",
                                    item.line,
                                    ": ",
                                    item.reason
                                ]
                            }, item.line))
                    })
                ]
            }),
            result.state && /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
                type: "button",
                "aria-label": "Apply parsed Python code to the current graph",
                onClick: onApply,
                style: {
                    alignSelf: 'flex-start',
                    padding: '9px 14px',
                    borderRadius: '6px',
                    border: 'none',
                    background: '#198754',
                    color: '#fff',
                    cursor: 'pointer',
                    fontSize: '14px'
                },
                children: "Apply parsed result"
            })
        ]
    });
}
function $8a208501073d048d$export$2e2bcd8739ae039({ code: code, graphName: graphName, onGraphNameChange: onGraphNameChange, stateFields: stateFields, onStateFieldsChange: onStateFieldsChange, validation: validation, onCopy: onCopy, onFocusNodes: onFocusNodes, onApplyPython: onApplyPython }) {
    const [mode, setMode] = (0, $kyXgS.useState)('generated');
    const [pythonSource, setPythonSource] = (0, $kyXgS.useState)('');
    const [importResult, setImportResult] = (0, $kyXgS.useState)(null);
    const tokens = (0, $kyXgS.useMemo)(()=>(0, $638ad299a2611792$export$2b4dd9309f97eb17)(code), [
        code
    ]);
    const handleSourceChange = (event)=>{
        setPythonSource(event.target.value);
        setImportResult(null);
    };
    const handleConvert = ()=>{
        setImportResult((0, $5821f2f277f9d237$export$9266306278d4ae62)(pythonSource));
    };
    const handleApply = ()=>{
        if (!importResult?.state) return;
        if (!onApplyPython(importResult)) return;
        setPythonSource('');
        setImportResult(null);
        setMode('generated');
    };
    return /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minHeight: 0,
            padding: '15px',
            gap: '12px'
        },
        children: [
            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '10px'
                },
                children: [
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("h2", {
                        style: {
                            margin: 0,
                            color: '#333',
                            fontSize: '18px',
                            flex: 1
                        },
                        children: mode === 'generated' ? 'Generated Code' : 'Import Python Code'
                    }),
                    mode === 'generated' && /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
                        type: "button",
                        onClick: onCopy,
                        disabled: validation.hasErrors,
                        title: validation.hasErrors ? 'Resolve errors before copying.' : 'Copy code to clipboard',
                        style: {
                            padding: '9px 14px',
                            borderRadius: '6px',
                            border: 'none',
                            background: validation.hasErrors ? '#c9ccd1' : '#007bff',
                            color: '#fff',
                            cursor: validation.hasErrors ? 'not-allowed' : 'pointer',
                            fontSize: '14px'
                        },
                        children: "Copy Code"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
                role: "group",
                "aria-label": "Code panel mode",
                style: {
                    display: 'flex'
                },
                children: [
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)($8a208501073d048d$var$ModeButton, {
                        active: mode === 'generated',
                        rounded: "6px 0 0 6px",
                        onClick: ()=>setMode('generated'),
                        children: "Generated Code"
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)($8a208501073d048d$var$ModeButton, {
                        active: mode === 'import',
                        rounded: "0 6px 6px 0",
                        onClick: ()=>setMode('import'),
                        children: "Paste Code"
                    })
                ]
            }),
            mode === 'generated' ? /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)((0, $09d47804029b6d46$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px',
                            padding: '12px',
                            background: '#f0f0f0',
                            borderRadius: '6px',
                            border: '1px solid #e0e0e0'
                        },
                        children: [
                            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("label", {
                                htmlFor: "graphNameInput",
                                style: {
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    color: '#333'
                                },
                                children: "Graph Name"
                            }),
                            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("input", {
                                id: "graphNameInput",
                                type: "text",
                                value: graphName,
                                onChange: (event)=>onGraphNameChange(event.target.value.replace(/[^A-Za-z0-9_]/g, '')),
                                placeholder: "my_workflow_graph",
                                style: {
                                    padding: '9px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    fontSize: '14px',
                                    width: '100%',
                                    boxSizing: 'border-box'
                                }
                            }),
                            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("label", {
                                htmlFor: "stateFieldsInput",
                                style: {
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    color: '#333'
                                },
                                children: [
                                    "State fields ",
                                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("span", {
                                        style: {
                                            fontWeight: 400,
                                            color: '#777'
                                        },
                                        children: [
                                            "(one ",
                                            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("code", {
                                                children: "name: type"
                                            }),
                                            " per line)"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("textarea", {
                                id: "stateFieldsInput",
                                rows: 3,
                                value: stateFields,
                                onChange: (event)=>onStateFieldsChange(event.target.value),
                                spellCheck: false,
                                style: {
                                    padding: '9px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    font: '13px monospace',
                                    width: '100%',
                                    boxSizing: 'border-box',
                                    resize: 'vertical'
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
                        style: {
                            overflowY: 'auto',
                            maxHeight: '30%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)($8a208501073d048d$var$IssueList, {
                                issues: validation.errors,
                                onFocus: onFocusNodes
                            }),
                            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)($8a208501073d048d$var$IssueList, {
                                issues: validation.warnings,
                                onFocus: onFocusNodes
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("div", {
                        style: {
                            flex: 1,
                            minHeight: '120px',
                            overflow: 'auto',
                            background: '#2d2d2d',
                            borderRadius: '6px',
                            border: '1px solid #444'
                        },
                        children: /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("pre", {
                            style: {
                                margin: 0,
                                padding: '15px',
                                font: '13px/1.5 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
                                color: (0, $638ad299a2611792$export$4d67c03d46371216).plain,
                                whiteSpace: 'pre'
                            },
                            children: /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("code", {
                                children: tokens.map((token, index)=>// eslint-disable-next-line react/no-array-index-key
                                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("span", {
                                        style: {
                                            color: (0, $638ad299a2611792$export$4d67c03d46371216)[token.type]
                                        },
                                        children: token.value
                                    }, index))
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)((0, $09d47804029b6d46$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("label", {
                        htmlFor: "pythonSourceInput",
                        style: {
                            fontSize: '13px',
                            fontWeight: 500,
                            color: '#333'
                        },
                        children: "LangGraph Python source"
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("textarea", {
                        id: "pythonSourceInput",
                        "aria-label": "LangGraph Python source to convert into a graph",
                        rows: importResult ? 6 : 14,
                        value: pythonSource,
                        onChange: handleSourceChange,
                        placeholder: "Paste Python code containing StateGraph, add_node, and add_edge calls.",
                        spellCheck: false,
                        style: {
                            padding: '10px',
                            border: '1px solid #aeb4bc',
                            borderRadius: '6px',
                            font: '13px/1.5 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
                            width: '100%',
                            boxSizing: 'border-box',
                            resize: 'vertical'
                        }
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
                        type: "button",
                        "aria-label": "Convert pasted Python code into a graph",
                        onClick: handleConvert,
                        style: {
                            alignSelf: 'flex-start',
                            padding: '9px 14px',
                            borderRadius: '6px',
                            border: 'none',
                            background: '#0d6efd',
                            color: '#fff',
                            cursor: 'pointer',
                            fontSize: '14px'
                        },
                        children: "Convert to Graph"
                    }),
                    importResult && /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)($8a208501073d048d$var$ImportReview, {
                        source: pythonSource,
                        result: importResult,
                        onApply: handleApply
                    })
                ]
            })
        ]
    });
}




var $kyXgS = parcelRequire("kyXgS");


var $kyXgS = parcelRequire("kyXgS");
const $9c4ac0b042af0ce8$export$27b8dd149e32f6c7 = /*#__PURE__*/ (0, $kyXgS.createContext)(null);
function $9c4ac0b042af0ce8$var$useEditorContext() {
    const editor = (0, $kyXgS.useContext)($9c4ac0b042af0ce8$export$27b8dd149e32f6c7);
    if (!editor) throw new Error('EditorContext.Provider is required.');
    return editor;
}
function $9c4ac0b042af0ce8$export$c5d05a2ee6a7322f(nodeId) {
    const editor = $9c4ac0b042af0ce8$var$useEditorContext();
    return {
        isEditing: editor.editingNodeId === nodeId,
        onEditClick: editor.onEditClick,
        onLabelUpdate: editor.onLabelUpdate,
        onEditCancel: editor.onEditCancel
    };
}
function $9c4ac0b042af0ce8$export$67d4741705d6f1cf() {
    return $9c4ac0b042af0ce8$var$useEditorContext().onGraphChange;
}



var $kyXgS = parcelRequire("kyXgS");
const $ef5da41f1b60b383$var$EMPTY = {
    flaggedNodeIds: new Set(),
    flaggedEdgeIds: new Set()
};
const $ef5da41f1b60b383$export$d452675449e81987 = /*#__PURE__*/ (0, $kyXgS.createContext)($ef5da41f1b60b383$var$EMPTY);
const $ef5da41f1b60b383$export$8ea4b0d90996ca26 = (id)=>(0, $kyXgS.useContext)($ef5da41f1b60b383$export$d452675449e81987).flaggedNodeIds.has(id);
const $ef5da41f1b60b383$export$da9424c2ef50647c = (id)=>(0, $kyXgS.useContext)($ef5da41f1b60b383$export$d452675449e81987).flaggedEdgeIds.has(id);


const $e1fde44a4d975604$export$46a24d47e6eff537 = 140;
function $e1fde44a4d975604$export$721a2d3f8db45ae5(sourceX, sourceY, targetX, targetY, selfLoop = false) {
    const bendsBack = selfLoop || targetY < sourceY;
    return {
        x: (sourceX + targetX) / 2 + (bendsBack ? $e1fde44a4d975604$export$46a24d47e6eff537 : 0),
        y: (sourceY + targetY) / 2
    };
}



// How far the curve bows away from the straight source -> target line.
const $f21224e76a9b78aa$var$CURVATURE_STRENGTH = 0.25;
function $f21224e76a9b78aa$var$buildPath(sourceX, sourceY, targetX, targetY, control) {
    const dx = targetX - sourceX;
    const dy = targetY - sourceY;
    const distance = Math.hypot(dx, dy);
    if (distance === 0) return `M ${sourceX},${sourceY}`;
    const offset = distance * $f21224e76a9b78aa$var$CURVATURE_STRENGTH;
    const handleX = control.x - dx / distance * offset;
    const handleY = control.y - dy / distance * offset;
    return `M ${sourceX},${sourceY} Q ${handleX},${handleY} ${control.x},${control.y} T ${targetX},${targetY}`;
}
const $f21224e76a9b78aa$var$selectEdgeMeta = (source, target)=>(store)=>{
        const sourceNode = store.nodeInternals.get(source);
        const targetNode = store.nodeInternals.get(target);
        const isBranch = sourceNode?.data?.type === 'conditional_edge';
        const adjacency = (0, $b6645270109f11ec$export$d3e3ede9ca55bc3f)({
            nodes: [
                ...store.nodeInternals.values()
            ],
            edges: store.edges
        });
        const isLoop = isBranch && (0, $b6645270109f11ec$export$4a9be9cb8ef3f267)(source, target, adjacency);
        return {
            isBranch: isBranch,
            isLoop: isLoop,
            fallbackKey: targetNode?.data?.type === 'end' ? 'end' : isLoop ? '' : targetNode?.data?.codeIdentifier || ''
        };
    };
const $f21224e76a9b78aa$var$metaEqual = (a, b)=>a.isBranch === b.isBranch && a.isLoop === b.isLoop && a.fallbackKey === b.fallbackKey;
function $f21224e76a9b78aa$export$2e2bcd8739ae039({ id: id, source: source, target: target, sourceX: sourceX, sourceY: sourceY, targetX: targetX, targetY: targetY, data: data, markerEnd: markerEnd, selected: selected }) {
    const { setEdges: setEdges, getViewport: getViewport } = (0, $b869bf1d00b93ac1$export$d820c8c2d187e1fb)();
    const hasError = (0, $ef5da41f1b60b383$export$da9424c2ef50647c)(id);
    const markGraphChanged = (0, $9c4ac0b042af0ce8$export$67d4741705d6f1cf)();
    const { isBranch: isBranch, fallbackKey: fallbackKey } = (0, $b869bf1d00b93ac1$export$6ccbb43953eebf8)($f21224e76a9b78aa$var$selectEdgeMeta(source, target), $f21224e76a9b78aa$var$metaEqual);
    const selfLoop = source === target;
    const [control, setControl] = (0, $kyXgS.useState)(()=>data?.controlPoint || (0, $e1fde44a4d975604$export$721a2d3f8db45ae5)(sourceX, sourceY, targetX, targetY, selfLoop));
    const controlRef = (0, $kyXgS.useRef)(control);
    const [drag, setDrag] = (0, $kyXgS.useState)(null);
    const [editingKey, setEditingKey] = (0, $kyXgS.useState)(false);
    const [keyDraft, setKeyDraft] = (0, $kyXgS.useState)('');
    const pinned = Boolean(data?.controlPointDragged);
    controlRef.current = control;
    (0, $kyXgS.useEffect)(()=>{
        if (!pinned) setControl((0, $e1fde44a4d975604$export$721a2d3f8db45ae5)(sourceX, sourceY, targetX, targetY, selfLoop));
    }, [
        sourceX,
        sourceY,
        targetX,
        targetY,
        pinned,
        selfLoop
    ]);
    (0, $kyXgS.useEffect)(()=>{
        if (data?.controlPoint) setControl(data.controlPoint);
    }, [
        data?.controlPoint
    ]);
    const patchEdge = (0, $kyXgS.useCallback)((patch)=>{
        const changed = Object.entries(patch).some(([key, value])=>!Object.is(data?.[key], value));
        if (!changed) return;
        markGraphChanged();
        setEdges((edges)=>edges.map((edge)=>edge.id === id ? {
                    ...edge,
                    data: {
                        ...edge.data,
                        ...patch
                    }
                } : edge));
    }, [
        data,
        markGraphChanged,
        setEdges,
        id
    ]);
    const onControlMouseDown = (0, $kyXgS.useCallback)((event)=>{
        event.stopPropagation();
        setDrag({
            x: event.clientX,
            y: event.clientY,
            originX: control.x,
            originY: control.y
        });
    }, [
        control
    ]);
    (0, $kyXgS.useEffect)(()=>{
        if (!drag) return undefined;
        const onMove = (event)=>{
            const { zoom: zoom } = getViewport();
            const nextControl = {
                x: drag.originX + (event.clientX - drag.x) / zoom,
                y: drag.originY + (event.clientY - drag.y) / zoom
            };
            controlRef.current = nextControl;
            setControl(nextControl);
        };
        const onUp = ()=>{
            setDrag(null);
            patchEdge({
                controlPoint: controlRef.current,
                controlPointDragged: true
            });
        };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        return ()=>{
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
        };
    }, [
        drag,
        getViewport,
        patchEdge
    ]);
    const resetCurve = (0, $kyXgS.useCallback)(()=>{
        markGraphChanged();
        setEdges((edges)=>edges.map((edge)=>{
                if (edge.id !== id) return edge;
                const { controlPoint: controlPoint, controlPointDragged: controlPointDragged, ...rest } = edge.data || {};
                return {
                    ...edge,
                    data: rest
                };
            }));
        setControl((0, $e1fde44a4d975604$export$721a2d3f8db45ae5)(sourceX, sourceY, targetX, targetY, selfLoop));
    }, [
        markGraphChanged,
        setEdges,
        id,
        sourceX,
        sourceY,
        targetX,
        targetY,
        selfLoop
    ]);
    const commitKey = (0, $kyXgS.useCallback)(()=>{
        setEditingKey(false);
        const next = keyDraft.trim();
        patchEdge({
            branchKey: next || undefined
        });
    }, [
        keyDraft,
        patchEdge
    ]);
    const stroke = hasError ? '#dc3545' : selected ? '#007bff' : '#555';
    const path = $f21224e76a9b78aa$var$buildPath(sourceX, sourceY, targetX, targetY, control);
    const branchKey = data?.branchKey || fallbackKey;
    return /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)((0, $09d47804029b6d46$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("path", {
                d: path,
                style: {
                    stroke: 'transparent',
                    strokeWidth: 15,
                    fill: 'none',
                    pointerEvents: 'stroke'
                }
            }),
            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("path", {
                id: id,
                className: "react-flow__edge-path",
                d: path,
                markerEnd: markerEnd,
                style: {
                    stroke: stroke,
                    strokeWidth: hasError || selected ? 2.5 : 1.5,
                    strokeDasharray: isBranch ? '5,5' : undefined,
                    fill: 'none'
                }
            }),
            isBranch && /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)((0, $b869bf1d00b93ac1$export$9646290936eecd78), {
                children: /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("div", {
                    className: "nodrag nopan",
                    style: {
                        position: 'absolute',
                        transform: `translate(-50%, -50%) translate(${control.x}px, ${control.y - 18}px)`,
                        pointerEvents: 'all'
                    },
                    children: editingKey ? /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("input", {
                        autoFocus: true,
                        value: keyDraft,
                        "aria-label": "Branch key",
                        onChange: (event)=>setKeyDraft(event.target.value),
                        onBlur: commitKey,
                        onKeyDown: (event)=>{
                            if (event.key === 'Enter') commitKey();
                            if (event.key === 'Escape') setEditingKey(false);
                        },
                        style: {
                            font: '11px monospace',
                            width: '110px',
                            padding: '2px 4px',
                            border: '1px solid #7e57c2',
                            borderRadius: '4px'
                        }
                    }) : /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
                        type: "button",
                        title: "Value returned when the router function selects this branch",
                        "aria-label": `Edit branch key ${branchKey}`,
                        onClick: (event)=>{
                            event.stopPropagation();
                            setKeyDraft(data?.branchKey || fallbackKey);
                            setEditingKey(true);
                        },
                        style: {
                            font: '11px monospace',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            border: `1px solid ${hasError ? '#dc3545' : '#b39ddb'}`,
                            background: '#f3efff',
                            color: '#4527a0',
                            cursor: 'pointer',
                            maxWidth: '140px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        },
                        children: branchKey || '(branch key)'
                    })
                })
            }),
            selected && /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)((0, $09d47804029b6d46$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("circle", {
                        cx: control.x,
                        cy: control.y,
                        r: 10,
                        fill: "transparent",
                        style: {
                            cursor: 'move'
                        },
                        onMouseDown: onControlMouseDown
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("circle", {
                        cx: control.x,
                        cy: control.y,
                        r: 6,
                        fill: "#fff",
                        stroke: "#007bff",
                        strokeWidth: 1.5,
                        style: {
                            cursor: 'move'
                        },
                        onMouseDown: onControlMouseDown
                    }),
                    pinned && /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)((0, $b869bf1d00b93ac1$export$9646290936eecd78), {
                        children: /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
                            type: "button",
                            className: "nodrag nopan",
                            onClick: resetCurve,
                            title: "Restore curve to default shape",
                            "aria-label": "Reset curve shape",
                            style: {
                                position: 'absolute',
                                transform: `translate(-50%, -50%) translate(${control.x + 22}px, ${control.y}px)`,
                                pointerEvents: 'all',
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                border: '1px solid #007bff',
                                background: '#fff',
                                color: '#007bff',
                                cursor: 'pointer',
                                fontSize: '11px',
                                lineHeight: 1,
                                padding: 0
                            },
                            children: "\u27F2"
                        })
                    })
                ]
            })
        ]
    });
}




var $kyXgS = parcelRequire("kyXgS");



const $59f06d0f67f5492f$var$BASE_STYLE = {
    padding: '10px 15px',
    borderRadius: '8px',
    position: 'relative',
    minWidth: '180px',
    cursor: 'default',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    transition: 'all 0.2s ease-in-out'
};
const $59f06d0f67f5492f$var$TYPE_STYLES = {
    start: {
        backgroundColor: '#e8f5e9',
        borderColor: '#4caf50',
        color: '#2e7d32'
    },
    end: {
        backgroundColor: '#ffebee',
        borderColor: '#f44336',
        color: '#c62828'
    },
    conditional_edge: {
        backgroundColor: '#ede7f6',
        borderColor: '#7e57c2',
        color: '#4527a0'
    },
    text: {
        backgroundColor: '#fff3e0',
        borderColor: '#ff9800',
        color: '#e65100',
        fontStyle: 'italic',
        minWidth: '200px',
        maxWidth: '300px'
    }
};
function $59f06d0f67f5492f$export$2e2bcd8739ae039({ data: data, id: id, selected: selected }) {
    const [draft, setDraft] = (0, $kyXgS.useState)(data.label || '');
    const inputRef = (0, $kyXgS.useRef)(null);
    const hasError = (0, $ef5da41f1b60b383$export$8ea4b0d90996ca26)(id);
    const { isEditing: isEditing, onEditClick: onEditClick, onLabelUpdate: onLabelUpdate, onEditCancel: onEditCancel } = (0, $9c4ac0b042af0ce8$export$c5d05a2ee6a7322f)(id);
    (0, $kyXgS.useEffect)(()=>{
        setDraft(data.label || '');
    }, [
        data.label
    ]);
    (0, $kyXgS.useEffect)(()=>{
        if (isEditing && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [
        isEditing
    ]);
    const commit = (0, $kyXgS.useCallback)(()=>onLabelUpdate(id, draft), [
        onLabelUpdate,
        draft,
        id
    ]);
    const handleKeyDown = (0, $kyXgS.useCallback)((event)=>{
        if (event.key === 'Enter') {
            event.preventDefault();
            commit();
        } else if (event.key === 'Escape') {
            event.preventDefault();
            setDraft(data.label || '');
            onEditCancel();
        }
    }, [
        commit,
        onEditCancel,
        data.label
    ]);
    const isEditable = data.type !== 'start' && data.type !== 'end';
    const style = {
        ...$59f06d0f67f5492f$var$BASE_STYLE,
        border: '1px solid #ccc',
        backgroundColor: '#fff',
        ...$59f06d0f67f5492f$var$TYPE_STYLES[data.type] || {},
        ...hasError ? {
            borderColor: '#dc3545',
            boxShadow: '0 0 0 3px rgba(220,53,69,0.25)'
        } : {}
    };
    return /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
        className: "custom-node-wrapper",
        style: style,
        title: data.codeIdentifier ? `Code name: ${data.codeIdentifier}` : `${data.label} node`,
        children: [
            selected && !isEditing && isEditable && /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
                type: "button",
                onClick: (event)=>{
                    event.stopPropagation();
                    setDraft(data.label || '');
                    onEditClick(id);
                },
                "aria-label": `Edit ${data.label} node name`,
                title: "Edit node name",
                style: {
                    position: 'absolute',
                    top: '-10px',
                    right: '-10px',
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    border: '1px solid #ddd',
                    backgroundColor: '#fff',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    padding: 0,
                    boxShadow: '0 2px 5px rgba(0,0,0,0.15)',
                    zIndex: 10
                },
                children: "\u270E"
            }),
            data.type !== 'start' && /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)((0, $b869bf1d00b93ac1$export$94890c79f4cae6d6), {
                type: "target",
                position: (0, $b869bf1d00b93ac1$export$13807d9ee5a34a42).Top,
                style: {
                    background: '#555'
                }
            }),
            isEditing ? /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("input", {
                ref: inputRef,
                value: draft,
                "aria-label": "Node name",
                onChange: (event)=>setDraft(event.target.value),
                onBlur: commit,
                onKeyDown: handleKeyDown,
                style: {
                    width: '100%',
                    border: '1px dashed #aaa',
                    outline: 'none',
                    backgroundColor: 'transparent',
                    fontSize: '14px',
                    fontWeight: '500',
                    color: 'inherit',
                    padding: '2px',
                    boxSizing: 'border-box'
                }
            }) : /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("div", {
                style: {
                    fontSize: '14px',
                    fontWeight: '500',
                    userSelect: 'none',
                    textAlign: 'center'
                },
                children: data.label || '(Unnamed)'
            }),
            data.type !== 'end' && /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)((0, $b869bf1d00b93ac1$export$94890c79f4cae6d6), {
                type: "source",
                position: (0, $b869bf1d00b93ac1$export$13807d9ee5a34a42).Bottom,
                style: {
                    background: '#555'
                }
            }),
            data.codeIdentifier && data.codeIdentifier !== data.label && /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("div", {
                style: {
                    fontSize: '10px',
                    color: '#777',
                    marginTop: '5px',
                    textAlign: 'center'
                },
                children: data.codeIdentifier
            })
        ]
    });
}




var $kyXgS = parcelRequire("kyXgS");


const $8cfa09048c352926$export$b91be528d762cda9 = {
    v: (0, $4dbddc370d338f21$export$65c3dcaa85b9883b),
    graphName: 'react_agent',
    stateFields: 'messages: Annotated[list, add_messages]',
    nodes: [
        {
            id: 'react-start',
            position: {
                x: 360,
                y: 40
            },
            data: {
                type: 'start',
                label: 'START'
            }
        },
        {
            id: 'react-agent',
            position: {
                x: 360,
                y: 180
            },
            data: {
                type: 'agent',
                label: 'Agent',
                codeIdentifier: 'Agent'
            }
        },
        {
            id: 'react-router',
            position: {
                x: 360,
                y: 320
            },
            data: {
                type: 'conditional_edge',
                label: 'Should Continue',
                codeIdentifier: 'ShouldContinue'
            }
        },
        {
            id: 'react-tool',
            position: {
                x: 40,
                y: 480
            },
            data: {
                type: 'tool',
                label: 'Tool',
                codeIdentifier: 'Tool'
            }
        },
        {
            id: 'react-end',
            position: {
                x: 680,
                y: 480
            },
            data: {
                type: 'end',
                label: 'END'
            }
        }
    ],
    edges: [
        {
            id: 'react-start-agent',
            source: 'react-start',
            target: 'react-agent'
        },
        {
            id: 'react-agent-router',
            source: 'react-agent',
            target: 'react-router'
        },
        {
            id: 'react-router-tool',
            source: 'react-router',
            target: 'react-tool',
            data: {
                branchKey: 'tools'
            }
        },
        {
            id: 'react-router-end',
            source: 'react-router',
            target: 'react-end',
            data: {
                branchKey: 'end'
            }
        },
        {
            id: 'react-tool-agent',
            source: 'react-tool',
            target: 'react-agent'
        }
    ]
};
const $8cfa09048c352926$export$968efd15567a91f8 = {
    v: (0, $4dbddc370d338f21$export$65c3dcaa85b9883b),
    graphName: 'evaluator_optimizer',
    stateFields: 'draft: str\nfeedback: str',
    nodes: [
        {
            id: 'evaluator-start',
            position: {
                x: 360,
                y: 40
            },
            data: {
                type: 'start',
                label: 'START'
            }
        },
        {
            id: 'evaluator-generator',
            position: {
                x: 360,
                y: 180
            },
            data: {
                type: 'agent',
                label: 'Generator',
                codeIdentifier: 'Generator'
            }
        },
        {
            id: 'evaluator-router',
            position: {
                x: 360,
                y: 340
            },
            data: {
                type: 'conditional_edge',
                label: 'Evaluate Draft',
                codeIdentifier: 'EvaluateDraft'
            }
        },
        {
            id: 'evaluator-end',
            position: {
                x: 680,
                y: 500
            },
            data: {
                type: 'end',
                label: 'END'
            }
        }
    ],
    edges: [
        {
            id: 'evaluator-start-generator',
            source: 'evaluator-start',
            target: 'evaluator-generator'
        },
        {
            id: 'evaluator-generator-router',
            source: 'evaluator-generator',
            target: 'evaluator-router'
        },
        {
            id: 'evaluator-router-generator',
            source: 'evaluator-router',
            target: 'evaluator-generator',
            data: {
                branchKey: 'revise'
            }
        },
        {
            id: 'evaluator-router-end',
            source: 'evaluator-router',
            target: 'evaluator-end',
            data: {
                branchKey: 'accepted'
            }
        }
    ]
};
const $8cfa09048c352926$export$eab28bd267ce56a5 = {
    v: (0, $4dbddc370d338f21$export$65c3dcaa85b9883b),
    graphName: 'prompt_chaining',
    stateFields: 'input: str\nextracted: str\nsummary: str',
    nodes: [
        {
            id: 'chaining-start',
            position: {
                x: 360,
                y: 40
            },
            data: {
                type: 'start',
                label: 'START'
            }
        },
        {
            id: 'chaining-extract',
            position: {
                x: 360,
                y: 180
            },
            data: {
                type: 'agent',
                label: 'Extract',
                codeIdentifier: 'Extract'
            }
        },
        {
            id: 'chaining-gate',
            position: {
                x: 360,
                y: 320
            },
            data: {
                type: 'conditional_edge',
                label: 'Quality Gate',
                codeIdentifier: 'QualityGate'
            }
        },
        {
            id: 'chaining-summarize',
            position: {
                x: 40,
                y: 480
            },
            data: {
                type: 'agent',
                label: 'Summarize',
                codeIdentifier: 'Summarize'
            }
        },
        {
            id: 'chaining-end',
            position: {
                x: 360,
                y: 650
            },
            data: {
                type: 'end',
                label: 'END'
            }
        }
    ],
    edges: [
        {
            id: 'chaining-start-extract',
            source: 'chaining-start',
            target: 'chaining-extract'
        },
        {
            id: 'chaining-extract-gate',
            source: 'chaining-extract',
            target: 'chaining-gate'
        },
        {
            id: 'chaining-gate-summarize',
            source: 'chaining-gate',
            target: 'chaining-summarize',
            data: {
                branchKey: 'continue'
            }
        },
        {
            id: 'chaining-gate-end',
            source: 'chaining-gate',
            target: 'chaining-end',
            data: {
                branchKey: 'end'
            }
        },
        {
            id: 'chaining-summarize-end',
            source: 'chaining-summarize',
            target: 'chaining-end'
        }
    ]
};
const $8cfa09048c352926$export$b274f48589fa579d = {
    v: (0, $4dbddc370d338f21$export$65c3dcaa85b9883b),
    graphName: 'routing_workflow',
    stateFields: 'request: str\nroute: str\nresult: str',
    nodes: [
        {
            id: 'routing-start',
            position: {
                x: 360,
                y: 40
            },
            data: {
                type: 'start',
                label: 'START'
            }
        },
        {
            id: 'routing-router',
            position: {
                x: 360,
                y: 180
            },
            data: {
                type: 'conditional_edge',
                label: 'Route Request',
                codeIdentifier: 'RouteRequest'
            }
        },
        {
            id: 'routing-research',
            position: {
                x: 40,
                y: 360
            },
            data: {
                type: 'agent',
                label: 'Research',
                codeIdentifier: 'Research'
            }
        },
        {
            id: 'routing-creative',
            position: {
                x: 360,
                y: 360
            },
            data: {
                type: 'agent',
                label: 'Creative',
                codeIdentifier: 'Creative'
            }
        },
        {
            id: 'routing-support',
            position: {
                x: 680,
                y: 360
            },
            data: {
                type: 'agent',
                label: 'Support',
                codeIdentifier: 'Support'
            }
        },
        {
            id: 'routing-end',
            position: {
                x: 360,
                y: 560
            },
            data: {
                type: 'end',
                label: 'END'
            }
        }
    ],
    edges: [
        {
            id: 'routing-start-router',
            source: 'routing-start',
            target: 'routing-router'
        },
        {
            id: 'routing-router-research',
            source: 'routing-router',
            target: 'routing-research',
            data: {
                branchKey: 'research'
            }
        },
        {
            id: 'routing-router-creative',
            source: 'routing-router',
            target: 'routing-creative',
            data: {
                branchKey: 'creative'
            }
        },
        {
            id: 'routing-router-support',
            source: 'routing-router',
            target: 'routing-support',
            data: {
                branchKey: 'support'
            }
        },
        {
            id: 'routing-research-end',
            source: 'routing-research',
            target: 'routing-end'
        },
        {
            id: 'routing-creative-end',
            source: 'routing-creative',
            target: 'routing-end'
        },
        {
            id: 'routing-support-end',
            source: 'routing-support',
            target: 'routing-end'
        }
    ]
};
const $8cfa09048c352926$export$d72fde873b9b76bb = {
    v: (0, $4dbddc370d338f21$export$65c3dcaa85b9883b),
    graphName: 'parallel_branch',
    stateFields: 'input: str\nleft_result: str\nright_result: str\nresult: str',
    nodes: [
        {
            id: 'parallel-start',
            position: {
                x: 360,
                y: 40
            },
            data: {
                type: 'start',
                label: 'START'
            }
        },
        {
            id: 'parallel-a',
            position: {
                x: 120,
                y: 220
            },
            data: {
                type: 'agent',
                label: 'Branch A',
                codeIdentifier: 'BranchA'
            }
        },
        {
            id: 'parallel-b',
            position: {
                x: 600,
                y: 220
            },
            data: {
                type: 'agent',
                label: 'Branch B',
                codeIdentifier: 'BranchB'
            }
        },
        {
            id: 'parallel-aggregate',
            position: {
                x: 360,
                y: 420
            },
            data: {
                type: 'agent',
                label: 'Aggregate',
                codeIdentifier: 'Aggregate'
            }
        },
        {
            id: 'parallel-end',
            position: {
                x: 360,
                y: 580
            },
            data: {
                type: 'end',
                label: 'END'
            }
        }
    ],
    edges: [
        {
            id: 'parallel-start-a',
            source: 'parallel-start',
            target: 'parallel-a'
        },
        {
            id: 'parallel-start-b',
            source: 'parallel-start',
            target: 'parallel-b'
        },
        {
            id: 'parallel-a-aggregate',
            source: 'parallel-a',
            target: 'parallel-aggregate'
        },
        {
            id: 'parallel-b-aggregate',
            source: 'parallel-b',
            target: 'parallel-aggregate'
        },
        {
            id: 'parallel-aggregate-end',
            source: 'parallel-aggregate',
            target: 'parallel-end'
        }
    ]
};
const $8cfa09048c352926$export$d0b9b51bc2ae00e9 = Object.freeze([
    {
        id: 'react-agent',
        label: 'ReAct Agent',
        description: 'A router loop that returns to Agent after a tool call',
        graph: $8cfa09048c352926$export$b91be528d762cda9
    },
    {
        id: 'evaluator-optimizer',
        label: 'Reflection Loop',
        description: 'An Evaluator-Optimizer that repeats generation based on evaluation results',
        graph: $8cfa09048c352926$export$968efd15567a91f8
    },
    {
        id: 'prompt-chaining',
        label: 'Sequential Pipeline',
        description: 'Passes only quality-gated results to the next step',
        graph: $8cfa09048c352926$export$eab28bd267ce56a5
    },
    {
        id: 'routing',
        label: 'Routing',
        description: 'Routes a request to one of three tasks immediately after START',
        graph: $8cfa09048c352926$export$b274f48589fa579d
    },
    {
        id: 'parallel-branch',
        label: 'Parallel Branches',
        description: 'Starts two tasks from START, then aggregates the results',
        graph: $8cfa09048c352926$export$d72fde873b9b76bb
    }
]);
const $8cfa09048c352926$var$TEMPLATE_BY_ID = new Map($8cfa09048c352926$export$d0b9b51bc2ae00e9.map((template)=>[
        template.id,
        template.graph
    ]));
const $8cfa09048c352926$export$7248111b40db6f2f = (templateId)=>$8cfa09048c352926$var$TEMPLATE_BY_ID.has(templateId);
function $8cfa09048c352926$export$b9d5af8c001653b8(templateId) {
    const template = $8cfa09048c352926$var$TEMPLATE_BY_ID.get(templateId);
    return template ? JSON.parse(JSON.stringify(template)) : null;
}


const $b48db40a6be63bf4$var$actionStyle = (color)=>({
        padding: '10px 15px',
        borderRadius: '6px',
        border: `1px solid ${color}`,
        background: '#fff',
        color: color,
        cursor: 'pointer',
        fontSize: '14px',
        width: '100%',
        transition: 'all 0.2s ease'
    });
function $b48db40a6be63bf4$var$ActionButton({ color: color, onClick: onClick, ariaLabel: ariaLabel, children: children }) {
    return /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
        type: "button",
        onClick: onClick,
        "aria-label": ariaLabel,
        style: $b48db40a6be63bf4$var$actionStyle(color),
        onMouseEnter: (event)=>{
            event.currentTarget.style.background = color;
            event.currentTarget.style.color = '#fff';
        },
        onMouseLeave: (event)=>{
            event.currentTarget.style.background = '#fff';
            event.currentTarget.style.color = color;
        },
        children: children
    });
}
function $b48db40a6be63bf4$export$2e2bcd8739ae039({ onAddNode: onAddNode, onNodeDragStart: onNodeDragStart, onLoadTemplate: onLoadTemplate, onReset: onReset, onCopyUrl: onCopyUrl, takenTypes: takenTypes }) {
    const [selectedTemplateId, setSelectedTemplateId] = (0, $kyXgS.useState)((0, $8cfa09048c352926$export$d0b9b51bc2ae00e9)[0].id);
    const selectedTemplate = (0, $8cfa09048c352926$export$d0b9b51bc2ae00e9).find(({ id: id })=>id === selectedTemplateId);
    return /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflowY: 'auto',
            padding: '15px'
        },
        children: [
            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("h2", {
                style: {
                    marginTop: 0,
                    marginBottom: '6px',
                    color: '#333',
                    fontSize: '18px'
                },
                children: "Add nodes"
            }),
            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("p", {
                style: {
                    margin: '0 0 15px',
                    fontSize: '12px',
                    color: '#777'
                },
                children: "Drag a node onto the canvas, or click to add it at the center of the view."
            }),
            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px'
                },
                children: (0, $0f96f2a40cf4a802$export$56306d5c07fe221a).map((key)=>{
                    const nodeType = (0, $0f96f2a40cf4a802$export$a473c43a4db1086c)[key];
                    const disabled = Boolean(nodeType.singleton && takenTypes.has(key));
                    return /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
                        type: "button",
                        draggable: !disabled,
                        disabled: disabled,
                        title: disabled ? `A ${nodeType.label} node already exists.` : nodeType.hint,
                        onDragStart: (event)=>{
                            event.dataTransfer.setData('application/reactflow', key);
                            event.dataTransfer.effectAllowed = 'move';
                            onNodeDragStart();
                        },
                        onClick: ()=>onAddNode(key),
                        style: {
                            padding: '12px 15px',
                            border: '1px solid #ddd',
                            borderRadius: '6px',
                            background: disabled ? '#f1f1f1' : '#fff',
                            cursor: disabled ? 'not-allowed' : 'grab',
                            textAlign: 'center',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: disabled ? '#aaa' : '#444',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                        },
                        children: nodeType.label
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("hr", {
                style: {
                    margin: '25px 0',
                    border: 0,
                    borderTop: '1px solid #eee'
                }
            }),
            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("section", {
                "aria-labelledby": "template-heading",
                children: [
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("h2", {
                        id: "template-heading",
                        style: {
                            margin: '0 0 6px',
                            color: '#333',
                            fontSize: '18px'
                        },
                        children: "Templates"
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("p", {
                        style: {
                            margin: '0 0 10px',
                            fontSize: '12px',
                            color: '#777',
                            lineHeight: 1.4
                        },
                        children: "Load an initial graph structure. You will be asked before the current graph is replaced."
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("label", {
                        htmlFor: "graph-template-select",
                        style: {
                            display: 'block',
                            marginBottom: '5px',
                            fontSize: '13px'
                        },
                        children: "Select a graph template"
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("select", {
                        id: "graph-template-select",
                        "aria-label": "Select a graph template",
                        value: selectedTemplateId,
                        onChange: (event)=>setSelectedTemplateId(event.target.value),
                        style: {
                            width: '100%',
                            padding: '9px',
                            border: '1px solid #ccc',
                            borderRadius: '6px',
                            background: '#fff'
                        },
                        children: (0, $8cfa09048c352926$export$d0b9b51bc2ae00e9).map(({ id: id, label: label })=>/*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("option", {
                                value: id,
                                children: label
                            }, id))
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("p", {
                        style: {
                            minHeight: '34px',
                            margin: '7px 0 9px',
                            fontSize: '12px',
                            color: '#666',
                            lineHeight: 1.4
                        },
                        children: selectedTemplate?.description
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)($b48db40a6be63bf4$var$ActionButton, {
                        color: "#7c3aed",
                        ariaLabel: "Load the selected graph template",
                        onClick: ()=>onLoadTemplate(selectedTemplateId),
                        children: "Load template"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("hr", {
                style: {
                    margin: '25px 0',
                    border: 0,
                    borderTop: '1px solid #eee'
                }
            }),
            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px'
                },
                children: [
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)($b48db40a6be63bf4$var$ActionButton, {
                        color: "#28a745",
                        onClick: onCopyUrl,
                        children: "Copy URL"
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)($b48db40a6be63bf4$var$ActionButton, {
                        color: "#dc3545",
                        onClick: onReset,
                        children: "Reset all"
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)($b48db40a6be63bf4$var$ActionButton, {
                        color: "#6c757d",
                        onClick: ()=>window.open('https://github.com/sjkwon1023/langgraph_cad/tree/main', '_blank', 'noopener'),
                        children: "Readme"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
                style: {
                    marginTop: 'auto',
                    paddingTop: '20px',
                    fontSize: '12px',
                    color: '#bbb',
                    lineHeight: 1.4
                },
                children: [
                    "Sejin Kwon",
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("br", {}),
                    "sjkwon1023@gmail.com"
                ]
            })
        ]
    });
}




var $kyXgS = parcelRequire("kyXgS");
const $b4e256a915787c5b$var$TONES = {
    info: {
        background: '#0d6efd'
    },
    success: {
        background: '#198754'
    },
    error: {
        background: '#dc3545'
    }
};
function $b4e256a915787c5b$export$c0652d2bc181de70(timeout = 5000) {
    const [toasts, setToasts] = (0, $kyXgS.useState)([]);
    const counter = (0, $kyXgS.useRef)(0);
    const timers = (0, $kyXgS.useRef)(new Set());
    const dismiss = (0, $kyXgS.useCallback)((id)=>{
        setToasts((current)=>current.filter((toast)=>toast.id !== id));
    }, []);
    const push = (0, $kyXgS.useCallback)((message, tone = 'info')=>{
        counter.current += 1;
        const id = counter.current;
        setToasts((current)=>[
                ...current,
                {
                    id: id,
                    message: message,
                    tone: tone
                }
            ]);
        const timer = setTimeout(()=>{
            timers.current.delete(timer);
            dismiss(id);
        }, timeout);
        timers.current.add(timer);
    }, [
        dismiss,
        timeout
    ]);
    (0, $kyXgS.useEffect)(()=>{
        const pending = timers.current;
        return ()=>{
            pending.forEach(clearTimeout);
            pending.clear();
        };
    }, []);
    return {
        toasts: toasts,
        push: push,
        dismiss: dismiss
    };
}
function $b4e256a915787c5b$export$d82decde2bdd5075({ toasts: toasts, onDismiss: onDismiss }) {
    return /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("div", {
        role: "status",
        "aria-live": "polite",
        style: {
            position: 'fixed',
            bottom: '16px',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            zIndex: 1000,
            maxWidth: 'min(560px, calc(100vw - 32px))'
        },
        children: toasts.map((toast)=>/*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
                style: {
                    ...$b4e256a915787c5b$var$TONES[toast.tone],
                    color: '#fff',
                    padding: '10px 14px',
                    borderRadius: '6px',
                    boxShadow: '0 4px 14px rgba(0,0,0,0.2)',
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                },
                children: [
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("span", {
                        style: {
                            flex: 1
                        },
                        children: toast.message
                    }),
                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onDismiss(toast.id),
                        "aria-label": "Dismiss notification",
                        style: {
                            background: 'transparent',
                            border: 'none',
                            color: 'inherit',
                            cursor: 'pointer',
                            fontSize: '16px',
                            lineHeight: 1,
                            padding: 0
                        },
                        children: "\xd7"
                    })
                ]
            }, toast.id))
    });
}




const $6f4549903038110a$var$DEFAULT_STEP = 48;
const $6f4549903038110a$var$clamp = (value, minimum, maximum)=>Math.min(Math.max(value, minimum), maximum);
const $6f4549903038110a$var$positionKey = ({ x: x, y: y })=>`${x}:${y}`;
function $6f4549903038110a$export$25f9c1d511a24805(basePosition, existingNodes, bounds, step = $6f4549903038110a$var$DEFAULT_STEP) {
    const minimumX = Math.min(bounds.minX, bounds.maxX);
    const maximumX = Math.max(bounds.minX, bounds.maxX);
    const minimumY = Math.min(bounds.minY, bounds.maxY);
    const maximumY = Math.max(bounds.minY, bounds.maxY);
    const base = {
        x: $6f4549903038110a$var$clamp(basePosition.x, minimumX, maximumX),
        y: $6f4549903038110a$var$clamp(basePosition.y, minimumY, maximumY)
    };
    const occupied = new Set(existingNodes.map((node)=>$6f4549903038110a$var$positionKey(node.position)));
    const candidates = [];
    const candidateKeys = new Set();
    const addCandidate = (x, y)=>{
        const candidate = {
            x: $6f4549903038110a$var$clamp(x, minimumX, maximumX),
            y: $6f4549903038110a$var$clamp(y, minimumY, maximumY)
        };
        const key = $6f4549903038110a$var$positionKey(candidate);
        if (!candidateKeys.has(key)) {
            candidateKeys.add(key);
            candidates.push(candidate);
        }
    };
    addCandidate(base.x, base.y);
    const maximumDistance = Math.max(maximumX - minimumX, maximumY - minimumY);
    const maximumSteps = Math.ceil(maximumDistance / step);
    const directions = [
        [
            1,
            1
        ],
        [
            -1,
            -1
        ],
        [
            1,
            -1
        ],
        [
            -1,
            1
        ],
        [
            1,
            0
        ],
        [
            -1,
            0
        ],
        [
            0,
            1
        ],
        [
            0,
            -1
        ]
    ];
    for (const [directionX, directionY] of directions)for(let distance = 1; distance <= maximumSteps; distance += 1){
        const offset = distance * step;
        addCandidate(base.x + directionX * offset, base.y + directionY * offset);
    }
    return candidates.find((candidate)=>!occupied.has($6f4549903038110a$var$positionKey(candidate))) || base;
}









const $1dcacb4f32b4e5d7$var$error = (id, message, refs = {})=>({
        id: id,
        level: 'error',
        message: message,
        nodeIds: [],
        edgeIds: [],
        ...refs
    });
const $1dcacb4f32b4e5d7$var$warn = (id, message, refs = {})=>({
        id: id,
        level: 'warning',
        message: message,
        nodeIds: [],
        edgeIds: [],
        ...refs
    });
function $1dcacb4f32b4e5d7$export$ed3e6c81d6921774({ nodes: nodes = [], edges: edges = [], graphName: graphName = '', stateFields: stateFields = '' } = {}) {
    const issues = [];
    const byId = new Map(nodes.map((node)=>[
            node.id,
            node
        ]));
    const typeOf = (id)=>byId.get(id)?.data?.type;
    const labelOf = (id)=>byId.get(id)?.data?.label || id;
    const startNodes = nodes.filter((node)=>node.data?.type === 'start');
    const endNodes = nodes.filter((node)=>node.data?.type === 'end');
    const codeNodes = nodes.filter((node)=>(0, $0f96f2a40cf4a802$export$e8c7195f7e503a51)(node.data?.type));
    const routerNodes = nodes.filter((node)=>node.data?.type === 'conditional_edge');
    const liveEdges = edges.filter((edge)=>byId.has(edge.source) && byId.has(edge.target));
    // --- graph-level settings ---
    if (!(0, $309118e693f668de$export$6421a5e13ad6bdd7)(graphName)) issues.push($1dcacb4f32b4e5d7$var$error('invalid-graph-name', `Graph name "${graphName}" cannot be used as a Python identifier.`));
    const parsedStateFields = (0, $025995cee117ee16$export$23b3128d1e332759)(stateFields);
    parsedStateFields.invalid.forEach((line)=>{
        issues.push($1dcacb4f32b4e5d7$var$error('invalid-state-field', `State field "${line}" must use the "name: type" format.`));
    });
    (0, $025995cee117ee16$export$e45b44879ac03376)(parsedStateFields.fields).unknownNames.forEach((name)=>{
        issues.push($1dcacb4f32b4e5d7$var$warn('unknown-state-annotation-symbol', `State field "${name}" is not imported automatically \u{2014} add its import to the top of the generated code.`));
    });
    // --- START / END ---
    if (startNodes.length === 0) issues.push($1dcacb4f32b4e5d7$var$error('no-start', 'A START node is required to define the graph entry point.'));
    if (startNodes.length > 1) issues.push($1dcacb4f32b4e5d7$var$error('multiple-start', 'There must be exactly one START node.', {
        nodeIds: startNodes.map((node)=>node.id)
    }));
    if (endNodes.length > 1) issues.push($1dcacb4f32b4e5d7$var$error('multiple-end', 'There must be exactly one END node.', {
        nodeIds: endNodes.map((node)=>node.id)
    }));
    if (endNodes.length === 0) issues.push($1dcacb4f32b4e5d7$var$warn('no-end', 'There is no END node. Defining an explicit end point is recommended.'));
    startNodes.forEach((node)=>{
        if (!liveEdges.some((edge)=>edge.source === node.id)) issues.push($1dcacb4f32b4e5d7$var$error('start-no-outgoing', 'The START node is not connected to any node.', {
            nodeIds: [
                node.id
            ]
        }));
        const incoming = liveEdges.filter((edge)=>edge.target === node.id);
        if (incoming.length > 0) issues.push($1dcacb4f32b4e5d7$var$error('start-incoming', 'Edges into the START node are not allowed.', {
            nodeIds: [
                node.id
            ],
            edgeIds: incoming.map((edge)=>edge.id)
        }));
    });
    endNodes.forEach((node)=>{
        const outgoing = liveEdges.filter((edge)=>edge.source === node.id);
        if (outgoing.length > 0) issues.push($1dcacb4f32b4e5d7$var$error('end-outgoing', 'Edges out of the END node are not allowed.', {
            nodeIds: [
                node.id
            ],
            edgeIds: outgoing.map((edge)=>edge.id)
        }));
    });
    // --- node names ---
    const seenNames = new Map();
    codeNodes.forEach((node)=>{
        const name = node.data?.codeIdentifier;
        if ((0, $309118e693f668de$export$b0374bdaac8a7e4c).has(name)) issues.push($1dcacb4f32b4e5d7$var$error('reserved-node-name', `"${name}" is reserved by LangGraph and cannot be used as a node name.`, {
            nodeIds: [
                node.id
            ]
        }));
        if (seenNames.has(name)) issues.push($1dcacb4f32b4e5d7$var$error('duplicate-node-name', `The node name "${name}" is duplicated.`, {
            nodeIds: [
                seenNames.get(name),
                node.id
            ]
        }));
        else seenNames.set(name, node.id);
    });
    // --- conditional routers ---
    const plan = (0, $025995cee117ee16$export$9934590481ce934a)({
        nodes: nodes,
        edges: edges,
        graphName: graphName,
        stateFields: stateFields
    });
    routerNodes.forEach((node)=>{
        const label = node.data?.label || 'Conditional Edge';
        const outgoing = liveEdges.filter((edge)=>edge.source === node.id);
        const incoming = liveEdges.filter((edge)=>edge.target === node.id);
        const chained = outgoing.filter((edge)=>typeOf(edge.target) === 'conditional_edge');
        chained.forEach((edge)=>{
            issues.push($1dcacb4f32b4e5d7$var$error('conditional-chain', `Conditional Edge "${label}" cannot connect directly to another Conditional Edge.`, {
                nodeIds: [
                    node.id,
                    edge.target
                ],
                edgeIds: [
                    edge.id
                ]
            }));
        });
        const branchEdges = outgoing.filter((edge)=>plan.asTarget(edge.target));
        if (branchEdges.length === 0) issues.push($1dcacb4f32b4e5d7$var$error('conditional-no-target', `Conditional Edge "${label}" has no outgoing branch, so no code can be generated for it.`, {
            nodeIds: [
                node.id
            ]
        }));
        if (incoming.filter((edge)=>plan.asSource(edge.source)).length === 0) issues.push($1dcacb4f32b4e5d7$var$error('conditional-no-source', `Conditional Edge "${label}" has no incoming node, so no code can be generated for it.`, {
            nodeIds: [
                node.id
            ]
        }));
        const routerPlan = plan.allRouters.find((router)=>router.nodeId === node.id);
        const branchByEdgeId = new Map((routerPlan?.branches || []).map((branch)=>[
                branch.edgeId,
                branch
            ]));
        const keys = new Map();
        branchEdges.forEach((edge)=>{
            const branch = branchByEdgeId.get(edge.id);
            const key = branch?.key ?? '';
            if (branch?.isLoop && !branch.hasExplicitKey) issues.push($1dcacb4f32b4e5d7$var$error('missing-loop-branch-key', `The loop branch of Conditional Edge "${label}" needs a meaningful branch key such as revise or retry.`, {
                nodeIds: [
                    node.id,
                    edge.target
                ],
                edgeIds: [
                    edge.id
                ]
            }));
            if (keys.has(key)) issues.push($1dcacb4f32b4e5d7$var$error('duplicate-branch-key', `Conditional Edge "${label}" has a duplicate branch key "${key}".`, {
                nodeIds: [
                    node.id
                ],
                edgeIds: [
                    keys.get(key),
                    edge.id
                ]
            }));
            else keys.set(key, edge.id);
        });
    });
    // --- connectivity ---
    const routable = nodes.filter((node)=>node.data?.type !== 'text');
    const forward = (0, $b6645270109f11ec$export$d3e3ede9ca55bc3f)({
        nodes: nodes,
        edges: liveEdges
    });
    const backward = (0, $b6645270109f11ec$export$d3e3ede9ca55bc3f)({
        nodes: nodes,
        edges: liveEdges
    }, {
        reverse: true
    });
    if (startNodes.length > 0) {
        const reached = (0, $b6645270109f11ec$export$238baef9bde70669)(startNodes.map((node)=>node.id), forward);
        routable.filter((node)=>node.data?.type !== 'start' && !reached.has(node.id)).forEach((node)=>{
            issues.push($1dcacb4f32b4e5d7$var$warn('unreachable', `"${labelOf(node.id)}" cannot be reached from START.`, {
                nodeIds: [
                    node.id
                ]
            }));
        });
    }
    if (endNodes.length > 0) {
        const terminating = (0, $b6645270109f11ec$export$238baef9bde70669)(endNodes.map((node)=>node.id), backward);
        codeNodes.filter((node)=>!terminating.has(node.id)).forEach((node)=>{
            issues.push($1dcacb4f32b4e5d7$var$warn('no-path-to-end', `There is no path from "${labelOf(node.id)}" to END.`, {
                nodeIds: [
                    node.id
                ]
            }));
        });
    }
    routable.filter((node)=>!liveEdges.some((edge)=>edge.source === node.id || edge.target === node.id)).forEach((node)=>{
        issues.push($1dcacb4f32b4e5d7$var$warn('orphan', `"${labelOf(node.id)}" has no connected edges.`, {
            nodeIds: [
                node.id
            ]
        }));
    });
    const errors = issues.filter((issue)=>issue.level === 'error');
    const warnings = issues.filter((issue)=>issue.level === 'warning');
    return {
        issues: issues,
        errors: errors,
        warnings: warnings,
        hasErrors: errors.length > 0,
        flaggedNodeIds: new Set(errors.flatMap((issue)=>issue.nodeIds)),
        flaggedEdgeIds: new Set(errors.flatMap((issue)=>issue.edgeIds))
    };
}




const $2a1b924e1aad9c45$var$CUSTOM_NODE_TYPES = {
    custom: (0, $59f06d0f67f5492f$export$2e2bcd8739ae039)
};
const $2a1b924e1aad9c45$var$EDGE_TYPES = {
    customEdge: (0, $f21224e76a9b78aa$export$2e2bcd8739ae039)
};
const $2a1b924e1aad9c45$var$DEFAULT_EDGE_OPTIONS = {
    type: 'customEdge',
    data: {},
    markerEnd: {
        type: (0, $b869bf1d00b93ac1$export$196ed004c7fb0ef2).ArrowClosed,
        color: '#555',
        width: 15,
        height: 15
    }
};
function $2a1b924e1aad9c45$var$hydrateState(state) {
    return {
        graphName: state.graphName,
        stateFields: state.stateFields,
        nodes: state.nodes.map((0, $4dbddc370d338f21$export$d7cf40567ee3d83d)),
        edges: state.edges.map((0, $4dbddc370d338f21$export$ca2260abc4aabad5))
    };
}
function $2a1b924e1aad9c45$var$initializeEditor() {
    const decoded = (0, $4dbddc370d338f21$export$f011bbd5d4754f0f)(window.location.hash);
    if (!decoded.ok) return {
        ...$2a1b924e1aad9c45$var$hydrateState((0, $4dbddc370d338f21$export$de5e90bd767c5d82)()),
        decodeError: decoded.reason,
        fitLoadedGraph: false
    };
    const state = decoded.state || (0, $4dbddc370d338f21$export$de5e90bd767c5d82)();
    return {
        ...$2a1b924e1aad9c45$var$hydrateState(state),
        decodeError: null,
        fitLoadedGraph: Boolean(decoded.state)
    };
}
function $2a1b924e1aad9c45$var$structuralSnapshot(nodes, edges, graphName, stateFields) {
    return {
        graphName: graphName,
        stateFields: stateFields,
        nodes: nodes.map((node)=>({
                id: node.id,
                data: {
                    type: node.data.type,
                    label: node.data.label,
                    codeIdentifier: node.data.codeIdentifier
                }
            })),
        edges: edges.map((edge)=>({
                id: edge.id,
                source: edge.source,
                target: edge.target,
                data: {
                    branchKey: edge.data?.branchKey
                }
            }))
    };
}
const $2a1b924e1aad9c45$var$persistedNodesSignature = (nodes)=>JSON.stringify((0, $4dbddc370d338f21$export$1244e9dd32dc68ea)({
        nodes: nodes
    }).nodes);
const $2a1b924e1aad9c45$var$persistedEdgesSignature = (edges)=>JSON.stringify((0, $4dbddc370d338f21$export$1244e9dd32dc68ea)({
        edges: edges
    }).edges);
function $2a1b924e1aad9c45$var$useNarrowLayout() {
    const [isNarrow, setIsNarrow] = (0, $kyXgS.useState)(()=>window.matchMedia('(max-width: 900px)').matches);
    (0, $kyXgS.useEffect)(()=>{
        const query = window.matchMedia('(max-width: 900px)');
        const update = (event)=>setIsNarrow(event.matches);
        query.addEventListener('change', update);
        return ()=>query.removeEventListener('change', update);
    }, []);
    return isNarrow;
}
function $2a1b924e1aad9c45$export$2e2bcd8739ae039() {
    const [initial] = (0, $kyXgS.useState)($2a1b924e1aad9c45$var$initializeEditor);
    const [nodes, setNodes] = (0, $b869bf1d00b93ac1$export$bd078ae466d36fdb)(initial.nodes);
    const [edges, setEdges] = (0, $b869bf1d00b93ac1$export$e087148e8ce6c014)(initial.edges);
    const [graphName, setGraphName] = (0, $kyXgS.useState)(initial.graphName);
    const [stateFields, setStateFields] = (0, $kyXgS.useState)(initial.stateFields);
    const [editingNodeId, setEditingNodeId] = (0, $kyXgS.useState)(null);
    const [mobileView, setMobileView] = (0, $kyXgS.useState)('editor');
    const [paletteOpen, setPaletteOpen] = (0, $kyXgS.useState)(false);
    const [fitRequest, setFitRequest] = (0, $kyXgS.useState)(null);
    const [urlSaveRequest, setUrlSaveRequest] = (0, $kyXgS.useState)(0);
    const canvasRef = (0, $kyXgS.useRef)(null);
    const currentStateRef = (0, $kyXgS.useRef)(null);
    const edgesRef = (0, $kyXgS.useRef)(edges);
    const nodesRef = (0, $kyXgS.useRef)(nodes);
    const nextId = (0, $kyXgS.useRef)(0);
    const pendingUrlSave = (0, $kyXgS.useRef)(null);
    const urlSaveEpoch = (0, $kyXgS.useRef)(0);
    const warnedAboutHashLength = (0, $kyXgS.useRef)(false);
    const initialToastShown = (0, $kyXgS.useRef)(false);
    const { fitView: fitView, screenToFlowPosition: screenToFlowPosition } = (0, $b869bf1d00b93ac1$export$d820c8c2d187e1fb)();
    const nodesInitialized = (0, $b869bf1d00b93ac1$export$7ccf5bebb24321d8)();
    const isNarrow = $2a1b924e1aad9c45$var$useNarrowLayout();
    const { toasts: toasts, push: push, dismiss: dismiss } = (0, $b4e256a915787c5b$export$c0652d2bc181de70)();
    nodesRef.current = nodes;
    edgesRef.current = edges;
    const cancelPendingUrlSave = (0, $kyXgS.useCallback)(()=>{
        urlSaveEpoch.current += 1;
        if (pendingUrlSave.current !== null) {
            window.clearTimeout(pendingUrlSave.current);
            pendingUrlSave.current = null;
        }
    }, []);
    const requestUrlSave = (0, $kyXgS.useCallback)(()=>{
        cancelPendingUrlSave();
        setUrlSaveRequest((current)=>current + 1);
    }, [
        cancelPendingUrlSave
    ]);
    (0, $kyXgS.useEffect)(()=>{
        if (initial.decodeError && !initialToastShown.current) {
            initialToastShown.current = true;
            push(initial.decodeError, 'error');
        }
    }, [
        initial.decodeError,
        push
    ]);
    (0, $kyXgS.useEffect)(()=>{
        if (!fitRequest) return undefined;
        if (fitRequest.nodeIds.length === 0) {
            setFitRequest(null);
            return undefined;
        }
        if (!nodesInitialized) return undefined;
        const frame = requestAnimationFrame(()=>{
            const fitted = fitView({
                nodes: fitRequest.nodeIds.map((id)=>({
                        id: id
                    })),
                padding: 0.2,
                duration: 250
            });
            if (fitted || fitRequest.attemptsLeft <= 1) setFitRequest(null);
            else setFitRequest((current)=>current ? {
                    ...current,
                    attemptsLeft: current.attemptsLeft - 1
                } : current);
        });
        return ()=>cancelAnimationFrame(frame);
    }, [
        fitRequest,
        fitView,
        nodesInitialized
    ]);
    const currentState = (0, $kyXgS.useMemo)(()=>({
            nodes: nodes,
            edges: edges,
            graphName: graphName,
            stateFields: stateFields
        }), [
        nodes,
        edges,
        graphName,
        stateFields
    ]);
    currentStateRef.current = currentState;
    (0, $kyXgS.useEffect)(()=>{
        if (urlSaveRequest === 0) return undefined;
        const epoch = urlSaveEpoch.current;
        const stateToSave = currentStateRef.current;
        const timer = window.setTimeout(()=>{
            if (epoch !== urlSaveEpoch.current) return;
            pendingUrlSave.current = null;
            try {
                const hash = `#${(0, $4dbddc370d338f21$export$ba5ae29bdb29802d)(stateToSave)}`;
                if (hash.length > (0, $4dbddc370d338f21$export$27ea7785c5c74343) && !warnedAboutHashLength.current) {
                    warnedAboutHashLength.current = true;
                    push('The share URL is very long and may not work in some apps or browsers.', 'info');
                }
                if (hash === window.location.hash) return;
                window.history.replaceState(null, '', hash);
            } catch (error) {
                console.error('Failed to save the graph URL.', error);
                push('Could not save the graph to the URL.', 'error');
            }
        }, 400);
        pendingUrlSave.current = timer;
        return ()=>{
            window.clearTimeout(timer);
            if (pendingUrlSave.current === timer) pendingUrlSave.current = null;
        };
    }, [
        push,
        urlSaveRequest
    ]);
    const handleNodesChange = (0, $kyXgS.useCallback)((changes)=>{
        const previous = nodesRef.current;
        const next = (0, $b869bf1d00b93ac1$export$80563776c0ff2fb5)(changes, previous);
        nodesRef.current = next;
        if ($2a1b924e1aad9c45$var$persistedNodesSignature(previous) !== $2a1b924e1aad9c45$var$persistedNodesSignature(next)) requestUrlSave();
        setNodes(next);
    }, [
        requestUrlSave,
        setNodes
    ]);
    const handleEdgesChange = (0, $kyXgS.useCallback)((changes)=>{
        const previous = edgesRef.current;
        const next = (0, $b869bf1d00b93ac1$export$9beb31bb1f03bba4)(changes, previous);
        edgesRef.current = next;
        if ($2a1b924e1aad9c45$var$persistedEdgesSignature(previous) !== $2a1b924e1aad9c45$var$persistedEdgesSignature(next)) requestUrlSave();
        setEdges(next);
    }, [
        requestUrlSave,
        setEdges
    ]);
    const structure = $2a1b924e1aad9c45$var$structuralSnapshot(nodes, edges, graphName, stateFields);
    const structureSignature = JSON.stringify(structure);
    const validation = (0, $kyXgS.useMemo)(()=>(0, $1dcacb4f32b4e5d7$export$ed3e6c81d6921774)(structure), [
        structureSignature
    ]);
    const code = (0, $kyXgS.useMemo)(()=>(0, $025995cee117ee16$export$f508c41f57988c9f)(structure), [
        structureSignature
    ]);
    const validationContext = (0, $kyXgS.useMemo)(()=>({
            flaggedNodeIds: validation.flaggedNodeIds,
            flaggedEdgeIds: validation.flaggedEdgeIds
        }), [
        validation.flaggedNodeIds,
        validation.flaggedEdgeIds
    ]);
    const takenTypes = (0, $kyXgS.useMemo)(()=>new Set(nodes.map((node)=>node.data.type)), [
        nodes
    ]);
    const allocateNodeId = (0, $kyXgS.useCallback)((type)=>{
        nextId.current += 1;
        return `${type}-${Date.now()}-${nextId.current}`;
    }, []);
    const addNodeAt = (0, $kyXgS.useCallback)((type, position, paletteBounds = null)=>{
        const definition = (0, $0f96f2a40cf4a802$export$a473c43a4db1086c)[type];
        if (!definition) return;
        if (definition.singleton && nodes.some((node)=>node.data.type === type)) {
            push(`Only one ${definition.label} node can be added.`, 'info');
            return;
        }
        const nodeId = allocateNodeId(type);
        requestUrlSave();
        setNodes((current)=>{
            if (definition.singleton && current.some((node)=>node.data.type === type)) return current;
            const data = {
                type: type,
                label: definition.label
            };
            if ((0, $0f96f2a40cf4a802$export$2ee57b564e50eb4b)(type)) data.codeIdentifier = (0, $309118e693f668de$export$3ee0ba14f603656f)(definition.label, current);
            const resolvedPosition = paletteBounds ? (0, $6f4549903038110a$export$25f9c1d511a24805)(position, current, paletteBounds) : position;
            return current.concat({
                id: nodeId,
                type: 'custom',
                position: resolvedPosition,
                data: data,
                zIndex: 10
            });
        });
        setPaletteOpen(false);
    }, [
        allocateNodeId,
        nodes,
        push,
        requestUrlSave,
        setNodes
    ]);
    const addNodeAtCanvasCenter = (0, $kyXgS.useCallback)((type)=>{
        const bounds = canvasRef.current?.getBoundingClientRect();
        if (!bounds || bounds.width === 0 || bounds.height === 0) return false;
        const topLeft = screenToFlowPosition({
            x: bounds.left,
            y: bounds.top
        });
        const bottomRight = screenToFlowPosition({
            x: bounds.right,
            y: bounds.bottom
        });
        const center = screenToFlowPosition({
            x: bounds.left + bounds.width / 2,
            y: bounds.top + bounds.height / 2
        });
        addNodeAt(type, center, {
            minX: topLeft.x,
            maxX: bottomRight.x,
            minY: topLeft.y,
            maxY: bottomRight.y
        });
        return true;
    }, [
        addNodeAt,
        screenToFlowPosition
    ]);
    const handlePaletteAdd = (0, $kyXgS.useCallback)((type)=>{
        if (isNarrow && mobileView !== 'editor') setMobileView('editor');
        addNodeAtCanvasCenter(type);
    }, [
        addNodeAtCanvasCenter,
        isNarrow,
        mobileView
    ]);
    const handleDrop = (0, $kyXgS.useCallback)((event)=>{
        event.preventDefault();
        const type = event.dataTransfer.getData('application/reactflow');
        if (!type) return;
        addNodeAt(type, screenToFlowPosition({
            x: event.clientX,
            y: event.clientY
        }));
    }, [
        addNodeAt,
        screenToFlowPosition
    ]);
    const handleDragOver = (0, $kyXgS.useCallback)((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
    }, []);
    const handleConnect = (0, $kyXgS.useCallback)((connection)=>{
        requestUrlSave();
        setEdges((current)=>(0, $b869bf1d00b93ac1$export$3b35d6dc248b6d92)({
                ...connection,
                data: {}
            }, current));
    }, [
        requestUrlSave,
        setEdges
    ]);
    const handleEditClick = (0, $kyXgS.useCallback)((nodeId)=>setEditingNodeId(nodeId), []);
    const handleEditCancel = (0, $kyXgS.useCallback)(()=>setEditingNodeId(null), []);
    const handleLabelUpdate = (0, $kyXgS.useCallback)((nodeId, nextLabel)=>{
        const label = nextLabel.trim();
        if (!label) {
            setEditingNodeId(null);
            push('The node name cannot be empty.', 'error');
            return;
        }
        if (nodesRef.current.find((node)=>node.id === nodeId)?.data.label === label) {
            setEditingNodeId(null);
            return;
        }
        requestUrlSave();
        setNodes((current)=>current.map((node)=>{
                if (node.id !== nodeId) return node;
                const data = {
                    ...node.data,
                    label: label
                };
                if ((0, $0f96f2a40cf4a802$export$2ee57b564e50eb4b)(node.data.type)) data.codeIdentifier = (0, $309118e693f668de$export$3ee0ba14f603656f)(label, current, nodeId);
                return {
                    ...node,
                    data: data
                };
            }));
        setEditingNodeId(null);
    }, [
        push,
        requestUrlSave,
        setNodes
    ]);
    const editorContext = (0, $kyXgS.useMemo)(()=>({
            editingNodeId: editingNodeId,
            onEditClick: handleEditClick,
            onLabelUpdate: handleLabelUpdate,
            onEditCancel: handleEditCancel,
            onGraphChange: requestUrlSave
        }), [
        editingNodeId,
        handleEditCancel,
        handleEditClick,
        handleLabelUpdate,
        requestUrlSave
    ]);
    const copyText = (0, $kyXgS.useCallback)(async (text, successMessage)=>{
        try {
            await navigator.clipboard.writeText(text);
            push(successMessage, 'success');
        } catch (error) {
            console.error('Clipboard write failed.', error);
            push('Could not copy to the clipboard. Check your browser permissions.', 'error');
        }
    }, [
        push
    ]);
    const handleCopyCode = (0, $kyXgS.useCallback)(()=>copyText(code, 'Copied the generated code.'), [
        code,
        copyText
    ]);
    const handleCopyUrl = (0, $kyXgS.useCallback)(()=>{
        try {
            const url = new URL(window.location.href);
            url.hash = (0, $4dbddc370d338f21$export$ba5ae29bdb29802d)(currentState);
            copyText(url.toString(), 'Copied the current graph URL.');
        } catch (error) {
            console.error('Failed to create a share URL.', error);
            push('Could not create a share URL.', 'error');
        }
    }, [
        copyText,
        currentState,
        push
    ]);
    const replaceGraph = (0, $kyXgS.useCallback)((state)=>{
        const hydrated = $2a1b924e1aad9c45$var$hydrateState(state);
        nodesRef.current = hydrated.nodes;
        edgesRef.current = hydrated.edges;
        setNodes(hydrated.nodes);
        setEdges(hydrated.edges);
        setGraphName(hydrated.graphName);
        setStateFields(hydrated.stateFields);
        setEditingNodeId(null);
        setMobileView('editor');
        setPaletteOpen(false);
        setFitRequest({
            nodeIds: hydrated.nodes.map((node)=>node.id),
            attemptsLeft: 8
        });
    }, [
        setEdges,
        setNodes
    ]);
    const handleReset = (0, $kyXgS.useCallback)(()=>{
        if (!window.confirm('Reset the entire graph to its initial state?')) return;
        requestUrlSave();
        replaceGraph((0, $4dbddc370d338f21$export$de5e90bd767c5d82)());
        push('Reset the graph.', 'success');
    }, [
        push,
        replaceGraph,
        requestUrlSave
    ]);
    const handleLoadTemplate = (0, $kyXgS.useCallback)((templateId)=>{
        if (!(0, $8cfa09048c352926$export$7248111b40db6f2f)(templateId)) {
            push('Unknown graph template.', 'error');
            return;
        }
        if (!window.confirm('Replace the current graph with the selected template?')) return;
        requestUrlSave();
        replaceGraph((0, $8cfa09048c352926$export$b9d5af8c001653b8)(templateId));
        push('Loaded the graph template.', 'success');
    }, [
        push,
        replaceGraph,
        requestUrlSave
    ]);
    const handleApplyPython = (0, $kyXgS.useCallback)((result)=>{
        if (!result.state) return false;
        const summary = [
            `${result.summary.nodes} nodes`,
            `${result.summary.edges} edges`,
            `${result.unreadable.length} unreadable lines`,
            `${result.implied.length} nodes referenced without add_node`
        ].join(' / ');
        if (!window.confirm(`Replace the current graph with the reviewed Python code?\n\n${summary}`)) return false;
        requestUrlSave();
        replaceGraph(result.state);
        push(`Loaded the graph from Python code. ${summary}`, 'success');
        return true;
    }, [
        push,
        replaceGraph,
        requestUrlSave
    ]);
    const handleGraphNameChange = (0, $kyXgS.useCallback)((nextGraphName)=>{
        if (nextGraphName === graphName) return;
        requestUrlSave();
        setGraphName(nextGraphName);
    }, [
        graphName,
        requestUrlSave
    ]);
    const handleStateFieldsChange = (0, $kyXgS.useCallback)((nextStateFields)=>{
        if (nextStateFields === stateFields) return;
        requestUrlSave();
        setStateFields(nextStateFields);
    }, [
        requestUrlSave,
        stateFields
    ]);
    const handleFocusNodes = (0, $kyXgS.useCallback)((nodeIds)=>{
        const ids = new Set(nodeIds);
        setNodes((current)=>current.map((node)=>({
                    ...node,
                    selected: ids.has(node.id)
                })));
        setEdges((current)=>current.map((edge)=>({
                    ...edge,
                    selected: false
                })));
        setMobileView('editor');
        requestAnimationFrame(()=>{
            fitView({
                nodes: nodeIds.map((id)=>({
                        id: id
                    })),
                padding: 0.3,
                duration: 250
            });
        });
    }, [
        fitView,
        setEdges,
        setNodes
    ]);
    (0, $kyXgS.useEffect)(()=>{
        if (!paletteOpen) return undefined;
        const closeOnEscape = (event)=>{
            if (event.key === 'Escape') setPaletteOpen(false);
        };
        document.addEventListener('keydown', closeOnEscape);
        return ()=>document.removeEventListener('keydown', closeOnEscape);
    }, [
        paletteOpen
    ]);
    return /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)((0, $ef5da41f1b60b383$export$d452675449e81987).Provider, {
        value: validationContext,
        children: /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)((0, $9c4ac0b042af0ce8$export$27b8dd149e32f6c7).Provider, {
            value: editorContext,
            children: [
                /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("main", {
                    className: "app-shell",
                    children: [
                        /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("header", {
                            className: "mobile-toolbar",
                            children: [
                                /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
                                    type: "button",
                                    className: "toolbar-button",
                                    "aria-label": "Open node palette",
                                    "aria-expanded": paletteOpen,
                                    "aria-controls": "node-palette",
                                    onClick: ()=>setPaletteOpen(true),
                                    children: "\u2630"
                                }),
                                /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("div", {
                                    className: "mobile-tabs",
                                    role: "tablist",
                                    "aria-label": "Workspace views",
                                    children: [
                                        /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
                                            type: "button",
                                            id: "editor-tab",
                                            role: "tab",
                                            "aria-selected": mobileView === 'editor',
                                            "aria-controls": "editor-panel",
                                            className: mobileView === 'editor' ? 'active' : '',
                                            onClick: ()=>setMobileView('editor'),
                                            children: "Editor"
                                        }),
                                        /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
                                            type: "button",
                                            id: "code-tab",
                                            role: "tab",
                                            "aria-selected": mobileView === 'code',
                                            "aria-controls": "code-panel",
                                            className: mobileView === 'code' ? 'active' : '',
                                            onClick: ()=>setMobileView('code'),
                                            children: "Code"
                                        })
                                    ]
                                })
                            ]
                        }),
                        paletteOpen && /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
                            type: "button",
                            className: "drawer-backdrop",
                            "aria-label": "Close node palette",
                            onClick: ()=>setPaletteOpen(false)
                        }),
                        /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)("aside", {
                            id: "node-palette",
                            className: `palette-pane ${paletteOpen ? 'open' : ''}`,
                            "aria-label": "Node palette",
                            children: [
                                /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("button", {
                                    type: "button",
                                    className: "drawer-close",
                                    "aria-label": "Close node palette",
                                    onClick: ()=>setPaletteOpen(false),
                                    children: "\xd7"
                                }),
                                /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)((0, $b48db40a6be63bf4$export$2e2bcd8739ae039), {
                                    onAddNode: handlePaletteAdd,
                                    onNodeDragStart: ()=>setPaletteOpen(false),
                                    onLoadTemplate: handleLoadTemplate,
                                    onReset: handleReset,
                                    onCopyUrl: handleCopyUrl,
                                    takenTypes: takenTypes
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("section", {
                            id: "editor-panel",
                            role: "tabpanel",
                            "aria-labelledby": "editor-tab",
                            "aria-hidden": isNarrow && mobileView !== 'editor',
                            ref: canvasRef,
                            className: `editor-pane ${mobileView === 'editor' ? '' : 'mobile-hidden'}`,
                            "aria-label": "Graph editor",
                            children: /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsxs)((0, $b869bf1d00b93ac1$export$d0a0e394104ac801), {
                                nodes: nodes,
                                edges: edges,
                                onNodesChange: handleNodesChange,
                                onEdgesChange: handleEdgesChange,
                                onConnect: handleConnect,
                                onDragOver: handleDragOver,
                                onDrop: handleDrop,
                                nodeTypes: $2a1b924e1aad9c45$var$CUSTOM_NODE_TYPES,
                                edgeTypes: $2a1b924e1aad9c45$var$EDGE_TYPES,
                                defaultEdgeOptions: $2a1b924e1aad9c45$var$DEFAULT_EDGE_OPTIONS,
                                deleteKeyCode: [
                                    'Backspace',
                                    'Delete'
                                ],
                                multiSelectionKeyCode: [
                                    'Shift'
                                ],
                                elevateNodesOnSelect: true,
                                elevateEdgesOnSelect: true,
                                selectionOnDrag: !isNarrow,
                                selectionMode: (0, $b869bf1d00b93ac1$export$91484609d16ec765).Partial,
                                panOnDrag: isNarrow ? true : [
                                    2
                                ],
                                panOnScroll: false,
                                fitView: initial.fitLoadedGraph,
                                fitViewOptions: {
                                    padding: 0.2
                                },
                                attributionPosition: "bottom-left",
                                children: [
                                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)((0, $0456767255f0c2cb$export$a97dd8f3835953ef), {
                                        nodeStrokeWidth: 3,
                                        zoomable: true,
                                        pannable: true
                                    }),
                                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)((0, $5d52deba1f384703$export$c7c44baae9d9f25f), {}),
                                    /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)((0, $88c35a3efe04b9ee$export$668799e4797757a8), {
                                        color: "#e9e9e9",
                                        gap: 20,
                                        size: 1.5
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)("section", {
                            id: "code-panel",
                            role: "tabpanel",
                            "aria-labelledby": "code-tab",
                            "aria-hidden": isNarrow && mobileView !== 'code',
                            className: `code-pane ${mobileView === 'code' ? '' : 'mobile-hidden'}`,
                            "aria-label": "Code panel",
                            children: /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)((0, $8a208501073d048d$export$2e2bcd8739ae039), {
                                code: code,
                                graphName: graphName,
                                onGraphNameChange: handleGraphNameChange,
                                stateFields: stateFields,
                                onStateFieldsChange: handleStateFieldsChange,
                                validation: validation,
                                onCopy: handleCopyCode,
                                onFocusNodes: handleFocusNodes,
                                onApplyPython: handleApplyPython
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)((0, $b4e256a915787c5b$export$d82decde2bdd5075), {
                    toasts: toasts,
                    onDismiss: dismiss
                })
            ]
        })
    });
}


function $d1a070809c4739c4$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)((0, $b869bf1d00b93ac1$export$9e7d1e09b3718a14), {
        children: /*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)((0, $2a1b924e1aad9c45$export$2e2bcd8739ae039), {})
    });
}



const $4637a9ab9ccdc7e5$var$container = document.getElementById('root');
if (!$4637a9ab9ccdc7e5$var$container) throw new Error('The #root container is missing.');
(0, $680d651e8a11cc7a$export$882461b6382ed46c)($4637a9ab9ccdc7e5$var$container).render(/*#__PURE__*/ (0, $09d47804029b6d46$exports.jsx)((0, $d1a070809c4739c4$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=repo.5dc02737.js.map
